/* tslint:disable */
/* eslint-disable */
/**
 * City Challenge API
 * The official API for all City Challenge services.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccessControlEntity
 */
export interface AccessControlEntity {
    /**
     * 
     * @type {UserEntity}
     * @memberof AccessControlEntity
     */
    user: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof AccessControlEntity
     */
    role: AccessControlEntityRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof AccessControlEntity
     */
    resourceId: string;
    /**
     * 
     * @type {string}
     * @memberof AccessControlEntity
     */
    resourceType: AccessControlEntityResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AccessControlEntity
     */
    resourceName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessControlEntity
     */
    ancestorIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AccessControlEntity
     */
    owner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccessControlEntity
     */
    lastLogin?: string;
    /**
     * A story grant\'s project
     * @type {string}
     * @memberof AccessControlEntity
     */
    parentName?: string;
    /**
     * The caller\'s own role where this grant sits
     * @type {string}
     * @memberof AccessControlEntity
     */
    manageAs?: AccessControlEntityManageAsEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AccessControlEntityRoleEnum {
    Admin = 'admin',
    Editor = 'editor',
    Viewer = 'viewer',
    Host = 'host'
}
/**
    * @export
    * @enum {string}
    */
export enum AccessControlEntityResourceTypeEnum {
    Whitelabel = 'whitelabel',
    Company = 'company',
    Division = 'division',
    Game = 'game',
    QrCode = 'qr_code',
    GameRelease = 'game_release',
    GameVariable = 'game_variable',
    Domain = 'domain',
    Session = 'session',
    Review = 'review',
    Article = 'article',
    ArticleGroup = 'article_group',
    Tag = 'tag',
    Theme = 'theme',
    Asset = 'asset',
    Event = 'event',
    EventVariant = 'event_variant',
    Scenario = 'scenario',
    Scenarios = 'scenarios',
    DivisionSubscription = 'division_subscription',
    DivisionDepartment = 'division_department',
    SubscriptionPackage = 'subscription_package',
    Subscription = 'subscription',
    Scene = 'scene',
    TemplateCategory = 'template_category',
    Template = 'template',
    Notification = 'notification',
    OnDemandVideo = 'on_demand_video',
    OnDemandPlaylist = 'on_demand_playlist',
    Collection = 'collection',
    Brandkit = 'brandkit',
    Page = 'page',
    PageSet = 'pageSet'
}
/**
    * @export
    * @enum {string}
    */
export enum AccessControlEntityManageAsEnum {
    Admin = 'admin',
    Editor = 'editor',
    Viewer = 'viewer',
    Host = 'host'
}

/**
 * 
 * @export
 * @interface AccessToken
 */
export interface AccessToken {
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    id: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof AccessToken
     */
    user: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    userAgent: string;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    ip: string;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    lastUsed: string;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    invalidated: string;
    /**
     * 
     * @type {number}
     * @memberof AccessToken
     */
    ttl: number;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    scope: string;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    provider: string;
}
/**
 * 
 * @export
 * @interface AddGameLanguageDto
 */
export interface AddGameLanguageDto {
    /**
     * 
     * @type {string}
     * @memberof AddGameLanguageDto
     */
    regionalVariant?: string | null;
    /**
     * formal or informal; unset is auto
     * @type {string}
     * @memberof AddGameLanguageDto
     */
    formality?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddGameLanguageDto
     */
    languageId: string;
}
/**
 * 
 * @export
 * @interface AddGameVariableDto
 */
export interface AddGameVariableDto {
    /**
     * 
     * @type {string}
     * @memberof AddGameVariableDto
     */
    id: string;
    /**
     * 
     * @type {GameVariableTypeEnum}
     * @memberof AddGameVariableDto
     */
    type: GameVariableTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof AddGameVariableDto
     */
    defaultValue?: object;
}
/**
 * 
 * @export
 * @interface AddParticipantDto
 */
export interface AddParticipantDto {
    /**
     * 
     * @type {string}
     * @memberof AddParticipantDto
     */
    userId: string;
}
/**
 * 
 * @export
 * @interface AddressedPageDto
 */
export interface AddressedPageDto {
    /**
     * 
     * @type {string}
     * @memberof AddressedPageDto
     */
    pageId: string;
    /**
     * 
     * @type {string}
     * @memberof AddressedPageDto
     */
    name: string;
}
/**
 * 
 * @export
 * @interface AiTranslateRequestDto
 */
export interface AiTranslateRequestDto {
    /**
     * Array of text items to translate
     * @type {Array<TranslationItem>}
     * @memberof AiTranslateRequestDto
     */
    items: Array<TranslationItem>;
    /**
     * Source language name (e.g., \'Dutch\', \'English (UK)\', \'English (US)\')
     * @type {string}
     * @memberof AiTranslateRequestDto
     */
    sourceLanguage: string;
    /**
     * Target language name (e.g., \'French\', \'German\')
     * @type {string}
     * @memberof AiTranslateRequestDto
     */
    targetLanguage: string;
    /**
     * Optional context about the content being translated
     * @type {string}
     * @memberof AiTranslateRequestDto
     */
    context?: string;
    /**
     * Story the texts belong to; adds its details and translation settings
     * @type {string}
     * @memberof AiTranslateRequestDto
     */
    gameId?: string;
    /**
     * Target language id (e.g. \'nl\', \'en-us\')
     * @type {string}
     * @memberof AiTranslateRequestDto
     */
    targetLanguageId?: string;
    /**
     * The story\'s full source text in reading order, used as context only
     * @type {string}
     * @memberof AiTranslateRequestDto
     */
    storyText?: string;
}
/**
 * 
 * @export
 * @interface AiTranslateResponseDto
 */
export interface AiTranslateResponseDto {
    /**
     * Array of translated items
     * @type {Array<TranslatedItem>}
     * @memberof AiTranslateResponseDto
     */
    translations: Array<TranslatedItem>;
    /**
     * Source language used
     * @type {string}
     * @memberof AiTranslateResponseDto
     */
    sourceLanguage: string;
    /**
     * Target language used
     * @type {string}
     * @memberof AiTranslateResponseDto
     */
    targetLanguage: string;
}
/**
 * 
 * @export
 * @interface AnalyticsDisplayValueDto
 */
export interface AnalyticsDisplayValueDto {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsDisplayValueDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsDisplayValueDto
     */
    value: string;
}
/**
 * 
 * @export
 * @interface AnalyticsFilterContainsDto
 */
export interface AnalyticsFilterContainsDto {
    /**
     * Array of ids to filter the data on.
     * @type {Array<string>}
     * @memberof AnalyticsFilterContainsDto
     */
    filter: Array<string>;
}
/**
 * 
 * @export
 * @interface AnalyticsFilterDto
 */
export interface AnalyticsFilterDto {
    /**
     * 
     * @type {AnalyticsFilterContainsDto}
     * @memberof AnalyticsFilterDto
     */
    source?: AnalyticsFilterContainsDto;
    /**
     * 
     * @type {AnalyticsFilterContainsDto}
     * @memberof AnalyticsFilterDto
     */
    language?: AnalyticsFilterContainsDto;
    /**
     * 
     * @type {AnalyticsFilterContainsDto}
     * @memberof AnalyticsFilterDto
     */
    sid?: AnalyticsFilterContainsDto;
    /**
     * 
     * @type {AnalyticsFilterContainsDto}
     * @memberof AnalyticsFilterDto
     */
    device?: AnalyticsFilterContainsDto;
    /**
     * 
     * @type {AnalyticsFilterContainsDto}
     * @memberof AnalyticsFilterDto
     */
    blocksViewed?: AnalyticsFilterContainsDto;
    /**
     * 
     * @type {AnalyticsFilterContainsDto}
     * @memberof AnalyticsFilterDto
     */
    country?: AnalyticsFilterContainsDto;
}
/**
 * 
 * @export
 * @interface AnonymousAccessDto
 */
export interface AnonymousAccessDto {
    /**
     * 
     * @type {string}
     * @memberof AnonymousAccessDto
     */
    deviceToken: string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousAccessDto
     */
    secret: string;
}
/**
 * 
 * @export
 * @interface AppleTokenDto
 */
export interface AppleTokenDto {
    /**
     * 
     * @type {string}
     * @memberof AppleTokenDto
     */
    authorizationCode: string;
    /**
     * 
     * @type {string}
     * @memberof AppleTokenDto
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof AppleTokenDto
     */
    bundleId: string;
}
/**
 * 
 * @export
 * @interface ArchiveInfo
 */
export interface ArchiveInfo {
    /**
     * 
     * @type {number}
     * @memberof ArchiveInfo
     */
    totalSize: number;
    /**
     * 
     * @type {number}
     * @memberof ArchiveInfo
     */
    compressedSize: number;
    /**
     * 
     * @type {Array<ArchivedFile>}
     * @memberof ArchiveInfo
     */
    files?: Array<ArchivedFile>;
}
/**
 * 
 * @export
 * @interface ArchivedFile
 */
export interface ArchivedFile {
    /**
     * 
     * @type {string}
     * @memberof ArchivedFile
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof ArchivedFile
     */
    fileKey: string;
    /**
     * 
     * @type {number}
     * @memberof ArchivedFile
     */
    fileSize: number;
}
/**
 * 
 * @export
 * @interface ArticleAnalyticsDto
 */
export interface ArticleAnalyticsDto {
    /**
     * 
     * @type {string}
     * @memberof ArticleAnalyticsDto
     */
    userKey: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleAnalyticsDto
     */
    divisionId: string;
}
/**
 * 
 * @export
 * @interface ArticleAnalyticsEntity
 */
export interface ArticleAnalyticsEntity {
    /**
     * 
     * @type {string}
     * @memberof ArticleAnalyticsEntity
     */
    id: string;
    /**
     * 
     * @type {ArticleEntity}
     * @memberof ArticleAnalyticsEntity
     */
    article?: ArticleEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof ArticleAnalyticsEntity
     */
    user?: UserEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof ArticleAnalyticsEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof ArticleAnalyticsEntity
     */
    userKey: string;
    /**
     * 
     * @type {number}
     * @memberof ArticleAnalyticsEntity
     */
    created: number;
}
/**
 * 
 * @export
 * @interface ArticleEntity
 */
export interface ArticleEntity {
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleEntity
     */
    isPublished: boolean;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof ArticleEntity
     */
    body: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    published?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    video?: string;
    /**
     * 
     * @type {Array<TagEntity>}
     * @memberof ArticleEntity
     */
    tags?: Array<TagEntity>;
    /**
     * 
     * @type {Array<ArticleGroupEntity>}
     * @memberof ArticleEntity
     */
    groups?: Array<ArticleGroupEntity>;
    /**
     * 
     * @type {Array<ArticleAnalyticsEntity>}
     * @memberof ArticleEntity
     */
    articleAnalytics?: Array<ArticleAnalyticsEntity>;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof ArticleEntity
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof ArticleEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {Array<LanguageEntity>}
     * @memberof ArticleEntity
     */
    baseLanguage?: Array<LanguageEntity>;
    /**
     * 
     * @type {Array<ArticleTranslationEntity>}
     * @memberof ArticleEntity
     */
    translations?: Array<ArticleTranslationEntity>;
}
/**
 * 
 * @export
 * @interface ArticleGroupDivisionEntity
 */
export interface ArticleGroupDivisionEntity {
    /**
     * 
     * @type {string}
     * @memberof ArticleGroupDivisionEntity
     */
    hideUntil?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof ArticleGroupDivisionEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {ArticleGroupEntity}
     * @memberof ArticleGroupDivisionEntity
     */
    articleGroup: ArticleGroupEntity;
}
/**
 * 
 * @export
 * @interface ArticleGroupEntity
 */
export interface ArticleGroupEntity {
    /**
     * 
     * @type {string}
     * @memberof ArticleGroupEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleGroupEntity
     */
    name: string;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof ArticleGroupEntity
     */
    company: CompanyEntity;
    /**
     * 
     * @type {Array<string>}
     * @memberof ArticleGroupEntity
     */
    articles?: Array<string>;
    /**
     * 
     * @type {Array<ArticleGroupDivisionEntity>}
     * @memberof ArticleGroupEntity
     */
    articleGroupDivisions?: Array<ArticleGroupDivisionEntity>;
}
/**
 * 
 * @export
 * @interface ArticleTranslationEntity
 */
export interface ArticleTranslationEntity {
    /**
     * 
     * @type {ArticleEntity}
     * @memberof ArticleTranslationEntity
     */
    article?: ArticleEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof ArticleTranslationEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {string}
     * @memberof ArticleTranslationEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTranslationEntity
     */
    video?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTranslationEntity
     */
    active?: boolean;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof ArticleTranslationEntity
     */
    body?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof ArticleTranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface AssetEntity
 */
export interface AssetEntity {
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    ref?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    src: string;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    size: number;
    /**
     * 
     * @type {AssetMetadataDto}
     * @memberof AssetEntity
     */
    metadata?: AssetMetadataDto;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    extension: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    mimetype: string;
    /**
     * 
     * @type {{ [key: string]: AssetJobDto; }}
     * @memberof AssetEntity
     */
    jobs?: { [key: string]: AssetJobDto; };
    /**
     * 
     * @type {DivisionEntity}
     * @memberof AssetEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof AssetEntity
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    updated?: string;
    /**
     * 
     * @type {AssetOriginType}
     * @memberof AssetEntity
     */
    origin: AssetOriginType;
    /**
     * 
     * @type {UserEntity}
     * @memberof AssetEntity
     */
    user?: UserEntity;
}
/**
 * 
 * @export
 * @interface AssetJobDto
 */
export interface AssetJobDto {
    /**
     * 
     * @type {string}
     * @memberof AssetJobDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetJobDto
     */
    status: AssetJobDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AssetJobDto
     */
    progress?: number;
    /**
     * 
     * @type {object}
     * @memberof AssetJobDto
     */
    result?: object;
    /**
     * 
     * @type {number}
     * @memberof AssetJobDto
     */
    updated?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum AssetJobDtoStatusEnum {
    Done = 'done',
    Error = 'error',
    Pending = 'pending',
    Suspended = 'suspended'
}

/**
 * 
 * @export
 * @interface AssetMetadaAttributionDto
 */
export interface AssetMetadaAttributionDto {
    /**
     * 
     * @type {string}
     * @memberof AssetMetadaAttributionDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetMetadaAttributionDto
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface AssetMetadataDto
 */
export interface AssetMetadataDto {
    /**
     * 
     * @type {AssetMetadataResolutionDto}
     * @memberof AssetMetadataDto
     */
    resolution?: AssetMetadataResolutionDto;
    /**
     * 
     * @type {AssetMetadaAttributionDto}
     * @memberof AssetMetadataDto
     */
    attribution?: AssetMetadaAttributionDto;
    /**
     * 
     * @type {string}
     * @memberof AssetMetadataDto
     */
    alt?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetMetadataDto
     */
    transcript?: string;
    /**
     * 
     * @type {number}
     * @memberof AssetMetadataDto
     */
    duration?: number;
    /**
     * 
     * @type {AssetMetadataResolutionDto}
     * @memberof AssetMetadataDto
     */
    focusPoint?: AssetMetadataResolutionDto;
    /**
     * User-defined tags for organizing and filtering media files (e.g., \'icon\', \'background\', \'logo\')
     * @type {Array<string>}
     * @memberof AssetMetadataDto
     */
    tags?: Array<string>;
}
/**
 * 
 * @export
 * @interface AssetMetadataResolutionDto
 */
export interface AssetMetadataResolutionDto {
    /**
     * 
     * @type {number}
     * @memberof AssetMetadataResolutionDto
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof AssetMetadataResolutionDto
     */
    height: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AssetOriginType {
    Upload = 'upload',
    Unsplash = 'unsplash',
    Pexels = 'pexels',
    Giphy = 'giphy',
    Generated = 'generated'
}

/**
 * 
 * @export
 * @interface AssetTagDto
 */
export interface AssetTagDto {
    /**
     * The tag name/value
     * @type {string}
     * @memberof AssetTagDto
     */
    tag: string;
    /**
     * Number of assets with this tag
     * @type {number}
     * @memberof AssetTagDto
     */
    count: number;
}
/**
 * 
 * @export
 * @interface BaseLanguageDto
 */
export interface BaseLanguageDto {
    /**
     * 
     * @type {string}
     * @memberof BaseLanguageDto
     */
    baseLanguage?: string;
}
/**
 * 
 * @export
 * @interface BrandkitColorDto
 */
export interface BrandkitColorDto {
    /**
     * The semantic role this color fills in the brand
     * @type {string}
     * @memberof BrandkitColorDto
     */
    role: string;
    /**
     * 6-digit hex color with # prefix
     * @type {string}
     * @memberof BrandkitColorDto
     */
    hex: string;
    /**
     * Short description of where this color was found on the page
     * @type {string}
     * @memberof BrandkitColorDto
     */
    source: string;
}
/**
 * 
 * @export
 * @interface BrandkitCreateDto
 */
export interface BrandkitCreateDto {
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    colorBackground?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    colorSurface?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitCreateDto
     */
    colorSurfaceOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    colorBorder?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitCreateDto
     */
    colorBorderOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    colorHeading?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    colorText?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    colorButtonPrimary?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitCreateDto
     */
    colorButtonPrimaryOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    colorButtonText?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitCreateDto
     */
    colorButtonTextOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    colorAccent?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    colorWarning?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    feedbackColorPositive?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    feedbackColorNegative?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    colorProgress?: string;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof BrandkitCreateDto
     */
    fontPrimary?: FontDefinitionDto;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof BrandkitCreateDto
     */
    fontSecondary?: FontDefinitionDto;
    /**
     * 
     * @type {CornerRadiusEnum}
     * @memberof BrandkitCreateDto
     */
    cornerRadius?: CornerRadiusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof BrandkitCreateDto
     */
    balloonArrowEnabled?: boolean;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof BrandkitCreateDto
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {BrandkitEntity}
     * @memberof BrandkitCreateDto
     */
    sourceBrandkit?: BrandkitEntity;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    sourceBrandkitId?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitCreateDto
     */
    creationMethod?: string;
}
/**
 * 
 * @export
 * @interface BrandkitEntity
 */
export interface BrandkitEntity {
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandkitEntity
     */
    isDefault?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    colorBackground?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    colorSurface?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitEntity
     */
    colorSurfaceOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    colorBorder?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitEntity
     */
    colorBorderOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    colorHeading?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    colorText?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    colorButtonPrimary?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitEntity
     */
    colorButtonPrimaryOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    colorButtonText?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitEntity
     */
    colorButtonTextOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    colorAccent?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    colorWarning?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    feedbackColorPositive?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    feedbackColorNegative?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    colorProgress?: string;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof BrandkitEntity
     */
    fontPrimary?: FontDefinitionDto;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof BrandkitEntity
     */
    fontSecondary?: FontDefinitionDto;
    /**
     * 
     * @type {CornerRadiusEnum}
     * @memberof BrandkitEntity
     */
    cornerRadius?: CornerRadiusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof BrandkitEntity
     */
    balloonArrowEnabled?: boolean;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof BrandkitEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof BrandkitEntity
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {BrandkitEntity}
     * @memberof BrandkitEntity
     */
    sourceBrandkit?: BrandkitEntity;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    sourceBrandkitId?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    creationMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface BrandkitExtractRequestDto
 */
export interface BrandkitExtractRequestDto {
    /**
     * The HTTPS URL of the company website to extract colors from
     * @type {string}
     * @memberof BrandkitExtractRequestDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface BrandkitExtractResponseDto
 */
export interface BrandkitExtractResponseDto {
    /**
     * 
     * @type {Array<BrandkitColorDto>}
     * @memberof BrandkitExtractResponseDto
     */
    colors: Array<BrandkitColorDto>;
    /**
     * 
     * @type {Array<BrandkitFontDto>}
     * @memberof BrandkitExtractResponseDto
     */
    fonts: Array<BrandkitFontDto>;
    /**
     * The URL that was fetched
     * @type {string}
     * @memberof BrandkitExtractResponseDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface BrandkitFontDto
 */
export interface BrandkitFontDto {
    /**
     * The semantic role: primary (body/general text) or secondary (headings/buttons)
     * @type {string}
     * @memberof BrandkitFontDto
     */
    role: string;
    /**
     * The font family name
     * @type {string}
     * @memberof BrandkitFontDto
     */
    family: string;
    /**
     * Font type: google, custom, or default
     * @type {string}
     * @memberof BrandkitFontDto
     */
    type: string;
    /**
     * Google Fonts CSS URL (only if type=google)
     * @type {string}
     * @memberof BrandkitFontDto
     */
    googleUrl?: string;
    /**
     * Custom font file objects keyed by weight variant (only if type=custom)
     * @type {object}
     * @memberof BrandkitFontDto
     */
    customFont?: object;
    /**
     * Short description of where this font was found on the page
     * @type {string}
     * @memberof BrandkitFontDto
     */
    source: string;
}
/**
 * 
 * @export
 * @interface BrandkitGeneratePaletteRequestDto
 */
export interface BrandkitGeneratePaletteRequestDto {
    /**
     * Primary brand color as 6-digit hex with # prefix (e.g. #FF5500)
     * @type {string}
     * @memberof BrandkitGeneratePaletteRequestDto
     */
    primaryColor: string;
}
/**
 * 
 * @export
 * @interface BrandkitGeneratePaletteResponseDto
 */
export interface BrandkitGeneratePaletteResponseDto {
    /**
     * 
     * @type {Array<BrandkitPaletteDto>}
     * @memberof BrandkitGeneratePaletteResponseDto
     */
    palettes: Array<BrandkitPaletteDto>;
    /**
     * The primary color that was provided
     * @type {string}
     * @memberof BrandkitGeneratePaletteResponseDto
     */
    primaryColor: string;
    /**
     * Default surface opacity (0.6 = 60%)
     * @type {number}
     * @memberof BrandkitGeneratePaletteResponseDto
     */
    colorSurfaceOpacity: number;
}
/**
 * 
 * @export
 * @interface BrandkitPaletteDto
 */
export interface BrandkitPaletteDto {
    /**
     * Human-readable palette name
     * @type {string}
     * @memberof BrandkitPaletteDto
     */
    name: string;
    /**
     * 
     * @type {Array<BrandkitColorDto>}
     * @memberof BrandkitPaletteDto
     */
    colors: Array<BrandkitColorDto>;
}
/**
 * 
 * @export
 * @interface BrandkitUpdateDto
 */
export interface BrandkitUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    colorBackground?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    colorSurface?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitUpdateDto
     */
    colorSurfaceOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    colorBorder?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitUpdateDto
     */
    colorBorderOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    colorHeading?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    colorText?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    colorButtonPrimary?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitUpdateDto
     */
    colorButtonPrimaryOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    colorButtonText?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandkitUpdateDto
     */
    colorButtonTextOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    colorAccent?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    colorWarning?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    feedbackColorPositive?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    feedbackColorNegative?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    colorProgress?: string;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof BrandkitUpdateDto
     */
    fontPrimary?: FontDefinitionDto;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof BrandkitUpdateDto
     */
    fontSecondary?: FontDefinitionDto;
    /**
     * 
     * @type {CornerRadiusEnum}
     * @memberof BrandkitUpdateDto
     */
    cornerRadius?: CornerRadiusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof BrandkitUpdateDto
     */
    balloonArrowEnabled?: boolean;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof BrandkitUpdateDto
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {BrandkitEntity}
     * @memberof BrandkitUpdateDto
     */
    sourceBrandkit?: BrandkitEntity;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    sourceBrandkitId?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandkitUpdateDto
     */
    creationMethod?: string;
}
/**
 * 
 * @export
 * @interface ChangePasswordDto
 */
export interface ChangePasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordDto
     */
    currentPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordDto
     */
    newPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordDto
     */
    repeatNewPassword: string;
}
/**
 * 
 * @export
 * @interface ClientEventDto
 */
export interface ClientEventDto {
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    demioEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    webinarGeekBroadcastId?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof ClientEventDto
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    emailNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    hideUntil?: string;
    /**
     * This URL field will replace the button \'I want to join!\' when the field has content. The button will redirect the user to the URL.
     * @type {string}
     * @memberof ClientEventDto
     */
    link?: string;
    /**
     * 
     * @type {ThemeEntity}
     * @memberof ClientEventDto
     */
    theme?: ThemeEntity;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    image?: string;
    /**
     * If zero, this will mean unlimited participants
     * @type {number}
     * @memberof ClientEventDto
     */
    maxParticipants?: number;
    /**
     * Whether hiding participants list or not, default is false
     * @type {boolean}
     * @memberof ClientEventDto
     */
    hideParticipants?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    updated?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof ClientEventDto
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof ClientEventDto
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    processedDemioOn?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientEventDto
     */
    processedWebinarGeekOn?: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof ClientEventDto
     */
    user?: UserEntity;
    /**
     * 
     * @type {EventEntity}
     * @memberof ClientEventDto
     */
    copyFrom?: EventEntity;
    /**
     * 
     * @type {Array<EventVariantEntity>}
     * @memberof ClientEventDto
     */
    variants?: Array<EventVariantEntity>;
    /**
     * 
     * @type {Array<EventTranslationEntity>}
     * @memberof ClientEventDto
     */
    translations?: Array<EventTranslationEntity>;
    /**
     * The base language required in order to translate this event.
     * @type {LanguageEntity}
     * @memberof ClientEventDto
     */
    baseLanguage?: LanguageEntity;
    /**
     * 
     * @type {EventLanguageTypeEnum}
     * @memberof ClientEventDto
     */
    eventLanguage?: EventLanguageTypeEnum;
    /**
     * 
     * @type {EventTypeEnum}
     * @memberof ClientEventDto
     */
    eventType?: EventTypeEnum;
    /**
     * Whether the event is published and visible to users
     * @type {boolean}
     * @memberof ClientEventDto
     */
    published?: boolean;
    /**
     * 
     * @type {Array<ClientEventParticipantDto>}
     * @memberof ClientEventDto
     */
    participants?: Array<ClientEventParticipantDto>;
}
/**
 * 
 * @export
 * @interface ClientEventParticipantDto
 */
export interface ClientEventParticipantDto {
    /**
     * Own rows only
     * @type {string}
     * @memberof ClientEventParticipantDto
     */
    id?: string;
    /**
     * Own rows only
     * @type {ClientEventParticipantUserDto}
     * @memberof ClientEventParticipantDto
     */
    user?: ClientEventParticipantUserDto;
    /**
     * Set when the place is confirmed; absent on the waiting list. Day precision on other users\' rows.
     * @type {string}
     * @memberof ClientEventParticipantDto
     */
    confirmed?: string;
    /**
     * Own rows only
     * @type {string}
     * @memberof ClientEventParticipantDto
     */
    created?: string;
    /**
     * Own rows only
     * @type {EventVariantEntity}
     * @memberof ClientEventParticipantDto
     */
    variant?: EventVariantEntity;
    /**
     * Own rows only
     * @type {string}
     * @memberof ClientEventParticipantDto
     */
    demioJoinUrl?: string;
    /**
     * Own rows only
     * @type {string}
     * @memberof ClientEventParticipantDto
     */
    webinarGeekJoinUrl?: string;
}
/**
 * 
 * @export
 * @interface ClientEventParticipantUserDto
 */
export interface ClientEventParticipantUserDto {
    /**
     * 
     * @type {string}
     * @memberof ClientEventParticipantUserDto
     */
    id: string;
}
/**
 * 
 * @export
 * @interface CollectionEntity
 */
export interface CollectionEntity {
    /**
     * 
     * @type {string}
     * @memberof CollectionEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionEntity
     */
    name: string;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof CollectionEntity
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof CollectionEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {number}
     * @memberof CollectionEntity
     */
    weight?: number;
    /**
     * 
     * @type {Array<CollectionMemberEntity>}
     * @memberof CollectionEntity
     */
    members?: Array<CollectionMemberEntity>;
}
/**
 * 
 * @export
 * @interface CollectionMemberEntity
 */
export interface CollectionMemberEntity {
    /**
     * 
     * @type {string}
     * @memberof CollectionMemberEntity
     */
    id: string;
    /**
     * 
     * @type {CollectionMemberType}
     * @memberof CollectionMemberEntity
     */
    type: CollectionMemberType;
    /**
     * 
     * @type {number}
     * @memberof CollectionMemberEntity
     */
    weight?: number;
    /**
     * 
     * @type {GameEntity}
     * @memberof CollectionMemberEntity
     */
    game?: GameEntity;
    /**
     * 
     * @type {EventEntity}
     * @memberof CollectionMemberEntity
     */
    event?: EventEntity;
    /**
     * 
     * @type {ArticleEntity}
     * @memberof CollectionMemberEntity
     */
    article?: ArticleEntity;
    /**
     * 
     * @type {OnDemandVideoEntity}
     * @memberof CollectionMemberEntity
     */
    onDemandVideo?: OnDemandVideoEntity;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CollectionMemberType {
    Game = 'game',
    Event = 'event',
    Article = 'article',
    OnDemandVideo = 'on_demand_video'
}

/**
 * 
 * @export
 * @interface CompanyEntity
 */
export interface CompanyEntity {
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CompanyEntity
     */
    contentTypeNames?: { [key: string]: string; };
    /**
     * 
     * @type {CompanyTypeEnum}
     * @memberof CompanyEntity
     */
    type: CompanyTypeEnum;
    /**
     * 
     * @type {WhitelabelEntity}
     * @memberof CompanyEntity
     */
    whitelabel: WhitelabelEntity;
    /**
     * 
     * @type {Array<DivisionEntity>}
     * @memberof CompanyEntity
     */
    divisions?: Array<DivisionEntity>;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    crmId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    churnedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    demioApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    demioApiSecret?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    webinarGeekApiKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyEntity
     */
    demioConfigured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyEntity
     */
    webinarGeekConfigured?: boolean;
    /**
     * 
     * @type {Array<ArticleEntity>}
     * @memberof CompanyEntity
     */
    articles?: Array<ArticleEntity>;
    /**
     * 
     * @type {Array<TagEntity>}
     * @memberof CompanyEntity
     */
    tags?: Array<TagEntity>;
    /**
     * 
     * @type {Array<ArticleGroupEntity>}
     * @memberof CompanyEntity
     */
    articleGroups?: Array<ArticleGroupEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoEntity>}
     * @memberof CompanyEntity
     */
    onDemandVideos?: Array<OnDemandVideoEntity>;
    /**
     * 
     * @type {Array<OnDemandPlaylistEntity>}
     * @memberof CompanyEntity
     */
    onDemandPlaylists?: Array<OnDemandPlaylistEntity>;
    /**
     * 
     * @type {Array<CollectionEntity>}
     * @memberof CompanyEntity
     */
    collections?: Array<CollectionEntity>;
    /**
     * 
     * @type {Array<GameEntity>}
     * @memberof CompanyEntity
     */
    games?: Array<GameEntity>;
    /**
     * 
     * @type {Array<EventEntity>}
     * @memberof CompanyEntity
     */
    events?: Array<EventEntity>;
    /**
     * 
     * @type {Array<AssetEntity>}
     * @memberof CompanyEntity
     */
    assets?: Array<AssetEntity>;
    /**
     * 
     * @type {Array<BrandkitEntity>}
     * @memberof CompanyEntity
     */
    brandkits?: Array<BrandkitEntity>;
    /**
     * 
     * @type {BrandkitEntity}
     * @memberof CompanyEntity
     */
    defaultBrandkit?: BrandkitEntity;
    /**
     * 
     * @type {PreferredColorThemeEnum}
     * @memberof CompanyEntity
     */
    preferredColorTheme?: PreferredColorThemeEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    updated?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyEntity
     */
    disableTracking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyEntity
     */
    workspaceEnabled?: boolean;
    /**
     * 
     * @type {ResolvedSubscriptionDto}
     * @memberof CompanyEntity
     */
    subscriptionInfo: ResolvedSubscriptionDto;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CompanyTypeEnum {
    Company = 'company',
    Country = 'country'
}

/**
 * 
 * @export
 * @interface ConsentBannerSettingsDto
 */
export interface ConsentBannerSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof ConsentBannerSettingsDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConsentBannerSettingsDto
     */
    body?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentBannerSettingsDto
     */
    enabled: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ConsentResponse {
    Shown = 'shown',
    Accepted = 'accepted',
    Declined = 'declined'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConversionEvent {
    Lead = 'lead',
    SignUp = 'sign_up',
    ViewContent = 'view_content',
    Custom = 'custom'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum CornerRadiusEnum {
    Default = 'default',
    None = 'none',
    Small = 'small',
    Medium = 'medium',
    Full = 'full'
}

/**
 * 
 * @export
 * @interface CountEventParticipantsDto
 */
export interface CountEventParticipantsDto {
    /**
     * 
     * @type {number}
     * @memberof CountEventParticipantsDto
     */
    mainParticipants: number;
    /**
     * 
     * @type {number}
     * @memberof CountEventParticipantsDto
     */
    waitingList: number;
}
/**
 * 
 * @export
 * @interface CreateEventVariantDto
 */
export interface CreateEventVariantDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEventVariantDto
     */
    demioEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventVariantDto
     */
    webinarGeekBroadcastId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventVariantDto
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventVariantDto
     */
    endDate?: string;
    /**
     * 
     * @type {EventLanguageTypeEnum}
     * @memberof CreateEventVariantDto
     */
    eventLanguage?: EventLanguageTypeEnum;
}
/**
 * 
 * @export
 * @interface CredentialsDto
 */
export interface CredentialsDto {
    /**
     * 
     * @type {string}
     * @memberof CredentialsDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CredentialsDto
     */
    password: string;
}
/**
 * 
 * @export
 * @interface DeepLinkFindDto
 */
export interface DeepLinkFindDto {
    /**
     * 
     * @type {number}
     * @memberof DeepLinkFindDto
     */
    screenWidth: number;
    /**
     * 
     * @type {number}
     * @memberof DeepLinkFindDto
     */
    screenHeight: number;
}
/**
 * 
 * @export
 * @interface DeepLinkPutDto
 */
export interface DeepLinkPutDto {
    /**
     * 
     * @type {string}
     * @memberof DeepLinkPutDto
     */
    domain: string;
    /**
     * 
     * @type {number}
     * @memberof DeepLinkPutDto
     */
    screenWidth: number;
    /**
     * 
     * @type {number}
     * @memberof DeepLinkPutDto
     */
    screenHeight: number;
    /**
     * 
     * @type {string}
     * @memberof DeepLinkPutDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface DeepLinkResponseDto
 */
export interface DeepLinkResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DeepLinkResponseDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface DeliverTokensDto
 */
export interface DeliverTokensDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeliverTokensDto
     */
    tokens: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DeliverTokensDto
     */
    appVersion: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverTokensDto
     */
    buildNumber: string;
}
/**
 * 
 * @export
 * @interface DeliverTokensResultDto
 */
export interface DeliverTokensResultDto {
    /**
     * 
     * @type {number}
     * @memberof DeliverTokensResultDto
     */
    delivered: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverTokensResultDto
     */
    missing: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverTokensResultDto
     */
    stale: number;
    /**
     * 
     * @type {number}
     * @memberof DeliverTokensResultDto
     */
    unstale: number;
}
/**
 * 
 * @export
 * @interface DivisionBehaviour
 */
export interface DivisionBehaviour {
    /**
     * 
     * @type {boolean}
     * @memberof DivisionBehaviour
     */
    watermark: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionBehaviour
     */
    expires?: string;
}
/**
 * 
 * @export
 * @interface DivisionContactDto
 */
export interface DivisionContactDto {
    /**
     * 
     * @type {string}
     * @memberof DivisionContactDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionContactDto
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionContactDto
     */
    email?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionContactDto
     */
    bio?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof DivisionContactDto
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionContactDto
     */
    phone?: string;
}
/**
 * 
 * @export
 * @interface DivisionCreateDto
 */
export interface DivisionCreateDto {
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    updated?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    published?: boolean;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof DivisionCreateDto
     */
    coordinates?: GeoPointDto;
    /**
     * 
     * @type {DivisionPlatformTypeEnum}
     * @memberof DivisionCreateDto
     */
    platformType?: DivisionPlatformTypeEnum;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof DivisionCreateDto
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    code?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionCreateDto
     */
    domains?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionCreateDto
     */
    excludedDomains?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    forceAuthentication?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    enableOnboarding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    enableMfa?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    requiresValidQR?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    projectWideLeaderboard?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    experiencesTabTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    experiencesWelcomeText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    articlesEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    articlesTabTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    onDemandEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    onDemandTabTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    eventsEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    eventsTabTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    disableEventCreation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    webinarsEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    workspaceEnabled?: boolean;
    /**
     * 
     * @type {PagesEntryBehaviorEnum}
     * @memberof DivisionCreateDto
     */
    pagesEntryBehavior?: PagesEntryBehaviorEnum;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    pagesAccent?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    disableStoryOverview?: boolean;
    /**
     * When enabled, opening a story whose active session was built from an older release discards that session so a fresh one is started at the latest published release version.
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    showLatestStoryVersion?: boolean;
    /**
     * Always hide map, even if this division has multiple location-based games.
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    alwaysHideMap?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    mapBased?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    mapBasedDisableGps?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    mapBasedTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    mapBasedShowLegend?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    customMapUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    favicon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    pwaIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    backgroundImage?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionCreateDto
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {Array<GameEntity>}
     * @memberof DivisionCreateDto
     */
    games?: Array<GameEntity>;
    /**
     * 
     * @type {Array<EventEntity>}
     * @memberof DivisionCreateDto
     */
    events?: Array<EventEntity>;
    /**
     * 
     * @type {Array<AssetEntity>}
     * @memberof DivisionCreateDto
     */
    assets?: Array<AssetEntity>;
    /**
     * 
     * @type {Array<ArticleEntity>}
     * @memberof DivisionCreateDto
     */
    articles?: Array<ArticleEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoEntity>}
     * @memberof DivisionCreateDto
     */
    onDemandVideos?: Array<OnDemandVideoEntity>;
    /**
     * 
     * @type {Array<CollectionEntity>}
     * @memberof DivisionCreateDto
     */
    collections?: Array<CollectionEntity>;
    /**
     * 
     * @type {Array<DivisionUserEntity>}
     * @memberof DivisionCreateDto
     */
    users?: Array<DivisionUserEntity>;
    /**
     * 
     * @type {Array<DomainEntity>}
     * @memberof DivisionCreateDto
     */
    customDomains?: Array<DomainEntity>;
    /**
     * 
     * @type {UserEntity}
     * @memberof DivisionCreateDto
     */
    contact?: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    contactButtonTitle?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionCreateDto
     */
    contactPageText?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    contactPageImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    hasContact?: boolean;
    /**
     * 
     * @type {Array<BrandkitEntity>}
     * @memberof DivisionCreateDto
     */
    brandkits?: Array<BrandkitEntity>;
    /**
     * 
     * @type {BrandkitEntity}
     * @memberof DivisionCreateDto
     */
    defaultBrandkit?: BrandkitEntity;
    /**
     * 
     * @type {Array<PasswordlessTokenEntity>}
     * @memberof DivisionCreateDto
     */
    passwordlessTokens?: Array<PasswordlessTokenEntity>;
    /**
     * 
     * @type {Array<ArticleGroupDivisionEntity>}
     * @memberof DivisionCreateDto
     */
    articleGroupDivisions?: Array<ArticleGroupDivisionEntity>;
    /**
     * 
     * @type {Array<ArticleAnalyticsEntity>}
     * @memberof DivisionCreateDto
     */
    articleAnalytics?: Array<ArticleAnalyticsEntity>;
    /**
     * 
     * @type {Array<OnDemandPlaylistDivisionEntity>}
     * @memberof DivisionCreateDto
     */
    onDemandPlaylistDivisions?: Array<OnDemandPlaylistDivisionEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoAnalyticsEntity>}
     * @memberof DivisionCreateDto
     */
    onDemandVideoAnalytics?: Array<OnDemandVideoAnalyticsEntity>;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof DivisionCreateDto
     */
    baseLanguage?: LanguageEntity;
    /**
     * 
     * @type {Array<DivisionTranslationEntity>}
     * @memberof DivisionCreateDto
     */
    translations?: Array<DivisionTranslationEntity>;
    /**
     * 
     * @type {Array<DivisionSubscriptionEntity>}
     * @memberof DivisionCreateDto
     */
    subscriptions?: Array<DivisionSubscriptionEntity>;
    /**
     * 
     * @type {Array<QRCodeEntity>}
     * @memberof DivisionCreateDto
     */
    qrCodes?: Array<QRCodeEntity>;
    /**
     * 
     * @type {EmailServiceTypeEnum}
     * @memberof DivisionCreateDto
     */
    emailService?: EmailServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    emailServiceIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    colorBackground?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    colorText?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    colorPrimaryDarkMode?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    colorTextDarkMode?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    feedbackColorPositive?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    feedbackColorNegative?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    colorSurface?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionCreateDto
     */
    colorSurfaceOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    colorBorder?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionCreateDto
     */
    colorBorderOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    colorHeading?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    colorButtonPrimary?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionCreateDto
     */
    colorButtonPrimaryOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    colorButtonText?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionCreateDto
     */
    colorButtonTextOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    colorAccent?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    colorWarning?: string;
    /**
     * 
     * @type {CornerRadiusEnum}
     * @memberof DivisionCreateDto
     */
    cornerRadius?: CornerRadiusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    balloonArrowEnabled?: boolean;
    /**
     * 
     * @type {PreferredColorThemeEnum}
     * @memberof DivisionCreateDto
     */
    preferredColorTheme?: PreferredColorThemeEnum;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof DivisionCreateDto
     */
    fontPrimary?: FontDefinitionDto;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof DivisionCreateDto
     */
    fontSecondary?: FontDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionCreateDto
     */
    privacyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionCreateDto
     */
    tosDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionCreateDto
     */
    cookiePolicyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionCreateDto
     */
    customPolicyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {PrivacyModeEnum}
     * @memberof DivisionCreateDto
     */
    privacyMode?: PrivacyModeEnum;
    /**
     * 
     * @type {ConsentBannerSettingsDto}
     * @memberof DivisionCreateDto
     */
    pagesConsentBanner?: ConsentBannerSettingsDto | null;
    /**
     * 
     * @type {TrackingIdsDto}
     * @memberof DivisionCreateDto
     */
    tracking?: TrackingIdsDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    sessionJournal?: boolean;
    /**
     * 
     * @type {DivisionBehaviour}
     * @memberof DivisionCreateDto
     */
    behaviour?: DivisionBehaviour;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    gtmTagId?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    headerScripts?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    footerScripts?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    legalName?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    legalAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionCreateDto
     */
    legalEmail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionCreateDto
     */
    shareButtonEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionCreateDto
     */
    selectableLanguages?: Array<string>;
}
/**
 * 
 * @export
 * @interface DivisionDepartmentEntity
 */
export interface DivisionDepartmentEntity {
    /**
     * 
     * @type {string}
     * @memberof DivisionDepartmentEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionDepartmentEntity
     */
    name: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof DivisionDepartmentEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionDepartmentEntity
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionDepartmentEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface DivisionDuplicateBulkDto
 */
export interface DivisionDuplicateBulkDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionDuplicateBulkDto
     */
    ids: Array<string>;
}
/**
 * 
 * @export
 * @interface DivisionDuplicateDto
 */
export interface DivisionDuplicateDto {
    /**
     * 
     * @type {string}
     * @memberof DivisionDuplicateDto
     */
    toDivisionId: string;
}
/**
 * 
 * @export
 * @interface DivisionEntity
 */
export interface DivisionEntity {
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    updated?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    published?: boolean;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof DivisionEntity
     */
    coordinates?: GeoPointDto;
    /**
     * 
     * @type {DivisionTypeEnum}
     * @memberof DivisionEntity
     */
    type: DivisionTypeEnum;
    /**
     * 
     * @type {DivisionPlatformTypeEnum}
     * @memberof DivisionEntity
     */
    platformType?: DivisionPlatformTypeEnum;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof DivisionEntity
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    code?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionEntity
     */
    domains?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionEntity
     */
    excludedDomains?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    forceAuthentication?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    enableOnboarding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    enableMfa?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    requiresValidQR?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    projectWideLeaderboard?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    experiencesTabTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    experiencesWelcomeText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    articlesEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    articlesTabTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    onDemandEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    onDemandTabTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    eventsEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    eventsTabTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    disableEventCreation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    webinarsEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    workspaceEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    pagesEnabled?: boolean;
    /**
     * 
     * @type {PagesEntryBehaviorEnum}
     * @memberof DivisionEntity
     */
    pagesEntryBehavior?: PagesEntryBehaviorEnum;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    pagesAccent?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    disableStoryOverview?: boolean;
    /**
     * When enabled, opening a story whose active session was built from an older release discards that session so a fresh one is started at the latest published release version.
     * @type {boolean}
     * @memberof DivisionEntity
     */
    showLatestStoryVersion?: boolean;
    /**
     * Always hide map, even if this division has multiple location-based games.
     * @type {boolean}
     * @memberof DivisionEntity
     */
    alwaysHideMap?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    mapBased?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    mapBasedDisableGps?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    mapBasedTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    mapBasedShowLegend?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    customMapUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    favicon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    pwaIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    backgroundImage?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionEntity
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {Array<GameEntity>}
     * @memberof DivisionEntity
     */
    games?: Array<GameEntity>;
    /**
     * 
     * @type {Array<EventEntity>}
     * @memberof DivisionEntity
     */
    events?: Array<EventEntity>;
    /**
     * 
     * @type {Array<AssetEntity>}
     * @memberof DivisionEntity
     */
    assets?: Array<AssetEntity>;
    /**
     * 
     * @type {Array<ArticleEntity>}
     * @memberof DivisionEntity
     */
    articles?: Array<ArticleEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoEntity>}
     * @memberof DivisionEntity
     */
    onDemandVideos?: Array<OnDemandVideoEntity>;
    /**
     * 
     * @type {Array<CollectionEntity>}
     * @memberof DivisionEntity
     */
    collections?: Array<CollectionEntity>;
    /**
     * 
     * @type {Array<DivisionUserEntity>}
     * @memberof DivisionEntity
     */
    users?: Array<DivisionUserEntity>;
    /**
     * 
     * @type {Array<DomainEntity>}
     * @memberof DivisionEntity
     */
    customDomains?: Array<DomainEntity>;
    /**
     * 
     * @type {UserEntity}
     * @memberof DivisionEntity
     */
    contact?: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    contactButtonTitle?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionEntity
     */
    contactPageText?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    contactPageImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    hasContact?: boolean;
    /**
     * 
     * @type {Array<BrandkitEntity>}
     * @memberof DivisionEntity
     */
    brandkits?: Array<BrandkitEntity>;
    /**
     * 
     * @type {BrandkitEntity}
     * @memberof DivisionEntity
     */
    defaultBrandkit?: BrandkitEntity;
    /**
     * 
     * @type {Array<PasswordlessTokenEntity>}
     * @memberof DivisionEntity
     */
    passwordlessTokens?: Array<PasswordlessTokenEntity>;
    /**
     * 
     * @type {Array<ArticleGroupDivisionEntity>}
     * @memberof DivisionEntity
     */
    articleGroupDivisions?: Array<ArticleGroupDivisionEntity>;
    /**
     * 
     * @type {Array<ArticleAnalyticsEntity>}
     * @memberof DivisionEntity
     */
    articleAnalytics?: Array<ArticleAnalyticsEntity>;
    /**
     * 
     * @type {Array<OnDemandPlaylistDivisionEntity>}
     * @memberof DivisionEntity
     */
    onDemandPlaylistDivisions?: Array<OnDemandPlaylistDivisionEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoAnalyticsEntity>}
     * @memberof DivisionEntity
     */
    onDemandVideoAnalytics?: Array<OnDemandVideoAnalyticsEntity>;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof DivisionEntity
     */
    baseLanguage?: LanguageEntity;
    /**
     * 
     * @type {Array<DivisionTranslationEntity>}
     * @memberof DivisionEntity
     */
    translations?: Array<DivisionTranslationEntity>;
    /**
     * 
     * @type {Array<DivisionSubscriptionEntity>}
     * @memberof DivisionEntity
     */
    subscriptions?: Array<DivisionSubscriptionEntity>;
    /**
     * 
     * @type {Array<QRCodeEntity>}
     * @memberof DivisionEntity
     */
    qrCodes?: Array<QRCodeEntity>;
    /**
     * 
     * @type {EmailServiceTypeEnum}
     * @memberof DivisionEntity
     */
    emailService?: EmailServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    emailServiceIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorBackground?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorText?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorPrimaryDarkMode?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorTextDarkMode?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    feedbackColorPositive?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    feedbackColorNegative?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorSurface?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionEntity
     */
    colorSurfaceOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorBorder?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionEntity
     */
    colorBorderOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorHeading?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorButtonPrimary?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionEntity
     */
    colorButtonPrimaryOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorButtonText?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionEntity
     */
    colorButtonTextOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorAccent?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorWarning?: string;
    /**
     * 
     * @type {CornerRadiusEnum}
     * @memberof DivisionEntity
     */
    cornerRadius?: CornerRadiusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    balloonArrowEnabled?: boolean;
    /**
     * 
     * @type {PreferredColorThemeEnum}
     * @memberof DivisionEntity
     */
    preferredColorTheme?: PreferredColorThemeEnum;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof DivisionEntity
     */
    fontPrimary?: FontDefinitionDto;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof DivisionEntity
     */
    fontSecondary?: FontDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionEntity
     */
    privacyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionEntity
     */
    tosDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionEntity
     */
    cookiePolicyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionEntity
     */
    customPolicyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {PrivacyModeEnum}
     * @memberof DivisionEntity
     */
    privacyMode?: PrivacyModeEnum;
    /**
     * 
     * @type {ConsentBannerSettingsDto}
     * @memberof DivisionEntity
     */
    pagesConsentBanner?: ConsentBannerSettingsDto | null;
    /**
     * 
     * @type {TrackingIdsDto}
     * @memberof DivisionEntity
     */
    tracking?: TrackingIdsDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    sessionJournal?: boolean;
    /**
     * 
     * @type {DivisionBehaviour}
     * @memberof DivisionEntity
     */
    behaviour?: DivisionBehaviour;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    gtmTagId?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    headerScripts?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    footerScripts?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    legalName?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    legalAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    legalEmail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    shareButtonEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionEntity
     */
    selectableLanguages?: Array<string>;
}
/**
 * 
 * @export
 * @interface DivisionPagesTakenDto
 */
export interface DivisionPagesTakenDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionPagesTakenDto
     */
    pageIds: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DivisionPlatformTypeEnum {
    Default = 'default',
    Web = 'web',
    Mobile = 'mobile'
}

/**
 * 
 * @export
 * @interface DivisionStoryCategoriesDto
 */
export interface DivisionStoryCategoriesDto {
    /**
     * 
     * @type {boolean}
     * @memberof DivisionStoryCategoriesDto
     */
    hasCategories: boolean;
}
/**
 * 
 * @export
 * @interface DivisionSubscriptionEntity
 */
export interface DivisionSubscriptionEntity {
    /**
     * 
     * @type {string}
     * @memberof DivisionSubscriptionEntity
     */
    id: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof DivisionSubscriptionEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {number}
     * @memberof DivisionSubscriptionEntity
     */
    pricePerYear: number;
    /**
     * 
     * @type {number}
     * @memberof DivisionSubscriptionEntity
     */
    maxPublishedGames: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionSubscriptionEntity
     */
    fromDate: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionSubscriptionEntity
     */
    toDate?: string;
}
/**
 * 
 * @export
 * @interface DivisionTranslationEntity
 */
export interface DivisionTranslationEntity {
    /**
     * 
     * @type {DivisionEntity}
     * @memberof DivisionTranslationEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof DivisionTranslationEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionTranslationEntity
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionTranslationEntity
     */
    privacyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionTranslationEntity
     */
    tosDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionTranslationEntity
     */
    cookiePolicyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionTranslationEntity
     */
    customPolicyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    contactButtonTitle?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionTranslationEntity
     */
    contactPageText?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    contactPageImage?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    experiencesTabTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    experiencesWelcomeText?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    articlesTabTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    eventsTabTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    onDemandTabTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    mapBasedTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionTranslationEntity
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DivisionTypeEnum {
    Division = 'division',
    City = 'city'
}

/**
 * 
 * @export
 * @interface DivisionUpdateDto
 */
export interface DivisionUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    updated?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    published?: boolean;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof DivisionUpdateDto
     */
    coordinates?: GeoPointDto;
    /**
     * 
     * @type {DivisionTypeEnum}
     * @memberof DivisionUpdateDto
     */
    type?: DivisionTypeEnum;
    /**
     * 
     * @type {DivisionPlatformTypeEnum}
     * @memberof DivisionUpdateDto
     */
    platformType?: DivisionPlatformTypeEnum;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof DivisionUpdateDto
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    code?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionUpdateDto
     */
    domains?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionUpdateDto
     */
    excludedDomains?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    forceAuthentication?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    enableOnboarding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    enableMfa?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    requiresValidQR?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    projectWideLeaderboard?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    experiencesTabTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    experiencesWelcomeText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    articlesEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    articlesTabTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    onDemandEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    onDemandTabTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    eventsEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    eventsTabTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    disableEventCreation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    webinarsEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    workspaceEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    pagesEnabled?: boolean;
    /**
     * 
     * @type {PagesEntryBehaviorEnum}
     * @memberof DivisionUpdateDto
     */
    pagesEntryBehavior?: PagesEntryBehaviorEnum;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    pagesAccent?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    disableStoryOverview?: boolean;
    /**
     * When enabled, opening a story whose active session was built from an older release discards that session so a fresh one is started at the latest published release version.
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    showLatestStoryVersion?: boolean;
    /**
     * Always hide map, even if this division has multiple location-based games.
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    alwaysHideMap?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    mapBased?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    mapBasedDisableGps?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    mapBasedTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    mapBasedShowLegend?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    customMapUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    favicon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    pwaIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    backgroundImage?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionUpdateDto
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {Array<GameEntity>}
     * @memberof DivisionUpdateDto
     */
    games?: Array<GameEntity>;
    /**
     * 
     * @type {Array<EventEntity>}
     * @memberof DivisionUpdateDto
     */
    events?: Array<EventEntity>;
    /**
     * 
     * @type {Array<AssetEntity>}
     * @memberof DivisionUpdateDto
     */
    assets?: Array<AssetEntity>;
    /**
     * 
     * @type {Array<ArticleEntity>}
     * @memberof DivisionUpdateDto
     */
    articles?: Array<ArticleEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoEntity>}
     * @memberof DivisionUpdateDto
     */
    onDemandVideos?: Array<OnDemandVideoEntity>;
    /**
     * 
     * @type {Array<CollectionEntity>}
     * @memberof DivisionUpdateDto
     */
    collections?: Array<CollectionEntity>;
    /**
     * 
     * @type {Array<DivisionUserEntity>}
     * @memberof DivisionUpdateDto
     */
    users?: Array<DivisionUserEntity>;
    /**
     * 
     * @type {Array<DomainEntity>}
     * @memberof DivisionUpdateDto
     */
    customDomains?: Array<DomainEntity>;
    /**
     * 
     * @type {UserEntity}
     * @memberof DivisionUpdateDto
     */
    contact?: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    contactButtonTitle?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionUpdateDto
     */
    contactPageText?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    contactPageImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    hasContact?: boolean;
    /**
     * 
     * @type {Array<BrandkitEntity>}
     * @memberof DivisionUpdateDto
     */
    brandkits?: Array<BrandkitEntity>;
    /**
     * 
     * @type {BrandkitEntity}
     * @memberof DivisionUpdateDto
     */
    defaultBrandkit?: BrandkitEntity;
    /**
     * 
     * @type {Array<PasswordlessTokenEntity>}
     * @memberof DivisionUpdateDto
     */
    passwordlessTokens?: Array<PasswordlessTokenEntity>;
    /**
     * 
     * @type {Array<ArticleGroupDivisionEntity>}
     * @memberof DivisionUpdateDto
     */
    articleGroupDivisions?: Array<ArticleGroupDivisionEntity>;
    /**
     * 
     * @type {Array<ArticleAnalyticsEntity>}
     * @memberof DivisionUpdateDto
     */
    articleAnalytics?: Array<ArticleAnalyticsEntity>;
    /**
     * 
     * @type {Array<OnDemandPlaylistDivisionEntity>}
     * @memberof DivisionUpdateDto
     */
    onDemandPlaylistDivisions?: Array<OnDemandPlaylistDivisionEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoAnalyticsEntity>}
     * @memberof DivisionUpdateDto
     */
    onDemandVideoAnalytics?: Array<OnDemandVideoAnalyticsEntity>;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof DivisionUpdateDto
     */
    baseLanguage?: LanguageEntity;
    /**
     * 
     * @type {Array<DivisionTranslationEntity>}
     * @memberof DivisionUpdateDto
     */
    translations?: Array<DivisionTranslationEntity>;
    /**
     * 
     * @type {Array<DivisionSubscriptionEntity>}
     * @memberof DivisionUpdateDto
     */
    subscriptions?: Array<DivisionSubscriptionEntity>;
    /**
     * 
     * @type {Array<QRCodeEntity>}
     * @memberof DivisionUpdateDto
     */
    qrCodes?: Array<QRCodeEntity>;
    /**
     * 
     * @type {EmailServiceTypeEnum}
     * @memberof DivisionUpdateDto
     */
    emailService?: EmailServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    emailServiceIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    colorBackground?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    colorText?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    colorPrimaryDarkMode?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    colorTextDarkMode?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    feedbackColorPositive?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    feedbackColorNegative?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    colorSurface?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionUpdateDto
     */
    colorSurfaceOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    colorBorder?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionUpdateDto
     */
    colorBorderOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    colorHeading?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    colorButtonPrimary?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionUpdateDto
     */
    colorButtonPrimaryOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    colorButtonText?: string;
    /**
     * 
     * @type {number}
     * @memberof DivisionUpdateDto
     */
    colorButtonTextOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    colorAccent?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    colorWarning?: string;
    /**
     * 
     * @type {CornerRadiusEnum}
     * @memberof DivisionUpdateDto
     */
    cornerRadius?: CornerRadiusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    balloonArrowEnabled?: boolean;
    /**
     * 
     * @type {PreferredColorThemeEnum}
     * @memberof DivisionUpdateDto
     */
    preferredColorTheme?: PreferredColorThemeEnum;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof DivisionUpdateDto
     */
    fontPrimary?: FontDefinitionDto;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof DivisionUpdateDto
     */
    fontSecondary?: FontDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionUpdateDto
     */
    privacyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionUpdateDto
     */
    tosDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionUpdateDto
     */
    cookiePolicyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionUpdateDto
     */
    customPolicyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {PrivacyModeEnum}
     * @memberof DivisionUpdateDto
     */
    privacyMode?: PrivacyModeEnum;
    /**
     * 
     * @type {ConsentBannerSettingsDto}
     * @memberof DivisionUpdateDto
     */
    pagesConsentBanner?: ConsentBannerSettingsDto | null;
    /**
     * 
     * @type {TrackingIdsDto}
     * @memberof DivisionUpdateDto
     */
    tracking?: TrackingIdsDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    sessionJournal?: boolean;
    /**
     * 
     * @type {DivisionBehaviour}
     * @memberof DivisionUpdateDto
     */
    behaviour?: DivisionBehaviour;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    gtmTagId?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    headerScripts?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    footerScripts?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    legalName?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    legalAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUpdateDto
     */
    legalEmail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionUpdateDto
     */
    shareButtonEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionUpdateDto
     */
    selectableLanguages?: Array<string>;
}
/**
 * 
 * @export
 * @interface DivisionUserEntity
 */
export interface DivisionUserEntity {
    /**
     * 
     * @type {DivisionEntity}
     * @memberof DivisionUserEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof DivisionUserEntity
     */
    user: UserEntity;
    /**
     * 
     * @type {DivisionDepartmentEntity}
     * @memberof DivisionUserEntity
     */
    department?: DivisionDepartmentEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionUserEntity
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUserEntity
     */
    lastLogin: string;
}
/**
 * 
 * @export
 * @interface DivisionUsersCountDto
 */
export interface DivisionUsersCountDto {
    /**
     * 
     * @type {number}
     * @memberof DivisionUsersCountDto
     */
    totalUsers: number;
}
/**
 * 
 * @export
 * @interface DocumentDefinitionDto
 */
export interface DocumentDefinitionDto {
    /**
     * 
     * @type {DocumentTypeEnum}
     * @memberof DocumentDefinitionDto
     */
    type: DocumentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentDefinitionDto
     */
    upload?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDefinitionDto
     */
    url?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DocumentDefinitionDto
     */
    markdown?: MarkdownTextDto;
    /**
     * Custom title to display for this document
     * @type {string}
     * @memberof DocumentDefinitionDto
     */
    customTitle?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DocumentTypeEnum {
    None = 'none',
    Link = 'link',
    Upload = 'upload',
    Markdown = 'markdown',
    Pregenerated = 'pregenerated'
}

/**
 * 
 * @export
 * @interface DomainEntity
 */
export interface DomainEntity {
    /**
     * 
     * @type {string}
     * @memberof DomainEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DomainEntity
     */
    domain: string;
    /**
     * 
     * @type {DomainTypeEnum}
     * @memberof DomainEntity
     */
    type: DomainTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DomainEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof DomainEntity
     */
    updated?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof DomainEntity
     */
    division: DivisionEntity;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DomainTypeEnum {
    Subdomain = 'subdomain',
    Custom = 'custom'
}

/**
 * 
 * @export
 * @interface DownloadDto
 */
export interface DownloadDto {
    /**
     * 
     * @type {string}
     * @memberof DownloadDto
     */
    gameId: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadDto
     */
    appVersion: string;
    /**
     * 
     * @type {number}
     * @memberof DownloadDto
     */
    releaseVersion?: number;
}
/**
 * 
 * @export
 * @interface DownloadTranslationsResultDto
 */
export interface DownloadTranslationsResultDto {
    /**
     * 
     * @type {number}
     * @memberof DownloadTranslationsResultDto
     */
    total: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DownloadTranslationsResultDto
     */
    unfound: Array<string>;
}
/**
 * 
 * @export
 * @interface DownloadUrlDto
 */
export interface DownloadUrlDto {
    /**
     * 
     * @type {string}
     * @memberof DownloadUrlDto
     */
    downloadUrl: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadUrlDto
     */
    bundlePath?: string;
}
/**
 * 
 * @export
 * @interface DuplicateGameDto
 */
export interface DuplicateGameDto {
    /**
     * 
     * @type {string}
     * @memberof DuplicateGameDto
     */
    divisionId: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EmailServiceTypeEnum {
    Mailchimp = 'mailchimp',
    Brevo = 'brevo'
}

/**
 * 
 * @export
 * @interface EstimatedLocationDto
 */
export interface EstimatedLocationDto {
    /**
     * 
     * @type {number}
     * @memberof EstimatedLocationDto
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof EstimatedLocationDto
     */
    lon: number;
}
/**
 * 
 * @export
 * @interface EventConnectionDto
 */
export interface EventConnectionDto {
    /**
     * 
     * @type {EventConnectionFromDto}
     * @memberof EventConnectionDto
     */
    from: EventConnectionFromDto;
    /**
     * 
     * @type {EventConnectionToDto}
     * @memberof EventConnectionDto
     */
    to: EventConnectionToDto;
    /**
     * 
     * @type {boolean}
     * @memberof EventConnectionDto
     */
    completed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventConnectionDto
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface EventConnectionFromDto
 */
export interface EventConnectionFromDto {
    /**
     * 
     * @type {string}
     * @memberof EventConnectionFromDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventConnectionFromDto
     */
    prop: string;
}
/**
 * 
 * @export
 * @interface EventConnectionToDto
 */
export interface EventConnectionToDto {
    /**
     * 
     * @type {string}
     * @memberof EventConnectionToDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventConnectionToDto
     */
    prop: string;
    /**
     * 
     * @type {string}
     * @memberof EventConnectionToDto
     */
    transform?: string;
}
/**
 * 
 * @export
 * @interface EventCreateDto
 */
export interface EventCreateDto {
    /**
     * 
     * @type {string}
     * @memberof EventCreateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EventCreateDto
     */
    demioEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof EventCreateDto
     */
    webinarGeekBroadcastId?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof EventCreateDto
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof EventCreateDto
     */
    emailNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof EventCreateDto
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof EventCreateDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof EventCreateDto
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof EventCreateDto
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EventCreateDto
     */
    hideUntil?: string;
    /**
     * This URL field will replace the button \'I want to join!\' when the field has content. The button will redirect the user to the URL.
     * @type {string}
     * @memberof EventCreateDto
     */
    link?: string;
    /**
     * 
     * @type {ThemeEntity}
     * @memberof EventCreateDto
     */
    theme?: ThemeEntity;
    /**
     * 
     * @type {string}
     * @memberof EventCreateDto
     */
    image?: string;
    /**
     * If zero, this will mean unlimited participants
     * @type {number}
     * @memberof EventCreateDto
     */
    maxParticipants?: number;
    /**
     * Whether hiding participants list or not, default is false
     * @type {boolean}
     * @memberof EventCreateDto
     */
    hideParticipants?: boolean;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof EventCreateDto
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof EventCreateDto
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof EventCreateDto
     */
    user?: UserEntity;
    /**
     * The base language required in order to translate this event.
     * @type {LanguageEntity}
     * @memberof EventCreateDto
     */
    baseLanguage?: LanguageEntity;
    /**
     * 
     * @type {EventLanguageTypeEnum}
     * @memberof EventCreateDto
     */
    eventLanguage?: EventLanguageTypeEnum;
    /**
     * 
     * @type {EventTypeEnum}
     * @memberof EventCreateDto
     */
    eventType?: EventTypeEnum;
    /**
     * Whether the event is published and visible to users
     * @type {boolean}
     * @memberof EventCreateDto
     */
    published?: boolean;
}
/**
 * 
 * @export
 * @interface EventDuplicateDto
 */
export interface EventDuplicateDto {
    /**
     * 
     * @type {string}
     * @memberof EventDuplicateDto
     */
    divisionId: string;
}
/**
 * 
 * @export
 * @interface EventEntity
 */
export interface EventEntity {
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    demioEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    webinarGeekBroadcastId?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof EventEntity
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    emailNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    hideUntil?: string;
    /**
     * This URL field will replace the button \'I want to join!\' when the field has content. The button will redirect the user to the URL.
     * @type {string}
     * @memberof EventEntity
     */
    link?: string;
    /**
     * 
     * @type {ThemeEntity}
     * @memberof EventEntity
     */
    theme?: ThemeEntity;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    image?: string;
    /**
     * If zero, this will mean unlimited participants
     * @type {number}
     * @memberof EventEntity
     */
    maxParticipants?: number;
    /**
     * Whether hiding participants list or not, default is false
     * @type {boolean}
     * @memberof EventEntity
     */
    hideParticipants?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    updated?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof EventEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof EventEntity
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    processedDemioOn?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    processedWebinarGeekOn?: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof EventEntity
     */
    user?: UserEntity;
    /**
     * 
     * @type {Array<EventParticipantEntity>}
     * @memberof EventEntity
     */
    participants?: Array<EventParticipantEntity>;
    /**
     * 
     * @type {EventEntity}
     * @memberof EventEntity
     */
    copyFrom?: EventEntity;
    /**
     * 
     * @type {Array<EventVariantEntity>}
     * @memberof EventEntity
     */
    variants?: Array<EventVariantEntity>;
    /**
     * 
     * @type {Array<EventTranslationEntity>}
     * @memberof EventEntity
     */
    translations?: Array<EventTranslationEntity>;
    /**
     * The base language required in order to translate this event.
     * @type {LanguageEntity}
     * @memberof EventEntity
     */
    baseLanguage?: LanguageEntity;
    /**
     * 
     * @type {EventLanguageTypeEnum}
     * @memberof EventEntity
     */
    eventLanguage?: EventLanguageTypeEnum;
    /**
     * 
     * @type {EventTypeEnum}
     * @memberof EventEntity
     */
    eventType?: EventTypeEnum;
    /**
     * Whether the event is published and visible to users
     * @type {boolean}
     * @memberof EventEntity
     */
    published?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EventLanguageTypeEnum {
    En = 'en',
    Nl = 'nl'
}

/**
 * 
 * @export
 * @interface EventParticipantEntity
 */
export interface EventParticipantEntity {
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    id: string;
    /**
     * 
     * @type {EventEntity}
     * @memberof EventParticipantEntity
     */
    event: EventEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof EventParticipantEntity
     */
    user: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    confirmed?: string;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    created: string;
    /**
     * 
     * @type {boolean}
     * @memberof EventParticipantEntity
     */
    noShow?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    reminderSent?: string;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    demioJoinUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    webinarGeekJoinUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    webinarGeekSubscriptionId?: string;
    /**
     * 
     * @type {EventVariantEntity}
     * @memberof EventParticipantEntity
     */
    variant?: EventVariantEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof EventParticipantEntity
     */
    division?: DivisionEntity;
}
/**
 * 
 * @export
 * @interface EventParticipantsDto
 */
export interface EventParticipantsDto {
    /**
     * 
     * @type {boolean}
     * @memberof EventParticipantsDto
     */
    noShow?: boolean;
}
/**
 * 
 * @export
 * @interface EventTranslationEntity
 */
export interface EventTranslationEntity {
    /**
     * 
     * @type {EventEntity}
     * @memberof EventTranslationEntity
     */
    event: EventEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof EventTranslationEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {string}
     * @memberof EventTranslationEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EventTranslationEntity
     */
    image?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof EventTranslationEntity
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {boolean}
     * @memberof EventTranslationEntity
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventTranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof EventTranslationEntity
     */
    updated?: string;
}
/**
 * The type of the event
 * @export
 * @enum {string}
 */
export enum EventTypeEnum {
    Webinar = 'webinar',
    Event = 'event'
}

/**
 * 
 * @export
 * @interface EventUpdateDto
 */
export interface EventUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    demioEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    webinarGeekBroadcastId?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof EventUpdateDto
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    emailNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    hideUntil?: string;
    /**
     * This URL field will replace the button \'I want to join!\' when the field has content. The button will redirect the user to the URL.
     * @type {string}
     * @memberof EventUpdateDto
     */
    link?: string;
    /**
     * 
     * @type {ThemeEntity}
     * @memberof EventUpdateDto
     */
    theme?: ThemeEntity;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    image?: string;
    /**
     * If zero, this will mean unlimited participants
     * @type {number}
     * @memberof EventUpdateDto
     */
    maxParticipants?: number;
    /**
     * Whether hiding participants list or not, default is false
     * @type {boolean}
     * @memberof EventUpdateDto
     */
    hideParticipants?: boolean;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof EventUpdateDto
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof EventUpdateDto
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof EventUpdateDto
     */
    user?: UserEntity;
    /**
     * The base language required in order to translate this event.
     * @type {LanguageEntity}
     * @memberof EventUpdateDto
     */
    baseLanguage?: LanguageEntity;
    /**
     * 
     * @type {EventLanguageTypeEnum}
     * @memberof EventUpdateDto
     */
    eventLanguage?: EventLanguageTypeEnum;
    /**
     * 
     * @type {EventTypeEnum}
     * @memberof EventUpdateDto
     */
    eventType?: EventTypeEnum;
    /**
     * Whether the event is published and visible to users
     * @type {boolean}
     * @memberof EventUpdateDto
     */
    published?: boolean;
}
/**
 * 
 * @export
 * @interface EventVariantEntity
 */
export interface EventVariantEntity {
    /**
     * 
     * @type {string}
     * @memberof EventVariantEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventVariantEntity
     */
    demioEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof EventVariantEntity
     */
    webinarGeekBroadcastId?: string;
    /**
     * 
     * @type {string}
     * @memberof EventVariantEntity
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof EventVariantEntity
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EventVariantEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof EventVariantEntity
     */
    updated?: string;
    /**
     * 
     * @type {EventEntity}
     * @memberof EventVariantEntity
     */
    event: EventEntity;
    /**
     * 
     * @type {EventLanguageTypeEnum}
     * @memberof EventVariantEntity
     */
    eventLanguage?: EventLanguageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EventVariantEntity
     */
    processedDemioOn?: string;
    /**
     * 
     * @type {string}
     * @memberof EventVariantEntity
     */
    processedWebinarGeekOn?: string;
}
/**
 * 
 * @export
 * @interface FacebookTokenDto
 */
export interface FacebookTokenDto {
    /**
     * 
     * @type {string}
     * @memberof FacebookTokenDto
     */
    accessToken: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FacebookTokenDto
     */
    permissions: Array<string>;
}
/**
 * 
 * @export
 * @interface FeatureSetDto
 */
export interface FeatureSetDto {
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    events?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    articles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    auth?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    branding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    advancedLogic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    onDemandVideos?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    aiEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    kioskMode?: boolean;
}
/**
 * 
 * @export
 * @interface FeedbackEntity
 */
export interface FeedbackEntity {
    /**
     * 
     * @type {string}
     * @memberof FeedbackEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackEntity
     */
    content: string;
    /**
     * 
     * @type {SceneEntity}
     * @memberof FeedbackEntity
     */
    scene?: SceneEntity;
    /**
     * 
     * @type {SessionEntity}
     * @memberof FeedbackEntity
     */
    session?: SessionEntity;
}
/**
 * 
 * @export
 * @interface FeedbackItemDto
 */
export interface FeedbackItemDto {
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    sceneId: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    platform?: FeedbackItemDtoPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    systemVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    appVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    buildNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    releaseVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    locale?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    gameId: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    gameName: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    divisionId: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    divisionName: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    whitelabelId: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    whitelabelName: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackItemDto
     */
    whitelabelType: string;
}

/**
    * @export
    * @enum {string}
    */
export enum FeedbackItemDtoPlatformEnum {
    Ios = 'ios',
    Android = 'android'
}

/**
 * 
 * @export
 * @interface FeedbackPostDto
 */
export interface FeedbackPostDto {
    /**
     * 
     * @type {string}
     * @memberof FeedbackPostDto
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackPostDto
     */
    sessionId?: string;
}
/**
 * 
 * @export
 * @interface FileDeleteDto
 */
export interface FileDeleteDto {
    /**
     * 
     * @type {string}
     * @memberof FileDeleteDto
     */
    uri: string;
}
/**
 * 
 * @export
 * @interface FileUploadDto
 */
export interface FileUploadDto {
    /**
     * 
     * @type {any}
     * @memberof FileUploadDto
     */
    file: any;
}
/**
 * 
 * @export
 * @interface FileUploadResultDto
 */
export interface FileUploadResultDto {
    /**
     * 
     * @type {string}
     * @memberof FileUploadResultDto
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof FileUploadResultDto
     */
    fileKey: string;
}
/**
 * 
 * @export
 * @interface FontDefinitionDto
 */
export interface FontDefinitionDto {
    /**
     * 
     * @type {FontTypeEnum}
     * @memberof FontDefinitionDto
     */
    type: FontTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FontDefinitionDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FontDefinitionDto
     */
    googleUrl?: string;
    /**
     * 
     * @type {any}
     * @memberof FontDefinitionDto
     */
    customFont?: any;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum FontTypeEnum {
    Default = 'default',
    Google = 'google',
    Custom = 'custom',
    Primary = 'primary'
}

/**
 * 
 * @export
 * @interface GameCreateDto
 */
export interface GameCreateDto {
    /**
     * 
     * @type {string}
     * @memberof GameCreateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GameCreateDto
     */
    defaultColorTheme?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof GameCreateDto
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof GameCreateDto
     */
    company?: CompanyEntity;
}
/**
 * 
 * @export
 * @interface GameData
 */
export interface GameData {
    /**
     * 
     * @type {string}
     * @memberof GameData
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GameData
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof GameData
     */
    baseScenario: object;
    /**
     * 
     * @type {object}
     * @memberof GameData
     */
    release: object;
}
/**
 * 
 * @export
 * @interface GameEntity
 */
export interface GameEntity {
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    gameType: GameEntityGameTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    defaultColorTheme?: string;
    /**
     * When a game is hidden, it does not show up on game overview, but as an unlockable item.
     * @type {boolean}
     * @memberof GameEntity
     */
    hidden?: boolean;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof GameEntity
     */
    coordinates?: GeoPointDto;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    distanceInMeters?: number;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    timeInMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GameEntity
     */
    hideLeaderboard?: boolean;
    /**
     * 
     * @type {ThemeEntity}
     * @memberof GameEntity
     */
    theme?: ThemeEntity;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    linkingForceRedirect?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    updated?: string;
    /**
     * 
     * @type {Array<ScenarioEntity>}
     * @memberof GameEntity
     */
    scenarios?: Array<ScenarioEntity>;
    /**
     * 
     * @type {ScenarioEntity}
     * @memberof GameEntity
     */
    baseScenario?: ScenarioEntity;
    /**
     * 
     * @type {Array<GameLanguageEntity>}
     * @memberof GameEntity
     */
    gameLanguages?: Array<GameLanguageEntity>;
    /**
     * 
     * @type {Array<GameVariableEntity>}
     * @memberof GameEntity
     */
    variables?: Array<GameVariableEntity>;
    /**
     * 
     * @type {GameReleaseEntity}
     * @memberof GameEntity
     */
    release?: GameReleaseEntity;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    releaseCount?: number;
    /**
     * 
     * @type {GameReleaseStatus}
     * @memberof GameEntity
     */
    releaseStatus?: GameReleaseStatus;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    lastEdit?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GameEntity
     */
    published?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    editingBlockSetId?: string | null;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof GameEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof GameEntity
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {Array<SessionEntity>}
     * @memberof GameEntity
     */
    sessions?: Array<SessionEntity>;
    /**
     * 
     * @type {Array<QRCodeEntity>}
     * @memberof GameEntity
     */
    qrCodes?: Array<QRCodeEntity>;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    reviewCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    reviewRating?: number;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    contentBlocksCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    shareCount?: number;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof GameEntity
     */
    defaultLanguage?: LanguageEntity;
    /**
     * Whether the base (default) language is offered as an active language in the story/web player. When false, the base language is excluded from the released list of languages.
     * @type {boolean}
     * @memberof GameEntity
     */
    defaultLanguageActive?: boolean;
    /**
     * If set to true, the generated QR code will cause the app start a game session after scanning it.
     * @type {boolean}
     * @memberof GameEntity
     */
    startSessionImmediately?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    hideUntil?: string;
    /**
     * If set to true, this experience will not automatically add UTM parameters to each outbound URL.
     * @type {boolean}
     * @memberof GameEntity
     */
    disableOutboundUtm?: boolean;
    /**
     * If set to false, content animations will not be enabled for this experience.
     * @type {boolean}
     * @memberof GameEntity
     */
    enableContentAnimations?: boolean;
    /**
     * If set to false, this story will not show the icon overlay on top of the experience
     * @type {boolean}
     * @memberof GameEntity
     */
    enableIconOverlay?: boolean;
    /**
     * Enable tap to skip for this game, this will disable sliding motions.
     * @type {boolean}
     * @memberof GameEntity
     */
    enableTapToSkip?: boolean;
    /**
     * Enable to maximize accessibility features for this story.
     * @type {boolean}
     * @memberof GameEntity
     */
    maximizeAccessibility?: boolean;
    /**
     * If enabled, kiosk mode is available on this story. Kiosk mode auto-scales the story pane and resets the session after a period of inactivity.
     * @type {boolean}
     * @memberof GameEntity
     */
    enableKioskMode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    storyIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    shareTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    shareDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    footerText?: string;
    /**
     * Main media can be either a file or a color
     * @type {MediaFileDto | MediaColorDto}
     * @memberof GameEntity
     */
    mainMedia?: MediaFileDto | MediaColorDto;
    /**
     * Custom thumbnail uploaded by the builder. When set, it overrides the auto-selected mainMedia in story overviews.
     * @type {MediaFileDto | MediaColorDto}
     * @memberof GameEntity
     */
    customMainMedia?: MediaFileDto | MediaColorDto;
    /**
     * The template that uses this story as a base to build on.
     * @type {TemplateEntity}
     * @memberof GameEntity
     */
    template?: TemplateEntity;
    /**
     * The template this story was created from.
     * @type {TemplateEntity}
     * @memberof GameEntity
     */
    sourceTemplate?: TemplateEntity;
    /**
     * The user who created this story.
     * @type {UserEntity}
     * @memberof GameEntity
     */
    createdBy?: UserEntity;
    /**
     * The user who last edited this story or its content; none when unknown.
     * @type {UserEntity}
     * @memberof GameEntity
     */
    lastEditedBy?: UserEntity | null;
    /**
     * The story this was duplicated from (for non-template copies).
     * @type {GameEntity}
     * @memberof GameEntity
     */
    sourceGame?: GameEntity;
}

/**
    * @export
    * @enum {string}
    */
export enum GameEntityGameTypeEnum {
    Story = 'story',
    Trivia = 'trivia',
    Minigame = 'minigame'
}

/**
 * 
 * @export
 * @interface GameLanguageEntity
 */
export interface GameLanguageEntity {
    /**
     * 
     * @type {GameEntity}
     * @memberof GameLanguageEntity
     */
    game: GameEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof GameLanguageEntity
     */
    language: LanguageEntity;
    /**
     * 
     * @type {boolean}
     * @memberof GameLanguageEntity
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GameLanguageEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof GameLanguageEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof GameLanguageEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GameLanguageEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GameLanguageEntity
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof GameLanguageEntity
     */
    regionalVariant?: string | null;
    /**
     * formal or informal; unset is auto
     * @type {string}
     * @memberof GameLanguageEntity
     */
    formality?: string | null;
}
/**
 * 
 * @export
 * @interface GamePayloadDto
 */
export interface GamePayloadDto {
    /**
     * 
     * @type {GameEntity}
     * @memberof GamePayloadDto
     */
    game: GameEntity;
    /**
     * 
     * @type {Array<GameLanguageEntity>}
     * @memberof GamePayloadDto
     */
    languages?: Array<GameLanguageEntity>;
    /**
     * 
     * @type {Array<BrandkitEntity>}
     * @memberof GamePayloadDto
     */
    brandkits?: Array<BrandkitEntity>;
    /**
     * 
     * @type {string}
     * @memberof GamePayloadDto
     */
    defaultBrandkitId?: string;
}
/**
 * 
 * @export
 * @interface GamePlayerDto
 */
export interface GamePlayerDto {
    /**
     * 
     * @type {string}
     * @memberof GamePlayerDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePlayerDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePlayerDto
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePlayerDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof GamePlayerDto
     */
    distanceInMeters?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GamePlayerDto
     */
    hideLeaderboard?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GamePlayerDto
     */
    updated?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GamePlayerDto
     */
    published?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GamePlayerDto
     */
    storyIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePlayerDto
     */
    shareTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePlayerDto
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePlayerDto
     */
    shareDescription?: string;
    /**
     * 
     * @type {GamePlayerReleaseDto}
     * @memberof GamePlayerDto
     */
    release?: GamePlayerReleaseDto;
}
/**
 * 
 * @export
 * @interface GamePlayerReleaseDto
 */
export interface GamePlayerReleaseDto {
    /**
     * 
     * @type {string}
     * @memberof GamePlayerReleaseDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof GamePlayerReleaseDto
     */
    releaseVersion?: number;
    /**
     * 
     * @type {Array<ReleaseLanguageDto>}
     * @memberof GamePlayerReleaseDto
     */
    languages?: Array<ReleaseLanguageDto>;
    /**
     * 
     * @type {boolean}
     * @memberof GamePlayerReleaseDto
     */
    containsGps?: boolean;
    /**
     * 
     * @type {GamePlayerReleaseGameDto}
     * @memberof GamePlayerReleaseDto
     */
    game: GamePlayerReleaseGameDto;
}
/**
 * 
 * @export
 * @interface GamePlayerReleaseGameDto
 */
export interface GamePlayerReleaseGameDto {
    /**
     * 
     * @type {string}
     * @memberof GamePlayerReleaseGameDto
     */
    id: string;
}
/**
 * 
 * @export
 * @interface GamePublicDto
 */
export interface GamePublicDto {
    /**
     * 
     * @type {string}
     * @memberof GamePublicDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePublicDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePublicDto
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePublicDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePublicDto
     */
    linkingForceRedirect?: string;
}
/**
 * 
 * @export
 * @interface GamePutDto
 */
export interface GamePutDto {
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    gameType?: GamePutDtoGameTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    defaultColorTheme?: string;
    /**
     * When a game is hidden, it does not show up on game overview, but as an unlockable item.
     * @type {boolean}
     * @memberof GamePutDto
     */
    hidden?: boolean;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof GamePutDto
     */
    coordinates?: GeoPointDto;
    /**
     * 
     * @type {number}
     * @memberof GamePutDto
     */
    distanceInMeters?: number;
    /**
     * 
     * @type {number}
     * @memberof GamePutDto
     */
    timeInMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GamePutDto
     */
    hideLeaderboard?: boolean;
    /**
     * 
     * @type {ThemeEntity}
     * @memberof GamePutDto
     */
    theme?: ThemeEntity;
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    linkingForceRedirect?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GamePutDto
     */
    published?: boolean;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof GamePutDto
     */
    defaultLanguage?: LanguageEntity;
    /**
     * Whether the base (default) language is offered as an active language in the story/web player. When false, the base language is excluded from the released list of languages.
     * @type {boolean}
     * @memberof GamePutDto
     */
    defaultLanguageActive?: boolean;
    /**
     * If set to true, the generated QR code will cause the app start a game session after scanning it.
     * @type {boolean}
     * @memberof GamePutDto
     */
    startSessionImmediately?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    hideUntil?: string;
    /**
     * If set to true, this experience will not automatically add UTM parameters to each outbound URL.
     * @type {boolean}
     * @memberof GamePutDto
     */
    disableOutboundUtm?: boolean;
    /**
     * If set to false, content animations will not be enabled for this experience.
     * @type {boolean}
     * @memberof GamePutDto
     */
    enableContentAnimations?: boolean;
    /**
     * If set to false, this story will not show the icon overlay on top of the experience
     * @type {boolean}
     * @memberof GamePutDto
     */
    enableIconOverlay?: boolean;
    /**
     * Enable tap to skip for this game, this will disable sliding motions.
     * @type {boolean}
     * @memberof GamePutDto
     */
    enableTapToSkip?: boolean;
    /**
     * Enable to maximize accessibility features for this story.
     * @type {boolean}
     * @memberof GamePutDto
     */
    maximizeAccessibility?: boolean;
    /**
     * If enabled, kiosk mode is available on this story. Kiosk mode auto-scales the story pane and resets the session after a period of inactivity.
     * @type {boolean}
     * @memberof GamePutDto
     */
    enableKioskMode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    storyIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    shareTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    shareDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof GamePutDto
     */
    footerText?: string;
    /**
     * Custom thumbnail uploaded by the builder. When set, it overrides the auto-selected mainMedia in story overviews.
     * @type {MediaFileDto | MediaColorDto}
     * @memberof GamePutDto
     */
    customMainMedia?: MediaFileDto | MediaColorDto;
}

/**
    * @export
    * @enum {string}
    */
export enum GamePutDtoGameTypeEnum {
    Story = 'story',
    Trivia = 'trivia',
    Minigame = 'minigame'
}

/**
 * 
 * @export
 * @interface GameReleaseEntity
 */
export interface GameReleaseEntity {
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof GameReleaseEntity
     */
    releaseVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    created?: string;
    /**
     * 
     * @type {GameEntity}
     * @memberof GameReleaseEntity
     */
    game: GameEntity;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    downloadUrl: string;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    bundlePath: string;
    /**
     * 
     * @type {ArchiveInfo}
     * @memberof GameReleaseEntity
     */
    archiveInfo?: ArchiveInfo;
    /**
     * 
     * @type {GameData}
     * @memberof GameReleaseEntity
     */
    gameData?: GameData;
    /**
     * 
     * @type {Array<MapInfo>}
     * @memberof GameReleaseEntity
     */
    maps?: Array<MapInfo>;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    releaseStatus?: GameReleaseEntityReleaseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    warningMessage?: string;
    /**
     * Which version of the mobile API the release was built against
     * @type {string}
     * @memberof GameReleaseEntity
     */
    appVersionBuilt?: string;
    /**
     * Up to which mobile API version the auto checks have passed for this release
     * @type {string}
     * @memberof GameReleaseEntity
     */
    appVersionAutoChecked?: string;
    /**
     * 
     * @type {number}
     * @memberof GameReleaseEntity
     */
    mapSize?: number;
    /**
     * 
     * @type {Array<ReleaseLanguageDto>}
     * @memberof GameReleaseEntity
     */
    languages?: Array<ReleaseLanguageDto>;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    appVersionVerified?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    containsAr: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    containsVr: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    containsGps: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    containsMagneto: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    containsCamera: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    supportsDynamicDownloads: boolean;
    /**
     * 
     * @type {UserEntity}
     * @memberof GameReleaseEntity
     */
    user?: UserEntity;
}

/**
    * @export
    * @enum {string}
    */
export enum GameReleaseEntityReleaseStatusEnum {
    Pending = 'pending',
    Published = 'published',
    Error = 'error'
}

/**
 * 
 * @export
 * @interface GameReleasePostDto
 */
export interface GameReleasePostDto {
    /**
     * 
     * @type {string}
     * @memberof GameReleasePostDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GameReleasePostDto
     */
    appVersion?: string;
}
/**
 * 
 * @export
 * @interface GameReleaseStatus
 */
export interface GameReleaseStatus {
    /**
     * 
     * @type {string}
     * @memberof GameReleaseStatus
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GameReleaseStatus
     */
    releaseVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseStatus
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseStatus
     */
    releaseStatus?: GameReleaseStatusReleaseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseStatus
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseStatus
     */
    warningMessage?: string;
    /**
     * 
     * @type {number}
     * @memberof GameReleaseStatus
     */
    progress?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum GameReleaseStatusReleaseStatusEnum {
    Pending = 'pending',
    Published = 'published',
    Error = 'error'
}

/**
 * 
 * @export
 * @interface GameSessionsCountDto
 */
export interface GameSessionsCountDto {
    /**
     * 
     * @type {number}
     * @memberof GameSessionsCountDto
     */
    totalSessions: number;
    /**
     * 
     * @type {number}
     * @memberof GameSessionsCountDto
     */
    completedSessions: number;
}
/**
 * 
 * @export
 * @interface GameVariableEntity
 */
export interface GameVariableEntity {
    /**
     * 
     * @type {GameEntity}
     * @memberof GameVariableEntity
     */
    game: GameEntity;
    /**
     * 
     * @type {string}
     * @memberof GameVariableEntity
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GameVariableEntity
     */
    weight?: number;
    /**
     * 
     * @type {GameVariableTypeEnum}
     * @memberof GameVariableEntity
     */
    type: GameVariableTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof GameVariableEntity
     */
    defaultValue?: object;
    /**
     * 
     * @type {string}
     * @memberof GameVariableEntity
     */
    created?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum GameVariableTypeEnum {
    String = 'string',
    Number = 'number',
    Boolean = 'boolean'
}

/**
 * 
 * @export
 * @interface GeoPointDto
 */
export interface GeoPointDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof GeoPointDto
     */
    coordinates: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof GeoPointDto
     */
    type: string;
}
/**
 * 
 * @export
 * @interface GoogleTokenDto
 */
export interface GoogleTokenDto {
    /**
     * 
     * @type {string}
     * @memberof GoogleTokenDto
     */
    idToken: string;
}
/**
 * 
 * @export
 * @interface GraphEntryDto
 */
export interface GraphEntryDto {
    /**
     * 
     * @type {string}
     * @memberof GraphEntryDto
     */
    x: string;
    /**
     * 
     * @type {number}
     * @memberof GraphEntryDto
     */
    y: number;
}
/**
 * 
 * @export
 * @interface GraphPlatformDto
 */
export interface GraphPlatformDto {
    /**
     * 
     * @type {string}
     * @memberof GraphPlatformDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GraphPlatformDto
     */
    label: string;
    /**
     * 
     * @type {Array<GraphEntryDto>}
     * @memberof GraphPlatformDto
     */
    data: Array<GraphEntryDto>;
}
/**
 * 
 * @export
 * @interface GraphRequestDto
 */
export interface GraphRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GraphRequestDto
     */
    timespan: GraphRequestDtoTimespanEnum;
    /**
     * 
     * @type {string}
     * @memberof GraphRequestDto
     */
    since: string;
    /**
     * 
     * @type {AnalyticsFilterDto}
     * @memberof GraphRequestDto
     */
    filters?: AnalyticsFilterDto;
}

/**
    * @export
    * @enum {string}
    */
export enum GraphRequestDtoTimespanEnum {
    Month = 'month',
    Year = 'year',
    Week = 'week'
}

/**
 * 
 * @export
 * @interface HighscoreDto
 */
export interface HighscoreDto {
    /**
     * 
     * @type {string}
     * @memberof HighscoreDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HighscoreDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof HighscoreDto
     */
    score: number;
    /**
     * 
     * @type {number}
     * @memberof HighscoreDto
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof HighscoreDto
     */
    finished: string;
}
/**
 * 
 * @export
 * @interface HotlinkDeployEventDto
 */
export interface HotlinkDeployEventDto {
    /**
     * 
     * @type {number}
     * @memberof HotlinkDeployEventDto
     */
    timestamp: number;
    /**
     * 
     * @type {object}
     * @memberof HotlinkDeployEventDto
     */
    payload: object;
}
/**
 * 
 * @export
 * @interface HotlinkTokenDto
 */
export interface HotlinkTokenDto {
    /**
     * Opaque token to pass as `token` to the hotlink preview.
     * @type {string}
     * @memberof HotlinkTokenDto
     */
    token: string;
    /**
     * Expiry as unix milliseconds.
     * @type {number}
     * @memberof HotlinkTokenDto
     */
    expiresAt: number;
}
/**
 * 
 * @export
 * @interface ImageTrainOptionsDto
 */
export interface ImageTrainOptionsDto {
    /**
     * 
     * @type {boolean}
     * @memberof ImageTrainOptionsDto
     */
    cylindrical?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ImageTrainOptionsDto
     */
    circumference?: number;
    /**
     * 
     * @type {number}
     * @memberof ImageTrainOptionsDto
     */
    inputWidth?: number;
}
/**
 * 
 * @export
 * @interface InviteAccessControlDto
 */
export interface InviteAccessControlDto {
    /**
     * 
     * @type {string}
     * @memberof InviteAccessControlDto
     */
    role: InviteAccessControlDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof InviteAccessControlDto
     */
    resourceId: string;
    /**
     * 
     * @type {string}
     * @memberof InviteAccessControlDto
     */
    resourceType: InviteAccessControlDtoResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InviteAccessControlDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteAccessControlDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InviteAccessControlDto
     */
    message?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum InviteAccessControlDtoRoleEnum {
    Admin = 'admin',
    Editor = 'editor',
    Viewer = 'viewer',
    Host = 'host'
}
/**
    * @export
    * @enum {string}
    */
export enum InviteAccessControlDtoResourceTypeEnum {
    Whitelabel = 'whitelabel',
    Company = 'company',
    Division = 'division',
    Game = 'game',
    QrCode = 'qr_code',
    GameRelease = 'game_release',
    GameVariable = 'game_variable',
    Domain = 'domain',
    Session = 'session',
    Review = 'review',
    Article = 'article',
    ArticleGroup = 'article_group',
    Tag = 'tag',
    Theme = 'theme',
    Asset = 'asset',
    Event = 'event',
    EventVariant = 'event_variant',
    Scenario = 'scenario',
    Scenarios = 'scenarios',
    DivisionSubscription = 'division_subscription',
    DivisionDepartment = 'division_department',
    SubscriptionPackage = 'subscription_package',
    Subscription = 'subscription',
    Scene = 'scene',
    TemplateCategory = 'template_category',
    Template = 'template',
    Notification = 'notification',
    OnDemandVideo = 'on_demand_video',
    OnDemandPlaylist = 'on_demand_playlist',
    Collection = 'collection',
    Brandkit = 'brandkit',
    Page = 'page',
    PageSet = 'pageSet'
}

/**
 * 
 * @export
 * @interface JobEntity
 */
export interface JobEntity {
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    status: JobEntityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof JobEntity
     */
    progress?: number;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    error?: string;
    /**
     * 
     * @type {object}
     * @memberof JobEntity
     */
    data?: object;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    assetId?: string;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    updated?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum JobEntityStatusEnum {
    Pending = 'pending',
    Error = 'error',
    Done = 'done',
    Suspended = 'suspended'
}

/**
 * 
 * @export
 * @interface JournalAppendDto
 */
export interface JournalAppendDto {
    /**
     * Session id
     * @type {string}
     * @memberof JournalAppendDto
     */
    id: string;
    /**
     * Session key
     * @type {string}
     * @memberof JournalAppendDto
     */
    key: string;
    /**
     * Sequence number of this chunk
     * @type {number}
     * @memberof JournalAppendDto
     */
    seq: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof JournalAppendDto
     */
    events: Array<object>;
}
/**
 * 
 * @export
 * @interface JournalEventsDto
 */
export interface JournalEventsDto {
    /**
     * 
     * @type {string}
     * @memberof JournalEventsDto
     */
    status: JournalEventsDtoStatusEnum;
    /**
     * 
     * @type {Array<object>}
     * @memberof JournalEventsDto
     */
    events: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof JournalEventsDto
     */
    chunkCount: number;
    /**
     * 
     * @type {number}
     * @memberof JournalEventsDto
     */
    totalBytes: number;
    /**
     * 
     * @type {string}
     * @memberof JournalEventsDto
     */
    firstEventAt?: string;
    /**
     * 
     * @type {string}
     * @memberof JournalEventsDto
     */
    lastEventAt?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum JournalEventsDtoStatusEnum {
    Active = 'active',
    Archived = 'archived'
}

/**
 * 
 * @export
 * @interface LanguageEntity
 */
export interface LanguageEntity {
    /**
     * 
     * @type {string}
     * @memberof LanguageEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageEntity
     */
    updated?: string;
    /**
     * 
     * @type {Array<TranslationEntity>}
     * @memberof LanguageEntity
     */
    translations?: Array<TranslationEntity>;
    /**
     * 
     * @type {Array<GameLanguageEntity>}
     * @memberof LanguageEntity
     */
    gameLanguages?: Array<GameLanguageEntity>;
    /**
     * 
     * @type {Array<GameEntity>}
     * @memberof LanguageEntity
     */
    games?: Array<GameEntity>;
    /**
     * 
     * @type {Array<ArticleTranslationEntity>}
     * @memberof LanguageEntity
     */
    articleTranslations?: Array<ArticleTranslationEntity>;
    /**
     * 
     * @type {Array<DivisionTranslationEntity>}
     * @memberof LanguageEntity
     */
    divisionTranslations?: Array<DivisionTranslationEntity>;
    /**
     * 
     * @type {Array<TagTranslationEntity>}
     * @memberof LanguageEntity
     */
    tagTranslations?: Array<TagTranslationEntity>;
    /**
     * 
     * @type {Array<ThemeTranslationEntity>}
     * @memberof LanguageEntity
     */
    themeTranslations?: Array<ThemeTranslationEntity>;
    /**
     * 
     * @type {Array<ArticleEntity>}
     * @memberof LanguageEntity
     */
    articles?: Array<ArticleEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoTranslationEntity>}
     * @memberof LanguageEntity
     */
    onDemandVideoTranslations?: Array<OnDemandVideoTranslationEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoEntity>}
     * @memberof LanguageEntity
     */
    onDemandVideos?: Array<OnDemandVideoEntity>;
    /**
     * 
     * @type {Array<OnDemandPlaylistTranslationEntity>}
     * @memberof LanguageEntity
     */
    onDemandPlaylistTranslations?: Array<OnDemandPlaylistTranslationEntity>;
    /**
     * 
     * @type {Array<OnDemandPlaylistEntity>}
     * @memberof LanguageEntity
     */
    onDemandPlaylists?: Array<OnDemandPlaylistEntity>;
    /**
     * 
     * @type {Array<TagEntity>}
     * @memberof LanguageEntity
     */
    tags?: Array<TagEntity>;
    /**
     * 
     * @type {Array<ThemeEntity>}
     * @memberof LanguageEntity
     */
    themes?: Array<ThemeEntity>;
    /**
     * 
     * @type {Array<DivisionEntity>}
     * @memberof LanguageEntity
     */
    divisions?: Array<DivisionEntity>;
    /**
     * 
     * @type {Array<EventTranslationEntity>}
     * @memberof LanguageEntity
     */
    eventTranslations?: Array<EventTranslationEntity>;
    /**
     * 
     * @type {Array<EventEntity>}
     * @memberof LanguageEntity
     */
    events?: Array<EventEntity>;
    /**
     * 
     * @type {Array<MarkdownPageContentEntity>}
     * @memberof LanguageEntity
     */
    markdownPageContent?: Array<MarkdownPageContentEntity>;
    /**
     * 
     * @type {boolean}
     * @memberof LanguageEntity
     */
    enabled?: boolean;
}
/**
 * 
 * @export
 * @interface LanguageTranslationsDto
 */
export interface LanguageTranslationsDto {
    /**
     * 
     * @type {string}
     * @memberof LanguageTranslationsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageTranslationsDto
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof LanguageTranslationsDto
     */
    translations?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof LanguageTranslationsDto
     */
    enabled: boolean;
}
/**
 * 
 * @export
 * @interface LayoutNodeDto
 */
export interface LayoutNodeDto {
    /**
     * 
     * @type {string}
     * @memberof LayoutNodeDto
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof LayoutNodeDto
     */
    props: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof LayoutNodeDto
     */
    displayName?: string;
    /**
     * 
     * @type {Array<LayoutNodeDto>}
     * @memberof LayoutNodeDto
     */
    children: Array<LayoutNodeDto>;
}
/**
 * 
 * @export
 * @interface MapInfo
 */
export interface MapInfo {
    /**
     * 
     * @type {string}
     * @memberof MapInfo
     */
    id: string;
    /**
     * 
     * @type {MapInfoBounds}
     * @memberof MapInfo
     */
    bounds: MapInfoBounds;
    /**
     * 
     * @type {string}
     * @memberof MapInfo
     */
    styleURL: string;
    /**
     * 
     * @type {number}
     * @memberof MapInfo
     */
    zoom: number;
}
/**
 * 
 * @export
 * @interface MapInfoBounds
 */
export interface MapInfoBounds {
    /**
     * 
     * @type {MapInfoLocation}
     * @memberof MapInfoBounds
     */
    sw: MapInfoLocation;
    /**
     * 
     * @type {MapInfoLocation}
     * @memberof MapInfoBounds
     */
    ne: MapInfoLocation;
}
/**
 * 
 * @export
 * @interface MapInfoLocation
 */
export interface MapInfoLocation {
    /**
     * 
     * @type {number}
     * @memberof MapInfoLocation
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof MapInfoLocation
     */
    lng: number;
}
/**
 * 
 * @export
 * @interface MarkdownPageContentEntity
 */
export interface MarkdownPageContentEntity {
    /**
     * 
     * @type {MarkdownPageEntity}
     * @memberof MarkdownPageContentEntity
     */
    markdownPage?: MarkdownPageEntity;
    /**
     * 
     * @type {WhitelabelEntity}
     * @memberof MarkdownPageContentEntity
     */
    whitelabel?: WhitelabelEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof MarkdownPageContentEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof MarkdownPageContentEntity
     */
    content: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof MarkdownPageContentEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof MarkdownPageContentEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface MarkdownPageContentPutDto
 */
export interface MarkdownPageContentPutDto {
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof MarkdownPageContentPutDto
     */
    content: MarkdownTextDto;
}
/**
 * 
 * @export
 * @interface MarkdownPageEntity
 */
export interface MarkdownPageEntity {
    /**
     * 
     * @type {string}
     * @memberof MarkdownPageEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MarkdownPageEntity
     */
    name: string;
    /**
     * 
     * @type {Array<MarkdownPageContentEntity>}
     * @memberof MarkdownPageEntity
     */
    markdownPageContent?: Array<MarkdownPageContentEntity>;
}
/**
 * 
 * @export
 * @interface MarkdownPageUpdateDto
 */
export interface MarkdownPageUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof MarkdownPageUpdateDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MarkdownPageUpdateDto
     */
    name: string;
    /**
     * 
     * @type {Array<MarkdownPageContentEntity>}
     * @memberof MarkdownPageUpdateDto
     */
    markdownPageContent?: Array<MarkdownPageContentEntity>;
}
/**
 * 
 * @export
 * @interface MarkdownTextDto
 */
export interface MarkdownTextDto {
    /**
     * 
     * @type {string}
     * @memberof MarkdownTextDto
     */
    text?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MarkdownTextDto
     */
    files?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface MediaColorDto
 */
export interface MediaColorDto {
    /**
     * 
     * @type {string}
     * @memberof MediaColorDto
     */
    type: MediaColorDtoTypeEnum;
    /**
     * Color string
     * @type {string}
     * @memberof MediaColorDto
     */
    color: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MediaColorDtoTypeEnum {
    Color = 'color'
}

/**
 * 
 * @export
 * @interface MediaFileDto
 */
export interface MediaFileDto {
    /**
     * 
     * @type {string}
     * @memberof MediaFileDto
     */
    type: MediaFileDtoTypeEnum;
    /**
     * FileObject - any type for now
     * @type {object}
     * @memberof MediaFileDto
     */
    file: object;
}

/**
    * @export
    * @enum {string}
    */
export enum MediaFileDtoTypeEnum {
    Media = 'media'
}

/**
 * 
 * @export
 * @interface MemberScopeDto
 */
export interface MemberScopeDto {
    /**
     * 
     * @type {string}
     * @memberof MemberScopeDto
     */
    resourceType: MemberScopeDtoResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MemberScopeDto
     */
    resourceId: string;
    /**
     * 
     * @type {string}
     * @memberof MemberScopeDto
     */
    name: string;
    /**
     * A story\'s project
     * @type {string}
     * @memberof MemberScopeDto
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberScopeDto
     */
    parentName?: string;
    /**
     * The caller\'s role there
     * @type {string}
     * @memberof MemberScopeDto
     */
    manageAs: MemberScopeDtoManageAsEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum MemberScopeDtoResourceTypeEnum {
    Whitelabel = 'whitelabel',
    Company = 'company',
    Division = 'division',
    Game = 'game',
    QrCode = 'qr_code',
    GameRelease = 'game_release',
    GameVariable = 'game_variable',
    Domain = 'domain',
    Session = 'session',
    Review = 'review',
    Article = 'article',
    ArticleGroup = 'article_group',
    Tag = 'tag',
    Theme = 'theme',
    Asset = 'asset',
    Event = 'event',
    EventVariant = 'event_variant',
    Scenario = 'scenario',
    Scenarios = 'scenarios',
    DivisionSubscription = 'division_subscription',
    DivisionDepartment = 'division_department',
    SubscriptionPackage = 'subscription_package',
    Subscription = 'subscription',
    Scene = 'scene',
    TemplateCategory = 'template_category',
    Template = 'template',
    Notification = 'notification',
    OnDemandVideo = 'on_demand_video',
    OnDemandPlaylist = 'on_demand_playlist',
    Collection = 'collection',
    Brandkit = 'brandkit',
    Page = 'page',
    PageSet = 'pageSet'
}
/**
    * @export
    * @enum {string}
    */
export enum MemberScopeDtoManageAsEnum {
    Admin = 'admin',
    Editor = 'editor',
    Viewer = 'viewer',
    Host = 'host'
}

/**
 * 
 * @export
 * @interface MfaSetupResultDto
 */
export interface MfaSetupResultDto {
    /**
     * 
     * @type {string}
     * @memberof MfaSetupResultDto
     */
    qrCodeDataUrl: string;
    /**
     * 
     * @type {string}
     * @memberof MfaSetupResultDto
     */
    secret: string;
}
/**
 * 
 * @export
 * @interface MfaVerifyDto
 */
export interface MfaVerifyDto {
    /**
     * 
     * @type {string}
     * @memberof MfaVerifyDto
     */
    token: string;
}
/**
 * 
 * @export
 * @interface MfaVerifyResultDto
 */
export interface MfaVerifyResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof MfaVerifyResultDto
     */
    verified: boolean;
    /**
     * 
     * @type {ReturnedAccessToken}
     * @memberof MfaVerifyResultDto
     */
    accessToken?: ReturnedAccessToken;
}
/**
 * 
 * @export
 * @interface MyAccountDto
 */
export interface MyAccountDto {
    /**
     * 
     * @type {UserEntity}
     * @memberof MyAccountDto
     */
    user: UserEntity;
    /**
     * 
     * @type {Array<AccessControlEntity>}
     * @memberof MyAccountDto
     */
    rules: Array<AccessControlEntity>;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof MyAccountDto
     */
    defaultDivision?: DivisionEntity;
}
/**
 * 
 * @export
 * @interface OnDemandPlaylistDivisionEntity
 */
export interface OnDemandPlaylistDivisionEntity {
    /**
     * 
     * @type {string}
     * @memberof OnDemandPlaylistDivisionEntity
     */
    hideUntil?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof OnDemandPlaylistDivisionEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {OnDemandPlaylistEntity}
     * @memberof OnDemandPlaylistDivisionEntity
     */
    playlist: OnDemandPlaylistEntity;
}
/**
 * 
 * @export
 * @interface OnDemandPlaylistEntity
 */
export interface OnDemandPlaylistEntity {
    /**
     * 
     * @type {string}
     * @memberof OnDemandPlaylistEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OnDemandPlaylistEntity
     */
    name: string;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof OnDemandPlaylistEntity
     */
    company: CompanyEntity;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnDemandPlaylistEntity
     */
    videos?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OnDemandPlaylistEntity
     */
    weight?: number;
    /**
     * 
     * @type {Array<OnDemandPlaylistDivisionEntity>}
     * @memberof OnDemandPlaylistEntity
     */
    playlistDivisions?: Array<OnDemandPlaylistDivisionEntity>;
    /**
     * 
     * @type {Array<LanguageEntity>}
     * @memberof OnDemandPlaylistEntity
     */
    baseLanguage?: Array<LanguageEntity>;
    /**
     * 
     * @type {Array<OnDemandPlaylistTranslationEntity>}
     * @memberof OnDemandPlaylistEntity
     */
    translations?: Array<OnDemandPlaylistTranslationEntity>;
    /**
     * 
     * @type {ThemeEntity}
     * @memberof OnDemandPlaylistEntity
     */
    theme?: ThemeEntity;
}
/**
 * 
 * @export
 * @interface OnDemandPlaylistTranslationEntity
 */
export interface OnDemandPlaylistTranslationEntity {
    /**
     * 
     * @type {OnDemandPlaylistEntity}
     * @memberof OnDemandPlaylistTranslationEntity
     */
    onDemandPlaylist?: OnDemandPlaylistEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof OnDemandPlaylistTranslationEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {string}
     * @memberof OnDemandPlaylistTranslationEntity
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OnDemandPlaylistTranslationEntity
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OnDemandPlaylistTranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof OnDemandPlaylistTranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface OnDemandVideoAnalyticsDto
 */
export interface OnDemandVideoAnalyticsDto {
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoAnalyticsDto
     */
    userKey: string;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoAnalyticsDto
     */
    divisionId?: string;
}
/**
 * 
 * @export
 * @interface OnDemandVideoAnalyticsEntity
 */
export interface OnDemandVideoAnalyticsEntity {
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoAnalyticsEntity
     */
    id: string;
    /**
     * 
     * @type {OnDemandVideoEntity}
     * @memberof OnDemandVideoAnalyticsEntity
     */
    video?: OnDemandVideoEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof OnDemandVideoAnalyticsEntity
     */
    user?: UserEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof OnDemandVideoAnalyticsEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoAnalyticsEntity
     */
    userKey: string;
    /**
     * 
     * @type {number}
     * @memberof OnDemandVideoAnalyticsEntity
     */
    created: number;
}
/**
 * 
 * @export
 * @interface OnDemandVideoEntity
 */
export interface OnDemandVideoEntity {
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoEntity
     */
    video?: string;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoEntity
     */
    image?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof OnDemandVideoEntity
     */
    text?: MarkdownTextDto;
    /**
     * 
     * @type {number}
     * @memberof OnDemandVideoEntity
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof OnDemandVideoEntity
     */
    durationMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoEntity
     */
    attachment?: string;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoEntity
     */
    updated?: string;
    /**
     * 
     * @type {Array<OnDemandPlaylistEntity>}
     * @memberof OnDemandVideoEntity
     */
    groups?: Array<OnDemandPlaylistEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoAnalyticsEntity>}
     * @memberof OnDemandVideoEntity
     */
    videoAnalytics?: Array<OnDemandVideoAnalyticsEntity>;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof OnDemandVideoEntity
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof OnDemandVideoEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {Array<LanguageEntity>}
     * @memberof OnDemandVideoEntity
     */
    baseLanguage?: Array<LanguageEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoTranslationEntity>}
     * @memberof OnDemandVideoEntity
     */
    translations?: Array<OnDemandVideoTranslationEntity>;
}
/**
 * 
 * @export
 * @interface OnDemandVideoTranslationEntity
 */
export interface OnDemandVideoTranslationEntity {
    /**
     * 
     * @type {OnDemandVideoEntity}
     * @memberof OnDemandVideoTranslationEntity
     */
    onDemandVideo?: OnDemandVideoEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof OnDemandVideoTranslationEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoTranslationEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoTranslationEntity
     */
    video?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof OnDemandVideoTranslationEntity
     */
    text?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoTranslationEntity
     */
    attachment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OnDemandVideoTranslationEntity
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoTranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof OnDemandVideoTranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface OrganisationMembersDto
 */
export interface OrganisationMembersDto {
    /**
     * 
     * @type {string}
     * @memberof OrganisationMembersDto
     */
    organisationName: string;
    /**
     * The caller\'s role on the organization itself
     * @type {string}
     * @memberof OrganisationMembersDto
     */
    role?: OrganisationMembersDtoRoleEnum;
    /**
     * 
     * @type {Array<AccessControlEntity>}
     * @memberof OrganisationMembersDto
     */
    grants: Array<AccessControlEntity>;
    /**
     * 
     * @type {Array<MemberScopeDto>}
     * @memberof OrganisationMembersDto
     */
    scopes: Array<MemberScopeDto>;
}

/**
    * @export
    * @enum {string}
    */
export enum OrganisationMembersDtoRoleEnum {
    Admin = 'admin',
    Editor = 'editor',
    Viewer = 'viewer',
    Host = 'host'
}

/**
 * 
 * @export
 * @interface PageAddressConflictDto
 */
export interface PageAddressConflictDto {
    /**
     * 
     * @type {string}
     * @memberof PageAddressConflictDto
     */
    slug: string;
    /**
     * 
     * @type {Array<AddressedPageDto>}
     * @memberof PageAddressConflictDto
     */
    pages: Array<AddressedPageDto>;
}
/**
 * 
 * @export
 * @interface PageAnalyticsCountDto
 */
export interface PageAnalyticsCountDto {
    /**
     * 
     * @type {string}
     * @memberof PageAnalyticsCountDto
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsCountDto
     */
    visits: number;
}
/**
 * 
 * @export
 * @interface PageAnalyticsFunnelDto
 */
export interface PageAnalyticsFunnelDto {
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsFunnelDto
     */
    visits: number;
    /**
     * Visits that saw a block showing content.
     * @type {number}
     * @memberof PageAnalyticsFunnelDto
     */
    sawContent: number;
    /**
     * Visits that opened a story, article or video.
     * @type {number}
     * @memberof PageAnalyticsFunnelDto
     */
    openedContent: number;
    /**
     * Visits that followed a link to another site.
     * @type {number}
     * @memberof PageAnalyticsFunnelDto
     */
    clickedOut: number;
}
/**
 * 
 * @export
 * @interface PageAnalyticsPageDto
 */
export interface PageAnalyticsPageDto {
    /**
     * 
     * @type {string}
     * @memberof PageAnalyticsPageDto
     */
    pageId: string;
    /**
     * 
     * @type {string}
     * @memberof PageAnalyticsPageDto
     */
    name?: string;
    /**
     * Owner of a project page.
     * @type {string}
     * @memberof PageAnalyticsPageDto
     */
    divisionId?: string;
    /**
     * Owner of an organisation page.
     * @type {string}
     * @memberof PageAnalyticsPageDto
     */
    setId?: string;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsPageDto
     */
    views: number;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsPageDto
     */
    visits: number;
}
/**
 * 
 * @export
 * @interface PageAnalyticsProjectDto
 */
export interface PageAnalyticsProjectDto {
    /**
     * 
     * @type {string}
     * @memberof PageAnalyticsProjectDto
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsProjectDto
     */
    visits: number;
    /**
     * 
     * @type {string}
     * @memberof PageAnalyticsProjectDto
     */
    divisionId: string;
}
/**
 * 
 * @export
 * @interface PageAnalyticsSeriesPointDto
 */
export interface PageAnalyticsSeriesPointDto {
    /**
     * Start of the bucket on the requested time zone\'s clock.
     * @type {string}
     * @memberof PageAnalyticsSeriesPointDto
     */
    at: string;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsSeriesPointDto
     */
    visits: number;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsSeriesPointDto
     */
    averageActiveSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsSeriesPointDto
     */
    contentOpens: number;
}
/**
 * 
 * @export
 * @interface PageAnalyticsSourceDto
 */
export interface PageAnalyticsSourceDto {
    /**
     * 
     * @type {string}
     * @memberof PageAnalyticsSourceDto
     */
    kind: PageAnalyticsSourceDtoKindEnum;
    /**
     * The tracked link, group or story id, the UTM source or the referrer host.
     * @type {string}
     * @memberof PageAnalyticsSourceDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof PageAnalyticsSourceDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsSourceDto
     */
    visits: number;
    /**
     * A group\'s links, its own included.
     * @type {number}
     * @memberof PageAnalyticsSourceDto
     */
    links?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum PageAnalyticsSourceDtoKindEnum {
    Link = 'link',
    Group = 'group',
    Story = 'story',
    Utm = 'utm',
    Referrer = 'referrer',
    Direct = 'direct'
}

/**
 * 
 * @export
 * @interface PageAnalyticsSummaryDto
 */
export interface PageAnalyticsSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsSummaryDto
     */
    visits: number;
    /**
     * Per person when known, otherwise per browser.
     * @type {number}
     * @memberof PageAnalyticsSummaryDto
     */
    uniqueVisitors: number;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsSummaryDto
     */
    averageActiveSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsSummaryDto
     */
    pageViews: number;
    /**
     * Stories, articles and videos opened.
     * @type {number}
     * @memberof PageAnalyticsSummaryDto
     */
    contentOpens: number;
    /**
     * Links followed to other sites or email.
     * @type {number}
     * @memberof PageAnalyticsSummaryDto
     */
    outboundClicks: number;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsSummaryDto
     */
    downloads: number;
    /**
     * Times the consent banner was put to a visitor.
     * @type {number}
     * @memberof PageAnalyticsSummaryDto
     */
    consentShown: number;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsSummaryDto
     */
    consentAccepted: number;
    /**
     * 
     * @type {number}
     * @memberof PageAnalyticsSummaryDto
     */
    consentDeclined: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PageBlockAction {
    Navigate = 'navigate',
    Section = 'section',
    Open = 'open',
    Outbound = 'outbound',
    Email = 'email',
    Download = 'download'
}

/**
 * 
 * @export
 * @interface PageBlockActionCountDto
 */
export interface PageBlockActionCountDto {
    /**
     * 
     * @type {PageBlockAction}
     * @memberof PageBlockActionCountDto
     */
    action: PageBlockAction;
    /**
     * 
     * @type {number}
     * @memberof PageBlockActionCountDto
     */
    clicks: number;
}
/**
 * 
 * @export
 * @interface PageBlockDto
 */
export interface PageBlockDto {
    /**
     * 
     * @type {string}
     * @memberof PageBlockDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PageBlockDto
     */
    type: PageBlockDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PageBlockDto
     */
    activeBrandkitId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PageBlockDto
     */
    hidden?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PageBlockDto
     */
    props: { [key: string]: any; };
}

/**
    * @export
    * @enum {string}
    */
export enum PageBlockDtoTypeEnum {
    Text = 'text',
    Collection = 'collection',
    ContentItem = 'content-item',
    Events = 'events',
    Grid = 'grid',
    Journey = 'journey',
    Checklist = 'checklist',
    EpHero = 'ep-hero',
    EpTeaser = 'ep-teaser',
    EpProgress = 'ep-progress',
    EpAnnouncement = 'ep-announcement',
    EpCoach = 'ep-coach',
    EpMasterclass = 'ep-masterclass'
}

/**
 * 
 * @export
 * @interface PageBlockItemCountDto
 */
export interface PageBlockItemCountDto {
    /**
     * The card or button followed, as the page marks it.
     * @type {string}
     * @memberof PageBlockItemCountDto
     */
    itemId: string;
    /**
     * Its title or label when last followed.
     * @type {string}
     * @memberof PageBlockItemCountDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof PageBlockItemCountDto
     */
    clicks: number;
}
/**
 * 
 * @export
 * @interface PageBlockStatDto
 */
export interface PageBlockStatDto {
    /**
     * 
     * @type {string}
     * @memberof PageBlockStatDto
     */
    blockId: string;
    /**
     * 
     * @type {string}
     * @memberof PageBlockStatDto
     */
    blockType: string;
    /**
     * Visits in which the block was seen.
     * @type {number}
     * @memberof PageBlockStatDto
     */
    seenVisits: number;
    /**
     * Links followed from the block.
     * @type {number}
     * @memberof PageBlockStatDto
     */
    actions: number;
    /**
     * Visits that followed a link from the block.
     * @type {number}
     * @memberof PageBlockStatDto
     */
    clickVisits: number;
    /**
     * 
     * @type {Array<PageBlockActionCountDto>}
     * @memberof PageBlockStatDto
     */
    byAction: Array<PageBlockActionCountDto>;
    /**
     * Clicks per card or button; clicks from before items were marked are left out.
     * @type {Array<PageBlockItemCountDto>}
     * @memberof PageBlockStatDto
     */
    items: Array<PageBlockItemCountDto>;
    /**
     * Visits from the projects that show the block.
     * @type {number}
     * @memberof PageBlockStatDto
     */
    visits: number;
}
/**
 * 
 * @export
 * @interface PageBlockStatsDto
 */
export interface PageBlockStatsDto {
    /**
     * Visits that opened the page.
     * @type {number}
     * @memberof PageBlockStatsDto
     */
    visits: number;
    /**
     * 
     * @type {Array<PageBlockStatDto>}
     * @memberof PageBlockStatsDto
     */
    blocks: Array<PageBlockStatDto>;
}
/**
 * 
 * @export
 * @interface PageConsentDto
 */
export interface PageConsentDto {
    /**
     * 
     * @type {string}
     * @memberof PageConsentDto
     */
    divisionId: string;
    /**
     * 
     * @type {ConsentResponse}
     * @memberof PageConsentDto
     */
    response: ConsentResponse;
}
/**
 * 
 * @export
 * @interface PageConversionDto
 */
export interface PageConversionDto {
    /**
     * 
     * @type {ConversionEvent}
     * @memberof PageConversionDto
     */
    event: ConversionEvent;
    /**
     * 
     * @type {string}
     * @memberof PageConversionDto
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface PageCreateDto
 */
export interface PageCreateDto {
    /**
     * 
     * @type {string}
     * @memberof PageCreateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PageCreateDto
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof PageCreateDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PageCreateDto
     */
    weight?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageCreateDto
     */
    isHome?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageCreateDto
     */
    isCore?: boolean;
    /**
     * 
     * @type {Array<PageBlockDto>}
     * @memberof PageCreateDto
     */
    blocks?: Array<PageBlockDto>;
    /**
     * 
     * @type {string}
     * @memberof PageCreateDto
     */
    activeBrandkitId?: string;
    /**
     * 
     * @type {PageStoryTransition}
     * @memberof PageCreateDto
     */
    storyTransition?: PageStoryTransition;
    /**
     * 
     * @type {string}
     * @memberof PageCreateDto
     */
    baseLanguage?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PageCreateDto
     */
    variablePreviews?: { [key: string]: string; };
    /**
     * 
     * @type {PageConversionDto}
     * @memberof PageCreateDto
     */
    conversion?: PageConversionDto | null;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof PageCreateDto
     */
    translations?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface PageDistributionColorDto
 */
export interface PageDistributionColorDto {
    /**
     * 
     * @type {string}
     * @memberof PageDistributionColorDto
     */
    color?: string;
}
/**
 * 
 * @export
 * @interface PageDistributionEntity
 */
export interface PageDistributionEntity {
    /**
     * 
     * @type {string}
     * @memberof PageDistributionEntity
     */
    id: string;
    /**
     * 
     * @type {PageEntity}
     * @memberof PageDistributionEntity
     */
    page: PageEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof PageDistributionEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {boolean}
     * @memberof PageDistributionEntity
     */
    taken?: boolean;
    /**
     * 
     * @type {PageOverridesDto}
     * @memberof PageDistributionEntity
     */
    overrides?: PageOverridesDto;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof PageDistributionEntity
     */
    translations?: { [key: string]: object; };
    /**
     * 
     * @type {PageOverridesDto}
     * @memberof PageDistributionEntity
     */
    publishedOverrides?: PageOverridesDto;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof PageDistributionEntity
     */
    publishedTranslations?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof PageDistributionEntity
     */
    published?: string;
    /**
     * 
     * @type {string}
     * @memberof PageDistributionEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof PageDistributionEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface PageDistributionResolvedDto
 */
export interface PageDistributionResolvedDto {
    /**
     * 
     * @type {PageDistributionEntity}
     * @memberof PageDistributionResolvedDto
     */
    distribution: PageDistributionEntity;
    /**
     * 
     * @type {PageDistributionResolvedMasterDto}
     * @memberof PageDistributionResolvedDto
     */
    master: PageDistributionResolvedMasterDto;
    /**
     * 
     * @type {Array<PageBlockDto>}
     * @memberof PageDistributionResolvedDto
     */
    resolvedBlocks: Array<PageBlockDto>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PageDistributionResolvedDto
     */
    resolvedVariables: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface PageDistributionResolvedMasterDto
 */
export interface PageDistributionResolvedMasterDto {
    /**
     * 
     * @type {string}
     * @memberof PageDistributionResolvedMasterDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PageDistributionResolvedMasterDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PageDistributionResolvedMasterDto
     */
    isPublished: boolean;
    /**
     * 
     * @type {string}
     * @memberof PageDistributionResolvedMasterDto
     */
    published?: string;
    /**
     * 
     * @type {string}
     * @memberof PageDistributionResolvedMasterDto
     */
    activeBrandkitId?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PageDistributionResolvedMasterDto
     */
    variablePreviews?: { [key: string]: string; };
    /**
     * 
     * @type {Array<PageBlockDto>}
     * @memberof PageDistributionResolvedMasterDto
     */
    publishedBlocks: Array<PageBlockDto> | null;
}
/**
 * 
 * @export
 * @interface PageDuplicateDto
 */
export interface PageDuplicateDto {
    /**
     * 
     * @type {string}
     * @memberof PageDuplicateDto
     */
    pageSetId?: string;
}
/**
 * 
 * @export
 * @interface PageEntity
 */
export interface PageEntity {
    /**
     * 
     * @type {string}
     * @memberof PageEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PageEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PageEntity
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof PageEntity
     */
    parentId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PageEntity
     */
    weight?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageEntity
     */
    isHome?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageEntity
     */
    isCore?: boolean;
    /**
     * 
     * @type {Array<PageBlockDto>}
     * @memberof PageEntity
     */
    blocks?: Array<PageBlockDto>;
    /**
     * 
     * @type {string}
     * @memberof PageEntity
     */
    activeBrandkitId?: string;
    /**
     * 
     * @type {PageStoryTransition}
     * @memberof PageEntity
     */
    storyTransition?: PageStoryTransition;
    /**
     * 
     * @type {string}
     * @memberof PageEntity
     */
    baseLanguage?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PageEntity
     */
    variablePreviews?: { [key: string]: string; };
    /**
     * 
     * @type {PageConversionDto}
     * @memberof PageEntity
     */
    conversion?: PageConversionDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof PageEntity
     */
    isPublished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PageEntity
     */
    published?: string;
    /**
     * 
     * @type {Array<PageBlockDto>}
     * @memberof PageEntity
     */
    publishedBlocks?: Array<PageBlockDto>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof PageEntity
     */
    translations?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof PageEntity
     */
    publishedTranslations?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof PageEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof PageEntity
     */
    updated?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof PageEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {PageSetEntity}
     * @memberof PageEntity
     */
    pageSet?: PageSetEntity;
}
/**
 * 
 * @export
 * @interface PageEventDto
 */
export interface PageEventDto {
    /**
     * 
     * @type {string}
     * @memberof PageEventDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PageEventDto
     */
    pageId: string;
    /**
     * 
     * @type {string}
     * @memberof PageEventDto
     */
    type: PageEventDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PageEventDto
     */
    blockId?: string;
    /**
     * 
     * @type {string}
     * @memberof PageEventDto
     */
    blockType?: string;
    /**
     * 
     * @type {string}
     * @memberof PageEventDto
     */
    action?: PageEventDtoActionEnum;
    /**
     * 
     * @type {string}
     * @memberof PageEventDto
     */
    itemId?: string;
    /**
     * 
     * @type {string}
     * @memberof PageEventDto
     */
    itemName?: string;
    /**
     * 
     * @type {string}
     * @memberof PageEventDto
     */
    target?: string;
    /**
     * Client clock, epoch ms
     * @type {number}
     * @memberof PageEventDto
     */
    occurredAt: number;
}

/**
    * @export
    * @enum {string}
    */
export enum PageEventDtoTypeEnum {
    PageView = 'page_view',
    BlockImpression = 'block_impression',
    BlockAction = 'block_action'
}
/**
    * @export
    * @enum {string}
    */
export enum PageEventDtoActionEnum {
    Navigate = 'navigate',
    Section = 'section',
    Open = 'open',
    Outbound = 'outbound',
    Email = 'email',
    Download = 'download'
}

/**
 * 
 * @export
 * @interface PageEventsBatchDto
 */
export interface PageEventsBatchDto {
    /**
     * 
     * @type {PageVisitDto}
     * @memberof PageEventsBatchDto
     */
    visit: PageVisitDto;
    /**
     * 
     * @type {Array<PageEventDto>}
     * @memberof PageEventsBatchDto
     */
    events: Array<PageEventDto>;
    /**
     * Client clock when the batch was sent, epoch ms. Corrects the other client timestamps for clock skew.
     * @type {number}
     * @memberof PageEventsBatchDto
     */
    sentAt: number;
}
/**
 * 
 * @export
 * @interface PageHomeDto
 */
export interface PageHomeDto {
    /**
     * 
     * @type {Array<AddressedPageDto>}
     * @memberof PageHomeDto
     */
    claimants: Array<AddressedPageDto>;
    /**
     * 
     * @type {AddressedPageDto}
     * @memberof PageHomeDto
     */
    landing?: AddressedPageDto;
}
/**
 * 
 * @export
 * @interface PageIssuesDto
 */
export interface PageIssuesDto {
    /**
     * 
     * @type {Array<PageLinkIssueDto>}
     * @memberof PageIssuesDto
     */
    deadLinks: Array<PageLinkIssueDto>;
    /**
     * 
     * @type {Array<PageAddressConflictDto>}
     * @memberof PageIssuesDto
     */
    addressConflicts: Array<PageAddressConflictDto>;
    /**
     * 
     * @type {PageHomeDto}
     * @memberof PageIssuesDto
     */
    home: PageHomeDto;
}
/**
 * 
 * @export
 * @interface PageLinkIssueDto
 */
export interface PageLinkIssueDto {
    /**
     * 
     * @type {string}
     * @memberof PageLinkIssueDto
     */
    pageId: string;
    /**
     * 
     * @type {string}
     * @memberof PageLinkIssueDto
     */
    pageName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PageLinkIssueDto
     */
    blockIds: Array<string>;
}
/**
 * 
 * @export
 * @interface PageMoveDto
 */
export interface PageMoveDto {
    /**
     * 
     * @type {string}
     * @memberof PageMoveDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PageMoveDto
     */
    index: number;
}
/**
 * 
 * @export
 * @interface PageMoveToSetDto
 */
export interface PageMoveToSetDto {
    /**
     * 
     * @type {string}
     * @memberof PageMoveToSetDto
     */
    pageSetId: string;
}
/**
 * 
 * @export
 * @interface PageOverridesDto
 */
export interface PageOverridesDto {
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof PageOverridesDto
     */
    blocks?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PageOverridesDto
     */
    variables?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof PageOverridesDto
     */
    hiddenBlocks?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PageOverridesDto
     */
    unhiddenBlocks?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PageOverridesDto
     */
    slug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PageOverridesDto
     */
    isHome?: boolean;
}
/**
 * 
 * @export
 * @interface PageOverviewDto
 */
export interface PageOverviewDto {
    /**
     * Visits that opened the page.
     * @type {number}
     * @memberof PageOverviewDto
     */
    visits: number;
    /**
     * 
     * @type {number}
     * @memberof PageOverviewDto
     */
    uniqueVisitors: number;
    /**
     * Visits that started on the page.
     * @type {number}
     * @memberof PageOverviewDto
     */
    landed: number;
    /**
     * 
     * @type {Array<PageAnalyticsSeriesPointDto>}
     * @memberof PageOverviewDto
     */
    series: Array<PageAnalyticsSeriesPointDto>;
    /**
     * How far the page\'s visits got on the page itself.
     * @type {PageAnalyticsFunnelDto}
     * @memberof PageOverviewDto
     */
    funnel: PageAnalyticsFunnelDto;
    /**
     * Where the visits that started on the page came from.
     * @type {Array<PageAnalyticsSourceDto>}
     * @memberof PageOverviewDto
     */
    sources: Array<PageAnalyticsSourceDto>;
    /**
     * 
     * @type {Array<PageAnalyticsCountDto>}
     * @memberof PageOverviewDto
     */
    languages: Array<PageAnalyticsCountDto>;
    /**
     * 
     * @type {Array<PageAnalyticsCountDto>}
     * @memberof PageOverviewDto
     */
    devices: Array<PageAnalyticsCountDto>;
    /**
     * Pages the visits opened after this one.
     * @type {Array<PageAnalyticsPageDto>}
     * @memberof PageOverviewDto
     */
    nextPages: Array<PageAnalyticsPageDto>;
    /**
     * Visits per project; only across every project the page is on.
     * @type {Array<PageAnalyticsProjectDto>}
     * @memberof PageOverviewDto
     */
    projects: Array<PageAnalyticsProjectDto>;
}
/**
 * 
 * @export
 * @interface PageProgressDto
 */
export interface PageProgressDto {
    /**
     * 
     * @type {PageProgressScopeDto}
     * @memberof PageProgressDto
     */
    page: PageProgressScopeDto;
    /**
     * 
     * @type {PageProgressScopeDto}
     * @memberof PageProgressDto
     */
    project: PageProgressScopeDto;
}
/**
 * 
 * @export
 * @interface PageProgressScopeDto
 */
export interface PageProgressScopeDto {
    /**
     * 
     * @type {number}
     * @memberof PageProgressScopeDto
     */
    percent: number;
    /**
     * 
     * @type {number}
     * @memberof PageProgressScopeDto
     */
    completed: number;
    /**
     * 
     * @type {number}
     * @memberof PageProgressScopeDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface PageSetDistributeDto
 */
export interface PageSetDistributeDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof PageSetDistributeDto
     */
    divisionIds: Array<string>;
}
/**
 * 
 * @export
 * @interface PageSetDistributionEntity
 */
export interface PageSetDistributionEntity {
    /**
     * 
     * @type {string}
     * @memberof PageSetDistributionEntity
     */
    id: string;
    /**
     * 
     * @type {PageSetEntity}
     * @memberof PageSetDistributionEntity
     */
    pageSet: PageSetEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof PageSetDistributionEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof PageSetDistributionEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof PageSetDistributionEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface PageSetEntity
 */
export interface PageSetEntity {
    /**
     * 
     * @type {string}
     * @memberof PageSetEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PageSetEntity
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PageSetEntity
     */
    weight?: number;
    /**
     * 
     * @type {TrackingIdsDto}
     * @memberof PageSetEntity
     */
    tracking?: TrackingIdsDto | null;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof PageSetEntity
     */
    company: CompanyEntity;
    /**
     * 
     * @type {string}
     * @memberof PageSetEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof PageSetEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface PageSetUpdateDto
 */
export interface PageSetUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof PageSetUpdateDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof PageSetUpdateDto
     */
    weight?: number;
    /**
     * 
     * @type {TrackingIdsDto}
     * @memberof PageSetUpdateDto
     */
    tracking?: TrackingIdsDto | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PageStoryTransition {
    Overlay = 'overlay',
    Push = 'push'
}

/**
 * 
 * @export
 * @interface PageSummaryDto
 */
export interface PageSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof PageSummaryDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PageSummaryDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PageSummaryDto
     */
    slug: string;
    /**
     * 
     * @type {boolean}
     * @memberof PageSummaryDto
     */
    isHome: boolean;
    /**
     * 
     * @type {string}
     * @memberof PageSummaryDto
     */
    parentId: string | null;
    /**
     * 
     * @type {ResolvedConsentBannerDto}
     * @memberof PageSummaryDto
     */
    consentBanner: ResolvedConsentBannerDto | null;
    /**
     * 
     * @type {ResolvedTrackingDto}
     * @memberof PageSummaryDto
     */
    tracking: ResolvedTrackingDto | null;
    /**
     * 
     * @type {PageConversionDto}
     * @memberof PageSummaryDto
     */
    conversion: PageConversionDto | null;
}
/**
 * 
 * @export
 * @interface PageTakenDto
 */
export interface PageTakenDto {
    /**
     * 
     * @type {boolean}
     * @memberof PageTakenDto
     */
    taken: boolean;
}
/**
 * 
 * @export
 * @interface PageTranslationDto
 */
export interface PageTranslationDto {
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof PageTranslationDto
     */
    blocks?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PageTranslationDto
     */
    variables?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof PageTranslationDto
     */
    hiddenBlocks?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PageTranslationDto
     */
    unhiddenBlocks?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PageTranslationDto
     */
    slug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PageTranslationDto
     */
    isHome?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PageTranslationDto
     */
    name?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof PageTranslationDto
     */
    sourceHashes?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PageTranslationDto
     */
    variableSourceHashes?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface PageUpdateDto
 */
export interface PageUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof PageUpdateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PageUpdateDto
     */
    slug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PageUpdateDto
     */
    isHome?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageUpdateDto
     */
    isCore?: boolean;
    /**
     * 
     * @type {Array<PageBlockDto>}
     * @memberof PageUpdateDto
     */
    blocks?: Array<PageBlockDto>;
    /**
     * 
     * @type {string}
     * @memberof PageUpdateDto
     */
    activeBrandkitId?: string;
    /**
     * 
     * @type {PageStoryTransition}
     * @memberof PageUpdateDto
     */
    storyTransition?: PageStoryTransition;
    /**
     * 
     * @type {string}
     * @memberof PageUpdateDto
     */
    baseLanguage?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PageUpdateDto
     */
    variablePreviews?: { [key: string]: string; };
    /**
     * 
     * @type {PageConversionDto}
     * @memberof PageUpdateDto
     */
    conversion?: PageConversionDto | null;
}
/**
 * 
 * @export
 * @interface PageVisitDto
 */
export interface PageVisitDto {
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    divisionId: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    entryPageId: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    userKey: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    referrerHost?: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    utmSource?: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    utmMedium?: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    utmCampaign?: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    utmTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    utmContent?: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    shareRef?: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    qrCodeHitId?: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    sourceStoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof PageVisitDto
     */
    sourceSessionId?: string;
    /**
     * Client clock, epoch ms
     * @type {number}
     * @memberof PageVisitDto
     */
    startedAt: number;
    /**
     * Client clock, epoch ms
     * @type {number}
     * @memberof PageVisitDto
     */
    lastActiveAt: number;
    /**
     * 
     * @type {number}
     * @memberof PageVisitDto
     */
    activeSeconds: number;
}
/**
 * What the pages runtime does when a visitor lands on the project root with a page remembered from earlier in the session: \'home\' keeps them on the home page, \'resume\' hands them back to that page.
 * @export
 * @enum {string}
 */
export enum PagesEntryBehaviorEnum {
    Home = 'home',
    Resume = 'resume'
}

/**
 * 
 * @export
 * @interface PasswordlessRequestDto
 */
export interface PasswordlessRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PasswordlessRequestDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessRequestDto
     */
    divisionId?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessRequestDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessRequestDto
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface PasswordlessRequestResultDto
 */
export interface PasswordlessRequestResultDto {
    /**
     * 
     * @type {string}
     * @memberof PasswordlessRequestResultDto
     */
    id: string;
}
/**
 * 
 * @export
 * @interface PasswordlessTokenEntity
 */
export interface PasswordlessTokenEntity {
    /**
     * 
     * @type {string}
     * @memberof PasswordlessTokenEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessTokenEntity
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessTokenEntity
     */
    token: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof PasswordlessTokenEntity
     */
    user: UserEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof PasswordlessTokenEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {number}
     * @memberof PasswordlessTokenEntity
     */
    tries: number;
}
/**
 * 
 * @export
 * @interface PasswordlessVerifyDto
 */
export interface PasswordlessVerifyDto {
    /**
     * 
     * @type {string}
     * @memberof PasswordlessVerifyDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessVerifyDto
     */
    token: string;
}
/**
 * 
 * @export
 * @interface PasswordlessVerifyResultDto
 */
export interface PasswordlessVerifyResultDto {
    /**
     * 
     * @type {ReturnedAccessToken}
     * @memberof PasswordlessVerifyResultDto
     */
    accessToken: ReturnedAccessToken;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordlessVerifyResultDto
     */
    setupCompleted: boolean;
    /**
     * 
     * @type {Array<DivisionDepartmentEntity>}
     * @memberof PasswordlessVerifyResultDto
     */
    departments?: Array<DivisionDepartmentEntity>;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordlessVerifyResultDto
     */
    mfaRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordlessVerifyResultDto
     */
    mfaSetupRequired?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PreferredColorThemeEnum {
    Auto = 'auto',
    Light = 'light',
    Dark = 'dark'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PrivacyModeEnum {
    Loose = 'loose',
    Strict = 'strict'
}

/**
 * 
 * @export
 * @interface ProjectParticipantsCountDto
 */
export interface ProjectParticipantsCountDto {
    /**
     * 
     * @type {number}
     * @memberof ProjectParticipantsCountDto
     */
    mainParticipants: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectParticipantsCountDto
     */
    waitingList: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectParticipantsCountDto
     */
    divisionId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectParticipantsCountDto
     */
    divisionName: string | null;
}
/**
 * 
 * @export
 * @interface QRCodeBulkCreateDto
 */
export interface QRCodeBulkCreateDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof QRCodeBulkCreateDto
     */
    names: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof QRCodeBulkCreateDto
     */
    pageId?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeBulkCreateDto
     */
    parentId?: string;
}
/**
 * 
 * @export
 * @interface QRCodeCountResult
 */
export interface QRCodeCountResult {
    /**
     * 
     * @type {string}
     * @memberof QRCodeCountResult
     */
    qrCodeId: string;
    /**
     * 
     * @type {number}
     * @memberof QRCodeCountResult
     */
    total: number;
}
/**
 * 
 * @export
 * @interface QRCodeEntity
 */
export interface QRCodeEntity {
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    type: QRCodeEntityTypeEnum;
    /**
     * 
     * @type {QRCodeShareTypeEnum}
     * @memberof QRCodeEntity
     */
    shareType?: QRCodeShareTypeEnum;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof QRCodeEntity
     */
    coordinates?: GeoPointDto;
    /**
     * If supplied, the QR code will redirect to this URL instead of the game.
     * @type {string}
     * @memberof QRCodeEntity
     */
    customUrl?: string;
    /**
     * If set to true, the game will automatically start.
     * @type {boolean}
     * @memberof QRCodeEntity
     */
    autoStart?: boolean;
    /**
     * If set to true, the game will always start from the start.
     * @type {boolean}
     * @memberof QRCodeEntity
     */
    alwaysRestart?: boolean;
    /**
     * 
     * @type {object}
     * @memberof QRCodeEntity
     */
    variables?: object;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    validFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    validUntil?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    updated?: string;
    /**
     * 
     * @type {GameEntity}
     * @memberof QRCodeEntity
     */
    game?: GameEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    language?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof QRCodeEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    pageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    parentId?: string | null;
    /**
     * 
     * @type {QRCodeEntity}
     * @memberof QRCodeEntity
     */
    parent?: QRCodeEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    style: QRCodeEntityStyleEnum;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    background?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    logo?: string;
    /**
     * 
     * @type {number}
     * @memberof QRCodeEntity
     */
    logoBorder?: number;
    /**
     * 
     * @type {boolean}
     * @memberof QRCodeEntity
     */
    logoBackgroundRemoved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    shareTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    shareDescription?: string;
    /**
     * If enabled, kiosk mode is forced on when the story is opened through this share, even if the story itself does not have kiosk mode enabled.
     * @type {boolean}
     * @memberof QRCodeEntity
     */
    enableKioskMode?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum QRCodeEntityTypeEnum {
    Mobile = 'mobile',
    Web = 'web'
}
/**
    * @export
    * @enum {string}
    */
export enum QRCodeEntityStyleEnum {
    Default = 'default',
    Square = 'square',
    Dotted = 'dotted'
}

/**
 * 
 * @export
 * @interface QRCodeHitEntity
 */
export interface QRCodeHitEntity {
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    device?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    os?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    osVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    browser?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    browserVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    country?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QRCodeHitEntity
     */
    bot?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    ipHash?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    incomingRef?: string;
}
/**
 * 
 * @export
 * @interface QRCodeMoveDto
 */
export interface QRCodeMoveDto {
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    type?: QRCodeMoveDtoTypeEnum;
    /**
     * 
     * @type {QRCodeShareTypeEnum}
     * @memberof QRCodeMoveDto
     */
    shareType?: QRCodeShareTypeEnum;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof QRCodeMoveDto
     */
    coordinates?: GeoPointDto;
    /**
     * If supplied, the QR code will redirect to this URL instead of the game.
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    customUrl?: string;
    /**
     * If set to true, the game will automatically start.
     * @type {boolean}
     * @memberof QRCodeMoveDto
     */
    autoStart?: boolean;
    /**
     * If set to true, the game will always start from the start.
     * @type {boolean}
     * @memberof QRCodeMoveDto
     */
    alwaysRestart?: boolean;
    /**
     * 
     * @type {object}
     * @memberof QRCodeMoveDto
     */
    variables?: object;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    validFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    validUntil?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    updated?: string;
    /**
     * 
     * @type {GameEntity}
     * @memberof QRCodeMoveDto
     */
    game?: GameEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    language?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof QRCodeMoveDto
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    pageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {QRCodeEntity}
     * @memberof QRCodeMoveDto
     */
    parent?: QRCodeEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    style?: QRCodeMoveDtoStyleEnum;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    background?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    logo?: string;
    /**
     * 
     * @type {number}
     * @memberof QRCodeMoveDto
     */
    logoBorder?: number;
    /**
     * 
     * @type {boolean}
     * @memberof QRCodeMoveDto
     */
    logoBackgroundRemoved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    shareTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    shareDescription?: string;
    /**
     * If enabled, kiosk mode is forced on when the story is opened through this share, even if the story itself does not have kiosk mode enabled.
     * @type {boolean}
     * @memberof QRCodeMoveDto
     */
    enableKioskMode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QRCodeMoveDto
     */
    toGameId: string;
}

/**
    * @export
    * @enum {string}
    */
export enum QRCodeMoveDtoTypeEnum {
    Mobile = 'mobile',
    Web = 'web'
}
/**
    * @export
    * @enum {string}
    */
export enum QRCodeMoveDtoStyleEnum {
    Default = 'default',
    Square = 'square',
    Dotted = 'dotted'
}

/**
 * 
 * @export
 * @interface QRCodeRequestDto
 */
export interface QRCodeRequestDto {
    /**
     * 
     * @type {QRCodeEntity}
     * @memberof QRCodeRequestDto
     */
    qr: QRCodeEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeRequestDto
     */
    qrCodeHitId: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum QRCodeShareTypeEnum {
    Legacy = 'legacy',
    ShareLink = 'shareLink',
    ShareQr = 'shareQr',
    ShareCanva = 'shareCanva',
    EmbedPopup = 'embedPopup',
    EmbedInline = 'embedInline',
    EmbedCustom = 'embedCustom',
    Social = 'social',
    SharePreview = 'sharePreview'
}

/**
 * 
 * @export
 * @interface QRCodeUpdateDto
 */
export interface QRCodeUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    type?: QRCodeUpdateDtoTypeEnum;
    /**
     * 
     * @type {QRCodeShareTypeEnum}
     * @memberof QRCodeUpdateDto
     */
    shareType?: QRCodeShareTypeEnum;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof QRCodeUpdateDto
     */
    coordinates?: GeoPointDto;
    /**
     * If supplied, the QR code will redirect to this URL instead of the game.
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    customUrl?: string;
    /**
     * If set to true, the game will automatically start.
     * @type {boolean}
     * @memberof QRCodeUpdateDto
     */
    autoStart?: boolean;
    /**
     * If set to true, the game will always start from the start.
     * @type {boolean}
     * @memberof QRCodeUpdateDto
     */
    alwaysRestart?: boolean;
    /**
     * 
     * @type {object}
     * @memberof QRCodeUpdateDto
     */
    variables?: object;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    validFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    validUntil?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    updated?: string;
    /**
     * 
     * @type {GameEntity}
     * @memberof QRCodeUpdateDto
     */
    game?: GameEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    language?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof QRCodeUpdateDto
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    pageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {QRCodeEntity}
     * @memberof QRCodeUpdateDto
     */
    parent?: QRCodeEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    style?: QRCodeUpdateDtoStyleEnum;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    background?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    logo?: string;
    /**
     * 
     * @type {number}
     * @memberof QRCodeUpdateDto
     */
    logoBorder?: number;
    /**
     * 
     * @type {boolean}
     * @memberof QRCodeUpdateDto
     */
    logoBackgroundRemoved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    shareTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeUpdateDto
     */
    shareDescription?: string;
    /**
     * If enabled, kiosk mode is forced on when the story is opened through this share, even if the story itself does not have kiosk mode enabled.
     * @type {boolean}
     * @memberof QRCodeUpdateDto
     */
    enableKioskMode?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum QRCodeUpdateDtoTypeEnum {
    Mobile = 'mobile',
    Web = 'web'
}
/**
    * @export
    * @enum {string}
    */
export enum QRCodeUpdateDtoStyleEnum {
    Default = 'default',
    Square = 'square',
    Dotted = 'dotted'
}

/**
 * 
 * @export
 * @interface QrDto
 */
export interface QrDto {
    /**
     * 
     * @type {string}
     * @memberof QrDto
     */
    png: string;
    /**
     * 
     * @type {string}
     * @memberof QrDto
     */
    text: string;
}
/**
 * 
 * @export
 * @interface QrRedirectDto
 */
export interface QrRedirectDto {
    /**
     * 
     * @type {string}
     * @memberof QrRedirectDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface RawQueryResult
 */
export interface RawQueryResult {
    /**
     * 
     * @type {string}
     * @memberof RawQueryResult
     */
    result: string;
}
/**
 * 
 * @export
 * @interface ReleaseLanguageDto
 */
export interface ReleaseLanguageDto {
    /**
     * 
     * @type {string}
     * @memberof ReleaseLanguageDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseLanguageDto
     */
    name: string;
}
/**
 * 
 * @export
 * @interface RemoveBackgroundJobDto
 */
export interface RemoveBackgroundJobDto {
    /**
     * 
     * @type {string}
     * @memberof RemoveBackgroundJobDto
     */
    originUrl: string;
}
/**
 * 
 * @export
 * @interface RequestResetPasswordDto
 */
export interface RequestResetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof RequestResetPasswordDto
     */
    email: string;
}
/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface ResolveAccessTokenDto
 */
export interface ResolveAccessTokenDto {
    /**
     * 
     * @type {string}
     * @memberof ResolveAccessTokenDto
     */
    tokenId: string;
}
/**
 * 
 * @export
 * @interface ResolvedCollectionDto
 */
export interface ResolvedCollectionDto {
    /**
     * 
     * @type {string}
     * @memberof ResolvedCollectionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedCollectionDto
     */
    name: string;
    /**
     * 
     * @type {Array<ResolvedCollectionMemberDto>}
     * @memberof ResolvedCollectionDto
     */
    members: Array<ResolvedCollectionMemberDto>;
}
/**
 * 
 * @export
 * @interface ResolvedCollectionMemberDto
 */
export interface ResolvedCollectionMemberDto {
    /**
     * 
     * @type {string}
     * @memberof ResolvedCollectionMemberDto
     */
    id: string;
    /**
     * 
     * @type {CollectionMemberType}
     * @memberof ResolvedCollectionMemberDto
     */
    kind: CollectionMemberType;
    /**
     * 
     * @type {string}
     * @memberof ResolvedCollectionMemberDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedCollectionMemberDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedCollectionMemberDto
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedCollectionMemberDto
     */
    startsAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedCollectionMemberDto
     */
    endsAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ResolvedCollectionMemberDto
     */
    timeInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof ResolvedCollectionMemberDto
     */
    readMinutes?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResolvedCollectionMemberDto
     */
    tags?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ResolvedCollectionMemberDto
     */
    durationMinutes?: number;
}
/**
 * 
 * @export
 * @interface ResolvedConsentBannerDto
 */
export interface ResolvedConsentBannerDto {
    /**
     * 
     * @type {string}
     * @memberof ResolvedConsentBannerDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedConsentBannerDto
     */
    body?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedConsentBannerDto
     */
    version: string;
}
/**
 * 
 * @export
 * @interface ResolvedContentItemDto
 */
export interface ResolvedContentItemDto {
    /**
     * 
     * @type {string}
     * @memberof ResolvedContentItemDto
     */
    id: string;
    /**
     * 
     * @type {CollectionMemberType}
     * @memberof ResolvedContentItemDto
     */
    kind: CollectionMemberType;
    /**
     * 
     * @type {string}
     * @memberof ResolvedContentItemDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedContentItemDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedContentItemDto
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedContentItemDto
     */
    startsAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedContentItemDto
     */
    endsAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ResolvedContentItemDto
     */
    timeInMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof ResolvedContentItemDto
     */
    readMinutes?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResolvedContentItemDto
     */
    tags?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ResolvedContentItemDto
     */
    durationMinutes?: number;
}
/**
 * 
 * @export
 * @interface ResolvedContentItemEntryDto
 */
export interface ResolvedContentItemEntryDto {
    /**
     * 
     * @type {CollectionMemberType}
     * @memberof ResolvedContentItemEntryDto
     */
    kind: CollectionMemberType;
    /**
     * 
     * @type {string}
     * @memberof ResolvedContentItemEntryDto
     */
    itemId: string;
    /**
     * 
     * @type {ResolvedContentItemDto}
     * @memberof ResolvedContentItemEntryDto
     */
    item?: ResolvedContentItemDto;
}
/**
 * 
 * @export
 * @interface ResolvedPageDto
 */
export interface ResolvedPageDto {
    /**
     * 
     * @type {string}
     * @memberof ResolvedPageDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedPageDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedPageDto
     */
    slug: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResolvedPageDto
     */
    isHome: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResolvedPageDto
     */
    activeBrandkitId?: string;
    /**
     * 
     * @type {PageStoryTransition}
     * @memberof ResolvedPageDto
     */
    storyTransition?: PageStoryTransition;
    /**
     * 
     * @type {string}
     * @memberof ResolvedPageDto
     */
    baseLanguage?: string;
    /**
     * 
     * @type {Array<PageBlockDto>}
     * @memberof ResolvedPageDto
     */
    resolvedBlocks: Array<PageBlockDto>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ResolvedPageDto
     */
    resolvedVariables: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface ResolvedSubscriptionDto
 */
export interface ResolvedSubscriptionDto {
    /**
     * 
     * @type {string}
     * @memberof ResolvedSubscriptionDto
     */
    packageId: string;
    /**
     * 
     * @type {number}
     * @memberof ResolvedSubscriptionDto
     */
    projectLimit: number;
    /**
     * 
     * @type {number}
     * @memberof ResolvedSubscriptionDto
     */
    gameLimit: number;
    /**
     * 
     * @type {number}
     * @memberof ResolvedSubscriptionDto
     */
    sceneLimit: number;
    /**
     * 
     * @type {number}
     * @memberof ResolvedSubscriptionDto
     */
    sessionLimit: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResolvedSubscriptionDto
     */
    watermark: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResolvedSubscriptionDto
     */
    excludedElements: Array<string>;
    /**
     * 
     * @type {FeatureSetDto}
     * @memberof ResolvedSubscriptionDto
     */
    featureSet: FeatureSetDto;
    /**
     * 
     * @type {boolean}
     * @memberof ResolvedSubscriptionDto
     */
    trial: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResolvedSubscriptionDto
     */
    expires?: string;
}
/**
 * 
 * @export
 * @interface ResolvedTrackingDto
 */
export interface ResolvedTrackingDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResolvedTrackingDto
     */
    ga4?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResolvedTrackingDto
     */
    meta?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResolvedTrackingDto
     */
    linkedin?: Array<string>;
}
/**
 * 
 * @export
 * @interface ResultDto
 */
export interface ResultDto {
    /**
     * 
     * @type {string}
     * @memberof ResultDto
     */
    result: string;
}
/**
 * 
 * @export
 * @interface ReturnedAccessToken
 */
export interface ReturnedAccessToken {
    /**
     * 
     * @type {string}
     * @memberof ReturnedAccessToken
     */
    id: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof ReturnedAccessToken
     */
    user: UserEntity;
}
/**
 * 
 * @export
 * @interface ReviewEntity
 */
export interface ReviewEntity {
    /**
     * 
     * @type {string}
     * @memberof ReviewEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewEntity
     */
    content?: string;
    /**
     * Default is true
     * @type {boolean}
     * @memberof ReviewEntity
     */
    approved: boolean;
    /**
     * Default is 5.0
     * @type {number}
     * @memberof ReviewEntity
     */
    rating: number;
    /**
     * 
     * @type {SessionEntity}
     * @memberof ReviewEntity
     */
    session?: SessionEntity;
}
/**
 * 
 * @export
 * @interface ReviewPostDto
 */
export interface ReviewPostDto {
    /**
     * 
     * @type {string}
     * @memberof ReviewPostDto
     */
    content?: string;
    /**
     * 
     * @type {number}
     * @memberof ReviewPostDto
     */
    rating: number;
}
/**
 * 
 * @export
 * @interface ScenarioEntity
 */
export interface ScenarioEntity {
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    mode: ScenarioEntityModeEnum;
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    jumpTarget?: string;
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    updated?: string;
    /**
     * 
     * @type {GameEntity}
     * @memberof ScenarioEntity
     */
    game: GameEntity;
    /**
     * 
     * @type {Array<ScenarioSceneEntity>}
     * @memberof ScenarioEntity
     */
    scenes?: Array<ScenarioSceneEntity>;
    /**
     * If this scenario is part of a scene it is a branch of that scene.
     * @type {SceneEntity}
     * @memberof ScenarioEntity
     */
    scene?: SceneEntity;
}

/**
    * @export
    * @enum {string}
    */
export enum ScenarioEntityModeEnum {
    Default = 'default',
    Loopback = 'loopback',
    Jump = 'jump'
}

/**
 * 
 * @export
 * @interface ScenarioSceneEntity
 */
export interface ScenarioSceneEntity {
    /**
     * 
     * @type {number}
     * @memberof ScenarioSceneEntity
     */
    weight?: number;
    /**
     * 
     * @type {SceneEntity}
     * @memberof ScenarioSceneEntity
     */
    scene: SceneEntity;
    /**
     * 
     * @type {ScenarioEntity}
     * @memberof ScenarioSceneEntity
     */
    scenario: ScenarioEntity;
}
/**
 * 
 * @export
 * @interface SceneEntity
 */
export interface SceneEntity {
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    translationsUpdated?: string | null;
    /**
     * 
     * @type {Array<LayoutNodeDto>}
     * @memberof SceneEntity
     */
    layout?: Array<LayoutNodeDto>;
    /**
     * 
     * @type {object}
     * @memberof SceneEntity
     */
    variableActions?: object;
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    lockedUntil?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SceneEntity
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof SceneEntity
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof SceneEntity
     */
    maxPoints?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SceneEntity
     */
    bonusWithinSeconds?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SceneEntity
     */
    timerDuration?: number | null;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof SceneEntity
     */
    explanationText?: MarkdownTextDto | null;
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    buttonText?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SceneEntity
     */
    translations?: { [key: string]: any; };
    /**
     * 
     * @type {Array<EventConnectionDto>}
     * @memberof SceneEntity
     */
    connections?: Array<EventConnectionDto>;
    /**
     * 
     * @type {ScenarioSceneEntity}
     * @memberof SceneEntity
     */
    scenarios?: ScenarioSceneEntity;
    /**
     * 
     * @type {ScenarioEntity}
     * @memberof SceneEntity
     */
    scenario?: ScenarioEntity;
    /**
     * 
     * @type {StatisticEntity}
     * @memberof SceneEntity
     */
    statistics?: StatisticEntity;
    /**
     * 
     * @type {StatisticEntity}
     * @memberof SceneEntity
     */
    statisticEvents?: StatisticEntity;
    /**
     * Scenarios that are branches of the scene are contained in this field.
     * @type {Array<ScenarioEntity>}
     * @memberof SceneEntity
     */
    branches?: Array<ScenarioEntity>;
    /**
     * 
     * @type {Array<any>}
     * @memberof SceneEntity
     */
    assets?: Array<any>;
}
/**
 * 
 * @export
 * @interface SessionCrudUpdateDto
 */
export interface SessionCrudUpdateDto {
    /**
     * 
     * @type {boolean}
     * @memberof SessionCrudUpdateDto
     */
    scoreHidden?: boolean;
}
/**
 * 
 * @export
 * @interface SessionEntity
 */
export interface SessionEntity {
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    userKey?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    playerName?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    updated: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    updatedSessionOn: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    processedStatsOn: string;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    score?: number;
    /**
     * Default null
     * @type {string}
     * @memberof SessionEntity
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    started: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    finished?: string;
    /**
     * Default 100, must be between 0 to 100
     * @type {number}
     * @memberof SessionEntity
     */
    batteryStarted: number;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    batteryFinished?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    completion: number;
    /**
     * 
     * @type {object}
     * @memberof SessionEntity
     */
    gameData?: object;
    /**
     * 
     * @type {GameEntity}
     * @memberof SessionEntity
     */
    game?: GameEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof SessionEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {ReviewEntity}
     * @memberof SessionEntity
     */
    review?: ReviewEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof SessionEntity
     */
    user?: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    platform: SessionEntityPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    systemVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    deviceId?: string;
    /**
     * Device category based on deviceId
     * @type {string}
     * @memberof SessionEntity
     */
    deviceCategory?: SessionEntityDeviceCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    appVersion?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    releaseVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    buildNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    bundleId?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    activeSceneIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    numScenes?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    activeSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    actionCount?: number;
    /**
     * 
     * @type {StatisticEntity}
     * @memberof SessionEntity
     */
    statistics?: StatisticEntity;
    /**
     * 
     * @type {StatisticEntity}
     * @memberof SessionEntity
     */
    statisticEvents?: StatisticEntity;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    lastProcessedScene?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    activeSceneId?: string;
    /**
     * 
     * @type {SessionJournalEntity}
     * @memberof SessionEntity
     */
    journal?: SessionJournalEntity;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    source?: SessionEntitySourceEnum;
    /**
     * ID of the inbound story if it was redirected.
     * @type {string}
     * @memberof SessionEntity
     */
    sourceStoryId?: string;
    /**
     * ID of the page the story was opened from.
     * @type {string}
     * @memberof SessionEntity
     */
    sourcePageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    sourcePageVisitId?: string;
    /**
     * Variables that were entered during the session
     * @type {{ [key: string]: string; }}
     * @memberof SessionEntity
     */
    variables?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    clientSyncedAt?: string;
    /**
     * Referral ID generated when user shares the story.
     * @type {string}
     * @memberof SessionEntity
     */
    shareRef?: string;
    /**
     * Incoming referral ID from URL parameter when session was started via a shared link.
     * @type {string}
     * @memberof SessionEntity
     */
    incomingRef?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SessionEntityPlatformEnum {
    Ios = 'ios',
    Android = 'android',
    Web = 'web'
}
/**
    * @export
    * @enum {string}
    */
export enum SessionEntityDeviceCategoryEnum {
    Mobile = 'mobile',
    Desktop = 'desktop',
    Other = 'other',
    Unknown = 'unknown'
}
/**
    * @export
    * @enum {string}
    */
export enum SessionEntitySourceEnum {
    Builder = 'builder',
    Story = 'story',
    Restart = 'restart'
}

/**
 * 
 * @export
 * @interface SessionJournalEntity
 */
export interface SessionJournalEntity {
    /**
     * 
     * @type {string}
     * @memberof SessionJournalEntity
     */
    id: string;
    /**
     * 
     * @type {SessionEntity}
     * @memberof SessionJournalEntity
     */
    session: SessionEntity;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalEntity
     */
    status: SessionJournalEntityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SessionJournalEntity
     */
    chunkCount: number;
    /**
     * 
     * @type {number}
     * @memberof SessionJournalEntity
     */
    totalBytes: number;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalEntity
     */
    firstEventAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalEntity
     */
    lastEventAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalEntity
     */
    archiveKey?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalEntity
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalEntity
     */
    updated: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SessionJournalEntityStatusEnum {
    Active = 'active',
    Archived = 'archived'
}

/**
 * 
 * @export
 * @interface SessionJournalItemDto
 */
export interface SessionJournalItemDto {
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    sessionId: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    journalStatus: SessionJournalItemDtoJournalStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SessionJournalItemDto
     */
    chunkCount: number;
    /**
     * 
     * @type {number}
     * @memberof SessionJournalItemDto
     */
    totalBytes: number;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    firstEventAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    lastEventAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    playerName?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    systemVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    appVersion?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionJournalItemDto
     */
    releaseVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    platform?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    deviceCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    locale?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    timezone?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionJournalItemDto
     */
    completion?: number;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    started: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    finished?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionJournalItemDto
     */
    activeSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionJournalItemDto
     */
    actionCount?: number;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    userEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    gameId: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    gameName: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    divisionId: string;
    /**
     * 
     * @type {string}
     * @memberof SessionJournalItemDto
     */
    divisionName: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SessionJournalItemDtoJournalStatusEnum {
    Active = 'active',
    Archived = 'archived'
}

/**
 * 
 * @export
 * @interface SessionSourceDto
 */
export interface SessionSourceDto {
    /**
     * 
     * @type {string}
     * @memberof SessionSourceDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionSourceDto
     */
    storyId?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionSourceDto
     */
    pageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionSourceDto
     */
    pageVisitId?: string;
}
/**
 * 
 * @export
 * @interface SessionUpdateDto
 */
export interface SessionUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    userKey: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    gameId: string;
    /**
     * Project the session is played in. Only honored for organization-owned stories and must belong to the story\'s organization; ignored for project-owned stories (their project is resolved server-side).
     * @type {string}
     * @memberof SessionUpdateDto
     */
    divisionId?: string;
    /**
     * 
     * @type {object}
     * @memberof SessionUpdateDto
     */
    gameData?: object;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    playerName?: string;
    /**
     * 
     * @type {ReviewPostDto}
     * @memberof SessionUpdateDto
     */
    review?: ReviewPostDto;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    started?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    finished?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    score?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    completion?: number;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    platform: SessionUpdateDtoPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    systemVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    appVersion?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    releaseVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    buildNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    bundleId?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    activeSceneIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    numScenes?: number;
    /**
     * Cumulative engaged time in seconds (30s idle timeout)
     * @type {number}
     * @memberof SessionUpdateDto
     */
    activeSeconds?: number;
    /**
     * Cumulative number of meaningful user interactions
     * @type {number}
     * @memberof SessionUpdateDto
     */
    actionCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    batteryStarted?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    batteryFinished?: number;
    /**
     * QR Code hit id for the session.
     * @type {QRCodeHitEntity}
     * @memberof SessionUpdateDto
     */
    qrCodeHit?: QRCodeHitEntity;
    /**
     * Source for the session
     * @type {SessionSourceDto}
     * @memberof SessionUpdateDto
     */
    source?: SessionSourceDto;
    /**
     * Variables that were entered during the session
     * @type {{ [key: string]: any; }}
     * @memberof SessionUpdateDto
     */
    variables?: { [key: string]: any; };
    /**
     * Client-side monotonic stamp (ms) of the state in this sync. A sync older than the stored stamp does not change gameplay state.
     * @type {number}
     * @memberof SessionUpdateDto
     */
    clientSyncedAt?: number;
    /**
     * Referral ID generated when user shares the story
     * @type {string}
     * @memberof SessionUpdateDto
     */
    shareRef?: string;
    /**
     * Incoming referral ID from URL parameter when session was started
     * @type {string}
     * @memberof SessionUpdateDto
     */
    incomingRef?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SessionUpdateDtoPlatformEnum {
    Ios = 'ios',
    Android = 'android',
    Web = 'web'
}

/**
 * 
 * @export
 * @interface SessionsRemoveVariablesDto
 */
export interface SessionsRemoveVariablesDto {
    /**
     * 
     * @type {string}
     * @memberof SessionsRemoveVariablesDto
     */
    beforeDate: string;
}
/**
 * 
 * @export
 * @interface SimpleOkResponse
 */
export interface SimpleOkResponse {
    /**
     * 
     * @type {string}
     * @memberof SimpleOkResponse
     */
    result: string;
}
/**
 * 
 * @export
 * @interface StatisticEntity
 */
export interface StatisticEntity {
    /**
     * 
     * @type {SessionEntity}
     * @memberof StatisticEntity
     */
    session: SessionEntity;
    /**
     * 
     * @type {SceneEntity}
     * @memberof StatisticEntity
     */
    scene: SceneEntity;
    /**
     * 
     * @type {string}
     * @memberof StatisticEntity
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof StatisticEntity
     */
    numberValue: number;
    /**
     * 
     * @type {string}
     * @memberof StatisticEntity
     */
    stringValue?: string;
    /**
     * 
     * @type {number}
     * @memberof StatisticEntity
     */
    index: number;
}
/**
 * 
 * @export
 * @interface TagEntity
 */
export interface TagEntity {
    /**
     * 
     * @type {string}
     * @memberof TagEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TagEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TagEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof TagEntity
     */
    updated?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TagEntity
     */
    articles?: Array<string>;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof TagEntity
     */
    company: CompanyEntity;
    /**
     * 
     * @type {Array<LanguageEntity>}
     * @memberof TagEntity
     */
    baseLanguage?: Array<LanguageEntity>;
    /**
     * 
     * @type {Array<TagTranslationEntity>}
     * @memberof TagEntity
     */
    translations?: Array<TagTranslationEntity>;
}
/**
 * 
 * @export
 * @interface TagTranslationEntity
 */
export interface TagTranslationEntity {
    /**
     * 
     * @type {TagEntity}
     * @memberof TagTranslationEntity
     */
    tag?: TagEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof TagTranslationEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {string}
     * @memberof TagTranslationEntity
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof TagTranslationEntity
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TagTranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof TagTranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface TemplateCategoryEntity
 */
export interface TemplateCategoryEntity {
    /**
     * 
     * @type {string}
     * @memberof TemplateCategoryEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateCategoryEntity
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof TemplateCategoryEntity
     */
    weight?: number;
    /**
     * 
     * @type {Array<TemplateEntity>}
     * @memberof TemplateCategoryEntity
     */
    templates?: Array<TemplateEntity>;
}
/**
 * 
 * @export
 * @interface TemplateEntity
 */
export interface TemplateEntity {
    /**
     * 
     * @type {string}
     * @memberof TemplateEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateEntity
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateEntity
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof TemplateEntity
     */
    weight?: number;
    /**
     * 
     * @type {GameEntity}
     * @memberof TemplateEntity
     */
    game?: GameEntity;
    /**
     * 
     * @type {TemplateCategoryEntity}
     * @memberof TemplateEntity
     */
    category?: TemplateCategoryEntity;
    /**
     * 
     * @type {Array<string>}
     * @memberof TemplateEntity
     */
    benefits?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TemplateEntity
     */
    characteristics?: Array<string>;
    /**
     * 
     * @type {Array<TemplateFlowStepDto>}
     * @memberof TemplateEntity
     */
    flowSteps?: Array<TemplateFlowStepDto>;
    /**
     * 
     * @type {number}
     * @memberof TemplateEntity
     */
    previewCount?: number;
}
/**
 * 
 * @export
 * @interface TemplateFlowStepDto
 */
export interface TemplateFlowStepDto {
    /**
     * 
     * @type {string}
     * @memberof TemplateFlowStepDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFlowStepDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFlowStepDto
     */
    imageType: TemplateFlowStepDtoImageTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TemplateFlowStepDtoImageTypeEnum {
    Hook = 'hook',
    Choice = 'choice',
    Form = 'form'
}

/**
 * 
 * @export
 * @interface ThemeEntity
 */
export interface ThemeEntity {
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    updated?: string;
    /**
     * 
     * @type {WhitelabelEntity}
     * @memberof ThemeEntity
     */
    whitelabel?: WhitelabelEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof ThemeEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {Array<LanguageEntity>}
     * @memberof ThemeEntity
     */
    baseLanguage?: Array<LanguageEntity>;
    /**
     * 
     * @type {Array<ThemeTranslationEntity>}
     * @memberof ThemeEntity
     */
    translations?: Array<ThemeTranslationEntity>;
}
/**
 * 
 * @export
 * @interface ThemeTranslationEntity
 */
export interface ThemeTranslationEntity {
    /**
     * 
     * @type {ThemeEntity}
     * @memberof ThemeTranslationEntity
     */
    theme?: ThemeEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof ThemeTranslationEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {string}
     * @memberof ThemeTranslationEntity
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThemeTranslationEntity
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThemeTranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeTranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface TrackingIdsDto
 */
export interface TrackingIdsDto {
    /**
     * 
     * @type {string}
     * @memberof TrackingIdsDto
     */
    ga4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingIdsDto
     */
    meta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingIdsDto
     */
    linkedin?: string | null;
}
/**
 * 
 * @export
 * @interface TranslatedItem
 */
export interface TranslatedItem {
    /**
     * The key matching the input item
     * @type {string}
     * @memberof TranslatedItem
     */
    key: string;
    /**
     * The translated text
     * @type {string}
     * @memberof TranslatedItem
     */
    translatedText: string;
}
/**
 * 
 * @export
 * @interface TranslationEntity
 */
export interface TranslationEntity {
    /**
     * 
     * @type {LanguageEntity}
     * @memberof TranslationEntity
     */
    language: LanguageEntity;
    /**
     * 
     * @type {TranslationTokenEntity}
     * @memberof TranslationEntity
     */
    translationToken: TranslationTokenEntity;
    /**
     * 
     * @type {string}
     * @memberof TranslationEntity
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface TranslationItem
 */
export interface TranslationItem {
    /**
     * Unique key to identify this text item
     * @type {string}
     * @memberof TranslationItem
     */
    key: string;
    /**
     * The text to translate
     * @type {string}
     * @memberof TranslationItem
     */
    text: string;
    /**
     * Where the text appears, e.g. \'button label in scene Intro\'
     * @type {string}
     * @memberof TranslationItem
     */
    hint?: string;
}
/**
 * 
 * @export
 * @interface TranslationTokenEntity
 */
export interface TranslationTokenEntity {
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    key: string;
    /**
     * 
     * @type {Array<TranslationEntity>}
     * @memberof TranslationTokenEntity
     */
    translations: Array<TranslationEntity>;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    firstUsedVersion: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    lastUsedVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    group: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface TwoFactorAuthDto
 */
export interface TwoFactorAuthDto {
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthDto
     */
    verifyId: string;
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthDto
     */
    code: string;
}
/**
 * 
 * @export
 * @interface TwoFactorEnableDto
 */
export interface TwoFactorEnableDto {
    /**
     * 
     * @type {string}
     * @memberof TwoFactorEnableDto
     */
    mfaPhone: string;
}
/**
 * 
 * @export
 * @interface TwoFactorResponseDto
 */
export interface TwoFactorResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TwoFactorResponseDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof TwoFactorResponseDto
     */
    verifyId: string;
}
/**
 * 
 * @export
 * @interface UpdateEventVariantDto
 */
export interface UpdateEventVariantDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEventVariantDto
     */
    demioEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventVariantDto
     */
    webinarGeekBroadcastId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventVariantDto
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventVariantDto
     */
    endDate?: string;
    /**
     * 
     * @type {EventLanguageTypeEnum}
     * @memberof UpdateEventVariantDto
     */
    eventLanguage?: EventLanguageTypeEnum;
}
/**
 * 
 * @export
 * @interface UpdateGameLanguageDto
 */
export interface UpdateGameLanguageDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateGameLanguageDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGameLanguageDto
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGameLanguageDto
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateGameLanguageDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateGameLanguageDto
     */
    regionalVariant?: string | null;
    /**
     * formal or informal; unset is auto
     * @type {string}
     * @memberof UpdateGameLanguageDto
     */
    formality?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateGameVariableDto
 */
export interface UpdateGameVariableDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateGameVariableDto
     */
    id: string;
    /**
     * 
     * @type {GameVariableTypeEnum}
     * @memberof UpdateGameVariableDto
     */
    type: GameVariableTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof UpdateGameVariableDto
     */
    defaultValue?: object;
}
/**
 * 
 * @export
 * @interface UpdateSeenGuidanceDto
 */
export interface UpdateSeenGuidanceDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSeenGuidanceDto
     */
    mark?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSeenGuidanceDto
     */
    unmark?: Array<string>;
}
/**
 * 
 * @export
 * @interface UserCompleteSetupDto
 */
export interface UserCompleteSetupDto {
    /**
     * 
     * @type {string}
     * @memberof UserCompleteSetupDto
     */
    departmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCompleteSetupDto
     */
    nickname?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserCompleteSetupDto
     */
    anonymous?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserCompleteSetupDto
     */
    locale?: string;
}
/**
 * 
 * @export
 * @interface UserCreateDto
 */
export interface UserCreateDto {
    /**
     * 
     * @type {string}
     * @memberof UserCreateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateDto
     */
    image?: string;
    /**
     * Minimum length of 12
     * @type {string}
     * @memberof UserCreateDto
     */
    password: string;
}
/**
 * 
 * @export
 * @interface UserEditAccount
 */
export interface UserEditAccount {
    /**
     * 
     * @type {string}
     * @memberof UserEditAccount
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEditAccount
     */
    nickname?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEditAccount
     */
    anonymous?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserEditAccount
     */
    phone?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof UserEditAccount
     */
    bio?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof UserEditAccount
     */
    storyEditor?: UserEditAccountStoryEditorEnum;
    /**
     * 
     * @type {string}
     * @memberof UserEditAccount
     */
    classicEditorUsedAt?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserEditAccountStoryEditorEnum {
    Canvas = 'canvas',
    Classic = 'classic'
}

/**
 * 
 * @export
 * @interface UserEditDto
 */
export interface UserEditDto {
    /**
     * 
     * @type {string}
     * @memberof UserEditDto
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEditDto
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEditDto
     */
    anonymous?: boolean;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof UserEditDto
     */
    bio?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof UserEditDto
     */
    locale?: string;
}
/**
 * 
 * @export
 * @interface UserEntity
 */
export interface UserEntity {
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    nickname?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    anonymous?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    mfaPhone?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof UserEntity
     */
    bio?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    acceptLanguage?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    activationPending?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    lastLogin?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    superAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    appleUserId?: string;
    /**
     * 
     * @type {Array<DivisionUserEntity>}
     * @memberof UserEntity
     */
    divisions?: Array<DivisionUserEntity>;
    /**
     * 
     * @type {Array<ArticleAnalyticsEntity>}
     * @memberof UserEntity
     */
    articleAnalytics?: Array<ArticleAnalyticsEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoAnalyticsEntity>}
     * @memberof UserEntity
     */
    onDemandVideoAnalytics?: Array<OnDemandVideoAnalyticsEntity>;
    /**
     * 
     * @type {Array<EventEntity>}
     * @memberof UserEntity
     */
    events?: Array<EventEntity>;
    /**
     * 
     * @type {Array<DivisionEntity>}
     * @memberof UserEntity
     */
    contactForDivisions?: Array<DivisionEntity>;
    /**
     * 
     * @type {Array<EventParticipantEntity>}
     * @memberof UserEntity
     */
    participations?: Array<EventParticipantEntity>;
    /**
     * Note: role is no longer a column on the entity, and is calculated by counting the AccessControl rules.When the user has more than one access control rule, he is considered a builder. Should only be used in the mobile app to decide wether or not to show developer options. 
     * @type {string}
     * @memberof UserEntity
     * @deprecated
     */
    role: UserEntityRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    twoFactorMethod?: UserEntityTwoFactorMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    nextAnalyticsMail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    restrictAccessByIPAddress?: boolean;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof UserEntity
     */
    activeDivision?: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    enterpriseSsoPolicy?: UserEntityEnterpriseSsoPolicyEnum;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    deprovisionDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    enterpriseSsoCompanyId?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof UserEntity
     */
    seenCanvasGuidance?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof UserEntity
     */
    seenPagesGuidance?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    storyEditor?: UserEntityStoryEditorEnum;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    classicEditorUsedAt?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserEntityRoleEnum {
    Client = 'client',
    Builder = 'builder'
}
/**
    * @export
    * @enum {string}
    */
export enum UserEntityTwoFactorMethodEnum {
    Sms = 'sms'
}
/**
    * @export
    * @enum {string}
    */
export enum UserEntityEnterpriseSsoPolicyEnum {
    Mandatory = 'mandatory',
    Optional = 'optional',
    Deprovisioned = 'deprovisioned'
}
/**
    * @export
    * @enum {string}
    */
export enum UserEntityStoryEditorEnum {
    Canvas = 'canvas',
    Classic = 'classic'
}

/**
 * 
 * @export
 * @interface UserRegisterDto
 */
export interface UserRegisterDto {
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    phone?: string;
    /**
     * Minimum length of 12
     * @type {string}
     * @memberof UserRegisterDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    organization: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    reference: string;
}
/**
 * 
 * @export
 * @interface UserRegisterWithTokenDto
 */
export interface UserRegisterWithTokenDto {
    /**
     * 
     * @type {string}
     * @memberof UserRegisterWithTokenDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterWithTokenDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterWithTokenDto
     */
    phone?: string;
    /**
     * Minimum length of 12
     * @type {string}
     * @memberof UserRegisterWithTokenDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterWithTokenDto
     */
    organization: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterWithTokenDto
     */
    reference: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterWithTokenDto
     */
    token: string;
}
/**
 * 
 * @export
 * @interface UserUpdateDto
 */
export interface UserUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    nickname?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateDto
     */
    anonymous?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    phone?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof UserUpdateDto
     */
    bio?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    acceptLanguage?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateDto
     */
    activationPending?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    lastLogin?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateDto
     */
    superAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    appleUserId?: string;
    /**
     * 
     * @type {Array<DivisionUserEntity>}
     * @memberof UserUpdateDto
     */
    divisions?: Array<DivisionUserEntity>;
    /**
     * 
     * @type {Array<ArticleAnalyticsEntity>}
     * @memberof UserUpdateDto
     */
    articleAnalytics?: Array<ArticleAnalyticsEntity>;
    /**
     * 
     * @type {Array<OnDemandVideoAnalyticsEntity>}
     * @memberof UserUpdateDto
     */
    onDemandVideoAnalytics?: Array<OnDemandVideoAnalyticsEntity>;
    /**
     * 
     * @type {Array<EventEntity>}
     * @memberof UserUpdateDto
     */
    events?: Array<EventEntity>;
    /**
     * 
     * @type {Array<DivisionEntity>}
     * @memberof UserUpdateDto
     */
    contactForDivisions?: Array<DivisionEntity>;
    /**
     * 
     * @type {Array<EventParticipantEntity>}
     * @memberof UserUpdateDto
     */
    participations?: Array<EventParticipantEntity>;
    /**
     * Note: role is no longer a column on the entity, and is calculated by counting the AccessControl rules.When the user has more than one access control rule, he is considered a builder. Should only be used in the mobile app to decide wether or not to show developer options. 
     * @type {string}
     * @memberof UserUpdateDto
     * @deprecated
     */
    role?: UserUpdateDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    nextAnalyticsMail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateDto
     */
    restrictAccessByIPAddress?: boolean;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof UserUpdateDto
     */
    activeDivision?: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    enterpriseSsoPolicy?: UserUpdateDtoEnterpriseSsoPolicyEnum;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    deprovisionDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    enterpriseSsoCompanyId?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof UserUpdateDto
     */
    seenCanvasGuidance?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof UserUpdateDto
     */
    seenPagesGuidance?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    storyEditor?: UserUpdateDtoStoryEditorEnum;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    classicEditorUsedAt?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserUpdateDtoRoleEnum {
    Client = 'client',
    Builder = 'builder'
}
/**
    * @export
    * @enum {string}
    */
export enum UserUpdateDtoEnterpriseSsoPolicyEnum {
    Mandatory = 'mandatory',
    Optional = 'optional',
    Deprovisioned = 'deprovisioned'
}
/**
    * @export
    * @enum {string}
    */
export enum UserUpdateDtoStoryEditorEnum {
    Canvas = 'canvas',
    Classic = 'classic'
}

/**
 * 
 * @export
 * @interface VerifyResetTokenDto
 */
export interface VerifyResetTokenDto {
    /**
     * 
     * @type {string}
     * @memberof VerifyResetTokenDto
     */
    token: string;
}
/**
 * 
 * @export
 * @interface VerifyResetTokenResponseDto
 */
export interface VerifyResetTokenResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyResetTokenResponseDto
     */
    ssoRequired: boolean;
    /**
     * 
     * @type {string}
     * @memberof VerifyResetTokenResponseDto
     */
    email?: string;
}
/**
 * 
 * @export
 * @interface VideoBGRemoverWebhookDto
 */
export interface VideoBGRemoverWebhookDto {
    /**
     * 
     * @type {string}
     * @memberof VideoBGRemoverWebhookDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VideoBGRemoverWebhookDto
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof VideoBGRemoverWebhookDto
     */
    progress: number;
    /**
     * 
     * @type {string}
     * @memberof VideoBGRemoverWebhookDto
     */
    output_url: string;
    /**
     * 
     * @type {object}
     * @memberof VideoBGRemoverWebhookDto
     */
    processed_video_url: object;
    /**
     * 
     * @type {string}
     * @memberof VideoBGRemoverWebhookDto
     */
    error: string;
    /**
     * 
     * @type {object}
     * @memberof VideoBGRemoverWebhookDto
     */
    message: object;
}
/**
 * 
 * @export
 * @interface WhitelabelEntity
 */
export interface WhitelabelEntity {
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    bundleId: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof WhitelabelEntity
     */
    contentTypeNames?: { [key: string]: string; };
    /**
     * 
     * @type {WhitelabelTypeEnum}
     * @memberof WhitelabelEntity
     */
    type: WhitelabelTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    updated?: string;
    /**
     * 
     * @type {Array<ThemeEntity>}
     * @memberof WhitelabelEntity
     */
    themes?: Array<ThemeEntity>;
    /**
     * 
     * @type {Array<MarkdownPageContentEntity>}
     * @memberof WhitelabelEntity
     */
    markdownPageContent?: Array<MarkdownPageContentEntity>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WhitelabelEntity
     */
    excludedElements?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    webDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    rootDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    linkingDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    authDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    senderName?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    senderEmail?: string;
    /**
     * The email address used as the organizer for calendar invites. If not set, senderEmail will be used instead.
     * @type {string}
     * @memberof WhitelabelEntity
     */
    senderEmailForCalendarInvites?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    passwordlessMailTemplate?: string;
    /**
     * The Brevo template of the confirmation e-mail that is sent when someone signs up for an event
     * @type {string}
     * @memberof WhitelabelEntity
     */
    eventConfirmation?: string;
    /**
     * The Brevo template of the reminder e-mail that is sent for events. (1 day in advance)
     * @type {string}
     * @memberof WhitelabelEntity
     */
    eventReminder?: string;
    /**
     * The Brevo template of the confirmation e-mail that is sent when someone signs up for an event, and they have been placed on the waiting list.
     * @type {string}
     * @memberof WhitelabelEntity
     */
    eventConfirmationSpot?: string;
    /**
     * The ID of the Brevo template that is sent when an event spot becomes available. A null value means that no mail will be sent for this Whitelabel
     * @type {string}
     * @memberof WhitelabelEntity
     */
    eventSpotTemplate?: string;
    /**
     * The ID of the Brevo template that is sent when a new account is invited. 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    invitedNewAccountTemplate?: string;
    /**
     * The ID of the Brevo template that is sent when a new account is invited. 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    invitedExistingAccountTemplate?: string;
    /**
     * The server for the Mailchimp API connection. If you define the Mailchimp settings, starting a new session will result in the user being added to Mailchimp list
     * @type {string}
     * @memberof WhitelabelEntity
     */
    mailchimpServer?: string;
    /**
     * The API key needed to connect to the Mailchimp API.
     * @type {string}
     * @memberof WhitelabelEntity
     */
    mailchimpApiKey?: string;
    /**
     * Wether this whitelabel forces authentication throughout all platform.
     * @type {boolean}
     * @memberof WhitelabelEntity
     */
    forceAuthentication?: boolean;
    /**
     * Wether billing is enabled on this whitelabel.
     * @type {boolean}
     * @memberof WhitelabelEntity
     */
    billingEnabled?: boolean;
    /**
     * The ID of the Mailchimp subscriber list where users get added to. Whenever a user starts a game, the game id will be added as a tag on that subscription.
     * @type {string}
     * @memberof WhitelabelEntity
     */
    mailchimpList?: string;
    /**
     * The API key needed to connect to the Brevo API.
     * @type {string}
     * @memberof WhitelabelEntity
     */
    brevoApiKey?: string;
    /**
     * The Brevo contact list that users get added to when signing up.
     * @type {string}
     * @memberof WhitelabelEntity
     */
    brevoList?: string;
    /**
     * The recipient mail address of various notification mails, such as feedback and reviews. 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    notificationRecipient?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WhitelabelTypeEnum {
    Geographic = 'geographic',
    Business = 'business',
    Learning = 'learning'
}


/**
 * AccessControlApi - axios parameter creator
 * @export
 */
export const AccessControlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Delete an access control rule
         * @param {string} resourceId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessControlRule: async (resourceId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            if (resourceId === null || resourceId === undefined) {
                throw new RequiredError('resourceId','Required parameter resourceId was null or undefined when calling deleteAccessControlRule.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling deleteAccessControlRule.');
            }
            const localVarPath = `/access-control/{resourceId}/{userId}`
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Get access control rules for given resource. Viewers get names only; `inherited` adds the grants above it that reach it.
         * @param {string} resourceType 
         * @param {string} resourceId 
         * @param {number} skip 
         * @param {number} take 
         * @param {boolean} [inherited] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessControlRules: async (resourceType: string, resourceId: string, skip: number, take: number, inherited?: boolean, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceType' is not null or undefined
            if (resourceType === null || resourceType === undefined) {
                throw new RequiredError('resourceType','Required parameter resourceType was null or undefined when calling getAccessControlRules.');
            }
            // verify required parameter 'resourceId' is not null or undefined
            if (resourceId === null || resourceId === undefined) {
                throw new RequiredError('resourceId','Required parameter resourceId was null or undefined when calling getAccessControlRules.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling getAccessControlRules.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling getAccessControlRules.');
            }
            const localVarPath = `/access-control/{resourceType}/{resourceId}`
                .replace(`{${"resourceType"}}`, encodeURIComponent(String(resourceType)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (inherited !== undefined) {
                localVarQueryParameter['inherited'] = inherited;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Get roles for currently logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRules: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/access-control`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Everyone with access inside an organization that the caller may see, the caller\'s own role at each grant, and where the caller may give access.
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisationMembers: async (companyId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling getOrganisationMembers.');
            }
            const localVarPath = `/access-control/company/{companyId}/members`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get access control rules for given userId
         * @param {string} userId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccessControl: async (userId: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling getUserAccessControl.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling getUserAccessControl.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling getUserAccessControl.');
            }
            const localVarPath = `/access-control/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Get the users that could be given access to a resource: with its type, those already in its organisation; without, everyone (superadmins only)
         * @param {string} resourceId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [resourceType] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAvailableUsers: async (resourceId: string, skip: number, take: number, resourceType?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            if (resourceId === null || resourceId === undefined) {
                throw new RequiredError('resourceId','Required parameter resourceId was null or undefined when calling paginateAvailableUsers.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateAvailableUsers.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateAvailableUsers.');
            }
            const localVarPath = `/access-control/{resourceId}/users`
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Create or update access control rule
         * @param {AccessControlEntity} accessControlEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAccessControlRule: async (accessControlEntity: AccessControlEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessControlEntity' is not null or undefined
            if (accessControlEntity === null || accessControlEntity === undefined) {
                throw new RequiredError('accessControlEntity','Required parameter accessControlEntity was null or undefined when calling putAccessControlRule.');
            }
            const localVarPath = `/access-control`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof accessControlEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(accessControlEntity !== undefined ? accessControlEntity : {}) : (accessControlEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessControlApi - functional programming interface
 * @export
 */
export const AccessControlApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Delete an access control rule
         * @param {string} resourceId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccessControlRule(resourceId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessControlEntity>> {
            const localVarAxiosArgs = await AccessControlApiAxiosParamCreator(configuration).deleteAccessControlRule(resourceId, userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Get access control rules for given resource. Viewers get names only; `inherited` adds the grants above it that reach it.
         * @param {string} resourceType 
         * @param {string} resourceId 
         * @param {number} skip 
         * @param {number} take 
         * @param {boolean} [inherited] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessControlRules(resourceType: string, resourceId: string, skip: number, take: number, inherited?: boolean, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccessControlEntity>>> {
            const localVarAxiosArgs = await AccessControlApiAxiosParamCreator(configuration).getAccessControlRules(resourceType, resourceId, skip, take, inherited, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Get roles for currently logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentRules(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccessControlEntity>>> {
            const localVarAxiosArgs = await AccessControlApiAxiosParamCreator(configuration).getCurrentRules(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Everyone with access inside an organization that the caller may see, the caller\'s own role at each grant, and where the caller may give access.
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganisationMembers(companyId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationMembersDto>> {
            const localVarAxiosArgs = await AccessControlApiAxiosParamCreator(configuration).getOrganisationMembers(companyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get access control rules for given userId
         * @param {string} userId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAccessControl(userId: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccessControlEntity>>> {
            const localVarAxiosArgs = await AccessControlApiAxiosParamCreator(configuration).getUserAccessControl(userId, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Get the users that could be given access to a resource: with its type, those already in its organisation; without, everyone (superadmins only)
         * @param {string} resourceId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [resourceType] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateAvailableUsers(resourceId: string, skip: number, take: number, resourceType?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEntity>>> {
            const localVarAxiosArgs = await AccessControlApiAxiosParamCreator(configuration).paginateAvailableUsers(resourceId, skip, take, resourceType, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Create or update access control rule
         * @param {AccessControlEntity} accessControlEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putAccessControlRule(accessControlEntity: AccessControlEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessControlEntity>> {
            const localVarAxiosArgs = await AccessControlApiAxiosParamCreator(configuration).putAccessControlRule(accessControlEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AccessControlApi - factory interface
 * @export
 */
export const AccessControlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Delete an access control rule
         * @param {string} resourceId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessControlRule(resourceId: string, userId: string, options?: any): AxiosPromise<AccessControlEntity> {
            return AccessControlApiFp(configuration).deleteAccessControlRule(resourceId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Get access control rules for given resource. Viewers get names only; `inherited` adds the grants above it that reach it.
         * @param {string} resourceType 
         * @param {string} resourceId 
         * @param {number} skip 
         * @param {number} take 
         * @param {boolean} [inherited] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessControlRules(resourceType: string, resourceId: string, skip: number, take: number, inherited?: boolean, keyword?: string, options?: any): AxiosPromise<Array<AccessControlEntity>> {
            return AccessControlApiFp(configuration).getAccessControlRules(resourceType, resourceId, skip, take, inherited, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Get roles for currently logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRules(options?: any): AxiosPromise<Array<AccessControlEntity>> {
            return AccessControlApiFp(configuration).getCurrentRules(options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Everyone with access inside an organization that the caller may see, the caller\'s own role at each grant, and where the caller may give access.
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganisationMembers(companyId: string, options?: any): AxiosPromise<OrganisationMembersDto> {
            return AccessControlApiFp(configuration).getOrganisationMembers(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get access control rules for given userId
         * @param {string} userId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccessControl(userId: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<AccessControlEntity>> {
            return AccessControlApiFp(configuration).getUserAccessControl(userId, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Get the users that could be given access to a resource: with its type, those already in its organisation; without, everyone (superadmins only)
         * @param {string} resourceId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [resourceType] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAvailableUsers(resourceId: string, skip: number, take: number, resourceType?: string, keyword?: string, options?: any): AxiosPromise<Array<UserEntity>> {
            return AccessControlApiFp(configuration).paginateAvailableUsers(resourceId, skip, take, resourceType, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Create or update access control rule
         * @param {AccessControlEntity} accessControlEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAccessControlRule(accessControlEntity: AccessControlEntity, options?: any): AxiosPromise<AccessControlEntity> {
            return AccessControlApiFp(configuration).putAccessControlRule(accessControlEntity, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccessControlApi - object-oriented interface
 * @export
 * @class AccessControlApi
 * @extends {BaseAPI}
 */
export class AccessControlApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
     * @summary Delete an access control rule
     * @param {string} resourceId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessControlApi
     */
    public deleteAccessControlRule(resourceId: string, userId: string, options?: any) {
        return AccessControlApiFp(this.configuration).deleteAccessControlRule(resourceId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
     * @summary Get access control rules for given resource. Viewers get names only; `inherited` adds the grants above it that reach it.
     * @param {string} resourceType 
     * @param {string} resourceId 
     * @param {number} skip 
     * @param {number} take 
     * @param {boolean} [inherited] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessControlApi
     */
    public getAccessControlRules(resourceType: string, resourceId: string, skip: number, take: number, inherited?: boolean, keyword?: string, options?: any) {
        return AccessControlApiFp(this.configuration).getAccessControlRules(resourceType, resourceId, skip, take, inherited, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
     * @summary Get roles for currently logged in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessControlApi
     */
    public getCurrentRules(options?: any) {
        return AccessControlApiFp(this.configuration).getCurrentRules(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
     * @summary Everyone with access inside an organization that the caller may see, the caller\'s own role at each grant, and where the caller may give access.
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessControlApi
     */
    public getOrganisationMembers(companyId: string, options?: any) {
        return AccessControlApiFp(this.configuration).getOrganisationMembers(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get access control rules for given userId
     * @param {string} userId 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessControlApi
     */
    public getUserAccessControl(userId: string, skip: number, take: number, keyword?: string, options?: any) {
        return AccessControlApiFp(this.configuration).getUserAccessControl(userId, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
     * @summary Get the users that could be given access to a resource: with its type, those already in its organisation; without, everyone (superadmins only)
     * @param {string} resourceId 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [resourceType] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessControlApi
     */
    public paginateAvailableUsers(resourceId: string, skip: number, take: number, resourceType?: string, keyword?: string, options?: any) {
        return AccessControlApiFp(this.configuration).paginateAvailableUsers(resourceId, skip, take, resourceType, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
     * @summary Create or update access control rule
     * @param {AccessControlEntity} accessControlEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessControlApi
     */
    public putAccessControlRule(accessControlEntity: AccessControlEntity, options?: any) {
        return AccessControlApiFp(this.configuration).putAccessControlRule(accessControlEntity, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ArticleApi - axios parameter creator
 * @export
 */
export const ArticleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new articles
         * @param {ArticleEntity} articleEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArticle: async (articleEntity: ArticleEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleEntity' is not null or undefined
            if (articleEntity === null || articleEntity === undefined) {
                throw new RequiredError('articleEntity','Required parameter articleEntity was null or undefined when calling createArticle.');
            }
            const localVarPath = `/builder/article`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof articleEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(articleEntity !== undefined ? articleEntity : {}) : (articleEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       |  | division     | editor       | 
         * @summary Delete article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticle: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteArticle.');
            }
            const localVarPath = `/builder/article/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get base language of Article
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleBaseLanguage: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getArticleBaseLanguage.');
            }
            const localVarPath = `/builder/article/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getArticleById.');
            }
            const localVarPath = `/builder/article/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get article QR Code for division
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleQR: async (id: string, divisionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getArticleQR.');
            }
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getArticleQR.');
            }
            const localVarPath = `/builder/article/{id}/division/{divisionId}/qr`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Get full translation of Article
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleTranslation: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getArticleTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling getArticleTranslation.');
            }
            const localVarPath = `/builder/article/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Get all translations of Article without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleTranslations: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getArticleTranslations.');
            }
            const localVarPath = `/builder/article/{id}/translation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Remove translation of Article
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeArticleTranslation: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeArticleTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling removeArticleTranslation.');
            }
            const localVarPath = `/builder/article/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Set base language of Article
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setArticleBaseLanguage: async (id: string, baseLanguageDto: BaseLanguageDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setArticleBaseLanguage.');
            }
            // verify required parameter 'baseLanguageDto' is not null or undefined
            if (baseLanguageDto === null || baseLanguageDto === undefined) {
                throw new RequiredError('baseLanguageDto','Required parameter baseLanguageDto was null or undefined when calling setArticleBaseLanguage.');
            }
            const localVarPath = `/builder/article/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof baseLanguageDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(baseLanguageDto !== undefined ? baseLanguageDto : {}) : (baseLanguageDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Update article by id (partial update)
         * @param {string} id 
         * @param {ArticleEntity} articleEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticle: async (id: string, articleEntity: ArticleEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateArticle.');
            }
            // verify required parameter 'articleEntity' is not null or undefined
            if (articleEntity === null || articleEntity === undefined) {
                throw new RequiredError('articleEntity','Required parameter articleEntity was null or undefined when calling updateArticle.');
            }
            const localVarPath = `/builder/article/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof articleEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(articleEntity !== undefined ? articleEntity : {}) : (articleEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Update translations of Article
         * @param {string} id 
         * @param {string} language 
         * @param {ArticleTranslationEntity} articleTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticleTranslation: async (id: string, language: string, articleTranslationEntity: ArticleTranslationEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateArticleTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling updateArticleTranslation.');
            }
            // verify required parameter 'articleTranslationEntity' is not null or undefined
            if (articleTranslationEntity === null || articleTranslationEntity === undefined) {
                throw new RequiredError('articleTranslationEntity','Required parameter articleTranslationEntity was null or undefined when calling updateArticleTranslation.');
            }
            const localVarPath = `/builder/article/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof articleTranslationEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(articleTranslationEntity !== undefined ? articleTranslationEntity : {}) : (articleTranslationEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArticleApi - functional programming interface
 * @export
 */
export const ArticleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new articles
         * @param {ArticleEntity} articleEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createArticle(articleEntity: ArticleEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleEntity>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).createArticle(articleEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       |  | division     | editor       | 
         * @summary Delete article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteArticle(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleEntity>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).deleteArticle(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get base language of Article
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleBaseLanguage(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseLanguageDto>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).getArticleBaseLanguage(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleEntity>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).getArticleById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get article QR Code for division
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleQR(id: string, divisionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrDto>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).getArticleQR(id, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Get full translation of Article
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleTranslation(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArticleTranslationEntity>>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).getArticleTranslation(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Get all translations of Article without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleTranslations(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArticleTranslationEntity>>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).getArticleTranslations(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Remove translation of Article
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeArticleTranslation(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).removeArticleTranslation(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Set base language of Article
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setArticleBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleEntity>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).setArticleBaseLanguage(id, baseLanguageDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Update article by id (partial update)
         * @param {string} id 
         * @param {ArticleEntity} articleEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArticle(id: string, articleEntity: ArticleEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleEntity>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).updateArticle(id, articleEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Update translations of Article
         * @param {string} id 
         * @param {string} language 
         * @param {ArticleTranslationEntity} articleTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArticleTranslation(id: string, language: string, articleTranslationEntity: ArticleTranslationEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleTranslationEntity>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).updateArticleTranslation(id, language, articleTranslationEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ArticleApi - factory interface
 * @export
 */
export const ArticleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new articles
         * @param {ArticleEntity} articleEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArticle(articleEntity: ArticleEntity, options?: any): AxiosPromise<ArticleEntity> {
            return ArticleApiFp(configuration).createArticle(articleEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       |  | division     | editor       | 
         * @summary Delete article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticle(id: string, options?: any): AxiosPromise<ArticleEntity> {
            return ArticleApiFp(configuration).deleteArticle(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get base language of Article
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleBaseLanguage(id: string, options?: any): AxiosPromise<BaseLanguageDto> {
            return ArticleApiFp(configuration).getArticleBaseLanguage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleById(id: string, options?: any): AxiosPromise<ArticleEntity> {
            return ArticleApiFp(configuration).getArticleById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get article QR Code for division
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleQR(id: string, divisionId: string, options?: any): AxiosPromise<QrDto> {
            return ArticleApiFp(configuration).getArticleQR(id, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Get full translation of Article
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleTranslation(id: string, language: string, options?: any): AxiosPromise<Array<ArticleTranslationEntity>> {
            return ArticleApiFp(configuration).getArticleTranslation(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Get all translations of Article without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleTranslations(id: string, options?: any): AxiosPromise<Array<ArticleTranslationEntity>> {
            return ArticleApiFp(configuration).getArticleTranslations(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Remove translation of Article
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeArticleTranslation(id: string, language: string, options?: any): AxiosPromise<void> {
            return ArticleApiFp(configuration).removeArticleTranslation(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Set base language of Article
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setArticleBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any): AxiosPromise<ArticleEntity> {
            return ArticleApiFp(configuration).setArticleBaseLanguage(id, baseLanguageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Update article by id (partial update)
         * @param {string} id 
         * @param {ArticleEntity} articleEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticle(id: string, articleEntity: ArticleEntity, options?: any): AxiosPromise<ArticleEntity> {
            return ArticleApiFp(configuration).updateArticle(id, articleEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
         * @summary Update translations of Article
         * @param {string} id 
         * @param {string} language 
         * @param {ArticleTranslationEntity} articleTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticleTranslation(id: string, language: string, articleTranslationEntity: ArticleTranslationEntity, options?: any): AxiosPromise<ArticleTranslationEntity> {
            return ArticleApiFp(configuration).updateArticleTranslation(id, language, articleTranslationEntity, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArticleApi - object-oriented interface
 * @export
 * @class ArticleApi
 * @extends {BaseAPI}
 */
export class ArticleApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
     * @summary Create new articles
     * @param {ArticleEntity} articleEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public createArticle(articleEntity: ArticleEntity, options?: any) {
        return ArticleApiFp(this.configuration).createArticle(articleEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       |  | division     | editor       | 
     * @summary Delete article by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public deleteArticle(id: string, options?: any) {
        return ArticleApiFp(this.configuration).deleteArticle(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
     * @summary Get base language of Article
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public getArticleBaseLanguage(id: string, options?: any) {
        return ArticleApiFp(this.configuration).getArticleBaseLanguage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
     * @summary Get article by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public getArticleById(id: string, options?: any) {
        return ArticleApiFp(this.configuration).getArticleById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
     * @summary Get article QR Code for division
     * @param {string} id 
     * @param {string} divisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public getArticleQR(id: string, divisionId: string, options?: any) {
        return ArticleApiFp(this.configuration).getArticleQR(id, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
     * @summary Get full translation of Article
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public getArticleTranslation(id: string, language: string, options?: any) {
        return ArticleApiFp(this.configuration).getArticleTranslation(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
     * @summary Get all translations of Article without data
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public getArticleTranslations(id: string, options?: any) {
        return ArticleApiFp(this.configuration).getArticleTranslations(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
     * @summary Remove translation of Article
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public removeArticleTranslation(id: string, language: string, options?: any) {
        return ArticleApiFp(this.configuration).removeArticleTranslation(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
     * @summary Set base language of Article
     * @param {string} id 
     * @param {BaseLanguageDto} baseLanguageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public setArticleBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any) {
        return ArticleApiFp(this.configuration).setArticleBaseLanguage(id, baseLanguageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
     * @summary Update article by id (partial update)
     * @param {string} id 
     * @param {ArticleEntity} articleEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public updateArticle(id: string, articleEntity: ArticleEntity, options?: any) {
        return ArticleApiFp(this.configuration).updateArticle(id, articleEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | editor       | 
     * @summary Update translations of Article
     * @param {string} id 
     * @param {string} language 
     * @param {ArticleTranslationEntity} articleTranslationEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public updateArticleTranslation(id: string, language: string, articleTranslationEntity: ArticleTranslationEntity, options?: any) {
        return ArticleApiFp(this.configuration).updateArticleTranslation(id, language, articleTranslationEntity, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ArticleGroupApi - axios parameter creator
 * @export
 */
export const ArticleGroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new articles
         * @param {ArticleGroupEntity} articleGroupEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArticleGroup: async (articleGroupEntity: ArticleGroupEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleGroupEntity' is not null or undefined
            if (articleGroupEntity === null || articleGroupEntity === undefined) {
                throw new RequiredError('articleGroupEntity','Required parameter articleGroupEntity was null or undefined when calling createArticleGroup.');
            }
            const localVarPath = `/builder/article-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof articleGroupEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(articleGroupEntity !== undefined ? articleGroupEntity : {}) : (articleGroupEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Delete article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticleGroup: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteArticleGroup.');
            }
            const localVarPath = `/builder/article-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleGroupById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getArticleGroupById.');
            }
            const localVarPath = `/builder/article-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article_group | editor       | 
         * @summary Update article by id (partial update)
         * @param {string} id 
         * @param {ArticleGroupEntity} articleGroupEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticleGroup: async (id: string, articleGroupEntity: ArticleGroupEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateArticleGroup.');
            }
            // verify required parameter 'articleGroupEntity' is not null or undefined
            if (articleGroupEntity === null || articleGroupEntity === undefined) {
                throw new RequiredError('articleGroupEntity','Required parameter articleGroupEntity was null or undefined when calling updateArticleGroup.');
            }
            const localVarPath = `/builder/article-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof articleGroupEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(articleGroupEntity !== undefined ? articleGroupEntity : {}) : (articleGroupEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArticleGroupApi - functional programming interface
 * @export
 */
export const ArticleGroupApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new articles
         * @param {ArticleGroupEntity} articleGroupEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createArticleGroup(articleGroupEntity: ArticleGroupEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleGroupEntity>> {
            const localVarAxiosArgs = await ArticleGroupApiAxiosParamCreator(configuration).createArticleGroup(articleGroupEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Delete article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteArticleGroup(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleGroupEntity>> {
            const localVarAxiosArgs = await ArticleGroupApiAxiosParamCreator(configuration).deleteArticleGroup(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleGroupById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleGroupEntity>> {
            const localVarAxiosArgs = await ArticleGroupApiAxiosParamCreator(configuration).getArticleGroupById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article_group | editor       | 
         * @summary Update article by id (partial update)
         * @param {string} id 
         * @param {ArticleGroupEntity} articleGroupEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArticleGroup(id: string, articleGroupEntity: ArticleGroupEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleGroupEntity>> {
            const localVarAxiosArgs = await ArticleGroupApiAxiosParamCreator(configuration).updateArticleGroup(id, articleGroupEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ArticleGroupApi - factory interface
 * @export
 */
export const ArticleGroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new articles
         * @param {ArticleGroupEntity} articleGroupEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArticleGroup(articleGroupEntity: ArticleGroupEntity, options?: any): AxiosPromise<ArticleGroupEntity> {
            return ArticleGroupApiFp(configuration).createArticleGroup(articleGroupEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Delete article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticleGroup(id: string, options?: any): AxiosPromise<ArticleGroupEntity> {
            return ArticleGroupApiFp(configuration).deleteArticleGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
         * @summary Get article by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleGroupById(id: string, options?: any): AxiosPromise<ArticleGroupEntity> {
            return ArticleGroupApiFp(configuration).getArticleGroupById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article_group | editor       | 
         * @summary Update article by id (partial update)
         * @param {string} id 
         * @param {ArticleGroupEntity} articleGroupEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticleGroup(id: string, articleGroupEntity: ArticleGroupEntity, options?: any): AxiosPromise<ArticleGroupEntity> {
            return ArticleGroupApiFp(configuration).updateArticleGroup(id, articleGroupEntity, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArticleGroupApi - object-oriented interface
 * @export
 * @class ArticleGroupApi
 * @extends {BaseAPI}
 */
export class ArticleGroupApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
     * @summary Create new articles
     * @param {ArticleGroupEntity} articleGroupEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleGroupApi
     */
    public createArticleGroup(articleGroupEntity: ArticleGroupEntity, options?: any) {
        return ArticleGroupApiFp(this.configuration).createArticleGroup(articleGroupEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
     * @summary Delete article by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleGroupApi
     */
    public deleteArticleGroup(id: string, options?: any) {
        return ArticleGroupApiFp(this.configuration).deleteArticleGroup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article      | viewer       | 
     * @summary Get article by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleGroupApi
     */
    public getArticleGroupById(id: string, options?: any) {
        return ArticleGroupApiFp(this.configuration).getArticleGroupById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | article_group | editor       | 
     * @summary Update article by id (partial update)
     * @param {string} id 
     * @param {ArticleGroupEntity} articleGroupEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleGroupApi
     */
    public updateArticleGroup(id: string, articleGroupEntity: ArticleGroupEntity, options?: any) {
        return ArticleGroupApiFp(this.configuration).updateArticleGroup(id, articleGroupEntity, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BrandkitApi - axios parameter creator
 * @export
 */
export const BrandkitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Clear default brandkit for division
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearDefaultBrandkit: async (divisionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling clearDefaultBrandkit.');
            }
            const localVarPath = `/builder/divisions/{divisionId}/brandkits/default`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Create new brandkit
         * @param {string} divisionId 
         * @param {BrandkitCreateDto} brandkitCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandkit: async (divisionId: string, brandkitCreateDto: BrandkitCreateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling createBrandkit.');
            }
            // verify required parameter 'brandkitCreateDto' is not null or undefined
            if (brandkitCreateDto === null || brandkitCreateDto === undefined) {
                throw new RequiredError('brandkitCreateDto','Required parameter brandkitCreateDto was null or undefined when calling createBrandkit.');
            }
            const localVarPath = `/builder/divisions/{divisionId}/brandkits`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof brandkitCreateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(brandkitCreateDto !== undefined ? brandkitCreateDto : {}) : (brandkitCreateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Delete brandkit by id
         * @param {string} divisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandkit: async (divisionId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling deleteBrandkit.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteBrandkit.');
            }
            const localVarPath = `/builder/divisions/{divisionId}/brandkits/{id}`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get brandkit by id
         * @param {string} divisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandkitById: async (divisionId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getBrandkitById.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getBrandkitById.');
            }
            const localVarPath = `/builder/divisions/{divisionId}/brandkits/{id}`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary List all brandkits for a division
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBrandkits: async (divisionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling listBrandkits.');
            }
            const localVarPath = `/builder/divisions/{divisionId}/brandkits`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Set brandkit as default for division
         * @param {string} divisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultBrandkit: async (divisionId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling setDefaultBrandkit.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setDefaultBrandkit.');
            }
            const localVarPath = `/builder/divisions/{divisionId}/brandkits/{id}/default`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Update brandkit by id
         * @param {string} divisionId 
         * @param {string} id 
         * @param {BrandkitUpdateDto} brandkitUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandkit: async (divisionId: string, id: string, brandkitUpdateDto: BrandkitUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling updateBrandkit.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateBrandkit.');
            }
            // verify required parameter 'brandkitUpdateDto' is not null or undefined
            if (brandkitUpdateDto === null || brandkitUpdateDto === undefined) {
                throw new RequiredError('brandkitUpdateDto','Required parameter brandkitUpdateDto was null or undefined when calling updateBrandkit.');
            }
            const localVarPath = `/builder/divisions/{divisionId}/brandkits/{id}`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof brandkitUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(brandkitUpdateDto !== undefined ? brandkitUpdateDto : {}) : (brandkitUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandkitApi - functional programming interface
 * @export
 */
export const BrandkitApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Clear default brandkit for division
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearDefaultBrandkit(divisionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await BrandkitApiAxiosParamCreator(configuration).clearDefaultBrandkit(divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Create new brandkit
         * @param {string} divisionId 
         * @param {BrandkitCreateDto} brandkitCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBrandkit(divisionId: string, brandkitCreateDto: BrandkitCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandkitEntity>> {
            const localVarAxiosArgs = await BrandkitApiAxiosParamCreator(configuration).createBrandkit(divisionId, brandkitCreateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Delete brandkit by id
         * @param {string} divisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBrandkit(divisionId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandkitEntity>> {
            const localVarAxiosArgs = await BrandkitApiAxiosParamCreator(configuration).deleteBrandkit(divisionId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get brandkit by id
         * @param {string} divisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandkitById(divisionId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandkitEntity>> {
            const localVarAxiosArgs = await BrandkitApiAxiosParamCreator(configuration).getBrandkitById(divisionId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary List all brandkits for a division
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBrandkits(divisionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandkitEntity>>> {
            const localVarAxiosArgs = await BrandkitApiAxiosParamCreator(configuration).listBrandkits(divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Set brandkit as default for division
         * @param {string} divisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDefaultBrandkit(divisionId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandkitEntity>> {
            const localVarAxiosArgs = await BrandkitApiAxiosParamCreator(configuration).setDefaultBrandkit(divisionId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Update brandkit by id
         * @param {string} divisionId 
         * @param {string} id 
         * @param {BrandkitUpdateDto} brandkitUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBrandkit(divisionId: string, id: string, brandkitUpdateDto: BrandkitUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandkitEntity>> {
            const localVarAxiosArgs = await BrandkitApiAxiosParamCreator(configuration).updateBrandkit(divisionId, id, brandkitUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BrandkitApi - factory interface
 * @export
 */
export const BrandkitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Clear default brandkit for division
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearDefaultBrandkit(divisionId: string, options?: any): AxiosPromise<void> {
            return BrandkitApiFp(configuration).clearDefaultBrandkit(divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Create new brandkit
         * @param {string} divisionId 
         * @param {BrandkitCreateDto} brandkitCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandkit(divisionId: string, brandkitCreateDto: BrandkitCreateDto, options?: any): AxiosPromise<BrandkitEntity> {
            return BrandkitApiFp(configuration).createBrandkit(divisionId, brandkitCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Delete brandkit by id
         * @param {string} divisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandkit(divisionId: string, id: string, options?: any): AxiosPromise<BrandkitEntity> {
            return BrandkitApiFp(configuration).deleteBrandkit(divisionId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get brandkit by id
         * @param {string} divisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandkitById(divisionId: string, id: string, options?: any): AxiosPromise<BrandkitEntity> {
            return BrandkitApiFp(configuration).getBrandkitById(divisionId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary List all brandkits for a division
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBrandkits(divisionId: string, options?: any): AxiosPromise<Array<BrandkitEntity>> {
            return BrandkitApiFp(configuration).listBrandkits(divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Set brandkit as default for division
         * @param {string} divisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultBrandkit(divisionId: string, id: string, options?: any): AxiosPromise<BrandkitEntity> {
            return BrandkitApiFp(configuration).setDefaultBrandkit(divisionId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Update brandkit by id
         * @param {string} divisionId 
         * @param {string} id 
         * @param {BrandkitUpdateDto} brandkitUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandkit(divisionId: string, id: string, brandkitUpdateDto: BrandkitUpdateDto, options?: any): AxiosPromise<BrandkitEntity> {
            return BrandkitApiFp(configuration).updateBrandkit(divisionId, id, brandkitUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandkitApi - object-oriented interface
 * @export
 * @class BrandkitApi
 * @extends {BaseAPI}
 */
export class BrandkitApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Clear default brandkit for division
     * @param {string} divisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandkitApi
     */
    public clearDefaultBrandkit(divisionId: string, options?: any) {
        return BrandkitApiFp(this.configuration).clearDefaultBrandkit(divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Create new brandkit
     * @param {string} divisionId 
     * @param {BrandkitCreateDto} brandkitCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandkitApi
     */
    public createBrandkit(divisionId: string, brandkitCreateDto: BrandkitCreateDto, options?: any) {
        return BrandkitApiFp(this.configuration).createBrandkit(divisionId, brandkitCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Delete brandkit by id
     * @param {string} divisionId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandkitApi
     */
    public deleteBrandkit(divisionId: string, id: string, options?: any) {
        return BrandkitApiFp(this.configuration).deleteBrandkit(divisionId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Get brandkit by id
     * @param {string} divisionId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandkitApi
     */
    public getBrandkitById(divisionId: string, id: string, options?: any) {
        return BrandkitApiFp(this.configuration).getBrandkitById(divisionId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary List all brandkits for a division
     * @param {string} divisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandkitApi
     */
    public listBrandkits(divisionId: string, options?: any) {
        return BrandkitApiFp(this.configuration).listBrandkits(divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Set brandkit as default for division
     * @param {string} divisionId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandkitApi
     */
    public setDefaultBrandkit(divisionId: string, id: string, options?: any) {
        return BrandkitApiFp(this.configuration).setDefaultBrandkit(divisionId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Update brandkit by id
     * @param {string} divisionId 
     * @param {string} id 
     * @param {BrandkitUpdateDto} brandkitUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandkitApi
     */
    public updateBrandkit(divisionId: string, id: string, brandkitUpdateDto: BrandkitUpdateDto, options?: any) {
        return BrandkitApiFp(this.configuration).updateBrandkit(divisionId, id, brandkitUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BrandkitToolsApi - axios parameter creator
 * @export
 */
export const BrandkitToolsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Extract brand colors from a website URL
         * @param {BrandkitExtractRequestDto} brandkitExtractRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractBrandkitColors: async (brandkitExtractRequestDto: BrandkitExtractRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandkitExtractRequestDto' is not null or undefined
            if (brandkitExtractRequestDto === null || brandkitExtractRequestDto === undefined) {
                throw new RequiredError('brandkitExtractRequestDto','Required parameter brandkitExtractRequestDto was null or undefined when calling extractBrandkitColors.');
            }
            const localVarPath = `/builder/brandkit/tools/extract`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof brandkitExtractRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(brandkitExtractRequestDto !== undefined ? brandkitExtractRequestDto : {}) : (brandkitExtractRequestDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Generate color palettes from a primary brand color using AI
         * @param {BrandkitGeneratePaletteRequestDto} brandkitGeneratePaletteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBrandkitPalette: async (brandkitGeneratePaletteRequestDto: BrandkitGeneratePaletteRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandkitGeneratePaletteRequestDto' is not null or undefined
            if (brandkitGeneratePaletteRequestDto === null || brandkitGeneratePaletteRequestDto === undefined) {
                throw new RequiredError('brandkitGeneratePaletteRequestDto','Required parameter brandkitGeneratePaletteRequestDto was null or undefined when calling generateBrandkitPalette.');
            }
            const localVarPath = `/builder/brandkit/tools/generate-palette`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof brandkitGeneratePaletteRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(brandkitGeneratePaletteRequestDto !== undefined ? brandkitGeneratePaletteRequestDto : {}) : (brandkitGeneratePaletteRequestDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandkitToolsApi - functional programming interface
 * @export
 */
export const BrandkitToolsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Extract brand colors from a website URL
         * @param {BrandkitExtractRequestDto} brandkitExtractRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extractBrandkitColors(brandkitExtractRequestDto: BrandkitExtractRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandkitExtractResponseDto>> {
            const localVarAxiosArgs = await BrandkitToolsApiAxiosParamCreator(configuration).extractBrandkitColors(brandkitExtractRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Generate color palettes from a primary brand color using AI
         * @param {BrandkitGeneratePaletteRequestDto} brandkitGeneratePaletteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateBrandkitPalette(brandkitGeneratePaletteRequestDto: BrandkitGeneratePaletteRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandkitGeneratePaletteResponseDto>> {
            const localVarAxiosArgs = await BrandkitToolsApiAxiosParamCreator(configuration).generateBrandkitPalette(brandkitGeneratePaletteRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BrandkitToolsApi - factory interface
 * @export
 */
export const BrandkitToolsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Extract brand colors from a website URL
         * @param {BrandkitExtractRequestDto} brandkitExtractRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractBrandkitColors(brandkitExtractRequestDto: BrandkitExtractRequestDto, options?: any): AxiosPromise<BrandkitExtractResponseDto> {
            return BrandkitToolsApiFp(configuration).extractBrandkitColors(brandkitExtractRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Generate color palettes from a primary brand color using AI
         * @param {BrandkitGeneratePaletteRequestDto} brandkitGeneratePaletteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBrandkitPalette(brandkitGeneratePaletteRequestDto: BrandkitGeneratePaletteRequestDto, options?: any): AxiosPromise<BrandkitGeneratePaletteResponseDto> {
            return BrandkitToolsApiFp(configuration).generateBrandkitPalette(brandkitGeneratePaletteRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandkitToolsApi - object-oriented interface
 * @export
 * @class BrandkitToolsApi
 * @extends {BaseAPI}
 */
export class BrandkitToolsApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
     * @summary Extract brand colors from a website URL
     * @param {BrandkitExtractRequestDto} brandkitExtractRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandkitToolsApi
     */
    public extractBrandkitColors(brandkitExtractRequestDto: BrandkitExtractRequestDto, options?: any) {
        return BrandkitToolsApiFp(this.configuration).extractBrandkitColors(brandkitExtractRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
     * @summary Generate color palettes from a primary brand color using AI
     * @param {BrandkitGeneratePaletteRequestDto} brandkitGeneratePaletteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandkitToolsApi
     */
    public generateBrandkitPalette(brandkitGeneratePaletteRequestDto: BrandkitGeneratePaletteRequestDto, options?: any) {
        return BrandkitToolsApiFp(this.configuration).generateBrandkitPalette(brandkitGeneratePaletteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ClientPrivateApi - axios parameter creator
 * @export
 */
export const ClientPrivateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authStatus: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move the current user\'s upcoming registration to another session of the event.
         * @param {string} eventId 
         * @param {string} [variantId] The target session: a variant id, or \&quot;main\&quot; for the event\&#39;s own date (the default).
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientChangeEventParticipation: async (eventId: string, variantId?: string, divisionId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling clientChangeEventParticipation.');
            }
            const localVarPath = `/client/event/{eventId}/changeParticipation`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (variantId !== undefined) {
                localVarQueryParameter['variantId'] = variantId;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an event.
         * @param {string} divisionId 
         * @param {EventCreateDto} eventCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateEvent: async (divisionId: string, eventCreateDto: EventCreateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling clientCreateEvent.');
            }
            // verify required parameter 'eventCreateDto' is not null or undefined
            if (eventCreateDto === null || eventCreateDto === undefined) {
                throw new RequiredError('eventCreateDto','Required parameter eventCreateDto was null or undefined when calling clientCreateEvent.');
            }
            const localVarPath = `/client/division/{divisionId}/event`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof eventCreateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(eventCreateDto !== undefined ? eventCreateDto : {}) : (eventCreateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invalidates the currently used Accesstoken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientLogout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Participate in event for current user.
         * @param {string} eventId 
         * @param {string} [variantId] Optional variant ID to participate in a specific variant
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientParticipateEvent: async (eventId: string, variantId?: string, divisionId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling clientParticipateEvent.');
            }
            const localVarPath = `/client/event/{eventId}/participate`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (variantId !== undefined) {
                localVarQueryParameter['variantId'] = variantId;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove participation from event for current user.
         * @param {string} eventId 
         * @param {string} [variantId] The session to cancel: a variant id, or \&quot;main\&quot; for the event\&#39;s own date. Omitted, the upcoming registration is cancelled (else the latest one).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUnparticipateEvent: async (eventId: string, variantId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling clientUnparticipateEvent.');
            }
            const localVarPath = `/client/event/{eventId}/unparticipate`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (variantId !== undefined) {
                localVarQueryParameter['variantId'] = variantId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an event.
         * @param {string} eventId 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUpdateEvent: async (eventId: string, eventUpdateDto: EventUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling clientUpdateEvent.');
            }
            // verify required parameter 'eventUpdateDto' is not null or undefined
            if (eventUpdateDto === null || eventUpdateDto === undefined) {
                throw new RequiredError('eventUpdateDto','Required parameter eventUpdateDto was null or undefined when calling clientUpdateEvent.');
            }
            const localVarPath = `/client/event/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof eventUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(eventUpdateDto !== undefined ? eventUpdateDto : {}) : (eventUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete account setup
         * @param {UserCompleteSetupDto} userCompleteSetupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAccountSetup: async (userCompleteSetupDto: UserCompleteSetupDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userCompleteSetupDto' is not null or undefined
            if (userCompleteSetupDto === null || userCompleteSetupDto === undefined) {
                throw new RequiredError('userCompleteSetupDto','Required parameter userCompleteSetupDto was null or undefined when calling completeAccountSetup.');
            }
            const localVarPath = `/client/complete-account-setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userCompleteSetupDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userCompleteSetupDto !== undefined ? userCompleteSetupDto : {}) : (userCompleteSetupDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionAuthStatus: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling divisionAuthStatus.');
            }
            const localVarPath = `/client/division/{id}/auth`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUrl: async (downloadDto: DownloadDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadDto' is not null or undefined
            if (downloadDto === null || downloadDto === undefined) {
                throw new RequiredError('downloadDto','Required parameter downloadDto was null or undefined when calling downloadUrl.');
            }
            const localVarPath = `/client/downloadUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof downloadDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(downloadDto !== undefined ? downloadDto : {}) : (downloadDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user account.
         * @param {UserEditDto} userEditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount: async (userEditDto: UserEditDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userEditDto' is not null or undefined
            if (userEditDto === null || userEditDto === undefined) {
                throw new RequiredError('userEditDto','Required parameter userEditDto was null or undefined when calling editAccount.');
            }
            const localVarPath = `/client/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userEditDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userEditDto !== undefined ? userEditDto : {}) : (userEditDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get events that the currently logged-in user is participating in
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserParticipatingEvents: async (divisionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getUserParticipatingEvents.');
            }
            const localVarPath = `/client/division/{divisionId}/event/my`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Set up MFA for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaSetup: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/mfa/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Verify MFA token for the current user
         * @param {MfaVerifyDto} mfaVerifyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaVerify: async (mfaVerifyDto: MfaVerifyDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mfaVerifyDto' is not null or undefined
            if (mfaVerifyDto === null || mfaVerifyDto === undefined) {
                throw new RequiredError('mfaVerifyDto','Required parameter mfaVerifyDto was null or undefined when calling mfaVerify.');
            }
            const localVarPath = `/client/mfa/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof mfaVerifyDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(mfaVerifyDto !== undefined ? mfaVerifyDto : {}) : (mfaVerifyDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The logged-in user\'s story progress on a page and across the project
         * @param {string} id 
         * @param {string} pageIdOrSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageProgressForUser: async (id: string, pageIdOrSlug: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling pageProgressForUser.');
            }
            // verify required parameter 'pageIdOrSlug' is not null or undefined
            if (pageIdOrSlug === null || pageIdOrSlug === undefined) {
                throw new RequiredError('pageIdOrSlug','Required parameter pageIdOrSlug was null or undefined when calling pageProgressForUser.');
            }
            const localVarPath = `/client/division/{id}/pages/{pageIdOrSlug}/progress`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"pageIdOrSlug"}}`, encodeURIComponent(String(pageIdOrSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove own user account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOwnAccount: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find sessions logged in user has for given division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsForDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sessionsForDivision.');
            }
            const localVarPath = `/client/division/{id}/sessions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a file to the generic storage
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadClientFile: async (file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadClientFile.');
            }
            const localVarPath = `/client/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientPrivateApi - functional programming interface
 * @export
 */
export const ClientPrivateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authStatus(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).authStatus(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Move the current user\'s upcoming registration to another session of the event.
         * @param {string} eventId 
         * @param {string} [variantId] The target session: a variant id, or \&quot;main\&quot; for the event\&#39;s own date (the default).
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientChangeEventParticipation(eventId: string, variantId?: string, divisionId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientEventParticipantDto>>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).clientChangeEventParticipation(eventId, variantId, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create an event.
         * @param {string} divisionId 
         * @param {EventCreateDto} eventCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientCreateEvent(divisionId: string, eventCreateDto: EventCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).clientCreateEvent(divisionId, eventCreateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Invalidates the currently used Accesstoken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientLogout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).clientLogout(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Participate in event for current user.
         * @param {string} eventId 
         * @param {string} [variantId] Optional variant ID to participate in a specific variant
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientParticipateEvent(eventId: string, variantId?: string, divisionId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientEventParticipantDto>>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).clientParticipateEvent(eventId, variantId, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Remove participation from event for current user.
         * @param {string} eventId 
         * @param {string} [variantId] The session to cancel: a variant id, or \&quot;main\&quot; for the event\&#39;s own date. Omitted, the upcoming registration is cancelled (else the latest one).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientUnparticipateEvent(eventId: string, variantId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientEventParticipantDto>>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).clientUnparticipateEvent(eventId, variantId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update an event.
         * @param {string} eventId 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientUpdateEvent(eventId: string, eventUpdateDto: EventUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).clientUpdateEvent(eventId, eventUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Complete account setup
         * @param {UserCompleteSetupDto} userCompleteSetupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeAccountSetup(userCompleteSetupDto: UserCompleteSetupDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).completeAccountSetup(userCompleteSetupDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async divisionAuthStatus(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).divisionAuthStatus(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadUrl(downloadDto: DownloadDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadUrlDto>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).downloadUrl(downloadDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update user account.
         * @param {UserEditDto} userEditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editAccount(userEditDto: UserEditDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).editAccount(userEditDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get events that the currently logged-in user is participating in
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserParticipatingEvents(divisionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventParticipantEntity>>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).getUserParticipatingEvents(divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Set up MFA for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaSetup(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MfaSetupResultDto>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).mfaSetup(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Verify MFA token for the current user
         * @param {MfaVerifyDto} mfaVerifyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaVerify(mfaVerifyDto: MfaVerifyDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MfaVerifyResultDto>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).mfaVerify(mfaVerifyDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary The logged-in user\'s story progress on a page and across the project
         * @param {string} id 
         * @param {string} pageIdOrSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageProgressForUser(id: string, pageIdOrSlug: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProgressDto>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).pageProgressForUser(id, pageIdOrSlug, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Remove own user account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeOwnAccount(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).removeOwnAccount(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find sessions logged in user has for given division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsForDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SessionEntity>>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).sessionsForDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Upload a file to the generic storage
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadClientFile(file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResultDto>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).uploadClientFile(file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientPrivateApi - factory interface
 * @export
 */
export const ClientPrivateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authStatus(options?: any): AxiosPromise<UserEntity> {
            return ClientPrivateApiFp(configuration).authStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move the current user\'s upcoming registration to another session of the event.
         * @param {string} eventId 
         * @param {string} [variantId] The target session: a variant id, or \&quot;main\&quot; for the event\&#39;s own date (the default).
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientChangeEventParticipation(eventId: string, variantId?: string, divisionId?: string, options?: any): AxiosPromise<Array<ClientEventParticipantDto>> {
            return ClientPrivateApiFp(configuration).clientChangeEventParticipation(eventId, variantId, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an event.
         * @param {string} divisionId 
         * @param {EventCreateDto} eventCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateEvent(divisionId: string, eventCreateDto: EventCreateDto, options?: any): AxiosPromise<EventEntity> {
            return ClientPrivateApiFp(configuration).clientCreateEvent(divisionId, eventCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invalidates the currently used Accesstoken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientLogout(options?: any): AxiosPromise<void> {
            return ClientPrivateApiFp(configuration).clientLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Participate in event for current user.
         * @param {string} eventId 
         * @param {string} [variantId] Optional variant ID to participate in a specific variant
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientParticipateEvent(eventId: string, variantId?: string, divisionId?: string, options?: any): AxiosPromise<Array<ClientEventParticipantDto>> {
            return ClientPrivateApiFp(configuration).clientParticipateEvent(eventId, variantId, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove participation from event for current user.
         * @param {string} eventId 
         * @param {string} [variantId] The session to cancel: a variant id, or \&quot;main\&quot; for the event\&#39;s own date. Omitted, the upcoming registration is cancelled (else the latest one).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUnparticipateEvent(eventId: string, variantId?: string, options?: any): AxiosPromise<Array<ClientEventParticipantDto>> {
            return ClientPrivateApiFp(configuration).clientUnparticipateEvent(eventId, variantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an event.
         * @param {string} eventId 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUpdateEvent(eventId: string, eventUpdateDto: EventUpdateDto, options?: any): AxiosPromise<EventEntity> {
            return ClientPrivateApiFp(configuration).clientUpdateEvent(eventId, eventUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete account setup
         * @param {UserCompleteSetupDto} userCompleteSetupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAccountSetup(userCompleteSetupDto: UserCompleteSetupDto, options?: any): AxiosPromise<UserEntity> {
            return ClientPrivateApiFp(configuration).completeAccountSetup(userCompleteSetupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionAuthStatus(id: string, options?: any): AxiosPromise<UserEntity> {
            return ClientPrivateApiFp(configuration).divisionAuthStatus(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUrl(downloadDto: DownloadDto, options?: any): AxiosPromise<DownloadUrlDto> {
            return ClientPrivateApiFp(configuration).downloadUrl(downloadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user account.
         * @param {UserEditDto} userEditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(userEditDto: UserEditDto, options?: any): AxiosPromise<UserEntity> {
            return ClientPrivateApiFp(configuration).editAccount(userEditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get events that the currently logged-in user is participating in
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserParticipatingEvents(divisionId: string, options?: any): AxiosPromise<Array<EventParticipantEntity>> {
            return ClientPrivateApiFp(configuration).getUserParticipatingEvents(divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Set up MFA for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaSetup(options?: any): AxiosPromise<MfaSetupResultDto> {
            return ClientPrivateApiFp(configuration).mfaSetup(options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Verify MFA token for the current user
         * @param {MfaVerifyDto} mfaVerifyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaVerify(mfaVerifyDto: MfaVerifyDto, options?: any): AxiosPromise<MfaVerifyResultDto> {
            return ClientPrivateApiFp(configuration).mfaVerify(mfaVerifyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The logged-in user\'s story progress on a page and across the project
         * @param {string} id 
         * @param {string} pageIdOrSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageProgressForUser(id: string, pageIdOrSlug: string, options?: any): AxiosPromise<PageProgressDto> {
            return ClientPrivateApiFp(configuration).pageProgressForUser(id, pageIdOrSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove own user account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOwnAccount(options?: any): AxiosPromise<UserEntity> {
            return ClientPrivateApiFp(configuration).removeOwnAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find sessions logged in user has for given division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsForDivision(id: string, options?: any): AxiosPromise<Array<SessionEntity>> {
            return ClientPrivateApiFp(configuration).sessionsForDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a file to the generic storage
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadClientFile(file: any, options?: any): AxiosPromise<FileUploadResultDto> {
            return ClientPrivateApiFp(configuration).uploadClientFile(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientPrivateApi - object-oriented interface
 * @export
 * @class ClientPrivateApi
 * @extends {BaseAPI}
 */
export class ClientPrivateApi extends BaseAPI {
    /**
     * 
     * @summary Verify authentication status and retrieve user info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public authStatus(options?: any) {
        return ClientPrivateApiFp(this.configuration).authStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move the current user\'s upcoming registration to another session of the event.
     * @param {string} eventId 
     * @param {string} [variantId] The target session: a variant id, or \&quot;main\&quot; for the event\&#39;s own date (the default).
     * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public clientChangeEventParticipation(eventId: string, variantId?: string, divisionId?: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).clientChangeEventParticipation(eventId, variantId, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an event.
     * @param {string} divisionId 
     * @param {EventCreateDto} eventCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public clientCreateEvent(divisionId: string, eventCreateDto: EventCreateDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).clientCreateEvent(divisionId, eventCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invalidates the currently used Accesstoken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public clientLogout(options?: any) {
        return ClientPrivateApiFp(this.configuration).clientLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Participate in event for current user.
     * @param {string} eventId 
     * @param {string} [variantId] Optional variant ID to participate in a specific variant
     * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public clientParticipateEvent(eventId: string, variantId?: string, divisionId?: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).clientParticipateEvent(eventId, variantId, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove participation from event for current user.
     * @param {string} eventId 
     * @param {string} [variantId] The session to cancel: a variant id, or \&quot;main\&quot; for the event\&#39;s own date. Omitted, the upcoming registration is cancelled (else the latest one).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public clientUnparticipateEvent(eventId: string, variantId?: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).clientUnparticipateEvent(eventId, variantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an event.
     * @param {string} eventId 
     * @param {EventUpdateDto} eventUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public clientUpdateEvent(eventId: string, eventUpdateDto: EventUpdateDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).clientUpdateEvent(eventId, eventUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete account setup
     * @param {UserCompleteSetupDto} userCompleteSetupDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public completeAccountSetup(userCompleteSetupDto: UserCompleteSetupDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).completeAccountSetup(userCompleteSetupDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify authentication status and retrieve user info.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public divisionAuthStatus(id: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).divisionAuthStatus(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve download URL for given game
     * @param {DownloadDto} downloadDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public downloadUrl(downloadDto: DownloadDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).downloadUrl(downloadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user account.
     * @param {UserEditDto} userEditDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public editAccount(userEditDto: UserEditDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).editAccount(userEditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get events that the currently logged-in user is participating in
     * @param {string} divisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public getUserParticipatingEvents(divisionId: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).getUserParticipatingEvents(divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
     * @summary Set up MFA for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public mfaSetup(options?: any) {
        return ClientPrivateApiFp(this.configuration).mfaSetup(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
     * @summary Verify MFA token for the current user
     * @param {MfaVerifyDto} mfaVerifyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public mfaVerify(mfaVerifyDto: MfaVerifyDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).mfaVerify(mfaVerifyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The logged-in user\'s story progress on a page and across the project
     * @param {string} id 
     * @param {string} pageIdOrSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public pageProgressForUser(id: string, pageIdOrSlug: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).pageProgressForUser(id, pageIdOrSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove own user account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public removeOwnAccount(options?: any) {
        return ClientPrivateApiFp(this.configuration).removeOwnAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find sessions logged in user has for given division
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public sessionsForDivision(id: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).sessionsForDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a file to the generic storage
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public uploadClientFile(file: any, options?: any) {
        return ClientPrivateApiFp(this.configuration).uploadClientFile(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ClientPublicApi - axios parameter creator
 * @export
 */
export const ClientPublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Log in anonymously
         * @param {AnonymousAccessDto} anonymousAccessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousLogin: async (anonymousAccessDto: AnonymousAccessDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'anonymousAccessDto' is not null or undefined
            if (anonymousAccessDto === null || anonymousAccessDto === undefined) {
                throw new RequiredError('anonymousAccessDto','Required parameter anonymousAccessDto was null or undefined when calling anonymousLogin.');
            }
            const localVarPath = `/client/login/anonymous`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof anonymousAccessDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(anonymousAccessDto !== undefined ? anonymousAccessDto : {}) : (anonymousAccessDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Append journal entries for a game session.
         * @param {JournalAppendDto} journalAppendDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendSessionJournal: async (journalAppendDto: JournalAppendDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'journalAppendDto' is not null or undefined
            if (journalAppendDto === null || journalAppendDto === undefined) {
                throw new RequiredError('journalAppendDto','Required parameter journalAppendDto was null or undefined when calling appendSessionJournal.');
            }
            const localVarPath = `/client/session/journal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof journalAppendDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(journalAppendDto !== undefined ? journalAppendDto : {}) : (journalAppendDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Log into client with apple token
         * @param {AppleTokenDto} appleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleLogin: async (appleTokenDto: AppleTokenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'appleTokenDto' is not null or undefined
            if (appleTokenDto === null || appleTokenDto === undefined) {
                throw new RequiredError('appleTokenDto','Required parameter appleTokenDto was null or undefined when calling appleLogin.');
            }
            const localVarPath = `/client/login/apple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof appleTokenDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(appleTokenDto !== undefined ? appleTokenDto : {}) : (appleTokenDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find articles for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesOfDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling articlesOfDivision.');
            }
            const localVarPath = `/client/division/{id}/articles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the contact information for the division.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactForDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contactForDivision.');
            }
            const localVarPath = `/client/division/{id}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create analytics based on the time user spends on article
         * @param {string} articleId 
         * @param {ArticleAnalyticsDto} articleAnalyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHitOnArticle: async (articleId: string, articleAnalyticsDto: ArticleAnalyticsDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            if (articleId === null || articleId === undefined) {
                throw new RequiredError('articleId','Required parameter articleId was null or undefined when calling createHitOnArticle.');
            }
            // verify required parameter 'articleAnalyticsDto' is not null or undefined
            if (articleAnalyticsDto === null || articleAnalyticsDto === undefined) {
                throw new RequiredError('articleAnalyticsDto','Required parameter articleAnalyticsDto was null or undefined when calling createHitOnArticle.');
            }
            const localVarPath = `/client/articleAnalytics/{articleId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof articleAnalyticsDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(articleAnalyticsDto !== undefined ? articleAnalyticsDto : {}) : (articleAnalyticsDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create analytics for on-demand video views
         * @param {string} videoId 
         * @param {OnDemandVideoAnalyticsDto} onDemandVideoAnalyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHitOnOnDemandVideo: async (videoId: string, onDemandVideoAnalyticsDto: OnDemandVideoAnalyticsDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoId' is not null or undefined
            if (videoId === null || videoId === undefined) {
                throw new RequiredError('videoId','Required parameter videoId was null or undefined when calling createHitOnOnDemandVideo.');
            }
            // verify required parameter 'onDemandVideoAnalyticsDto' is not null or undefined
            if (onDemandVideoAnalyticsDto === null || onDemandVideoAnalyticsDto === undefined) {
                throw new RequiredError('onDemandVideoAnalyticsDto','Required parameter onDemandVideoAnalyticsDto was null or undefined when calling createHitOnOnDemandVideo.');
            }
            const localVarPath = `/client/onDemandVideoAnalytics/{videoId}`
                .replace(`{${"videoId"}}`, encodeURIComponent(String(videoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof onDemandVideoAnalyticsDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(onDemandVideoAnalyticsDto !== undefined ? onDemandVideoAnalyticsDto : {}) : (onDemandVideoAnalyticsDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUrlPublic: async (downloadDto: DownloadDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadDto' is not null or undefined
            if (downloadDto === null || downloadDto === undefined) {
                throw new RequiredError('downloadDto','Required parameter downloadDto was null or undefined when calling downloadUrlPublic.');
            }
            const localVarPath = `/client/downloadUrlPublic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof downloadDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(downloadDto !== undefined ? downloadDto : {}) : (downloadDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsForDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling eventsForDivision.');
            }
            const localVarPath = `/client/division/{id}/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Log into client with facebook token
         * @param {FacebookTokenDto} facebookTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookLogin: async (facebookTokenDto: FacebookTokenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'facebookTokenDto' is not null or undefined
            if (facebookTokenDto === null || facebookTokenDto === undefined) {
                throw new RequiredError('facebookTokenDto','Required parameter facebookTokenDto was null or undefined when calling facebookLogin.');
            }
            const localVarPath = `/client/login/facebook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof facebookTokenDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(facebookTokenDto !== undefined ? facebookTokenDto : {}) : (facebookTokenDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find a single published game for division
         * @param {string} id 
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameOfDivision: async (id: string, gameId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling gameOfDivision.');
            }
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling gameOfDivision.');
            }
            const localVarPath = `/client/division/{id}/games/{gameId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find games for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesOfDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling gamesOfDivision.');
            }
            const localVarPath = `/client/division/{id}/games`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get division QR Code
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionQRCode: async (divisionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getDivisionQRCode.');
            }
            const localVarPath = `/client/division/{divisionId}/qr`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve estimated lat/lon location for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstimatedLocation: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/estimatedLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} id 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventInDivision: async (id: string, eventId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEventInDivision.');
            }
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling getEventInDivision.');
            }
            const localVarPath = `/client/division/{id}/events/{eventId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the leaderboard for a game.
         * @param {string} gameId 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighscores: async (gameId: string, divisionId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling getHighscores.');
            }
            const localVarPath = `/client/highscores/{gameId}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the leaderboard for a game, including the given session.
         * @param {string} gameId 
         * @param {string} sessionId 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighscoresWithSession: async (gameId: string, sessionId: string, divisionId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling getHighscoresWithSession.');
            }
            // verify required parameter 'sessionId' is not null or undefined
            if (sessionId === null || sessionId === undefined) {
                throw new RequiredError('sessionId','Required parameter sessionId was null or undefined when calling getHighscoresWithSession.');
            }
            const localVarPath = `/client/highscores/{gameId}/{sessionId}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)))
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get joined project-wide highscores based on user key.
         * @param {string} gameId 
         * @param {string} userKey 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJoinedHighscoresWithKey: async (gameId: string, userKey: string, divisionId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling getJoinedHighscoresWithKey.');
            }
            // verify required parameter 'userKey' is not null or undefined
            if (userKey === null || userKey === undefined) {
                throw new RequiredError('userKey','Required parameter userKey was null or undefined when calling getJoinedHighscoresWithKey.');
            }
            const localVarPath = `/client/highscores/joined/{gameId}/{userKey}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)))
                .replace(`{${"userKey"}}`, encodeURIComponent(String(userKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an organization\'s default brandkit for theming
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCompanyTheme: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPublicCompanyTheme.');
            }
            const localVarPath = `/client/company/{id}/theme`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a markdown page for active Whitelabel using the X-App-Bundle-ID request header.
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicMarkdownPageContent: async (languageId: string, pageId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'languageId' is not null or undefined
            if (languageId === null || languageId === undefined) {
                throw new RequiredError('languageId','Required parameter languageId was null or undefined when calling getPublicMarkdownPageContent.');
            }
            // verify required parameter 'pageId' is not null or undefined
            if (pageId === null || pageId === undefined) {
                throw new RequiredError('pageId','Required parameter pageId was null or undefined when calling getPublicMarkdownPageContent.');
            }
            const localVarPath = `/client/markdown-page/{languageId}/{pageId}`
                .replace(`{${"languageId"}}`, encodeURIComponent(String(languageId)))
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deprecated alias of getPublicMarkdownPageContent. Get a page for active Whitelabel using the X-App-Bundle-ID request header.
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicPageContent: async (languageId: string, pageId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'languageId' is not null or undefined
            if (languageId === null || languageId === undefined) {
                throw new RequiredError('languageId','Required parameter languageId was null or undefined when calling getPublicPageContent.');
            }
            // verify required parameter 'pageId' is not null or undefined
            if (pageId === null || pageId === undefined) {
                throw new RequiredError('pageId','Required parameter pageId was null or undefined when calling getPublicPageContent.');
            }
            const localVarPath = `/client/page/{languageId}/{pageId}`
                .replace(`{${"languageId"}}`, encodeURIComponent(String(languageId)))
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all up to date translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslations: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/translations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Log into client with google token
         * @param {GoogleTokenDto} googleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin: async (googleTokenDto: GoogleTokenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'googleTokenDto' is not null or undefined
            if (googleTokenDto === null || googleTokenDto === undefined) {
                throw new RequiredError('googleTokenDto','Required parameter googleTokenDto was null or undefined when calling googleLogin.');
            }
            const localVarPath = `/client/login/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof googleTokenDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(googleTokenDto !== undefined ? googleTokenDto : {}) : (googleTokenDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find on-demand playlists for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onDemandPlaylistsOfDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling onDemandPlaylistsOfDivision.');
            }
            const localVarPath = `/client/division/{id}/on-demand-playlists`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary An article available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContentArticle: async (id: string, articleId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling pageContentArticle.');
            }
            // verify required parameter 'articleId' is not null or undefined
            if (articleId === null || articleId === undefined) {
                throw new RequiredError('articleId','Required parameter articleId was null or undefined when calling pageContentArticle.');
            }
            const localVarPath = `/client/division/{id}/page-content/articles/{articleId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary An event available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContentEvent: async (id: string, eventId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling pageContentEvent.');
            }
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling pageContentEvent.');
            }
            const localVarPath = `/client/division/{id}/page-content/events/{eventId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All events available through the division\'s embedded collections
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContentEvents: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling pageContentEvents.');
            }
            const localVarPath = `/client/division/{id}/page-content/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary A game available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContentGame: async (id: string, gameId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling pageContentGame.');
            }
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling pageContentGame.');
            }
            const localVarPath = `/client/division/{id}/page-content/games/{gameId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary An on-demand video available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} videoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContentVideo: async (id: string, videoId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling pageContentVideo.');
            }
            // verify required parameter 'videoId' is not null or undefined
            if (videoId === null || videoId === undefined) {
                throw new RequiredError('videoId','Required parameter videoId was null or undefined when calling pageContentVideo.');
            }
            const localVarPath = `/client/division/{id}/page-content/videos/{videoId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"videoId"}}`, encodeURIComponent(String(videoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The page index of a division with pages
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagesOfDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling pagesOfDivision.');
            }
            const localVarPath = `/client/division/{id}/pages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get participants for event
         * @param {string} id 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participantsForEvent: async (id: string, divisionId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling participantsForEvent.');
            }
            const localVarPath = `/client/events/{id}/participants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a verification token via passwordless login
         * @param {PasswordlessRequestDto} passwordlessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordlessLogin: async (passwordlessRequestDto: PasswordlessRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordlessRequestDto' is not null or undefined
            if (passwordlessRequestDto === null || passwordlessRequestDto === undefined) {
                throw new RequiredError('passwordlessRequestDto','Required parameter passwordlessRequestDto was null or undefined when calling passwordlessLogin.');
            }
            const localVarPath = `/client/login/passwordless`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof passwordlessRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(passwordlessRequestDto !== undefined ? passwordlessRequestDto : {}) : (passwordlessRequestDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify a token against an earlier generated verification token
         * @param {PasswordlessVerifyDto} passwordlessVerifyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordlessVerify: async (passwordlessVerifyDto: PasswordlessVerifyDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordlessVerifyDto' is not null or undefined
            if (passwordlessVerifyDto === null || passwordlessVerifyDto === undefined) {
                throw new RequiredError('passwordlessVerifyDto','Required parameter passwordlessVerifyDto was null or undefined when calling passwordlessVerify.');
            }
            const localVarPath = `/client/login/passwordless/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof passwordlessVerifyDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(passwordlessVerifyDto !== undefined ? passwordlessVerifyDto : {}) : (passwordlessVerifyDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} sceneId 
         * @param {FeedbackPostDto} feedbackPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeeback: async (sceneId: string, feedbackPostDto: FeedbackPostDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sceneId' is not null or undefined
            if (sceneId === null || sceneId === undefined) {
                throw new RequiredError('sceneId','Required parameter sceneId was null or undefined when calling postFeeback.');
            }
            // verify required parameter 'feedbackPostDto' is not null or undefined
            if (feedbackPostDto === null || feedbackPostDto === undefined) {
                throw new RequiredError('feedbackPostDto','Required parameter feedbackPostDto was null or undefined when calling postFeeback.');
            }
            const localVarPath = `/client/feedback/{sceneId}`
                .replace(`{${"sceneId"}}`, encodeURIComponent(String(sceneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof feedbackPostDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(feedbackPostDto !== undefined ? feedbackPostDto : {}) : (feedbackPostDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a file from the player (user-generated content)
         * @param {string} divisionId 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicFileUpload: async (divisionId: string, file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling publicFileUpload.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling publicFileUpload.');
            }
            const localVarPath = `/client/upload/{divisionId}`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Count one answer to a project\'s consent banner, anonymously.
         * @param {PageConsentDto} pageConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordPageConsent: async (pageConsentDto: PageConsentDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageConsentDto' is not null or undefined
            if (pageConsentDto === null || pageConsentDto === undefined) {
                throw new RequiredError('pageConsentDto','Required parameter pageConsentDto was null or undefined when calling recordPageConsent.');
            }
            const localVarPath = `/client/pages/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageConsentDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageConsentDto !== undefined ? pageConsentDto : {}) : (pageConsentDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record a batch of page visit events. Ids are client generated.
         * @param {PageEventsBatchDto} pageEventsBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordPageEvents: async (pageEventsBatchDto: PageEventsBatchDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageEventsBatchDto' is not null or undefined
            if (pageEventsBatchDto === null || pageEventsBatchDto === undefined) {
                throw new RequiredError('pageEventsBatchDto','Required parameter pageEventsBatchDto was null or undefined when calling recordPageEvents.');
            }
            const localVarPath = `/client/pages/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageEventsBatchDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageEventsBatchDto !== undefined ? pageEventsBatchDto : {}) : (pageEventsBatchDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve an embedded collection\'s members for a division
         * @param {string} id 
         * @param {string} collectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCollectionInDivision: async (id: string, collectionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling resolveCollectionInDivision.');
            }
            // verify required parameter 'collectionId' is not null or undefined
            if (collectionId === null || collectionId === undefined) {
                throw new RequiredError('collectionId','Required parameter collectionId was null or undefined when calling resolveCollectionInDivision.');
            }
            const localVarPath = `/client/division/{id}/collections/{collectionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"collectionId"}}`, encodeURIComponent(String(collectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve a single embedded content item\'s card summary for a division
         * @param {string} id 
         * @param {string} kind 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveContentItemInDivision: async (id: string, kind: string, itemId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling resolveContentItemInDivision.');
            }
            // verify required parameter 'kind' is not null or undefined
            if (kind === null || kind === undefined) {
                throw new RequiredError('kind','Required parameter kind was null or undefined when calling resolveContentItemInDivision.');
            }
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling resolveContentItemInDivision.');
            }
            const localVarPath = `/client/division/{id}/content-items/{kind}/{itemId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve several embedded content items\' card summaries for a division in one go, e.g. a journey\'s; `items` is a comma-separated list of kind:itemId
         * @param {string} id 
         * @param {string} items 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveContentItemsInDivision: async (id: string, items: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling resolveContentItemsInDivision.');
            }
            // verify required parameter 'items' is not null or undefined
            if (items === null || items === undefined) {
                throw new RequiredError('items','Required parameter items was null or undefined when calling resolveContentItemsInDivision.');
            }
            const localVarPath = `/client/division/{id}/content-items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (items !== undefined) {
                localVarQueryParameter['items'] = items;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve a page (by slug or id) for a division and language
         * @param {string} id 
         * @param {string} pageIdOrSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolvePageInDivision: async (id: string, pageIdOrSlug: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling resolvePageInDivision.');
            }
            // verify required parameter 'pageIdOrSlug' is not null or undefined
            if (pageIdOrSlug === null || pageIdOrSlug === undefined) {
                throw new RequiredError('pageIdOrSlug','Required parameter pageIdOrSlug was null or undefined when calling resolvePageInDivision.');
            }
            const localVarPath = `/client/division/{id}/pages/{pageIdOrSlug}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"pageIdOrSlug"}}`, encodeURIComponent(String(pageIdOrSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update session data for game session. ID\'s are client generated.
         * @param {SessionUpdateDto} sessionUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSession: async (sessionUpdateDto: SessionUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUpdateDto' is not null or undefined
            if (sessionUpdateDto === null || sessionUpdateDto === undefined) {
                throw new RequiredError('sessionUpdateDto','Required parameter sessionUpdateDto was null or undefined when calling updateSession.');
            }
            const localVarPath = `/client/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof sessionUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(sessionUpdateDto !== undefined ? sessionUpdateDto : {}) : (sessionUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientPublicApi - functional programming interface
 * @export
 */
export const ClientPublicApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Log in anonymously
         * @param {AnonymousAccessDto} anonymousAccessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anonymousLogin(anonymousAccessDto: AnonymousAccessDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessToken>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).anonymousLogin(anonymousAccessDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Append journal entries for a game session.
         * @param {JournalAppendDto} journalAppendDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appendSessionJournal(journalAppendDto: JournalAppendDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).appendSessionJournal(journalAppendDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Log into client with apple token
         * @param {AppleTokenDto} appleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleLogin(appleTokenDto: AppleTokenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessToken>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).appleLogin(appleTokenDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find articles for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articlesOfDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArticleEntity>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).articlesOfDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the contact information for the division.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactForDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionContactDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).contactForDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create analytics based on the time user spends on article
         * @param {string} articleId 
         * @param {ArticleAnalyticsDto} articleAnalyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHitOnArticle(articleId: string, articleAnalyticsDto: ArticleAnalyticsDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleOkResponse>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).createHitOnArticle(articleId, articleAnalyticsDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create analytics for on-demand video views
         * @param {string} videoId 
         * @param {OnDemandVideoAnalyticsDto} onDemandVideoAnalyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHitOnOnDemandVideo(videoId: string, onDemandVideoAnalyticsDto: OnDemandVideoAnalyticsDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleOkResponse>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).createHitOnOnDemandVideo(videoId, onDemandVideoAnalyticsDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadUrlPublic(downloadDto: DownloadDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadUrlDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).downloadUrlPublic(downloadDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsForDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientEventDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).eventsForDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Log into client with facebook token
         * @param {FacebookTokenDto} facebookTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facebookLogin(facebookTokenDto: FacebookTokenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessToken>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).facebookLogin(facebookTokenDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find a single published game for division
         * @param {string} id 
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameOfDivision(id: string, gameId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GamePlayerDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).gameOfDivision(id, gameId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find games for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamesOfDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameEntity>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).gamesOfDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get division QR Code
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDivisionQRCode(divisionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getDivisionQRCode(divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve estimated lat/lon location for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstimatedLocation(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstimatedLocationDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getEstimatedLocation(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} id 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventInDivision(id: string, eventId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getEventInDivision(id, eventId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the leaderboard for a game.
         * @param {string} gameId 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHighscores(gameId: string, divisionId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HighscoreDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getHighscores(gameId, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the leaderboard for a game, including the given session.
         * @param {string} gameId 
         * @param {string} sessionId 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHighscoresWithSession(gameId: string, sessionId: string, divisionId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HighscoreDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getHighscoresWithSession(gameId, sessionId, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get joined project-wide highscores based on user key.
         * @param {string} gameId 
         * @param {string} userKey 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJoinedHighscoresWithKey(gameId: string, userKey: string, divisionId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HighscoreDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getJoinedHighscoresWithKey(gameId, userKey, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get an organization\'s default brandkit for theming
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicCompanyTheme(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandkitEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getPublicCompanyTheme(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a markdown page for active Whitelabel using the X-App-Bundle-ID request header.
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicMarkdownPageContent(languageId: string, pageId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkdownPageContentEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getPublicMarkdownPageContent(languageId, pageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deprecated alias of getPublicMarkdownPageContent. Get a page for active Whitelabel using the X-App-Bundle-ID request header.
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicPageContent(languageId: string, pageId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkdownPageContentEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getPublicPageContent(languageId, pageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all up to date translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslations(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageTranslationsDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getTranslations(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Log into client with google token
         * @param {GoogleTokenDto} googleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleLogin(googleTokenDto: GoogleTokenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessToken>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).googleLogin(googleTokenDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find on-demand playlists for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async onDemandPlaylistsOfDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OnDemandPlaylistEntity>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).onDemandPlaylistsOfDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary An article available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageContentArticle(id: string, articleId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).pageContentArticle(id, articleId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary An event available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageContentEvent(id: string, eventId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientEventDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).pageContentEvent(id, eventId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All events available through the division\'s embedded collections
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageContentEvents(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientEventDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).pageContentEvents(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary A game available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageContentGame(id: string, gameId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).pageContentGame(id, gameId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary An on-demand video available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} videoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageContentVideo(id: string, videoId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandVideoEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).pageContentVideo(id, videoId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary The page index of a division with pages
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagesOfDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageSummaryDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).pagesOfDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get participants for event
         * @param {string} id 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participantsForEvent(id: string, divisionId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientEventParticipantDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).participantsForEvent(id, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Request a verification token via passwordless login
         * @param {PasswordlessRequestDto} passwordlessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordlessLogin(passwordlessRequestDto: PasswordlessRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordlessRequestResultDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).passwordlessLogin(passwordlessRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Verify a token against an earlier generated verification token
         * @param {PasswordlessVerifyDto} passwordlessVerifyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordlessVerify(passwordlessVerifyDto: PasswordlessVerifyDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordlessVerifyResultDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).passwordlessVerify(passwordlessVerifyDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} sceneId 
         * @param {FeedbackPostDto} feedbackPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFeeback(sceneId: string, feedbackPostDto: FeedbackPostDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbackEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).postFeeback(sceneId, feedbackPostDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Upload a file from the player (user-generated content)
         * @param {string} divisionId 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicFileUpload(divisionId: string, file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResultDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).publicFileUpload(divisionId, file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Count one answer to a project\'s consent banner, anonymously.
         * @param {PageConsentDto} pageConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordPageConsent(pageConsentDto: PageConsentDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).recordPageConsent(pageConsentDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Record a batch of page visit events. Ids are client generated.
         * @param {PageEventsBatchDto} pageEventsBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordPageEvents(pageEventsBatchDto: PageEventsBatchDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).recordPageEvents(pageEventsBatchDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Resolve an embedded collection\'s members for a division
         * @param {string} id 
         * @param {string} collectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveCollectionInDivision(id: string, collectionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolvedCollectionDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).resolveCollectionInDivision(id, collectionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Resolve a single embedded content item\'s card summary for a division
         * @param {string} id 
         * @param {string} kind 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveContentItemInDivision(id: string, kind: string, itemId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolvedContentItemDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).resolveContentItemInDivision(id, kind, itemId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Resolve several embedded content items\' card summaries for a division in one go, e.g. a journey\'s; `items` is a comma-separated list of kind:itemId
         * @param {string} id 
         * @param {string} items 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveContentItemsInDivision(id: string, items: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResolvedContentItemEntryDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).resolveContentItemsInDivision(id, items, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Resolve a page (by slug or id) for a division and language
         * @param {string} id 
         * @param {string} pageIdOrSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolvePageInDivision(id: string, pageIdOrSlug: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolvedPageDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).resolvePageInDivision(id, pageIdOrSlug, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update session data for game session. ID\'s are client generated.
         * @param {SessionUpdateDto} sessionUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSession(sessionUpdateDto: SessionUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).updateSession(sessionUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientPublicApi - factory interface
 * @export
 */
export const ClientPublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Log in anonymously
         * @param {AnonymousAccessDto} anonymousAccessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousLogin(anonymousAccessDto: AnonymousAccessDto, options?: any): AxiosPromise<AccessToken> {
            return ClientPublicApiFp(configuration).anonymousLogin(anonymousAccessDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Append journal entries for a game session.
         * @param {JournalAppendDto} journalAppendDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendSessionJournal(journalAppendDto: JournalAppendDto, options?: any): AxiosPromise<ResultDto> {
            return ClientPublicApiFp(configuration).appendSessionJournal(journalAppendDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Log into client with apple token
         * @param {AppleTokenDto} appleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleLogin(appleTokenDto: AppleTokenDto, options?: any): AxiosPromise<AccessToken> {
            return ClientPublicApiFp(configuration).appleLogin(appleTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find articles for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesOfDivision(id: string, options?: any): AxiosPromise<Array<ArticleEntity>> {
            return ClientPublicApiFp(configuration).articlesOfDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the contact information for the division.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactForDivision(id: string, options?: any): AxiosPromise<DivisionContactDto> {
            return ClientPublicApiFp(configuration).contactForDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create analytics based on the time user spends on article
         * @param {string} articleId 
         * @param {ArticleAnalyticsDto} articleAnalyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHitOnArticle(articleId: string, articleAnalyticsDto: ArticleAnalyticsDto, options?: any): AxiosPromise<SimpleOkResponse> {
            return ClientPublicApiFp(configuration).createHitOnArticle(articleId, articleAnalyticsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create analytics for on-demand video views
         * @param {string} videoId 
         * @param {OnDemandVideoAnalyticsDto} onDemandVideoAnalyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHitOnOnDemandVideo(videoId: string, onDemandVideoAnalyticsDto: OnDemandVideoAnalyticsDto, options?: any): AxiosPromise<SimpleOkResponse> {
            return ClientPublicApiFp(configuration).createHitOnOnDemandVideo(videoId, onDemandVideoAnalyticsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUrlPublic(downloadDto: DownloadDto, options?: any): AxiosPromise<DownloadUrlDto> {
            return ClientPublicApiFp(configuration).downloadUrlPublic(downloadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsForDivision(id: string, options?: any): AxiosPromise<Array<ClientEventDto>> {
            return ClientPublicApiFp(configuration).eventsForDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Log into client with facebook token
         * @param {FacebookTokenDto} facebookTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookLogin(facebookTokenDto: FacebookTokenDto, options?: any): AxiosPromise<AccessToken> {
            return ClientPublicApiFp(configuration).facebookLogin(facebookTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find a single published game for division
         * @param {string} id 
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameOfDivision(id: string, gameId: string, options?: any): AxiosPromise<GamePlayerDto> {
            return ClientPublicApiFp(configuration).gameOfDivision(id, gameId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find games for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesOfDivision(id: string, options?: any): AxiosPromise<Array<GameEntity>> {
            return ClientPublicApiFp(configuration).gamesOfDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get division QR Code
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionQRCode(divisionId: string, options?: any): AxiosPromise<QrDto> {
            return ClientPublicApiFp(configuration).getDivisionQRCode(divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve estimated lat/lon location for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstimatedLocation(options?: any): AxiosPromise<EstimatedLocationDto> {
            return ClientPublicApiFp(configuration).getEstimatedLocation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} id 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventInDivision(id: string, eventId: string, options?: any): AxiosPromise<EventEntity> {
            return ClientPublicApiFp(configuration).getEventInDivision(id, eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the leaderboard for a game.
         * @param {string} gameId 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighscores(gameId: string, divisionId?: string, options?: any): AxiosPromise<Array<HighscoreDto>> {
            return ClientPublicApiFp(configuration).getHighscores(gameId, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the leaderboard for a game, including the given session.
         * @param {string} gameId 
         * @param {string} sessionId 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighscoresWithSession(gameId: string, sessionId: string, divisionId?: string, options?: any): AxiosPromise<Array<HighscoreDto>> {
            return ClientPublicApiFp(configuration).getHighscoresWithSession(gameId, sessionId, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get joined project-wide highscores based on user key.
         * @param {string} gameId 
         * @param {string} userKey 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJoinedHighscoresWithKey(gameId: string, userKey: string, divisionId?: string, options?: any): AxiosPromise<Array<HighscoreDto>> {
            return ClientPublicApiFp(configuration).getJoinedHighscoresWithKey(gameId, userKey, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an organization\'s default brandkit for theming
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCompanyTheme(id: string, options?: any): AxiosPromise<BrandkitEntity> {
            return ClientPublicApiFp(configuration).getPublicCompanyTheme(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a markdown page for active Whitelabel using the X-App-Bundle-ID request header.
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicMarkdownPageContent(languageId: string, pageId: string, options?: any): AxiosPromise<MarkdownPageContentEntity> {
            return ClientPublicApiFp(configuration).getPublicMarkdownPageContent(languageId, pageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deprecated alias of getPublicMarkdownPageContent. Get a page for active Whitelabel using the X-App-Bundle-ID request header.
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicPageContent(languageId: string, pageId: string, options?: any): AxiosPromise<MarkdownPageContentEntity> {
            return ClientPublicApiFp(configuration).getPublicPageContent(languageId, pageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all up to date translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslations(options?: any): AxiosPromise<Array<LanguageTranslationsDto>> {
            return ClientPublicApiFp(configuration).getTranslations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Log into client with google token
         * @param {GoogleTokenDto} googleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin(googleTokenDto: GoogleTokenDto, options?: any): AxiosPromise<AccessToken> {
            return ClientPublicApiFp(configuration).googleLogin(googleTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find on-demand playlists for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onDemandPlaylistsOfDivision(id: string, options?: any): AxiosPromise<Array<OnDemandPlaylistEntity>> {
            return ClientPublicApiFp(configuration).onDemandPlaylistsOfDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary An article available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContentArticle(id: string, articleId: string, options?: any): AxiosPromise<ArticleEntity> {
            return ClientPublicApiFp(configuration).pageContentArticle(id, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary An event available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContentEvent(id: string, eventId: string, options?: any): AxiosPromise<ClientEventDto> {
            return ClientPublicApiFp(configuration).pageContentEvent(id, eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All events available through the division\'s embedded collections
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContentEvents(id: string, options?: any): AxiosPromise<Array<ClientEventDto>> {
            return ClientPublicApiFp(configuration).pageContentEvents(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary A game available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContentGame(id: string, gameId: string, options?: any): AxiosPromise<GameEntity> {
            return ClientPublicApiFp(configuration).pageContentGame(id, gameId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary An on-demand video available through the division\'s embedded collections
         * @param {string} id 
         * @param {string} videoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageContentVideo(id: string, videoId: string, options?: any): AxiosPromise<OnDemandVideoEntity> {
            return ClientPublicApiFp(configuration).pageContentVideo(id, videoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The page index of a division with pages
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagesOfDivision(id: string, options?: any): AxiosPromise<Array<PageSummaryDto>> {
            return ClientPublicApiFp(configuration).pagesOfDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get participants for event
         * @param {string} id 
         * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participantsForEvent(id: string, divisionId?: string, options?: any): AxiosPromise<Array<ClientEventParticipantDto>> {
            return ClientPublicApiFp(configuration).participantsForEvent(id, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a verification token via passwordless login
         * @param {PasswordlessRequestDto} passwordlessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordlessLogin(passwordlessRequestDto: PasswordlessRequestDto, options?: any): AxiosPromise<PasswordlessRequestResultDto> {
            return ClientPublicApiFp(configuration).passwordlessLogin(passwordlessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify a token against an earlier generated verification token
         * @param {PasswordlessVerifyDto} passwordlessVerifyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordlessVerify(passwordlessVerifyDto: PasswordlessVerifyDto, options?: any): AxiosPromise<PasswordlessVerifyResultDto> {
            return ClientPublicApiFp(configuration).passwordlessVerify(passwordlessVerifyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} sceneId 
         * @param {FeedbackPostDto} feedbackPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeeback(sceneId: string, feedbackPostDto: FeedbackPostDto, options?: any): AxiosPromise<FeedbackEntity> {
            return ClientPublicApiFp(configuration).postFeeback(sceneId, feedbackPostDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a file from the player (user-generated content)
         * @param {string} divisionId 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicFileUpload(divisionId: string, file: any, options?: any): AxiosPromise<FileUploadResultDto> {
            return ClientPublicApiFp(configuration).publicFileUpload(divisionId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Count one answer to a project\'s consent banner, anonymously.
         * @param {PageConsentDto} pageConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordPageConsent(pageConsentDto: PageConsentDto, options?: any): AxiosPromise<ResultDto> {
            return ClientPublicApiFp(configuration).recordPageConsent(pageConsentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record a batch of page visit events. Ids are client generated.
         * @param {PageEventsBatchDto} pageEventsBatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordPageEvents(pageEventsBatchDto: PageEventsBatchDto, options?: any): AxiosPromise<ResultDto> {
            return ClientPublicApiFp(configuration).recordPageEvents(pageEventsBatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve an embedded collection\'s members for a division
         * @param {string} id 
         * @param {string} collectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCollectionInDivision(id: string, collectionId: string, options?: any): AxiosPromise<ResolvedCollectionDto> {
            return ClientPublicApiFp(configuration).resolveCollectionInDivision(id, collectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve a single embedded content item\'s card summary for a division
         * @param {string} id 
         * @param {string} kind 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveContentItemInDivision(id: string, kind: string, itemId: string, options?: any): AxiosPromise<ResolvedContentItemDto> {
            return ClientPublicApiFp(configuration).resolveContentItemInDivision(id, kind, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve several embedded content items\' card summaries for a division in one go, e.g. a journey\'s; `items` is a comma-separated list of kind:itemId
         * @param {string} id 
         * @param {string} items 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveContentItemsInDivision(id: string, items: string, options?: any): AxiosPromise<Array<ResolvedContentItemEntryDto>> {
            return ClientPublicApiFp(configuration).resolveContentItemsInDivision(id, items, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve a page (by slug or id) for a division and language
         * @param {string} id 
         * @param {string} pageIdOrSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolvePageInDivision(id: string, pageIdOrSlug: string, options?: any): AxiosPromise<ResolvedPageDto> {
            return ClientPublicApiFp(configuration).resolvePageInDivision(id, pageIdOrSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update session data for game session. ID\'s are client generated.
         * @param {SessionUpdateDto} sessionUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSession(sessionUpdateDto: SessionUpdateDto, options?: any): AxiosPromise<ResultDto> {
            return ClientPublicApiFp(configuration).updateSession(sessionUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientPublicApi - object-oriented interface
 * @export
 * @class ClientPublicApi
 * @extends {BaseAPI}
 */
export class ClientPublicApi extends BaseAPI {
    /**
     * 
     * @summary Log in anonymously
     * @param {AnonymousAccessDto} anonymousAccessDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public anonymousLogin(anonymousAccessDto: AnonymousAccessDto, options?: any) {
        return ClientPublicApiFp(this.configuration).anonymousLogin(anonymousAccessDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Append journal entries for a game session.
     * @param {JournalAppendDto} journalAppendDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public appendSessionJournal(journalAppendDto: JournalAppendDto, options?: any) {
        return ClientPublicApiFp(this.configuration).appendSessionJournal(journalAppendDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Log into client with apple token
     * @param {AppleTokenDto} appleTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public appleLogin(appleTokenDto: AppleTokenDto, options?: any) {
        return ClientPublicApiFp(this.configuration).appleLogin(appleTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find articles for division
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public articlesOfDivision(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).articlesOfDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the contact information for the division.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public contactForDivision(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).contactForDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create analytics based on the time user spends on article
     * @param {string} articleId 
     * @param {ArticleAnalyticsDto} articleAnalyticsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public createHitOnArticle(articleId: string, articleAnalyticsDto: ArticleAnalyticsDto, options?: any) {
        return ClientPublicApiFp(this.configuration).createHitOnArticle(articleId, articleAnalyticsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create analytics for on-demand video views
     * @param {string} videoId 
     * @param {OnDemandVideoAnalyticsDto} onDemandVideoAnalyticsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public createHitOnOnDemandVideo(videoId: string, onDemandVideoAnalyticsDto: OnDemandVideoAnalyticsDto, options?: any) {
        return ClientPublicApiFp(this.configuration).createHitOnOnDemandVideo(videoId, onDemandVideoAnalyticsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve download URL for given game
     * @param {DownloadDto} downloadDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public downloadUrlPublic(downloadDto: DownloadDto, options?: any) {
        return ClientPublicApiFp(this.configuration).downloadUrlPublic(downloadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get events for division
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public eventsForDivision(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).eventsForDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Log into client with facebook token
     * @param {FacebookTokenDto} facebookTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public facebookLogin(facebookTokenDto: FacebookTokenDto, options?: any) {
        return ClientPublicApiFp(this.configuration).facebookLogin(facebookTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find a single published game for division
     * @param {string} id 
     * @param {string} gameId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public gameOfDivision(id: string, gameId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).gameOfDivision(id, gameId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find games for division
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public gamesOfDivision(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).gamesOfDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get division QR Code
     * @param {string} divisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getDivisionQRCode(divisionId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getDivisionQRCode(divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve estimated lat/lon location for current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getEstimatedLocation(options?: any) {
        return ClientPublicApiFp(this.configuration).getEstimatedLocation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get events for division
     * @param {string} id 
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getEventInDivision(id: string, eventId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getEventInDivision(id, eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the leaderboard for a game.
     * @param {string} gameId 
     * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getHighscores(gameId: string, divisionId?: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getHighscores(gameId, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the leaderboard for a game, including the given session.
     * @param {string} gameId 
     * @param {string} sessionId 
     * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getHighscoresWithSession(gameId: string, sessionId: string, divisionId?: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getHighscoresWithSession(gameId, sessionId, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get joined project-wide highscores based on user key.
     * @param {string} gameId 
     * @param {string} userKey 
     * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getJoinedHighscoresWithKey(gameId: string, userKey: string, divisionId?: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getJoinedHighscoresWithKey(gameId, userKey, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an organization\'s default brandkit for theming
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getPublicCompanyTheme(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getPublicCompanyTheme(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a markdown page for active Whitelabel using the X-App-Bundle-ID request header.
     * @param {string} languageId 
     * @param {string} pageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getPublicMarkdownPageContent(languageId: string, pageId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getPublicMarkdownPageContent(languageId, pageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deprecated alias of getPublicMarkdownPageContent. Get a page for active Whitelabel using the X-App-Bundle-ID request header.
     * @param {string} languageId 
     * @param {string} pageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getPublicPageContent(languageId: string, pageId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getPublicPageContent(languageId, pageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all up to date translations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getTranslations(options?: any) {
        return ClientPublicApiFp(this.configuration).getTranslations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Log into client with google token
     * @param {GoogleTokenDto} googleTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public googleLogin(googleTokenDto: GoogleTokenDto, options?: any) {
        return ClientPublicApiFp(this.configuration).googleLogin(googleTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find on-demand playlists for division
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public onDemandPlaylistsOfDivision(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).onDemandPlaylistsOfDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary An article available through the division\'s embedded collections
     * @param {string} id 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public pageContentArticle(id: string, articleId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).pageContentArticle(id, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary An event available through the division\'s embedded collections
     * @param {string} id 
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public pageContentEvent(id: string, eventId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).pageContentEvent(id, eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary All events available through the division\'s embedded collections
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public pageContentEvents(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).pageContentEvents(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary A game available through the division\'s embedded collections
     * @param {string} id 
     * @param {string} gameId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public pageContentGame(id: string, gameId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).pageContentGame(id, gameId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary An on-demand video available through the division\'s embedded collections
     * @param {string} id 
     * @param {string} videoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public pageContentVideo(id: string, videoId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).pageContentVideo(id, videoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The page index of a division with pages
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public pagesOfDivision(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).pagesOfDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get participants for event
     * @param {string} id 
     * @param {string} [divisionId] The project the content is viewed in. Required for organization content, which has no project of its own; its authentication rules decide access.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public participantsForEvent(id: string, divisionId?: string, options?: any) {
        return ClientPublicApiFp(this.configuration).participantsForEvent(id, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a verification token via passwordless login
     * @param {PasswordlessRequestDto} passwordlessRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public passwordlessLogin(passwordlessRequestDto: PasswordlessRequestDto, options?: any) {
        return ClientPublicApiFp(this.configuration).passwordlessLogin(passwordlessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify a token against an earlier generated verification token
     * @param {PasswordlessVerifyDto} passwordlessVerifyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public passwordlessVerify(passwordlessVerifyDto: PasswordlessVerifyDto, options?: any) {
        return ClientPublicApiFp(this.configuration).passwordlessVerify(passwordlessVerifyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post feedback for a given scene ID.
     * @param {string} sceneId 
     * @param {FeedbackPostDto} feedbackPostDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public postFeeback(sceneId: string, feedbackPostDto: FeedbackPostDto, options?: any) {
        return ClientPublicApiFp(this.configuration).postFeeback(sceneId, feedbackPostDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a file from the player (user-generated content)
     * @param {string} divisionId 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public publicFileUpload(divisionId: string, file: any, options?: any) {
        return ClientPublicApiFp(this.configuration).publicFileUpload(divisionId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Count one answer to a project\'s consent banner, anonymously.
     * @param {PageConsentDto} pageConsentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public recordPageConsent(pageConsentDto: PageConsentDto, options?: any) {
        return ClientPublicApiFp(this.configuration).recordPageConsent(pageConsentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record a batch of page visit events. Ids are client generated.
     * @param {PageEventsBatchDto} pageEventsBatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public recordPageEvents(pageEventsBatchDto: PageEventsBatchDto, options?: any) {
        return ClientPublicApiFp(this.configuration).recordPageEvents(pageEventsBatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve an embedded collection\'s members for a division
     * @param {string} id 
     * @param {string} collectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public resolveCollectionInDivision(id: string, collectionId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).resolveCollectionInDivision(id, collectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve a single embedded content item\'s card summary for a division
     * @param {string} id 
     * @param {string} kind 
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public resolveContentItemInDivision(id: string, kind: string, itemId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).resolveContentItemInDivision(id, kind, itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve several embedded content items\' card summaries for a division in one go, e.g. a journey\'s; `items` is a comma-separated list of kind:itemId
     * @param {string} id 
     * @param {string} items 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public resolveContentItemsInDivision(id: string, items: string, options?: any) {
        return ClientPublicApiFp(this.configuration).resolveContentItemsInDivision(id, items, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve a page (by slug or id) for a division and language
     * @param {string} id 
     * @param {string} pageIdOrSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public resolvePageInDivision(id: string, pageIdOrSlug: string, options?: any) {
        return ClientPublicApiFp(this.configuration).resolvePageInDivision(id, pageIdOrSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update session data for game session. ID\'s are client generated.
     * @param {SessionUpdateDto} sessionUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public updateSession(sessionUpdateDto: SessionUpdateDto, options?: any) {
        return ClientPublicApiFp(this.configuration).updateSession(sessionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DeepLinkApi - axios parameter creator
 * @export
 */
export const DeepLinkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get deep link for request
         * @param {DeepLinkFindDto} deepLinkFindDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDeepLink: async (deepLinkFindDto: DeepLinkFindDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deepLinkFindDto' is not null or undefined
            if (deepLinkFindDto === null || deepLinkFindDto === undefined) {
                throw new RequiredError('deepLinkFindDto','Required parameter deepLinkFindDto was null or undefined when calling retrieveDeepLink.');
            }
            const localVarPath = `/deep-link/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deepLinkFindDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deepLinkFindDto !== undefined ? deepLinkFindDto : {}) : (deepLinkFindDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deep link for device
         * @param {DeepLinkPutDto} deepLinkPutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDeepLink: async (deepLinkPutDto: DeepLinkPutDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deepLinkPutDto' is not null or undefined
            if (deepLinkPutDto === null || deepLinkPutDto === undefined) {
                throw new RequiredError('deepLinkPutDto','Required parameter deepLinkPutDto was null or undefined when calling saveDeepLink.');
            }
            const localVarPath = `/deep-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deepLinkPutDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deepLinkPutDto !== undefined ? deepLinkPutDto : {}) : (deepLinkPutDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeepLinkApi - functional programming interface
 * @export
 */
export const DeepLinkApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get deep link for request
         * @param {DeepLinkFindDto} deepLinkFindDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveDeepLink(deepLinkFindDto: DeepLinkFindDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeepLinkResponseDto>> {
            const localVarAxiosArgs = await DeepLinkApiAxiosParamCreator(configuration).retrieveDeepLink(deepLinkFindDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Save deep link for device
         * @param {DeepLinkPutDto} deepLinkPutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDeepLink(deepLinkPutDto: DeepLinkPutDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await DeepLinkApiAxiosParamCreator(configuration).saveDeepLink(deepLinkPutDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DeepLinkApi - factory interface
 * @export
 */
export const DeepLinkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get deep link for request
         * @param {DeepLinkFindDto} deepLinkFindDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDeepLink(deepLinkFindDto: DeepLinkFindDto, options?: any): AxiosPromise<DeepLinkResponseDto> {
            return DeepLinkApiFp(configuration).retrieveDeepLink(deepLinkFindDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deep link for device
         * @param {DeepLinkPutDto} deepLinkPutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDeepLink(deepLinkPutDto: DeepLinkPutDto, options?: any): AxiosPromise<string> {
            return DeepLinkApiFp(configuration).saveDeepLink(deepLinkPutDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeepLinkApi - object-oriented interface
 * @export
 * @class DeepLinkApi
 * @extends {BaseAPI}
 */
export class DeepLinkApi extends BaseAPI {
    /**
     * 
     * @summary Get deep link for request
     * @param {DeepLinkFindDto} deepLinkFindDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeepLinkApi
     */
    public retrieveDeepLink(deepLinkFindDto: DeepLinkFindDto, options?: any) {
        return DeepLinkApiFp(this.configuration).retrieveDeepLink(deepLinkFindDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deep link for device
     * @param {DeepLinkPutDto} deepLinkPutDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeepLinkApi
     */
    public saveDeepLink(deepLinkPutDto: DeepLinkPutDto, options?: any) {
        return DeepLinkApiFp(this.configuration).saveDeepLink(deepLinkPutDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DivisionApi - axios parameter creator
 * @export
 */
export const DivisionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add department with given ID to this division
         * @param {string} id 
         * @param {DivisionDepartmentEntity} divisionDepartmentEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDivisionDepartment: async (id: string, divisionDepartmentEntity: DivisionDepartmentEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling addDivisionDepartment.');
            }
            // verify required parameter 'divisionDepartmentEntity' is not null or undefined
            if (divisionDepartmentEntity === null || divisionDepartmentEntity === undefined) {
                throw new RequiredError('divisionDepartmentEntity','Required parameter divisionDepartmentEntity was null or undefined when calling addDivisionDepartment.');
            }
            const localVarPath = `/builder/division/{id}/department`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof divisionDepartmentEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(divisionDepartmentEntity !== undefined ? divisionDepartmentEntity : {}) : (divisionDepartmentEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add subscription with given ID to this division
         * @param {string} id 
         * @param {DivisionSubscriptionEntity} divisionSubscriptionEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDivisionSubscription: async (id: string, divisionSubscriptionEntity: DivisionSubscriptionEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling addDivisionSubscription.');
            }
            // verify required parameter 'divisionSubscriptionEntity' is not null or undefined
            if (divisionSubscriptionEntity === null || divisionSubscriptionEntity === undefined) {
                throw new RequiredError('divisionSubscriptionEntity','Required parameter divisionSubscriptionEntity was null or undefined when calling addDivisionSubscription.');
            }
            const localVarPath = `/builder/division/{id}/subscription`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof divisionSubscriptionEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(divisionSubscriptionEntity !== undefined ? divisionSubscriptionEntity : {}) : (divisionSubscriptionEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create a collection owned by a division
         * @param {string} id 
         * @param {CollectionEntity} collectionEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollectionInDivision: async (id: string, collectionEntity: CollectionEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createCollectionInDivision.');
            }
            // verify required parameter 'collectionEntity' is not null or undefined
            if (collectionEntity === null || collectionEntity === undefined) {
                throw new RequiredError('collectionEntity','Required parameter collectionEntity was null or undefined when calling createCollectionInDivision.');
            }
            const localVarPath = `/builder/division/{id}/collections`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof collectionEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(collectionEntity !== undefined ? collectionEntity : {}) : (collectionEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @summary Create new divisions
         * @param {DivisionCreateDto} divisionCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDivision: async (divisionCreateDto: DivisionCreateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionCreateDto' is not null or undefined
            if (divisionCreateDto === null || divisionCreateDto === undefined) {
                throw new RequiredError('divisionCreateDto','Required parameter divisionCreateDto was null or undefined when calling createDivision.');
            }
            const localVarPath = `/builder/division`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof divisionCreateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(divisionCreateDto !== undefined ? divisionCreateDto : {}) : (divisionCreateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create a game in a division
         * @param {string} id 
         * @param {GameCreateDto} gameCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGameInDivision: async (id: string, gameCreateDto: GameCreateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createGameInDivision.');
            }
            // verify required parameter 'gameCreateDto' is not null or undefined
            if (gameCreateDto === null || gameCreateDto === undefined) {
                throw new RequiredError('gameCreateDto','Required parameter gameCreateDto was null or undefined when calling createGameInDivision.');
            }
            const localVarPath = `/builder/division/{id}/games`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof gameCreateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(gameCreateDto !== undefined ? gameCreateDto : {}) : (gameCreateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @summary Delete division by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteDivision.');
            }
            const localVarPath = `/builder/division/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
         * @summary Delete department by id
         * @param {string} id 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDivisionDepartment: async (id: string, departmentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteDivisionDepartment.');
            }
            // verify required parameter 'departmentId' is not null or undefined
            if (departmentId === null || departmentId === undefined) {
                throw new RequiredError('departmentId','Required parameter departmentId was null or undefined when calling deleteDivisionDepartment.');
            }
            const localVarPath = `/builder/division/{id}/department/{departmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete subscription by id
         * @param {string} id 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDivisionSubscription: async (id: string, subscriptionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteDivisionSubscription.');
            }
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new RequiredError('subscriptionId','Required parameter subscriptionId was null or undefined when calling deleteDivisionSubscription.');
            }
            const localVarPath = `/builder/division/{id}/subscription/{subscriptionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Whether any story in the given division has a category
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionHasStoryCategories: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling divisionHasStoryCategories.');
            }
            const localVarPath = `/builder/division/{id}/games/categories`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Count users of the given division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionUsersCount: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling divisionUsersCount.');
            }
            const localVarPath = `/builder/division/{id}/users/count`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Duplicate all games of this division to another division
         * @param {string} id 
         * @param {DivisionDuplicateDto} divisionDuplicateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateDivisionGames: async (id: string, divisionDuplicateDto: DivisionDuplicateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling duplicateDivisionGames.');
            }
            // verify required parameter 'divisionDuplicateDto' is not null or undefined
            if (divisionDuplicateDto === null || divisionDuplicateDto === undefined) {
                throw new RequiredError('divisionDuplicateDto','Required parameter divisionDuplicateDto was null or undefined when calling duplicateDivisionGames.');
            }
            const localVarPath = `/builder/division/{id}/duplicate/games`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof divisionDuplicateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(divisionDuplicateDto !== undefined ? divisionDuplicateDto : {}) : (divisionDuplicateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paste a game from data in a division
         * @param {string} id 
         * @param {DivisionDuplicateBulkDto} divisionDuplicateBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateEventsIntoDivision: async (id: string, divisionDuplicateBulkDto: DivisionDuplicateBulkDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling duplicateEventsIntoDivision.');
            }
            // verify required parameter 'divisionDuplicateBulkDto' is not null or undefined
            if (divisionDuplicateBulkDto === null || divisionDuplicateBulkDto === undefined) {
                throw new RequiredError('divisionDuplicateBulkDto','Required parameter divisionDuplicateBulkDto was null or undefined when calling duplicateEventsIntoDivision.');
            }
            const localVarPath = `/builder/division/{id}/events/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof divisionDuplicateBulkDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(divisionDuplicateBulkDto !== undefined ? divisionDuplicateBulkDto : {}) : (divisionDuplicateBulkDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paste a game from data in a division
         * @param {string} id 
         * @param {DivisionDuplicateBulkDto} divisionDuplicateBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateGamesIntoDivision: async (id: string, divisionDuplicateBulkDto: DivisionDuplicateBulkDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling duplicateGamesIntoDivision.');
            }
            // verify required parameter 'divisionDuplicateBulkDto' is not null or undefined
            if (divisionDuplicateBulkDto === null || divisionDuplicateBulkDto === undefined) {
                throw new RequiredError('divisionDuplicateBulkDto','Required parameter divisionDuplicateBulkDto was null or undefined when calling duplicateGamesIntoDivision.');
            }
            const localVarPath = `/builder/division/{id}/games/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof divisionDuplicateBulkDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(divisionDuplicateBulkDto !== undefined ? divisionDuplicateBulkDto : {}) : (divisionDuplicateBulkDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get all unique tags used in division assets.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetTagsInDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAssetTagsInDivision.');
            }
            const localVarPath = `/builder/division/{id}/assets/tags`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get base language of Division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionBaseLanguage: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getDivisionBaseLanguage.');
            }
            const localVarPath = `/builder/division/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
         * @summary Get division by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getDivisionById.');
            }
            const localVarPath = `/builder/division/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
         * @summary Get department by id
         * @param {string} id 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionDepartmentById: async (id: string, departmentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getDivisionDepartmentById.');
            }
            // verify required parameter 'departmentId' is not null or undefined
            if (departmentId === null || departmentId === undefined) {
                throw new RequiredError('departmentId','Required parameter departmentId was null or undefined when calling getDivisionDepartmentById.');
            }
            const localVarPath = `/builder/division/{id}/department/{departmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get division QR Code
         * @param {string} id 
         * @param {string} environment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionQR: async (id: string, environment: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getDivisionQR.');
            }
            // verify required parameter 'environment' is not null or undefined
            if (environment === null || environment === undefined) {
                throw new RequiredError('environment','Required parameter environment was null or undefined when calling getDivisionQR.');
            }
            const localVarPath = `/builder/division/{id}/qr/{environment}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"environment"}}`, encodeURIComponent(String(environment)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get theme by id
         * @param {string} id 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionSubscriptionById: async (id: string, subscriptionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getDivisionSubscriptionById.');
            }
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new RequiredError('subscriptionId','Required parameter subscriptionId was null or undefined when calling getDivisionSubscriptionById.');
            }
            const localVarPath = `/builder/division/{id}/subscription/{subscriptionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Get full translation of Division
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionTranslation: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getDivisionTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling getDivisionTranslation.');
            }
            const localVarPath = `/builder/division/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Get all translations of Division without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionTranslations: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getDivisionTranslations.');
            }
            const localVarPath = `/builder/division/{id}/translation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary List all divisions in collapsed format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllDivisions: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/builder/division/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate all divisions user has access to in extended format.
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAllDivision: async (skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateAllDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateAllDivision.');
            }
            const localVarPath = `/builder/division`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate articles owned by a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateArticlesInDivision: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateArticlesInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateArticlesInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateArticlesInDivision.');
            }
            const localVarPath = `/builder/division/{id}/articles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate available assets in division.
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {Array<string>} [extensions] Filter what type of acceptions are accepted.
         * @param {Array<string>} [origins] Filter what type of origins are accepted.
         * @param {Array<string>} [gameIds] Filter assets by game/story IDs they are attached to.
         * @param {Array<string>} [tags] Filter assets by tags (e.g., \&#39;icon\&#39;, \&#39;background\&#39;). Assets matching any of the provided tags will be returned.
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAssetsInDivision: async (id: string, skip: number, take: number, extensions?: Array<string>, origins?: Array<string>, gameIds?: Array<string>, tags?: Array<string>, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateAssetsInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateAssetsInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateAssetsInDivision.');
            }
            const localVarPath = `/builder/division/{id}/assets`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (extensions) {
                localVarQueryParameter['extensions'] = extensions;
            }

            if (origins) {
                localVarQueryParameter['origins'] = origins;
            }

            if (gameIds) {
                localVarQueryParameter['gameIds'] = gameIds;
            }

            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate the collections owned by a division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateCollectionsInDivision: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateCollectionsInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateCollectionsInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateCollectionsInDivision.');
            }
            const localVarPath = `/builder/division/{id}/collections`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Paginate departments of the given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateDivisionDepartments: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateDivisionDepartments.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateDivisionDepartments.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateDivisionDepartments.');
            }
            const localVarPath = `/builder/division/{id}/department`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Paginate subscriptions of the given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateDivisionSubscriptions: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateDivisionSubscriptions.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateDivisionSubscriptions.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateDivisionSubscriptions.');
            }
            const localVarPath = `/builder/division/{id}/subscription`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate divisions that have at least one brandkit.
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateDivisionsWithBrandkits: async (skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateDivisionsWithBrandkits.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateDivisionsWithBrandkits.');
            }
            const localVarPath = `/builder/division/with-brandkits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate hosts for a given event
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEventHosts: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateEventHosts.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateEventHosts.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateEventHosts.');
            }
            const localVarPath = `/builder/division/{id}/hosts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
         * @summary Paginate events for a given division
         * @param {string} id 
         * @param {'all' | 'past' | 'coming'} filter Filter between \&#39;all\&#39;,\&#39;past\&#39; or \&#39;coming\&#39; events. If omitted, this function fetches all events.
         * @param {number} skip 
         * @param {number} take 
         * @param {'webinar' | 'event'} [eventType] Filter by event type: \&#39;webinar\&#39; or \&#39;event\&#39;. If omitted, fetches all event types.
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEventsInDivision: async (id: string, filter: 'all' | 'past' | 'coming', skip: number, take: number, eventType?: 'webinar' | 'event', keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateEventsInDivision.');
            }
            // verify required parameter 'filter' is not null or undefined
            if (filter === null || filter === undefined) {
                throw new RequiredError('filter','Required parameter filter was null or undefined when calling paginateEventsInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateEventsInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateEventsInDivision.');
            }
            const localVarPath = `/builder/division/{id}/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (eventType !== undefined) {
                localVarQueryParameter['eventType'] = eventType;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Games for logged in user in a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {'custom' | 'last_edited' | 'created'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateGamesInDivision: async (id: string, skip: number, take: number, keyword?: string, order?: 'custom' | 'last_edited' | 'created', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateGamesInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateGamesInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateGamesInDivision.');
            }
            const localVarPath = `/builder/division/{id}/games`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate on-demand videos owned by a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateOnDemandVideosInDivision: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateOnDemandVideosInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateOnDemandVideosInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateOnDemandVideosInDivision.');
            }
            const localVarPath = `/builder/division/{id}/on-demand-videos`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate the articles of the organization a division belongs to
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateOrganizationArticlesInDivision: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateOrganizationArticlesInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateOrganizationArticlesInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateOrganizationArticlesInDivision.');
            }
            const localVarPath = `/builder/division/{id}/organization-articles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate the on-demand videos of the organization a division belongs to
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateOrganizationOnDemandVideosInDivision: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateOrganizationOnDemandVideosInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateOrganizationOnDemandVideosInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateOrganizationOnDemandVideosInDivision.');
            }
            const localVarPath = `/builder/division/{id}/organization-on-demand-videos`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate themes for a division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateThemesInDivision: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateThemesInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateThemesInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateThemesInDivision.');
            }
            const localVarPath = `/builder/division/{id}/themes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate themes for a division and the parent whitelabel
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateThemesInDivisionWithParents: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateThemesInDivisionWithParents.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateThemesInDivisionWithParents.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateThemesInDivisionWithParents.');
            }
            const localVarPath = `/builder/division/{id}/themes/parent`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paginate users for a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateUsersInDivision: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateUsersInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateUsersInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateUsersInDivision.');
            }
            const localVarPath = `/builder/division/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paste a game from data in a division
         * @param {string} id 
         * @param {GamePayloadDto} gamePayloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pasteGameInDivision: async (id: string, gamePayloadDto: GamePayloadDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling pasteGameInDivision.');
            }
            // verify required parameter 'gamePayloadDto' is not null or undefined
            if (gamePayloadDto === null || gamePayloadDto === undefined) {
                throw new RequiredError('gamePayloadDto','Required parameter gamePayloadDto was null or undefined when calling pasteGameInDivision.');
            }
            const localVarPath = `/builder/division/{id}/games/paste`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof gamePayloadDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(gamePayloadDto !== undefined ? gamePayloadDto : {}) : (gamePayloadDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Remove translation of Division
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDivisionTranslation: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeDivisionTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling removeDivisionTranslation.');
            }
            const localVarPath = `/builder/division/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Set base language of Division
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDivisionBaseLanguage: async (id: string, baseLanguageDto: BaseLanguageDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setDivisionBaseLanguage.');
            }
            // verify required parameter 'baseLanguageDto' is not null or undefined
            if (baseLanguageDto === null || baseLanguageDto === undefined) {
                throw new RequiredError('baseLanguageDto','Required parameter baseLanguageDto was null or undefined when calling setDivisionBaseLanguage.');
            }
            const localVarPath = `/builder/division/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof baseLanguageDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(baseLanguageDto !== undefined ? baseLanguageDto : {}) : (baseLanguageDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Sort collections owned by a division
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortCollectionsInDivision: async (id: string, requestBody: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sortCollectionsInDivision.');
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling sortCollectionsInDivision.');
            }
            const localVarPath = `/builder/division/{id}/collections/sort`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Sort games for user in a given division
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortGamesInDivision: async (id: string, requestBody: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sortGamesInDivision.');
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling sortGamesInDivision.');
            }
            const localVarPath = `/builder/division/{id}/games/sort`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Update division by id (partial update)
         * @param {string} id 
         * @param {DivisionUpdateDto} divisionUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDivision: async (id: string, divisionUpdateDto: DivisionUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateDivision.');
            }
            // verify required parameter 'divisionUpdateDto' is not null or undefined
            if (divisionUpdateDto === null || divisionUpdateDto === undefined) {
                throw new RequiredError('divisionUpdateDto','Required parameter divisionUpdateDto was null or undefined when calling updateDivision.');
            }
            const localVarPath = `/builder/division/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof divisionUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(divisionUpdateDto !== undefined ? divisionUpdateDto : {}) : (divisionUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
         * @summary Update department by id (partial update)
         * @param {string} id 
         * @param {string} departmentId 
         * @param {DivisionDepartmentEntity} divisionDepartmentEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDivisionDepartment: async (id: string, departmentId: string, divisionDepartmentEntity: DivisionDepartmentEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateDivisionDepartment.');
            }
            // verify required parameter 'departmentId' is not null or undefined
            if (departmentId === null || departmentId === undefined) {
                throw new RequiredError('departmentId','Required parameter departmentId was null or undefined when calling updateDivisionDepartment.');
            }
            // verify required parameter 'divisionDepartmentEntity' is not null or undefined
            if (divisionDepartmentEntity === null || divisionDepartmentEntity === undefined) {
                throw new RequiredError('divisionDepartmentEntity','Required parameter divisionDepartmentEntity was null or undefined when calling updateDivisionDepartment.');
            }
            const localVarPath = `/builder/division/{id}/department/{departmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof divisionDepartmentEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(divisionDepartmentEntity !== undefined ? divisionDepartmentEntity : {}) : (divisionDepartmentEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update subscription by id (partial update)
         * @param {string} id 
         * @param {string} subscriptionId 
         * @param {DivisionSubscriptionEntity} divisionSubscriptionEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDivisionSubscription: async (id: string, subscriptionId: string, divisionSubscriptionEntity: DivisionSubscriptionEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateDivisionSubscription.');
            }
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new RequiredError('subscriptionId','Required parameter subscriptionId was null or undefined when calling updateDivisionSubscription.');
            }
            // verify required parameter 'divisionSubscriptionEntity' is not null or undefined
            if (divisionSubscriptionEntity === null || divisionSubscriptionEntity === undefined) {
                throw new RequiredError('divisionSubscriptionEntity','Required parameter divisionSubscriptionEntity was null or undefined when calling updateDivisionSubscription.');
            }
            const localVarPath = `/builder/division/{id}/subscription/{subscriptionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof divisionSubscriptionEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(divisionSubscriptionEntity !== undefined ? divisionSubscriptionEntity : {}) : (divisionSubscriptionEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Update translations of Division
         * @param {string} id 
         * @param {string} language 
         * @param {DivisionTranslationEntity} divisionTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDivisionTranslation: async (id: string, language: string, divisionTranslationEntity: DivisionTranslationEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateDivisionTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling updateDivisionTranslation.');
            }
            // verify required parameter 'divisionTranslationEntity' is not null or undefined
            if (divisionTranslationEntity === null || divisionTranslationEntity === undefined) {
                throw new RequiredError('divisionTranslationEntity','Required parameter divisionTranslationEntity was null or undefined when calling updateDivisionTranslation.');
            }
            const localVarPath = `/builder/division/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof divisionTranslationEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(divisionTranslationEntity !== undefined ? divisionTranslationEntity : {}) : (divisionTranslationEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DivisionApi - functional programming interface
 * @export
 */
export const DivisionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add department with given ID to this division
         * @param {string} id 
         * @param {DivisionDepartmentEntity} divisionDepartmentEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDivisionDepartment(id: string, divisionDepartmentEntity: DivisionDepartmentEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).addDivisionDepartment(id, divisionDepartmentEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Add subscription with given ID to this division
         * @param {string} id 
         * @param {DivisionSubscriptionEntity} divisionSubscriptionEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDivisionSubscription(id: string, divisionSubscriptionEntity: DivisionSubscriptionEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).addDivisionSubscription(id, divisionSubscriptionEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create a collection owned by a division
         * @param {string} id 
         * @param {CollectionEntity} collectionEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCollectionInDivision(id: string, collectionEntity: CollectionEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).createCollectionInDivision(id, collectionEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @summary Create new divisions
         * @param {DivisionCreateDto} divisionCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDivision(divisionCreateDto: DivisionCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).createDivision(divisionCreateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create a game in a division
         * @param {string} id 
         * @param {GameCreateDto} gameCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGameInDivision(id: string, gameCreateDto: GameCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).createGameInDivision(id, gameCreateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @summary Delete division by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).deleteDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
         * @summary Delete department by id
         * @param {string} id 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDivisionDepartment(id: string, departmentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionDepartmentEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).deleteDivisionDepartment(id, departmentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete subscription by id
         * @param {string} id 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDivisionSubscription(id: string, subscriptionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionSubscriptionEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).deleteDivisionSubscription(id, subscriptionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Whether any story in the given division has a category
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async divisionHasStoryCategories(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionStoryCategoriesDto>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).divisionHasStoryCategories(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Count users of the given division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async divisionUsersCount(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionUsersCountDto>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).divisionUsersCount(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Duplicate all games of this division to another division
         * @param {string} id 
         * @param {DivisionDuplicateDto} divisionDuplicateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateDivisionGames(id: string, divisionDuplicateDto: DivisionDuplicateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleOkResponse>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).duplicateDivisionGames(id, divisionDuplicateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paste a game from data in a division
         * @param {string} id 
         * @param {DivisionDuplicateBulkDto} divisionDuplicateBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateEventsIntoDivision(id: string, divisionDuplicateBulkDto: DivisionDuplicateBulkDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).duplicateEventsIntoDivision(id, divisionDuplicateBulkDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paste a game from data in a division
         * @param {string} id 
         * @param {DivisionDuplicateBulkDto} divisionDuplicateBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateGamesIntoDivision(id: string, divisionDuplicateBulkDto: DivisionDuplicateBulkDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).duplicateGamesIntoDivision(id, divisionDuplicateBulkDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get all unique tags used in division assets.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetTagsInDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetTagDto>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).getAssetTagsInDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get base language of Division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDivisionBaseLanguage(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseLanguageDto>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).getDivisionBaseLanguage(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
         * @summary Get division by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDivisionById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).getDivisionById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
         * @summary Get department by id
         * @param {string} id 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDivisionDepartmentById(id: string, departmentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionDepartmentEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).getDivisionDepartmentById(id, departmentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get division QR Code
         * @param {string} id 
         * @param {string} environment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDivisionQR(id: string, environment: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrDto>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).getDivisionQR(id, environment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get theme by id
         * @param {string} id 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDivisionSubscriptionById(id: string, subscriptionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionSubscriptionEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).getDivisionSubscriptionById(id, subscriptionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Get full translation of Division
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDivisionTranslation(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DivisionTranslationEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).getDivisionTranslation(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Get all translations of Division without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDivisionTranslations(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DivisionTranslationEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).getDivisionTranslations(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary List all divisions in collapsed format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllDivisions(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DivisionEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).listAllDivisions(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate all divisions user has access to in extended format.
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateAllDivision(skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DivisionEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateAllDivision(skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate articles owned by a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateArticlesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArticleEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateArticlesInDivision(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate available assets in division.
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {Array<string>} [extensions] Filter what type of acceptions are accepted.
         * @param {Array<string>} [origins] Filter what type of origins are accepted.
         * @param {Array<string>} [gameIds] Filter assets by game/story IDs they are attached to.
         * @param {Array<string>} [tags] Filter assets by tags (e.g., \&#39;icon\&#39;, \&#39;background\&#39;). Assets matching any of the provided tags will be returned.
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateAssetsInDivision(id: string, skip: number, take: number, extensions?: Array<string>, origins?: Array<string>, gameIds?: Array<string>, tags?: Array<string>, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateAssetsInDivision(id, skip, take, extensions, origins, gameIds, tags, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate the collections owned by a division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateCollectionsInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CollectionEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateCollectionsInDivision(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Paginate departments of the given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateDivisionDepartments(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DivisionDepartmentEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateDivisionDepartments(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Paginate subscriptions of the given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateDivisionSubscriptions(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DivisionSubscriptionEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateDivisionSubscriptions(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate divisions that have at least one brandkit.
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateDivisionsWithBrandkits(skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DivisionEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateDivisionsWithBrandkits(skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate hosts for a given event
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateEventHosts(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateEventHosts(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
         * @summary Paginate events for a given division
         * @param {string} id 
         * @param {'all' | 'past' | 'coming'} filter Filter between \&#39;all\&#39;,\&#39;past\&#39; or \&#39;coming\&#39; events. If omitted, this function fetches all events.
         * @param {number} skip 
         * @param {number} take 
         * @param {'webinar' | 'event'} [eventType] Filter by event type: \&#39;webinar\&#39; or \&#39;event\&#39;. If omitted, fetches all event types.
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateEventsInDivision(id: string, filter: 'all' | 'past' | 'coming', skip: number, take: number, eventType?: 'webinar' | 'event', keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateEventsInDivision(id, filter, skip, take, eventType, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Games for logged in user in a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {'custom' | 'last_edited' | 'created'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateGamesInDivision(id: string, skip: number, take: number, keyword?: string, order?: 'custom' | 'last_edited' | 'created', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateGamesInDivision(id, skip, take, keyword, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate on-demand videos owned by a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateOnDemandVideosInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OnDemandVideoEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateOnDemandVideosInDivision(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate the articles of the organization a division belongs to
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateOrganizationArticlesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArticleEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateOrganizationArticlesInDivision(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate the on-demand videos of the organization a division belongs to
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateOrganizationOnDemandVideosInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OnDemandVideoEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateOrganizationOnDemandVideosInDivision(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate themes for a division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateThemesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ThemeEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateThemesInDivision(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate themes for a division and the parent whitelabel
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateThemesInDivisionWithParents(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ThemeEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateThemesInDivisionWithParents(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paginate users for a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateUsersInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEntity>>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).paginateUsersInDivision(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paste a game from data in a division
         * @param {string} id 
         * @param {GamePayloadDto} gamePayloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pasteGameInDivision(id: string, gamePayloadDto: GamePayloadDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).pasteGameInDivision(id, gamePayloadDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Remove translation of Division
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDivisionTranslation(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).removeDivisionTranslation(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Set base language of Division
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDivisionBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).setDivisionBaseLanguage(id, baseLanguageDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Sort collections owned by a division
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sortCollectionsInDivision(id: string, requestBody: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).sortCollectionsInDivision(id, requestBody, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Sort games for user in a given division
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sortGamesInDivision(id: string, requestBody: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).sortGamesInDivision(id, requestBody, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Update division by id (partial update)
         * @param {string} id 
         * @param {DivisionUpdateDto} divisionUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDivision(id: string, divisionUpdateDto: DivisionUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).updateDivision(id, divisionUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
         * @summary Update department by id (partial update)
         * @param {string} id 
         * @param {string} departmentId 
         * @param {DivisionDepartmentEntity} divisionDepartmentEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDivisionDepartment(id: string, departmentId: string, divisionDepartmentEntity: DivisionDepartmentEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionDepartmentEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).updateDivisionDepartment(id, departmentId, divisionDepartmentEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update subscription by id (partial update)
         * @param {string} id 
         * @param {string} subscriptionId 
         * @param {DivisionSubscriptionEntity} divisionSubscriptionEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDivisionSubscription(id: string, subscriptionId: string, divisionSubscriptionEntity: DivisionSubscriptionEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionSubscriptionEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).updateDivisionSubscription(id, subscriptionId, divisionSubscriptionEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Update translations of Division
         * @param {string} id 
         * @param {string} language 
         * @param {DivisionTranslationEntity} divisionTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDivisionTranslation(id: string, language: string, divisionTranslationEntity: DivisionTranslationEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionTranslationEntity>> {
            const localVarAxiosArgs = await DivisionApiAxiosParamCreator(configuration).updateDivisionTranslation(id, language, divisionTranslationEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DivisionApi - factory interface
 * @export
 */
export const DivisionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add department with given ID to this division
         * @param {string} id 
         * @param {DivisionDepartmentEntity} divisionDepartmentEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDivisionDepartment(id: string, divisionDepartmentEntity: DivisionDepartmentEntity, options?: any): AxiosPromise<void> {
            return DivisionApiFp(configuration).addDivisionDepartment(id, divisionDepartmentEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add subscription with given ID to this division
         * @param {string} id 
         * @param {DivisionSubscriptionEntity} divisionSubscriptionEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDivisionSubscription(id: string, divisionSubscriptionEntity: DivisionSubscriptionEntity, options?: any): AxiosPromise<void> {
            return DivisionApiFp(configuration).addDivisionSubscription(id, divisionSubscriptionEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create a collection owned by a division
         * @param {string} id 
         * @param {CollectionEntity} collectionEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollectionInDivision(id: string, collectionEntity: CollectionEntity, options?: any): AxiosPromise<CollectionEntity> {
            return DivisionApiFp(configuration).createCollectionInDivision(id, collectionEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @summary Create new divisions
         * @param {DivisionCreateDto} divisionCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDivision(divisionCreateDto: DivisionCreateDto, options?: any): AxiosPromise<DivisionEntity> {
            return DivisionApiFp(configuration).createDivision(divisionCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create a game in a division
         * @param {string} id 
         * @param {GameCreateDto} gameCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGameInDivision(id: string, gameCreateDto: GameCreateDto, options?: any): AxiosPromise<GameEntity> {
            return DivisionApiFp(configuration).createGameInDivision(id, gameCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @summary Delete division by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDivision(id: string, options?: any): AxiosPromise<DivisionEntity> {
            return DivisionApiFp(configuration).deleteDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
         * @summary Delete department by id
         * @param {string} id 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDivisionDepartment(id: string, departmentId: string, options?: any): AxiosPromise<DivisionDepartmentEntity> {
            return DivisionApiFp(configuration).deleteDivisionDepartment(id, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete subscription by id
         * @param {string} id 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDivisionSubscription(id: string, subscriptionId: string, options?: any): AxiosPromise<DivisionSubscriptionEntity> {
            return DivisionApiFp(configuration).deleteDivisionSubscription(id, subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Whether any story in the given division has a category
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionHasStoryCategories(id: string, options?: any): AxiosPromise<DivisionStoryCategoriesDto> {
            return DivisionApiFp(configuration).divisionHasStoryCategories(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Count users of the given division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionUsersCount(id: string, options?: any): AxiosPromise<DivisionUsersCountDto> {
            return DivisionApiFp(configuration).divisionUsersCount(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Duplicate all games of this division to another division
         * @param {string} id 
         * @param {DivisionDuplicateDto} divisionDuplicateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateDivisionGames(id: string, divisionDuplicateDto: DivisionDuplicateDto, options?: any): AxiosPromise<SimpleOkResponse> {
            return DivisionApiFp(configuration).duplicateDivisionGames(id, divisionDuplicateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paste a game from data in a division
         * @param {string} id 
         * @param {DivisionDuplicateBulkDto} divisionDuplicateBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateEventsIntoDivision(id: string, divisionDuplicateBulkDto: DivisionDuplicateBulkDto, options?: any): AxiosPromise<Array<EventEntity>> {
            return DivisionApiFp(configuration).duplicateEventsIntoDivision(id, divisionDuplicateBulkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paste a game from data in a division
         * @param {string} id 
         * @param {DivisionDuplicateBulkDto} divisionDuplicateBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateGamesIntoDivision(id: string, divisionDuplicateBulkDto: DivisionDuplicateBulkDto, options?: any): AxiosPromise<Array<GameEntity>> {
            return DivisionApiFp(configuration).duplicateGamesIntoDivision(id, divisionDuplicateBulkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get all unique tags used in division assets.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetTagsInDivision(id: string, options?: any): AxiosPromise<Array<AssetTagDto>> {
            return DivisionApiFp(configuration).getAssetTagsInDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get base language of Division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionBaseLanguage(id: string, options?: any): AxiosPromise<BaseLanguageDto> {
            return DivisionApiFp(configuration).getDivisionBaseLanguage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
         * @summary Get division by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionById(id: string, options?: any): AxiosPromise<DivisionEntity> {
            return DivisionApiFp(configuration).getDivisionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
         * @summary Get department by id
         * @param {string} id 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionDepartmentById(id: string, departmentId: string, options?: any): AxiosPromise<DivisionDepartmentEntity> {
            return DivisionApiFp(configuration).getDivisionDepartmentById(id, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Get division QR Code
         * @param {string} id 
         * @param {string} environment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionQR(id: string, environment: string, options?: any): AxiosPromise<QrDto> {
            return DivisionApiFp(configuration).getDivisionQR(id, environment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get theme by id
         * @param {string} id 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionSubscriptionById(id: string, subscriptionId: string, options?: any): AxiosPromise<DivisionSubscriptionEntity> {
            return DivisionApiFp(configuration).getDivisionSubscriptionById(id, subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Get full translation of Division
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionTranslation(id: string, language: string, options?: any): AxiosPromise<Array<DivisionTranslationEntity>> {
            return DivisionApiFp(configuration).getDivisionTranslation(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Get all translations of Division without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionTranslations(id: string, options?: any): AxiosPromise<Array<DivisionTranslationEntity>> {
            return DivisionApiFp(configuration).getDivisionTranslations(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary List all divisions in collapsed format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllDivisions(options?: any): AxiosPromise<Array<DivisionEntity>> {
            return DivisionApiFp(configuration).listAllDivisions(options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate all divisions user has access to in extended format.
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAllDivision(skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<DivisionEntity>> {
            return DivisionApiFp(configuration).paginateAllDivision(skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate articles owned by a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateArticlesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<ArticleEntity>> {
            return DivisionApiFp(configuration).paginateArticlesInDivision(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate available assets in division.
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {Array<string>} [extensions] Filter what type of acceptions are accepted.
         * @param {Array<string>} [origins] Filter what type of origins are accepted.
         * @param {Array<string>} [gameIds] Filter assets by game/story IDs they are attached to.
         * @param {Array<string>} [tags] Filter assets by tags (e.g., \&#39;icon\&#39;, \&#39;background\&#39;). Assets matching any of the provided tags will be returned.
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAssetsInDivision(id: string, skip: number, take: number, extensions?: Array<string>, origins?: Array<string>, gameIds?: Array<string>, tags?: Array<string>, keyword?: string, options?: any): AxiosPromise<Array<AssetEntity>> {
            return DivisionApiFp(configuration).paginateAssetsInDivision(id, skip, take, extensions, origins, gameIds, tags, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate the collections owned by a division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateCollectionsInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<CollectionEntity>> {
            return DivisionApiFp(configuration).paginateCollectionsInDivision(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Paginate departments of the given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateDivisionDepartments(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<DivisionDepartmentEntity>> {
            return DivisionApiFp(configuration).paginateDivisionDepartments(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Paginate subscriptions of the given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateDivisionSubscriptions(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<DivisionSubscriptionEntity>> {
            return DivisionApiFp(configuration).paginateDivisionSubscriptions(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate divisions that have at least one brandkit.
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateDivisionsWithBrandkits(skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<DivisionEntity>> {
            return DivisionApiFp(configuration).paginateDivisionsWithBrandkits(skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate hosts for a given event
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEventHosts(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<UserEntity>> {
            return DivisionApiFp(configuration).paginateEventHosts(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
         * @summary Paginate events for a given division
         * @param {string} id 
         * @param {'all' | 'past' | 'coming'} filter Filter between \&#39;all\&#39;,\&#39;past\&#39; or \&#39;coming\&#39; events. If omitted, this function fetches all events.
         * @param {number} skip 
         * @param {number} take 
         * @param {'webinar' | 'event'} [eventType] Filter by event type: \&#39;webinar\&#39; or \&#39;event\&#39;. If omitted, fetches all event types.
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEventsInDivision(id: string, filter: 'all' | 'past' | 'coming', skip: number, take: number, eventType?: 'webinar' | 'event', keyword?: string, options?: any): AxiosPromise<Array<EventEntity>> {
            return DivisionApiFp(configuration).paginateEventsInDivision(id, filter, skip, take, eventType, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Games for logged in user in a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {'custom' | 'last_edited' | 'created'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateGamesInDivision(id: string, skip: number, take: number, keyword?: string, order?: 'custom' | 'last_edited' | 'created', options?: any): AxiosPromise<Array<GameEntity>> {
            return DivisionApiFp(configuration).paginateGamesInDivision(id, skip, take, keyword, order, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate on-demand videos owned by a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateOnDemandVideosInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<OnDemandVideoEntity>> {
            return DivisionApiFp(configuration).paginateOnDemandVideosInDivision(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate the articles of the organization a division belongs to
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateOrganizationArticlesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<ArticleEntity>> {
            return DivisionApiFp(configuration).paginateOrganizationArticlesInDivision(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate the on-demand videos of the organization a division belongs to
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateOrganizationOnDemandVideosInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<OnDemandVideoEntity>> {
            return DivisionApiFp(configuration).paginateOrganizationOnDemandVideosInDivision(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate themes for a division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateThemesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<ThemeEntity>> {
            return DivisionApiFp(configuration).paginateThemesInDivision(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate themes for a division and the parent whitelabel
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateThemesInDivisionWithParents(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<ThemeEntity>> {
            return DivisionApiFp(configuration).paginateThemesInDivisionWithParents(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paginate users for a given division
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateUsersInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<UserEntity>> {
            return DivisionApiFp(configuration).paginateUsersInDivision(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Paste a game from data in a division
         * @param {string} id 
         * @param {GamePayloadDto} gamePayloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pasteGameInDivision(id: string, gamePayloadDto: GamePayloadDto, options?: any): AxiosPromise<GameEntity> {
            return DivisionApiFp(configuration).pasteGameInDivision(id, gamePayloadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Remove translation of Division
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDivisionTranslation(id: string, language: string, options?: any): AxiosPromise<void> {
            return DivisionApiFp(configuration).removeDivisionTranslation(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Set base language of Division
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDivisionBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any): AxiosPromise<DivisionEntity> {
            return DivisionApiFp(configuration).setDivisionBaseLanguage(id, baseLanguageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Sort collections owned by a division
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortCollectionsInDivision(id: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return DivisionApiFp(configuration).sortCollectionsInDivision(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Sort games for user in a given division
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortGamesInDivision(id: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return DivisionApiFp(configuration).sortGamesInDivision(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Update division by id (partial update)
         * @param {string} id 
         * @param {DivisionUpdateDto} divisionUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDivision(id: string, divisionUpdateDto: DivisionUpdateDto, options?: any): AxiosPromise<DivisionEntity> {
            return DivisionApiFp(configuration).updateDivision(id, divisionUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
         * @summary Update department by id (partial update)
         * @param {string} id 
         * @param {string} departmentId 
         * @param {DivisionDepartmentEntity} divisionDepartmentEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDivisionDepartment(id: string, departmentId: string, divisionDepartmentEntity: DivisionDepartmentEntity, options?: any): AxiosPromise<DivisionDepartmentEntity> {
            return DivisionApiFp(configuration).updateDivisionDepartment(id, departmentId, divisionDepartmentEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update subscription by id (partial update)
         * @param {string} id 
         * @param {string} subscriptionId 
         * @param {DivisionSubscriptionEntity} divisionSubscriptionEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDivisionSubscription(id: string, subscriptionId: string, divisionSubscriptionEntity: DivisionSubscriptionEntity, options?: any): AxiosPromise<DivisionSubscriptionEntity> {
            return DivisionApiFp(configuration).updateDivisionSubscription(id, subscriptionId, divisionSubscriptionEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Update translations of Division
         * @param {string} id 
         * @param {string} language 
         * @param {DivisionTranslationEntity} divisionTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDivisionTranslation(id: string, language: string, divisionTranslationEntity: DivisionTranslationEntity, options?: any): AxiosPromise<DivisionTranslationEntity> {
            return DivisionApiFp(configuration).updateDivisionTranslation(id, language, divisionTranslationEntity, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DivisionApi - object-oriented interface
 * @export
 * @class DivisionApi
 * @extends {BaseAPI}
 */
export class DivisionApi extends BaseAPI {
    /**
     * 
     * @summary Add department with given ID to this division
     * @param {string} id 
     * @param {DivisionDepartmentEntity} divisionDepartmentEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public addDivisionDepartment(id: string, divisionDepartmentEntity: DivisionDepartmentEntity, options?: any) {
        return DivisionApiFp(this.configuration).addDivisionDepartment(id, divisionDepartmentEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add subscription with given ID to this division
     * @param {string} id 
     * @param {DivisionSubscriptionEntity} divisionSubscriptionEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public addDivisionSubscription(id: string, divisionSubscriptionEntity: DivisionSubscriptionEntity, options?: any) {
        return DivisionApiFp(this.configuration).addDivisionSubscription(id, divisionSubscriptionEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Create a collection owned by a division
     * @param {string} id 
     * @param {CollectionEntity} collectionEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public createCollectionInDivision(id: string, collectionEntity: CollectionEntity, options?: any) {
        return DivisionApiFp(this.configuration).createCollectionInDivision(id, collectionEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
     * @summary Create new divisions
     * @param {DivisionCreateDto} divisionCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public createDivision(divisionCreateDto: DivisionCreateDto, options?: any) {
        return DivisionApiFp(this.configuration).createDivision(divisionCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Create a game in a division
     * @param {string} id 
     * @param {GameCreateDto} gameCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public createGameInDivision(id: string, gameCreateDto: GameCreateDto, options?: any) {
        return DivisionApiFp(this.configuration).createGameInDivision(id, gameCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
     * @summary Delete division by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public deleteDivision(id: string, options?: any) {
        return DivisionApiFp(this.configuration).deleteDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
     * @summary Delete department by id
     * @param {string} id 
     * @param {string} departmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public deleteDivisionDepartment(id: string, departmentId: string, options?: any) {
        return DivisionApiFp(this.configuration).deleteDivisionDepartment(id, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete subscription by id
     * @param {string} id 
     * @param {string} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public deleteDivisionSubscription(id: string, subscriptionId: string, options?: any) {
        return DivisionApiFp(this.configuration).deleteDivisionSubscription(id, subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Whether any story in the given division has a category
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public divisionHasStoryCategories(id: string, options?: any) {
        return DivisionApiFp(this.configuration).divisionHasStoryCategories(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Count users of the given division
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public divisionUsersCount(id: string, options?: any) {
        return DivisionApiFp(this.configuration).divisionUsersCount(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Duplicate all games of this division to another division
     * @param {string} id 
     * @param {DivisionDuplicateDto} divisionDuplicateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public duplicateDivisionGames(id: string, divisionDuplicateDto: DivisionDuplicateDto, options?: any) {
        return DivisionApiFp(this.configuration).duplicateDivisionGames(id, divisionDuplicateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Paste a game from data in a division
     * @param {string} id 
     * @param {DivisionDuplicateBulkDto} divisionDuplicateBulkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public duplicateEventsIntoDivision(id: string, divisionDuplicateBulkDto: DivisionDuplicateBulkDto, options?: any) {
        return DivisionApiFp(this.configuration).duplicateEventsIntoDivision(id, divisionDuplicateBulkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Paste a game from data in a division
     * @param {string} id 
     * @param {DivisionDuplicateBulkDto} divisionDuplicateBulkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public duplicateGamesIntoDivision(id: string, divisionDuplicateBulkDto: DivisionDuplicateBulkDto, options?: any) {
        return DivisionApiFp(this.configuration).duplicateGamesIntoDivision(id, divisionDuplicateBulkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Get all unique tags used in division assets.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public getAssetTagsInDivision(id: string, options?: any) {
        return DivisionApiFp(this.configuration).getAssetTagsInDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Get base language of Division
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public getDivisionBaseLanguage(id: string, options?: any) {
        return DivisionApiFp(this.configuration).getDivisionBaseLanguage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
     * @summary Get division by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public getDivisionById(id: string, options?: any) {
        return DivisionApiFp(this.configuration).getDivisionById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
     * @summary Get department by id
     * @param {string} id 
     * @param {string} departmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public getDivisionDepartmentById(id: string, departmentId: string, options?: any) {
        return DivisionApiFp(this.configuration).getDivisionDepartmentById(id, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Get division QR Code
     * @param {string} id 
     * @param {string} environment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public getDivisionQR(id: string, environment: string, options?: any) {
        return DivisionApiFp(this.configuration).getDivisionQR(id, environment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get theme by id
     * @param {string} id 
     * @param {string} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public getDivisionSubscriptionById(id: string, subscriptionId: string, options?: any) {
        return DivisionApiFp(this.configuration).getDivisionSubscriptionById(id, subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Get full translation of Division
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public getDivisionTranslation(id: string, language: string, options?: any) {
        return DivisionApiFp(this.configuration).getDivisionTranslation(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Get all translations of Division without data
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public getDivisionTranslations(id: string, options?: any) {
        return DivisionApiFp(this.configuration).getDivisionTranslations(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
     * @summary List all divisions in collapsed format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public listAllDivisions(options?: any) {
        return DivisionApiFp(this.configuration).listAllDivisions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
     * @summary Paginate all divisions user has access to in extended format.
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateAllDivision(skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateAllDivision(skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Paginate articles owned by a given division
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateArticlesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateArticlesInDivision(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Paginate available assets in division.
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {Array<string>} [extensions] Filter what type of acceptions are accepted.
     * @param {Array<string>} [origins] Filter what type of origins are accepted.
     * @param {Array<string>} [gameIds] Filter assets by game/story IDs they are attached to.
     * @param {Array<string>} [tags] Filter assets by tags (e.g., \&#39;icon\&#39;, \&#39;background\&#39;). Assets matching any of the provided tags will be returned.
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateAssetsInDivision(id: string, skip: number, take: number, extensions?: Array<string>, origins?: Array<string>, gameIds?: Array<string>, tags?: Array<string>, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateAssetsInDivision(id, skip, take, extensions, origins, gameIds, tags, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Paginate the collections owned by a division
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateCollectionsInDivision(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateCollectionsInDivision(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Paginate departments of the given division
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateDivisionDepartments(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateDivisionDepartments(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Paginate subscriptions of the given division
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateDivisionSubscriptions(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateDivisionSubscriptions(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
     * @summary Paginate divisions that have at least one brandkit.
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateDivisionsWithBrandkits(skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateDivisionsWithBrandkits(skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Paginate hosts for a given event
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateEventHosts(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateEventHosts(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
     * @summary Paginate events for a given division
     * @param {string} id 
     * @param {'all' | 'past' | 'coming'} filter Filter between \&#39;all\&#39;,\&#39;past\&#39; or \&#39;coming\&#39; events. If omitted, this function fetches all events.
     * @param {number} skip 
     * @param {number} take 
     * @param {'webinar' | 'event'} [eventType] Filter by event type: \&#39;webinar\&#39; or \&#39;event\&#39;. If omitted, fetches all event types.
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateEventsInDivision(id: string, filter: 'all' | 'past' | 'coming', skip: number, take: number, eventType?: 'webinar' | 'event', keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateEventsInDivision(id, filter, skip, take, eventType, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Games for logged in user in a given division
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {'custom' | 'last_edited' | 'created'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateGamesInDivision(id: string, skip: number, take: number, keyword?: string, order?: 'custom' | 'last_edited' | 'created', options?: any) {
        return DivisionApiFp(this.configuration).paginateGamesInDivision(id, skip, take, keyword, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Paginate on-demand videos owned by a given division
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateOnDemandVideosInDivision(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateOnDemandVideosInDivision(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Paginate the articles of the organization a division belongs to
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateOrganizationArticlesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateOrganizationArticlesInDivision(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Paginate the on-demand videos of the organization a division belongs to
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateOrganizationOnDemandVideosInDivision(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateOrganizationOnDemandVideosInDivision(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Paginate themes for a division
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateThemesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateThemesInDivision(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Paginate themes for a division and the parent whitelabel
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateThemesInDivisionWithParents(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateThemesInDivisionWithParents(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Paginate users for a given division
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public paginateUsersInDivision(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionApiFp(this.configuration).paginateUsersInDivision(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Paste a game from data in a division
     * @param {string} id 
     * @param {GamePayloadDto} gamePayloadDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public pasteGameInDivision(id: string, gamePayloadDto: GamePayloadDto, options?: any) {
        return DivisionApiFp(this.configuration).pasteGameInDivision(id, gamePayloadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Remove translation of Division
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public removeDivisionTranslation(id: string, language: string, options?: any) {
        return DivisionApiFp(this.configuration).removeDivisionTranslation(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Set base language of Division
     * @param {string} id 
     * @param {BaseLanguageDto} baseLanguageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public setDivisionBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any) {
        return DivisionApiFp(this.configuration).setDivisionBaseLanguage(id, baseLanguageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Sort collections owned by a division
     * @param {string} id 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public sortCollectionsInDivision(id: string, requestBody: Array<string>, options?: any) {
        return DivisionApiFp(this.configuration).sortCollectionsInDivision(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Sort games for user in a given division
     * @param {string} id 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public sortGamesInDivision(id: string, requestBody: Array<string>, options?: any) {
        return DivisionApiFp(this.configuration).sortGamesInDivision(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Update division by id (partial update)
     * @param {string} id 
     * @param {DivisionUpdateDto} divisionUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public updateDivision(id: string, divisionUpdateDto: DivisionUpdateDto, options?: any) {
        return DivisionApiFp(this.configuration).updateDivision(id, divisionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division_department | admin        | 
     * @summary Update department by id (partial update)
     * @param {string} id 
     * @param {string} departmentId 
     * @param {DivisionDepartmentEntity} divisionDepartmentEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public updateDivisionDepartment(id: string, departmentId: string, divisionDepartmentEntity: DivisionDepartmentEntity, options?: any) {
        return DivisionApiFp(this.configuration).updateDivisionDepartment(id, departmentId, divisionDepartmentEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update subscription by id (partial update)
     * @param {string} id 
     * @param {string} subscriptionId 
     * @param {DivisionSubscriptionEntity} divisionSubscriptionEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public updateDivisionSubscription(id: string, subscriptionId: string, divisionSubscriptionEntity: DivisionSubscriptionEntity, options?: any) {
        return DivisionApiFp(this.configuration).updateDivisionSubscription(id, subscriptionId, divisionSubscriptionEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Update translations of Division
     * @param {string} id 
     * @param {string} language 
     * @param {DivisionTranslationEntity} divisionTranslationEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionApi
     */
    public updateDivisionTranslation(id: string, language: string, divisionTranslationEntity: DivisionTranslationEntity, options?: any) {
        return DivisionApiFp(this.configuration).updateDivisionTranslation(id, language, divisionTranslationEntity, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DivisionPublicApi - axios parameter creator
 * @export
 */
export const DivisionPublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get division by code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionByCode: async (code: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling getDivisionByCode.');
            }
            const localVarPath = `/division/code/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get division by hostname
         * @param {string} hostname 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionByHostname: async (hostname: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'hostname' is not null or undefined
            if (hostname === null || hostname === undefined) {
                throw new RequiredError('hostname','Required parameter hostname was null or undefined when calling getDivisionByHostname.');
            }
            const localVarPath = `/division/hostname/{hostname}`
                .replace(`{${"hostname"}}`, encodeURIComponent(String(hostname)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get division by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicDivisionById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPublicDivisionById.');
            }
            const localVarPath = `/division/id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DivisionPublicApi - functional programming interface
 * @export
 */
export const DivisionPublicApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get division by code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDivisionByCode(code: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionEntity>> {
            const localVarAxiosArgs = await DivisionPublicApiAxiosParamCreator(configuration).getDivisionByCode(code, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get division by hostname
         * @param {string} hostname 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDivisionByHostname(hostname: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionEntity>> {
            const localVarAxiosArgs = await DivisionPublicApiAxiosParamCreator(configuration).getDivisionByHostname(hostname, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get division by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicDivisionById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionEntity>> {
            const localVarAxiosArgs = await DivisionPublicApiAxiosParamCreator(configuration).getPublicDivisionById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DivisionPublicApi - factory interface
 * @export
 */
export const DivisionPublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get division by code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionByCode(code: string, options?: any): AxiosPromise<DivisionEntity> {
            return DivisionPublicApiFp(configuration).getDivisionByCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get division by hostname
         * @param {string} hostname 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionByHostname(hostname: string, options?: any): AxiosPromise<DivisionEntity> {
            return DivisionPublicApiFp(configuration).getDivisionByHostname(hostname, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get division by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicDivisionById(id: string, options?: any): AxiosPromise<DivisionEntity> {
            return DivisionPublicApiFp(configuration).getPublicDivisionById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DivisionPublicApi - object-oriented interface
 * @export
 * @class DivisionPublicApi
 * @extends {BaseAPI}
 */
export class DivisionPublicApi extends BaseAPI {
    /**
     * 
     * @summary Get division by code
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionPublicApi
     */
    public getDivisionByCode(code: string, options?: any) {
        return DivisionPublicApiFp(this.configuration).getDivisionByCode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get division by hostname
     * @param {string} hostname 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionPublicApi
     */
    public getDivisionByHostname(hostname: string, options?: any) {
        return DivisionPublicApiFp(this.configuration).getDivisionByHostname(hostname, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get division by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionPublicApi
     */
    public getPublicDivisionById(id: string, options?: any) {
        return DivisionPublicApiFp(this.configuration).getPublicDivisionById(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DivisionUserApi - axios parameter creator
 * @export
 */
export const DivisionUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Get events for single user for a given division
         * @param {string} id 
         * @param {string} userId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEventsInDivision: async (id: string, userId: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getUserEventsInDivision.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling getUserEventsInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling getUserEventsInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling getUserEventsInDivision.');
            }
            const localVarPath = `/builder/division-user/{id}/users/{userId}/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Get games for single user for a given division
         * @param {string} id 
         * @param {string} userId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGamesInDivision: async (id: string, userId: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getUserGamesInDivision.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling getUserGamesInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling getUserGamesInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling getUserGamesInDivision.');
            }
            const localVarPath = `/builder/division-user/{id}/users/{userId}/games`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Get single user for a given division
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInDivision: async (id: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getUserInDivision.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling getUserInDivision.');
            }
            const localVarPath = `/builder/division-user/{id}/users/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Remove user from division
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromDivision: async (id: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeUserFromDivision.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling removeUserFromDivision.');
            }
            const localVarPath = `/builder/division-user/{id}/users/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DivisionUserApi - functional programming interface
 * @export
 */
export const DivisionUserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Get events for single user for a given division
         * @param {string} id 
         * @param {string} userId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserEventsInDivision(id: string, userId: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventEntity>>> {
            const localVarAxiosArgs = await DivisionUserApiAxiosParamCreator(configuration).getUserEventsInDivision(id, userId, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Get games for single user for a given division
         * @param {string} id 
         * @param {string} userId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGamesInDivision(id: string, userId: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameEntity>>> {
            const localVarAxiosArgs = await DivisionUserApiAxiosParamCreator(configuration).getUserGamesInDivision(id, userId, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Get single user for a given division
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInDivision(id: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await DivisionUserApiAxiosParamCreator(configuration).getUserInDivision(id, userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Remove user from division
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUserFromDivision(id: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await DivisionUserApiAxiosParamCreator(configuration).removeUserFromDivision(id, userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DivisionUserApi - factory interface
 * @export
 */
export const DivisionUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Get events for single user for a given division
         * @param {string} id 
         * @param {string} userId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEventsInDivision(id: string, userId: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<EventEntity>> {
            return DivisionUserApiFp(configuration).getUserEventsInDivision(id, userId, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Get games for single user for a given division
         * @param {string} id 
         * @param {string} userId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGamesInDivision(id: string, userId: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<GameEntity>> {
            return DivisionUserApiFp(configuration).getUserGamesInDivision(id, userId, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Get single user for a given division
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInDivision(id: string, userId: string, options?: any): AxiosPromise<UserEntity> {
            return DivisionUserApiFp(configuration).getUserInDivision(id, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
         * @summary Remove user from division
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromDivision(id: string, userId: string, options?: any): AxiosPromise<UserEntity> {
            return DivisionUserApiFp(configuration).removeUserFromDivision(id, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DivisionUserApi - object-oriented interface
 * @export
 * @class DivisionUserApi
 * @extends {BaseAPI}
 */
export class DivisionUserApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Get events for single user for a given division
     * @param {string} id 
     * @param {string} userId 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionUserApi
     */
    public getUserEventsInDivision(id: string, userId: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionUserApiFp(this.configuration).getUserEventsInDivision(id, userId, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Get games for single user for a given division
     * @param {string} id 
     * @param {string} userId 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionUserApi
     */
    public getUserGamesInDivision(id: string, userId: string, skip: number, take: number, keyword?: string, options?: any) {
        return DivisionUserApiFp(this.configuration).getUserGamesInDivision(id, userId, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Get single user for a given division
     * @param {string} id 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionUserApi
     */
    public getUserInDivision(id: string, userId: string, options?: any) {
        return DivisionUserApiFp(this.configuration).getUserInDivision(id, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        | 
     * @summary Remove user from division
     * @param {string} id 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionUserApi
     */
    public removeUserFromDivision(id: string, userId: string, options?: any) {
        return DivisionUserApiFp(this.configuration).removeUserFromDivision(id, userId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EventApi - axios parameter creator
 * @export
 */
export const EventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Add a participant to an event
         * @param {string} id 
         * @param {AddParticipantDto} addParticipantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEventParticipant: async (id: string, addParticipantDto: AddParticipantDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling addEventParticipant.');
            }
            // verify required parameter 'addParticipantDto' is not null or undefined
            if (addParticipantDto === null || addParticipantDto === undefined) {
                throw new RequiredError('addParticipantDto','Required parameter addParticipantDto was null or undefined when calling addEventParticipant.');
            }
            const localVarPath = `/builder/event/{id}/participant`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addParticipantDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addParticipantDto !== undefined ? addParticipantDto : {}) : (addParticipantDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Count all participants and waiting list for event
         * @param {string} id 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEventParticipants: async (id: string, variantId?: string, divisionId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling countEventParticipants.');
            }
            const localVarPath = `/builder/event/{id}/countParticipants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (variantId !== undefined) {
                localVarQueryParameter['variantId'] = variantId;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Count participants and waiting list per project the registrations were made from
         * @param {string} id 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEventParticipantsByProject: async (id: string, variantId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling countEventParticipantsByProject.');
            }
            const localVarPath = `/builder/event/{id}/countParticipantsByProject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (variantId !== undefined) {
                localVarQueryParameter['variantId'] = variantId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
         * @summary Create new event
         * @param {EventCreateDto} eventCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvent: async (eventCreateDto: EventCreateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventCreateDto' is not null or undefined
            if (eventCreateDto === null || eventCreateDto === undefined) {
                throw new RequiredError('eventCreateDto','Required parameter eventCreateDto was null or undefined when calling createEvent.');
            }
            const localVarPath = `/builder/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof eventCreateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(eventCreateDto !== undefined ? eventCreateDto : {}) : (eventCreateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Create a variant for an event
         * @param {string} id 
         * @param {CreateEventVariantDto} createEventVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVariant: async (id: string, createEventVariantDto: CreateEventVariantDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createVariant.');
            }
            // verify required parameter 'createEventVariantDto' is not null or undefined
            if (createEventVariantDto === null || createEventVariantDto === undefined) {
                throw new RequiredError('createEventVariantDto','Required parameter createEventVariantDto was null or undefined when calling createVariant.');
            }
            const localVarPath = `/builder/event/{id}/variant`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof createEventVariantDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createEventVariantDto !== undefined ? createEventVariantDto : {}) : (createEventVariantDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       |  | company      | editor       | 
         * @summary Delete event by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvent: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteEvent.');
            }
            const localVarPath = `/builder/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event_variant | editor       | 
         * @summary Delete a variant for an event
         * @param {string} variantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVariant: async (variantId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantId' is not null or undefined
            if (variantId === null || variantId === undefined) {
                throw new RequiredError('variantId','Required parameter variantId was null or undefined when calling deleteVariant.');
            }
            const localVarPath = `/builder/event/variant/{variantId}`
                .replace(`{${"variantId"}}`, encodeURIComponent(String(variantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       |  | company      | editor       | 
         * @summary Duplicate event by ID event by id
         * @param {string} id 
         * @param {EventDuplicateDto} eventDuplicateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateEvent: async (id: string, eventDuplicateDto: EventDuplicateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling duplicateEvent.');
            }
            // verify required parameter 'eventDuplicateDto' is not null or undefined
            if (eventDuplicateDto === null || eventDuplicateDto === undefined) {
                throw new RequiredError('eventDuplicateDto','Required parameter eventDuplicateDto was null or undefined when calling duplicateEvent.');
            }
            const localVarPath = `/builder/event/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof eventDuplicateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(eventDuplicateDto !== undefined ? eventDuplicateDto : {}) : (eventDuplicateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | viewer       | 
         * @summary Get base language of Event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventBaseLanguage: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEventBaseLanguage.');
            }
            const localVarPath = `/builder/event/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Get event by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEventById.');
            }
            const localVarPath = `/builder/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Get event QR Code
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventQR: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEventQR.');
            }
            const localVarPath = `/builder/event/{id}/qr`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Get full translation of Event
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTranslation: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEventTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling getEventTranslation.');
            }
            const localVarPath = `/builder/event/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Get all translations of Event without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTranslations: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEventTranslations.');
            }
            const localVarPath = `/builder/event/{id}/translation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Paginate all attending participants by id
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEventParticipants: async (id: string, skip: number, take: number, variantId?: string, divisionId?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateEventParticipants.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateEventParticipants.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateEventParticipants.');
            }
            const localVarPath = `/builder/event/{id}/participants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (variantId !== undefined) {
                localVarQueryParameter['variantId'] = variantId;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Paginate all participants on waiting list
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEventWaitingList: async (id: string, skip: number, take: number, variantId?: string, divisionId?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginateEventWaitingList.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateEventWaitingList.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateEventWaitingList.');
            }
            const localVarPath = `/builder/event/{id}/waiting`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (variantId !== undefined) {
                localVarQueryParameter['variantId'] = variantId;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Remove participant from event
         * @param {string} id 
         * @param {string} userId 
         * @param {string} [variantId] Remove the registration on this session only (\&quot;base\&quot; for the event\&#39;s own date); omitted, every registration of the user on the event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEventParticipants: async (id: string, userId: string, variantId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeEventParticipants.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling removeEventParticipants.');
            }
            const localVarPath = `/builder/event/{id}/participant/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (variantId !== undefined) {
                localVarQueryParameter['variantId'] = variantId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Remove translation of Event
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEventTranslation: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeEventTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling removeEventTranslation.');
            }
            const localVarPath = `/builder/event/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Set base language of Event
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEventBaseLanguage: async (id: string, baseLanguageDto: BaseLanguageDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setEventBaseLanguage.');
            }
            // verify required parameter 'baseLanguageDto' is not null or undefined
            if (baseLanguageDto === null || baseLanguageDto === undefined) {
                throw new RequiredError('baseLanguageDto','Required parameter baseLanguageDto was null or undefined when calling setEventBaseLanguage.');
            }
            const localVarPath = `/builder/event/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof baseLanguageDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(baseLanguageDto !== undefined ? baseLanguageDto : {}) : (baseLanguageDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Update event by id (partial update)
         * @param {string} id 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvent: async (id: string, eventUpdateDto: EventUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateEvent.');
            }
            // verify required parameter 'eventUpdateDto' is not null or undefined
            if (eventUpdateDto === null || eventUpdateDto === undefined) {
                throw new RequiredError('eventUpdateDto','Required parameter eventUpdateDto was null or undefined when calling updateEvent.');
            }
            const localVarPath = `/builder/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof eventUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(eventUpdateDto !== undefined ? eventUpdateDto : {}) : (eventUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Update event participant 
         * @param {string} id 
         * @param {string} userId 
         * @param {EventParticipantsDto} eventParticipantsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventParticipant: async (id: string, userId: string, eventParticipantsDto: EventParticipantsDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateEventParticipant.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling updateEventParticipant.');
            }
            // verify required parameter 'eventParticipantsDto' is not null or undefined
            if (eventParticipantsDto === null || eventParticipantsDto === undefined) {
                throw new RequiredError('eventParticipantsDto','Required parameter eventParticipantsDto was null or undefined when calling updateEventParticipant.');
            }
            const localVarPath = `/builder/event/{id}/participant/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof eventParticipantsDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(eventParticipantsDto !== undefined ? eventParticipantsDto : {}) : (eventParticipantsDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Update translations of Event
         * @param {string} id 
         * @param {string} language 
         * @param {EventTranslationEntity} eventTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventTranslation: async (id: string, language: string, eventTranslationEntity: EventTranslationEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateEventTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling updateEventTranslation.');
            }
            // verify required parameter 'eventTranslationEntity' is not null or undefined
            if (eventTranslationEntity === null || eventTranslationEntity === undefined) {
                throw new RequiredError('eventTranslationEntity','Required parameter eventTranslationEntity was null or undefined when calling updateEventTranslation.');
            }
            const localVarPath = `/builder/event/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof eventTranslationEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(eventTranslationEntity !== undefined ? eventTranslationEntity : {}) : (eventTranslationEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event_variant | editor       | 
         * @summary Update a variant for an event
         * @param {string} variantId 
         * @param {UpdateEventVariantDto} updateEventVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVariant: async (variantId: string, updateEventVariantDto: UpdateEventVariantDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantId' is not null or undefined
            if (variantId === null || variantId === undefined) {
                throw new RequiredError('variantId','Required parameter variantId was null or undefined when calling updateVariant.');
            }
            // verify required parameter 'updateEventVariantDto' is not null or undefined
            if (updateEventVariantDto === null || updateEventVariantDto === undefined) {
                throw new RequiredError('updateEventVariantDto','Required parameter updateEventVariantDto was null or undefined when calling updateVariant.');
            }
            const localVarPath = `/builder/event/variant/{variantId}`
                .replace(`{${"variantId"}}`, encodeURIComponent(String(variantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateEventVariantDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateEventVariantDto !== undefined ? updateEventVariantDto : {}) : (updateEventVariantDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventApi - functional programming interface
 * @export
 */
export const EventApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Add a participant to an event
         * @param {string} id 
         * @param {AddParticipantDto} addParticipantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEventParticipant(id: string, addParticipantDto: AddParticipantDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).addEventParticipant(id, addParticipantDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Count all participants and waiting list for event
         * @param {string} id 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countEventParticipants(id: string, variantId?: string, divisionId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountEventParticipantsDto>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).countEventParticipants(id, variantId, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Count participants and waiting list per project the registrations were made from
         * @param {string} id 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countEventParticipantsByProject(id: string, variantId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectParticipantsCountDto>>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).countEventParticipantsByProject(id, variantId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
         * @summary Create new event
         * @param {EventCreateDto} eventCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEvent(eventCreateDto: EventCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).createEvent(eventCreateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Create a variant for an event
         * @param {string} id 
         * @param {CreateEventVariantDto} createEventVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVariant(id: string, createEventVariantDto: CreateEventVariantDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventVariantEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).createVariant(id, createEventVariantDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       |  | company      | editor       | 
         * @summary Delete event by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEvent(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).deleteEvent(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event_variant | editor       | 
         * @summary Delete a variant for an event
         * @param {string} variantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVariant(variantId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventVariantEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).deleteVariant(variantId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       |  | company      | editor       | 
         * @summary Duplicate event by ID event by id
         * @param {string} id 
         * @param {EventDuplicateDto} eventDuplicateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateEvent(id: string, eventDuplicateDto: EventDuplicateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).duplicateEvent(id, eventDuplicateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | viewer       | 
         * @summary Get base language of Event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventBaseLanguage(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseLanguageDto>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).getEventBaseLanguage(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Get event by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).getEventById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Get event QR Code
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventQR(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrDto>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).getEventQR(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Get full translation of Event
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventTranslation(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTranslationEntity>>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).getEventTranslation(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Get all translations of Event without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventTranslations(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTranslationEntity>>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).getEventTranslations(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Paginate all attending participants by id
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateEventParticipants(id: string, skip: number, take: number, variantId?: string, divisionId?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventParticipantEntity>>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).paginateEventParticipants(id, skip, take, variantId, divisionId, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Paginate all participants on waiting list
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateEventWaitingList(id: string, skip: number, take: number, variantId?: string, divisionId?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventParticipantEntity>>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).paginateEventWaitingList(id, skip, take, variantId, divisionId, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Remove participant from event
         * @param {string} id 
         * @param {string} userId 
         * @param {string} [variantId] Remove the registration on this session only (\&quot;base\&quot; for the event\&#39;s own date); omitted, every registration of the user on the event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEventParticipants(id: string, userId: string, variantId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).removeEventParticipants(id, userId, variantId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Remove translation of Event
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEventTranslation(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).removeEventTranslation(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Set base language of Event
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setEventBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).setEventBaseLanguage(id, baseLanguageDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Update event by id (partial update)
         * @param {string} id 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEvent(id: string, eventUpdateDto: EventUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).updateEvent(id, eventUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Update event participant 
         * @param {string} id 
         * @param {string} userId 
         * @param {EventParticipantsDto} eventParticipantsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventParticipant(id: string, userId: string, eventParticipantsDto: EventParticipantsDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventParticipantEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).updateEventParticipant(id, userId, eventParticipantsDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Update translations of Event
         * @param {string} id 
         * @param {string} language 
         * @param {EventTranslationEntity} eventTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventTranslation(id: string, language: string, eventTranslationEntity: EventTranslationEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTranslationEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).updateEventTranslation(id, language, eventTranslationEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event_variant | editor       | 
         * @summary Update a variant for an event
         * @param {string} variantId 
         * @param {UpdateEventVariantDto} updateEventVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVariant(variantId: string, updateEventVariantDto: UpdateEventVariantDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventVariantEntity>> {
            const localVarAxiosArgs = await EventApiAxiosParamCreator(configuration).updateVariant(variantId, updateEventVariantDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EventApi - factory interface
 * @export
 */
export const EventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Add a participant to an event
         * @param {string} id 
         * @param {AddParticipantDto} addParticipantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEventParticipant(id: string, addParticipantDto: AddParticipantDto, options?: any): AxiosPromise<EventEntity> {
            return EventApiFp(configuration).addEventParticipant(id, addParticipantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Count all participants and waiting list for event
         * @param {string} id 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEventParticipants(id: string, variantId?: string, divisionId?: string, options?: any): AxiosPromise<CountEventParticipantsDto> {
            return EventApiFp(configuration).countEventParticipants(id, variantId, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Count participants and waiting list per project the registrations were made from
         * @param {string} id 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEventParticipantsByProject(id: string, variantId?: string, options?: any): AxiosPromise<Array<ProjectParticipantsCountDto>> {
            return EventApiFp(configuration).countEventParticipantsByProject(id, variantId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
         * @summary Create new event
         * @param {EventCreateDto} eventCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvent(eventCreateDto: EventCreateDto, options?: any): AxiosPromise<EventEntity> {
            return EventApiFp(configuration).createEvent(eventCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Create a variant for an event
         * @param {string} id 
         * @param {CreateEventVariantDto} createEventVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVariant(id: string, createEventVariantDto: CreateEventVariantDto, options?: any): AxiosPromise<EventVariantEntity> {
            return EventApiFp(configuration).createVariant(id, createEventVariantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       |  | company      | editor       | 
         * @summary Delete event by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvent(id: string, options?: any): AxiosPromise<EventEntity> {
            return EventApiFp(configuration).deleteEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event_variant | editor       | 
         * @summary Delete a variant for an event
         * @param {string} variantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVariant(variantId: string, options?: any): AxiosPromise<EventVariantEntity> {
            return EventApiFp(configuration).deleteVariant(variantId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       |  | company      | editor       | 
         * @summary Duplicate event by ID event by id
         * @param {string} id 
         * @param {EventDuplicateDto} eventDuplicateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateEvent(id: string, eventDuplicateDto: EventDuplicateDto, options?: any): AxiosPromise<EventEntity> {
            return EventApiFp(configuration).duplicateEvent(id, eventDuplicateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | viewer       | 
         * @summary Get base language of Event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventBaseLanguage(id: string, options?: any): AxiosPromise<BaseLanguageDto> {
            return EventApiFp(configuration).getEventBaseLanguage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Get event by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventById(id: string, options?: any): AxiosPromise<EventEntity> {
            return EventApiFp(configuration).getEventById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Get event QR Code
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventQR(id: string, options?: any): AxiosPromise<QrDto> {
            return EventApiFp(configuration).getEventQR(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Get full translation of Event
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTranslation(id: string, language: string, options?: any): AxiosPromise<Array<EventTranslationEntity>> {
            return EventApiFp(configuration).getEventTranslation(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Get all translations of Event without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTranslations(id: string, options?: any): AxiosPromise<Array<EventTranslationEntity>> {
            return EventApiFp(configuration).getEventTranslations(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Paginate all attending participants by id
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEventParticipants(id: string, skip: number, take: number, variantId?: string, divisionId?: string, keyword?: string, options?: any): AxiosPromise<Array<EventParticipantEntity>> {
            return EventApiFp(configuration).paginateEventParticipants(id, skip, take, variantId, divisionId, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Paginate all participants on waiting list
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
         * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEventWaitingList(id: string, skip: number, take: number, variantId?: string, divisionId?: string, keyword?: string, options?: any): AxiosPromise<Array<EventParticipantEntity>> {
            return EventApiFp(configuration).paginateEventWaitingList(id, skip, take, variantId, divisionId, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Remove participant from event
         * @param {string} id 
         * @param {string} userId 
         * @param {string} [variantId] Remove the registration on this session only (\&quot;base\&quot; for the event\&#39;s own date); omitted, every registration of the user on the event.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEventParticipants(id: string, userId: string, variantId?: string, options?: any): AxiosPromise<EventEntity> {
            return EventApiFp(configuration).removeEventParticipants(id, userId, variantId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Remove translation of Event
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEventTranslation(id: string, language: string, options?: any): AxiosPromise<void> {
            return EventApiFp(configuration).removeEventTranslation(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Set base language of Event
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEventBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any): AxiosPromise<EventEntity> {
            return EventApiFp(configuration).setEventBaseLanguage(id, baseLanguageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Update event by id (partial update)
         * @param {string} id 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvent(id: string, eventUpdateDto: EventUpdateDto, options?: any): AxiosPromise<EventEntity> {
            return EventApiFp(configuration).updateEvent(id, eventUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
         * @summary Update event participant 
         * @param {string} id 
         * @param {string} userId 
         * @param {EventParticipantsDto} eventParticipantsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventParticipant(id: string, userId: string, eventParticipantsDto: EventParticipantsDto, options?: any): AxiosPromise<EventParticipantEntity> {
            return EventApiFp(configuration).updateEventParticipant(id, userId, eventParticipantsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
         * @summary Update translations of Event
         * @param {string} id 
         * @param {string} language 
         * @param {EventTranslationEntity} eventTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventTranslation(id: string, language: string, eventTranslationEntity: EventTranslationEntity, options?: any): AxiosPromise<EventTranslationEntity> {
            return EventApiFp(configuration).updateEventTranslation(id, language, eventTranslationEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event_variant | editor       | 
         * @summary Update a variant for an event
         * @param {string} variantId 
         * @param {UpdateEventVariantDto} updateEventVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVariant(variantId: string, updateEventVariantDto: UpdateEventVariantDto, options?: any): AxiosPromise<EventVariantEntity> {
            return EventApiFp(configuration).updateVariant(variantId, updateEventVariantDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventApi - object-oriented interface
 * @export
 * @class EventApi
 * @extends {BaseAPI}
 */
export class EventApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
     * @summary Add a participant to an event
     * @param {string} id 
     * @param {AddParticipantDto} addParticipantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public addEventParticipant(id: string, addParticipantDto: AddParticipantDto, options?: any) {
        return EventApiFp(this.configuration).addEventParticipant(id, addParticipantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
     * @summary Count all participants and waiting list for event
     * @param {string} id 
     * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
     * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public countEventParticipants(id: string, variantId?: string, divisionId?: string, options?: any) {
        return EventApiFp(this.configuration).countEventParticipants(id, variantId, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
     * @summary Count participants and waiting list per project the registrations were made from
     * @param {string} id 
     * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public countEventParticipantsByProject(id: string, variantId?: string, options?: any) {
        return EventApiFp(this.configuration).countEventParticipantsByProject(id, variantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | host         | 
     * @summary Create new event
     * @param {EventCreateDto} eventCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public createEvent(eventCreateDto: EventCreateDto, options?: any) {
        return EventApiFp(this.configuration).createEvent(eventCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
     * @summary Create a variant for an event
     * @param {string} id 
     * @param {CreateEventVariantDto} createEventVariantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public createVariant(id: string, createEventVariantDto: CreateEventVariantDto, options?: any) {
        return EventApiFp(this.configuration).createVariant(id, createEventVariantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       |  | company      | editor       | 
     * @summary Delete event by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public deleteEvent(id: string, options?: any) {
        return EventApiFp(this.configuration).deleteEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event_variant | editor       | 
     * @summary Delete a variant for an event
     * @param {string} variantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public deleteVariant(variantId: string, options?: any) {
        return EventApiFp(this.configuration).deleteVariant(variantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       |  | company      | editor       | 
     * @summary Duplicate event by ID event by id
     * @param {string} id 
     * @param {EventDuplicateDto} eventDuplicateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public duplicateEvent(id: string, eventDuplicateDto: EventDuplicateDto, options?: any) {
        return EventApiFp(this.configuration).duplicateEvent(id, eventDuplicateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | viewer       | 
     * @summary Get base language of Event
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public getEventBaseLanguage(id: string, options?: any) {
        return EventApiFp(this.configuration).getEventBaseLanguage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
     * @summary Get event by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public getEventById(id: string, options?: any) {
        return EventApiFp(this.configuration).getEventById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
     * @summary Get event QR Code
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public getEventQR(id: string, options?: any) {
        return EventApiFp(this.configuration).getEventQR(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
     * @summary Get full translation of Event
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public getEventTranslation(id: string, language: string, options?: any) {
        return EventApiFp(this.configuration).getEventTranslation(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
     * @summary Get all translations of Event without data
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public getEventTranslations(id: string, options?: any) {
        return EventApiFp(this.configuration).getEventTranslations(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
     * @summary Paginate all attending participants by id
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
     * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public paginateEventParticipants(id: string, skip: number, take: number, variantId?: string, divisionId?: string, keyword?: string, options?: any) {
        return EventApiFp(this.configuration).paginateEventParticipants(id, skip, take, variantId, divisionId, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
     * @summary Paginate all participants on waiting list
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [variantId] Filter by variant ID. Use \&#39;all\&#39; for all variants, \&#39;base\&#39; for base event only, or a specific variant ID
     * @param {string} [divisionId] Filter by the project the registration was made from. Use \&#39;all\&#39; for every project, \&#39;none\&#39; for registrations without attribution, or a specific division ID
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public paginateEventWaitingList(id: string, skip: number, take: number, variantId?: string, divisionId?: string, keyword?: string, options?: any) {
        return EventApiFp(this.configuration).paginateEventWaitingList(id, skip, take, variantId, divisionId, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
     * @summary Remove participant from event
     * @param {string} id 
     * @param {string} userId 
     * @param {string} [variantId] Remove the registration on this session only (\&quot;base\&quot; for the event\&#39;s own date); omitted, every registration of the user on the event.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public removeEventParticipants(id: string, userId: string, variantId?: string, options?: any) {
        return EventApiFp(this.configuration).removeEventParticipants(id, userId, variantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
     * @summary Remove translation of Event
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public removeEventTranslation(id: string, language: string, options?: any) {
        return EventApiFp(this.configuration).removeEventTranslation(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
     * @summary Set base language of Event
     * @param {string} id 
     * @param {BaseLanguageDto} baseLanguageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public setEventBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any) {
        return EventApiFp(this.configuration).setEventBaseLanguage(id, baseLanguageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
     * @summary Update event by id (partial update)
     * @param {string} id 
     * @param {EventUpdateDto} eventUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public updateEvent(id: string, eventUpdateDto: EventUpdateDto, options?: any) {
        return EventApiFp(this.configuration).updateEvent(id, eventUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | host         | 
     * @summary Update event participant 
     * @param {string} id 
     * @param {string} userId 
     * @param {EventParticipantsDto} eventParticipantsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public updateEventParticipant(id: string, userId: string, eventParticipantsDto: EventParticipantsDto, options?: any) {
        return EventApiFp(this.configuration).updateEventParticipant(id, userId, eventParticipantsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event        | editor       | 
     * @summary Update translations of Event
     * @param {string} id 
     * @param {string} language 
     * @param {EventTranslationEntity} eventTranslationEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public updateEventTranslation(id: string, language: string, eventTranslationEntity: EventTranslationEntity, options?: any) {
        return EventApiFp(this.configuration).updateEventTranslation(id, language, eventTranslationEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | event_variant | editor       | 
     * @summary Update a variant for an event
     * @param {string} variantId 
     * @param {UpdateEventVariantDto} updateEventVariantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public updateVariant(variantId: string, updateEventVariantDto: UpdateEventVariantDto, options?: any) {
        return EventApiFp(this.configuration).updateVariant(variantId, updateEventVariantDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeedbackApi - axios parameter creator
 * @export
 */
export const FeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Paginate feedback
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateFeedback: async (skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateFeedback.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateFeedback.');
            }
            const localVarPath = `/builder/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeedbackApi - functional programming interface
 * @export
 */
export const FeedbackApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Paginate feedback
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateFeedback(skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeedbackItemDto>>> {
            const localVarAxiosArgs = await FeedbackApiAxiosParamCreator(configuration).paginateFeedback(skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FeedbackApi - factory interface
 * @export
 */
export const FeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Paginate feedback
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateFeedback(skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<FeedbackItemDto>> {
            return FeedbackApiFp(configuration).paginateFeedback(skip, take, keyword, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeedbackApi - object-oriented interface
 * @export
 * @class FeedbackApi
 * @extends {BaseAPI}
 */
export class FeedbackApi extends BaseAPI {
    /**
     * 
     * @summary Paginate feedback
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackApi
     */
    public paginateFeedback(skip: number, take: number, keyword?: string, options?: any) {
        return FeedbackApiFp(this.configuration).paginateFeedback(skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Delete a file from the generic storage
         * @param {FileDeleteDto} fileDeleteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (fileDeleteDto: FileDeleteDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileDeleteDto' is not null or undefined
            if (fileDeleteDto === null || fileDeleteDto === undefined) {
                throw new RequiredError('fileDeleteDto','Required parameter fileDeleteDto was null or undefined when calling _delete.');
            }
            const localVarPath = `/builder/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof fileDeleteDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(fileDeleteDto !== undefined ? fileDeleteDto : {}) : (fileDeleteDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Check the quality of given AR target
         * @param {string} uri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        arTargetQuality: async (uri: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uri' is not null or undefined
            if (uri === null || uri === undefined) {
                throw new RequiredError('uri','Required parameter uri was null or undefined when calling arTargetQuality.');
            }
            const localVarPath = `/builder/file/ar-target-quality`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (uri !== undefined) {
                localVarQueryParameter['uri'] = uri;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Convert given bucket file to a .zpt target file.
         * @param {string} path 
         * @param {ImageTrainOptionsDto} imageTrainOptionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertImageToWebAr: async (path: string, imageTrainOptionsDto: ImageTrainOptionsDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling convertImageToWebAr.');
            }
            // verify required parameter 'imageTrainOptionsDto' is not null or undefined
            if (imageTrainOptionsDto === null || imageTrainOptionsDto === undefined) {
                throw new RequiredError('imageTrainOptionsDto','Required parameter imageTrainOptionsDto was null or undefined when calling convertImageToWebAr.');
            }
            const localVarPath = `/builder/file/convert-to-web-ar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof imageTrainOptionsDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(imageTrainOptionsDto !== undefined ? imageTrainOptionsDto : {}) : (imageTrainOptionsDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Proxy
         * @param {string} uri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxy: async (uri: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uri' is not null or undefined
            if (uri === null || uri === undefined) {
                throw new RequiredError('uri','Required parameter uri was null or undefined when calling proxy.');
            }
            const localVarPath = `/builder/file/proxy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (uri !== undefined) {
                localVarQueryParameter['uri'] = uri;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Start a job to remove background from the video.
         * @param {RemoveBackgroundJobDto} removeBackgroundJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRemoveBackgroundJob: async (removeBackgroundJobDto: RemoveBackgroundJobDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'removeBackgroundJobDto' is not null or undefined
            if (removeBackgroundJobDto === null || removeBackgroundJobDto === undefined) {
                throw new RequiredError('removeBackgroundJobDto','Required parameter removeBackgroundJobDto was null or undefined when calling startRemoveBackgroundJob.');
            }
            const localVarPath = `/builder/file/remove-background`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof removeBackgroundJobDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(removeBackgroundJobDto !== undefined ? removeBackgroundJobDto : {}) : (removeBackgroundJobDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Upload a file to the generic storage
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: async (file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling upload.');
            }
            const localVarPath = `/builder/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Webhook endpoint for VideoBGRemover job updates
         * @param {VideoBGRemoverWebhookDto} videoBGRemoverWebhookDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookVideoBgRemover: async (videoBGRemoverWebhookDto: VideoBGRemoverWebhookDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoBGRemoverWebhookDto' is not null or undefined
            if (videoBGRemoverWebhookDto === null || videoBGRemoverWebhookDto === undefined) {
                throw new RequiredError('videoBGRemoverWebhookDto','Required parameter videoBGRemoverWebhookDto was null or undefined when calling webhookVideoBgRemover.');
            }
            const localVarPath = `/builder/file/webhook/videobgremover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof videoBGRemoverWebhookDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(videoBGRemoverWebhookDto !== undefined ? videoBGRemoverWebhookDto : {}) : (videoBGRemoverWebhookDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Delete a file from the generic storage
         * @param {FileDeleteDto} fileDeleteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(fileDeleteDto: FileDeleteDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration)._delete(fileDeleteDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Check the quality of given AR target
         * @param {string} uri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async arTargetQuality(uri: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).arTargetQuality(uri, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Convert given bucket file to a .zpt target file.
         * @param {string} path 
         * @param {ImageTrainOptionsDto} imageTrainOptionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertImageToWebAr(path: string, imageTrainOptionsDto: ImageTrainOptionsDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResultDto>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).convertImageToWebAr(path, imageTrainOptionsDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Proxy
         * @param {string} uri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proxy(uri: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).proxy(uri, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Start a job to remove background from the video.
         * @param {RemoveBackgroundJobDto} removeBackgroundJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startRemoveBackgroundJob(removeBackgroundJobDto: RemoveBackgroundJobDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobEntity>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).startRemoveBackgroundJob(removeBackgroundJobDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Upload a file to the generic storage
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upload(file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResultDto>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).upload(file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Webhook endpoint for VideoBGRemover job updates
         * @param {VideoBGRemoverWebhookDto} videoBGRemoverWebhookDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhookVideoBgRemover(videoBGRemoverWebhookDto: VideoBGRemoverWebhookDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).webhookVideoBgRemover(videoBGRemoverWebhookDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Delete a file from the generic storage
         * @param {FileDeleteDto} fileDeleteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(fileDeleteDto: FileDeleteDto, options?: any): AxiosPromise<boolean> {
            return FileApiFp(configuration)._delete(fileDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Check the quality of given AR target
         * @param {string} uri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        arTargetQuality(uri: string, options?: any): AxiosPromise<void> {
            return FileApiFp(configuration).arTargetQuality(uri, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Convert given bucket file to a .zpt target file.
         * @param {string} path 
         * @param {ImageTrainOptionsDto} imageTrainOptionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertImageToWebAr(path: string, imageTrainOptionsDto: ImageTrainOptionsDto, options?: any): AxiosPromise<FileUploadResultDto> {
            return FileApiFp(configuration).convertImageToWebAr(path, imageTrainOptionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Proxy
         * @param {string} uri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxy(uri: string, options?: any): AxiosPromise<void> {
            return FileApiFp(configuration).proxy(uri, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Start a job to remove background from the video.
         * @param {RemoveBackgroundJobDto} removeBackgroundJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRemoveBackgroundJob(removeBackgroundJobDto: RemoveBackgroundJobDto, options?: any): AxiosPromise<JobEntity> {
            return FileApiFp(configuration).startRemoveBackgroundJob(removeBackgroundJobDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Upload a file to the generic storage
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(file: any, options?: any): AxiosPromise<FileUploadResultDto> {
            return FileApiFp(configuration).upload(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Webhook endpoint for VideoBGRemover job updates
         * @param {VideoBGRemoverWebhookDto} videoBGRemoverWebhookDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookVideoBgRemover(videoBGRemoverWebhookDto: VideoBGRemoverWebhookDto, options?: any): AxiosPromise<void> {
            return FileApiFp(configuration).webhookVideoBgRemover(videoBGRemoverWebhookDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
     * @summary Delete a file from the generic storage
     * @param {FileDeleteDto} fileDeleteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public _delete(fileDeleteDto: FileDeleteDto, options?: any) {
        return FileApiFp(this.configuration)._delete(fileDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
     * @summary Check the quality of given AR target
     * @param {string} uri 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public arTargetQuality(uri: string, options?: any) {
        return FileApiFp(this.configuration).arTargetQuality(uri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
     * @summary Convert given bucket file to a .zpt target file.
     * @param {string} path 
     * @param {ImageTrainOptionsDto} imageTrainOptionsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public convertImageToWebAr(path: string, imageTrainOptionsDto: ImageTrainOptionsDto, options?: any) {
        return FileApiFp(this.configuration).convertImageToWebAr(path, imageTrainOptionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Proxy
     * @param {string} uri 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public proxy(uri: string, options?: any) {
        return FileApiFp(this.configuration).proxy(uri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
     * @summary Start a job to remove background from the video.
     * @param {RemoveBackgroundJobDto} removeBackgroundJobDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public startRemoveBackgroundJob(removeBackgroundJobDto: RemoveBackgroundJobDto, options?: any) {
        return FileApiFp(this.configuration).startRemoveBackgroundJob(removeBackgroundJobDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
     * @summary Upload a file to the generic storage
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public upload(file: any, options?: any) {
        return FileApiFp(this.configuration).upload(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Webhook endpoint for VideoBGRemover job updates
     * @param {VideoBGRemoverWebhookDto} videoBGRemoverWebhookDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public webhookVideoBgRemover(videoBGRemoverWebhookDto: VideoBGRemoverWebhookDto, options?: any) {
        return FileApiFp(this.configuration).webhookVideoBgRemover(videoBGRemoverWebhookDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GameApi - axios parameter creator
 * @export
 */
export const GameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Add variable with given ID to this game
         * @param {string} id 
         * @param {AddGameVariableDto} addGameVariableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGameVariable: async (id: string, addGameVariableDto: AddGameVariableDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling addGameVariable.');
            }
            // verify required parameter 'addGameVariableDto' is not null or undefined
            if (addGameVariableDto === null || addGameVariableDto === undefined) {
                throw new RequiredError('addGameVariableDto','Required parameter addGameVariableDto was null or undefined when calling addGameVariable.');
            }
            const localVarPath = `/builder/game/{id}/variable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addGameVariableDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addGameVariableDto !== undefined ? addGameVariableDto : {}) : (addGameVariableDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Add language with given ID to this game
         * @param {string} id 
         * @param {AddGameLanguageDto} addGameLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLanguage: async (id: string, addGameLanguageDto: AddGameLanguageDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling addLanguage.');
            }
            // verify required parameter 'addGameLanguageDto' is not null or undefined
            if (addGameLanguageDto === null || addGameLanguageDto === undefined) {
                throw new RequiredError('addGameLanguageDto','Required parameter addGameLanguageDto was null or undefined when calling addLanguage.');
            }
            const localVarPath = `/builder/game/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addGameLanguageDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addGameLanguageDto !== undefined ? addGameLanguageDto : {}) : (addGameLanguageDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get languages of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableLanguages: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling availableLanguages.');
            }
            const localVarPath = `/builder/game/{id}/languages/available`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Clear all scene translations for a language without removing the language
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearLanguageTranslations: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling clearLanguageTranslations.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling clearLanguageTranslations.');
            }
            const localVarPath = `/builder/game/{id}/language/{language}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Copy a full game definition
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyFullDefinition: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling copyFullDefinition.');
            }
            const localVarPath = `/builder/game/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Create a time-limited token that grants access to the hotlink preview of this game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGamePreviewToken: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createGamePreviewToken.');
            }
            const localVarPath = `/builder/game/{id}/preview-token`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update releases of the given game
         * @param {string} id 
         * @param {GameReleasePostDto} gameReleasePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelease: async (id: string, gameReleasePostDto: GameReleasePostDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createRelease.');
            }
            // verify required parameter 'gameReleasePostDto' is not null or undefined
            if (gameReleasePostDto === null || gameReleasePostDto === undefined) {
                throw new RequiredError('gameReleasePostDto','Required parameter gameReleasePostDto was null or undefined when calling createRelease.');
            }
            const localVarPath = `/builder/game/{id}/releases`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof gameReleasePostDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(gameReleasePostDto !== undefined ? gameReleasePostDto : {}) : (gameReleasePostDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Delete all sessions of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllGameSessions: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAllGameSessions.');
            }
            const localVarPath = `/builder/game/{id}/sessions/delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        |  | company      | admin        | 
         * @summary Delete game by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGame: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteGame.');
            }
            const localVarPath = `/builder/game/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Delete game session
         * @param {string} id 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGameSession: async (id: string, sessionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteGameSession.');
            }
            // verify required parameter 'sessionId' is not null or undefined
            if (sessionId === null || sessionId === undefined) {
                throw new RequiredError('sessionId','Required parameter sessionId was null or undefined when calling deleteGameSession.');
            }
            const localVarPath = `/builder/game/{id}/session/{sessionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game_release | admin        | 
         * @summary Delete releases of the given game
         * @param {string} releaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelease: async (releaseId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseId' is not null or undefined
            if (releaseId === null || releaseId === undefined) {
                throw new RequiredError('releaseId','Required parameter releaseId was null or undefined when calling deleteRelease.');
            }
            const localVarPath = `/builder/game/releases/{releaseId}`
                .replace(`{${"releaseId"}}`, encodeURIComponent(String(releaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Duplicate a game
         * @param {string} id 
         * @param {DuplicateGameDto} duplicateGameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicate: async (id: string, duplicateGameDto: DuplicateGameDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling duplicate.');
            }
            // verify required parameter 'duplicateGameDto' is not null or undefined
            if (duplicateGameDto === null || duplicateGameDto === undefined) {
                throw new RequiredError('duplicateGameDto','Required parameter duplicateGameDto was null or undefined when calling duplicate.');
            }
            const localVarPath = `/builder/game/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof duplicateGameDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(duplicateGameDto !== undefined ? duplicateGameDto : {}) : (duplicateGameDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Find game by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGameById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findGameById.');
            }
            const localVarPath = `/builder/game/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get languages of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameLanguages: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling gameLanguages.');
            }
            const localVarPath = `/builder/game/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get releases of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameReleases: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling gameReleases.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling gameReleases.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling gameReleases.');
            }
            const localVarPath = `/builder/game/{id}/releases`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get reviews of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameReviews: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling gameReviews.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling gameReviews.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling gameReviews.');
            }
            const localVarPath = `/builder/game/{id}/reviews`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get sessions of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameSessions: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling gameSessions.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling gameSessions.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling gameSessions.');
            }
            const localVarPath = `/builder/game/{id}/sessions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Count sessions of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameSessionsCount: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling gameSessionsCount.');
            }
            const localVarPath = `/builder/game/{id}/sessions/count`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get game QR Code
         * @param {string} id 
         * @param {string} environment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameQR: async (id: string, environment: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getGameQR.');
            }
            // verify required parameter 'environment' is not null or undefined
            if (environment === null || environment === undefined) {
                throw new RequiredError('environment','Required parameter environment was null or undefined when calling getGameQR.');
            }
            const localVarPath = `/builder/game/{id}/qr/{environment}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"environment"}}`, encodeURIComponent(String(environment)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get given game variable by ID.
         * @param {string} id 
         * @param {string} variable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameVariableById: async (id: string, variable: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getGameVariableById.');
            }
            // verify required parameter 'variable' is not null or undefined
            if (variable === null || variable === undefined) {
                throw new RequiredError('variable','Required parameter variable was null or undefined when calling getGameVariableById.');
            }
            const localVarPath = `/builder/game/{id}/variable/{variable}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"variable"}}`, encodeURIComponent(String(variable)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get variables of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameVariables: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getGameVariables.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling getGameVariables.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling getGameVariables.');
            }
            const localVarPath = `/builder/game/{id}/variable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate games the user has access to, searchable by name
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [companyId] Confine the search to one organization. Required unless the caller is a super admin
         * @param {string} [whitelabelId] Confine the search to one brand
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAllGames: async (skip: number, take: number, companyId?: string, whitelabelId?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateAllGames.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateAllGames.');
            }
            const localVarPath = `/builder/game`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (whitelabelId !== undefined) {
                localVarQueryParameter['whitelabelId'] = whitelabelId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Remove variable with given ID from this game
         * @param {string} id 
         * @param {string} variable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGameVariable: async (id: string, variable: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeGameVariable.');
            }
            // verify required parameter 'variable' is not null or undefined
            if (variable === null || variable === undefined) {
                throw new RequiredError('variable','Required parameter variable was null or undefined when calling removeGameVariable.');
            }
            const localVarPath = `/builder/game/{id}/variable/{variable}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"variable"}}`, encodeURIComponent(String(variable)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Remove language with given ID from this game
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLanguage: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeLanguage.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling removeLanguage.');
            }
            const localVarPath = `/builder/game/{id}/language/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Reset the scoreboard (set all scores hidden)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetScoreboard: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling resetScoreboard.');
            }
            const localVarPath = `/builder/game/{id}/sessions/reset-scoreboard`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Sort game variables
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortGameVariables: async (id: string, requestBody: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sortGameVariables.');
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling sortGameVariables.');
            }
            const localVarPath = `/builder/game/{id}/variable/sort`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update game by id (partial update)
         * @param {string} id 
         * @param {GamePutDto} gamePutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGame: async (id: string, gamePutDto: GamePutDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateGame.');
            }
            // verify required parameter 'gamePutDto' is not null or undefined
            if (gamePutDto === null || gamePutDto === undefined) {
                throw new RequiredError('gamePutDto','Required parameter gamePutDto was null or undefined when calling updateGame.');
            }
            const localVarPath = `/builder/game/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof gamePutDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(gamePutDto !== undefined ? gamePutDto : {}) : (gamePutDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update language
         * @param {string} id 
         * @param {string} language 
         * @param {UpdateGameLanguageDto} updateGameLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGameLanguage: async (id: string, language: string, updateGameLanguageDto: UpdateGameLanguageDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateGameLanguage.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling updateGameLanguage.');
            }
            // verify required parameter 'updateGameLanguageDto' is not null or undefined
            if (updateGameLanguageDto === null || updateGameLanguageDto === undefined) {
                throw new RequiredError('updateGameLanguageDto','Required parameter updateGameLanguageDto was null or undefined when calling updateGameLanguage.');
            }
            const localVarPath = `/builder/game/{id}/language/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateGameLanguageDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateGameLanguageDto !== undefined ? updateGameLanguageDto : {}) : (updateGameLanguageDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update variable
         * @param {string} id 
         * @param {string} variable 
         * @param {UpdateGameVariableDto} updateGameVariableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGameVariable: async (id: string, variable: string, updateGameVariableDto: UpdateGameVariableDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateGameVariable.');
            }
            // verify required parameter 'variable' is not null or undefined
            if (variable === null || variable === undefined) {
                throw new RequiredError('variable','Required parameter variable was null or undefined when calling updateGameVariable.');
            }
            // verify required parameter 'updateGameVariableDto' is not null or undefined
            if (updateGameVariableDto === null || updateGameVariableDto === undefined) {
                throw new RequiredError('updateGameVariableDto','Required parameter updateGameVariableDto was null or undefined when calling updateGameVariable.');
            }
            const localVarPath = `/builder/game/{id}/variable/{variable}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"variable"}}`, encodeURIComponent(String(variable)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateGameVariableDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateGameVariableDto !== undefined ? updateGameVariableDto : {}) : (updateGameVariableDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GameApi - functional programming interface
 * @export
 */
export const GameApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Add variable with given ID to this game
         * @param {string} id 
         * @param {AddGameVariableDto} addGameVariableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addGameVariable(id: string, addGameVariableDto: AddGameVariableDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).addGameVariable(id, addGameVariableDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Add language with given ID to this game
         * @param {string} id 
         * @param {AddGameLanguageDto} addGameLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addLanguage(id: string, addGameLanguageDto: AddGameLanguageDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).addLanguage(id, addGameLanguageDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get languages of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async availableLanguages(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageEntity>>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).availableLanguages(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Clear all scene translations for a language without removing the language
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearLanguageTranslations(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).clearLanguageTranslations(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Copy a full game definition
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyFullDefinition(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GamePayloadDto>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).copyFullDefinition(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Create a time-limited token that grants access to the hotlink preview of this game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGamePreviewToken(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HotlinkTokenDto>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).createGamePreviewToken(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update releases of the given game
         * @param {string} id 
         * @param {GameReleasePostDto} gameReleasePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRelease(id: string, gameReleasePostDto: GameReleasePostDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).createRelease(id, gameReleasePostDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Delete all sessions of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllGameSessions(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RawQueryResult>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).deleteAllGameSessions(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        |  | company      | admin        | 
         * @summary Delete game by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGame(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RawQueryResult>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).deleteGame(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Delete game session
         * @param {string} id 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGameSession(id: string, sessionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RawQueryResult>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).deleteGameSession(id, sessionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game_release | admin        | 
         * @summary Delete releases of the given game
         * @param {string} releaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRelease(releaseId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleOkResponse>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).deleteRelease(releaseId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Duplicate a game
         * @param {string} id 
         * @param {DuplicateGameDto} duplicateGameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicate(id: string, duplicateGameDto: DuplicateGameDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameEntity>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).duplicate(id, duplicateGameDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Find game by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findGameById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameEntity>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).findGameById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get languages of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameLanguages(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameLanguageEntity>>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).gameLanguages(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get releases of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameReleases(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameReleaseEntity>>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).gameReleases(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get reviews of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameReviews(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReviewEntity>>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).gameReviews(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get sessions of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameSessions(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SessionEntity>>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).gameSessions(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Count sessions of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gameSessionsCount(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameSessionsCountDto>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).gameSessionsCount(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get game QR Code
         * @param {string} id 
         * @param {string} environment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGameQR(id: string, environment: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrDto>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).getGameQR(id, environment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get given game variable by ID.
         * @param {string} id 
         * @param {string} variable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGameVariableById(id: string, variable: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GameVariableEntity>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).getGameVariableById(id, variable, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get variables of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGameVariables(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameVariableEntity>>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).getGameVariables(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate games the user has access to, searchable by name
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [companyId] Confine the search to one organization. Required unless the caller is a super admin
         * @param {string} [whitelabelId] Confine the search to one brand
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateAllGames(skip: number, take: number, companyId?: string, whitelabelId?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameEntity>>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).paginateAllGames(skip, take, companyId, whitelabelId, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Remove variable with given ID from this game
         * @param {string} id 
         * @param {string} variable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeGameVariable(id: string, variable: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).removeGameVariable(id, variable, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Remove language with given ID from this game
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeLanguage(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).removeLanguage(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Reset the scoreboard (set all scores hidden)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetScoreboard(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleOkResponse>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).resetScoreboard(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Sort game variables
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sortGameVariables(id: string, requestBody: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).sortGameVariables(id, requestBody, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update game by id (partial update)
         * @param {string} id 
         * @param {GamePutDto} gamePutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGame(id: string, gamePutDto: GamePutDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RawQueryResult>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).updateGame(id, gamePutDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update language
         * @param {string} id 
         * @param {string} language 
         * @param {UpdateGameLanguageDto} updateGameLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGameLanguage(id: string, language: string, updateGameLanguageDto: UpdateGameLanguageDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).updateGameLanguage(id, language, updateGameLanguageDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update variable
         * @param {string} id 
         * @param {string} variable 
         * @param {UpdateGameVariableDto} updateGameVariableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGameVariable(id: string, variable: string, updateGameVariableDto: UpdateGameVariableDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GameApiAxiosParamCreator(configuration).updateGameVariable(id, variable, updateGameVariableDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GameApi - factory interface
 * @export
 */
export const GameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Add variable with given ID to this game
         * @param {string} id 
         * @param {AddGameVariableDto} addGameVariableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGameVariable(id: string, addGameVariableDto: AddGameVariableDto, options?: any): AxiosPromise<void> {
            return GameApiFp(configuration).addGameVariable(id, addGameVariableDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Add language with given ID to this game
         * @param {string} id 
         * @param {AddGameLanguageDto} addGameLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLanguage(id: string, addGameLanguageDto: AddGameLanguageDto, options?: any): AxiosPromise<void> {
            return GameApiFp(configuration).addLanguage(id, addGameLanguageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get languages of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableLanguages(id: string, options?: any): AxiosPromise<Array<LanguageEntity>> {
            return GameApiFp(configuration).availableLanguages(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Clear all scene translations for a language without removing the language
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearLanguageTranslations(id: string, language: string, options?: any): AxiosPromise<void> {
            return GameApiFp(configuration).clearLanguageTranslations(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Copy a full game definition
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyFullDefinition(id: string, options?: any): AxiosPromise<GamePayloadDto> {
            return GameApiFp(configuration).copyFullDefinition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Create a time-limited token that grants access to the hotlink preview of this game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGamePreviewToken(id: string, options?: any): AxiosPromise<HotlinkTokenDto> {
            return GameApiFp(configuration).createGamePreviewToken(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update releases of the given game
         * @param {string} id 
         * @param {GameReleasePostDto} gameReleasePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelease(id: string, gameReleasePostDto: GameReleasePostDto, options?: any): AxiosPromise<void> {
            return GameApiFp(configuration).createRelease(id, gameReleasePostDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Delete all sessions of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllGameSessions(id: string, options?: any): AxiosPromise<RawQueryResult> {
            return GameApiFp(configuration).deleteAllGameSessions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        |  | company      | admin        | 
         * @summary Delete game by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGame(id: string, options?: any): AxiosPromise<RawQueryResult> {
            return GameApiFp(configuration).deleteGame(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Delete game session
         * @param {string} id 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGameSession(id: string, sessionId: string, options?: any): AxiosPromise<RawQueryResult> {
            return GameApiFp(configuration).deleteGameSession(id, sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game_release | admin        | 
         * @summary Delete releases of the given game
         * @param {string} releaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelease(releaseId: string, options?: any): AxiosPromise<SimpleOkResponse> {
            return GameApiFp(configuration).deleteRelease(releaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Duplicate a game
         * @param {string} id 
         * @param {DuplicateGameDto} duplicateGameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicate(id: string, duplicateGameDto: DuplicateGameDto, options?: any): AxiosPromise<GameEntity> {
            return GameApiFp(configuration).duplicate(id, duplicateGameDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Find game by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGameById(id: string, options?: any): AxiosPromise<GameEntity> {
            return GameApiFp(configuration).findGameById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get languages of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameLanguages(id: string, options?: any): AxiosPromise<Array<GameLanguageEntity>> {
            return GameApiFp(configuration).gameLanguages(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get releases of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameReleases(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<GameReleaseEntity>> {
            return GameApiFp(configuration).gameReleases(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get reviews of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameReviews(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<ReviewEntity>> {
            return GameApiFp(configuration).gameReviews(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get sessions of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameSessions(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<SessionEntity>> {
            return GameApiFp(configuration).gameSessions(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Count sessions of the given game
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gameSessionsCount(id: string, options?: any): AxiosPromise<GameSessionsCountDto> {
            return GameApiFp(configuration).gameSessionsCount(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get game QR Code
         * @param {string} id 
         * @param {string} environment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameQR(id: string, environment: string, options?: any): AxiosPromise<QrDto> {
            return GameApiFp(configuration).getGameQR(id, environment, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get given game variable by ID.
         * @param {string} id 
         * @param {string} variable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameVariableById(id: string, variable: string, options?: any): AxiosPromise<GameVariableEntity> {
            return GameApiFp(configuration).getGameVariableById(id, variable, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Get variables of the given game
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameVariables(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<GameVariableEntity>> {
            return GameApiFp(configuration).getGameVariables(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate games the user has access to, searchable by name
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [companyId] Confine the search to one organization. Required unless the caller is a super admin
         * @param {string} [whitelabelId] Confine the search to one brand
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateAllGames(skip: number, take: number, companyId?: string, whitelabelId?: string, keyword?: string, options?: any): AxiosPromise<Array<GameEntity>> {
            return GameApiFp(configuration).paginateAllGames(skip, take, companyId, whitelabelId, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Remove variable with given ID from this game
         * @param {string} id 
         * @param {string} variable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGameVariable(id: string, variable: string, options?: any): AxiosPromise<void> {
            return GameApiFp(configuration).removeGameVariable(id, variable, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Remove language with given ID from this game
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLanguage(id: string, language: string, options?: any): AxiosPromise<void> {
            return GameApiFp(configuration).removeLanguage(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Reset the scoreboard (set all scores hidden)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetScoreboard(id: string, options?: any): AxiosPromise<SimpleOkResponse> {
            return GameApiFp(configuration).resetScoreboard(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Sort game variables
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortGameVariables(id: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return GameApiFp(configuration).sortGameVariables(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update game by id (partial update)
         * @param {string} id 
         * @param {GamePutDto} gamePutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGame(id: string, gamePutDto: GamePutDto, options?: any): AxiosPromise<RawQueryResult> {
            return GameApiFp(configuration).updateGame(id, gamePutDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update language
         * @param {string} id 
         * @param {string} language 
         * @param {UpdateGameLanguageDto} updateGameLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGameLanguage(id: string, language: string, updateGameLanguageDto: UpdateGameLanguageDto, options?: any): AxiosPromise<void> {
            return GameApiFp(configuration).updateGameLanguage(id, language, updateGameLanguageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Update variable
         * @param {string} id 
         * @param {string} variable 
         * @param {UpdateGameVariableDto} updateGameVariableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGameVariable(id: string, variable: string, updateGameVariableDto: UpdateGameVariableDto, options?: any): AxiosPromise<void> {
            return GameApiFp(configuration).updateGameVariable(id, variable, updateGameVariableDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GameApi - object-oriented interface
 * @export
 * @class GameApi
 * @extends {BaseAPI}
 */
export class GameApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Add variable with given ID to this game
     * @param {string} id 
     * @param {AddGameVariableDto} addGameVariableDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public addGameVariable(id: string, addGameVariableDto: AddGameVariableDto, options?: any) {
        return GameApiFp(this.configuration).addGameVariable(id, addGameVariableDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Add language with given ID to this game
     * @param {string} id 
     * @param {AddGameLanguageDto} addGameLanguageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public addLanguage(id: string, addGameLanguageDto: AddGameLanguageDto, options?: any) {
        return GameApiFp(this.configuration).addLanguage(id, addGameLanguageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Get languages of the given game
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public availableLanguages(id: string, options?: any) {
        return GameApiFp(this.configuration).availableLanguages(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Clear all scene translations for a language without removing the language
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public clearLanguageTranslations(id: string, language: string, options?: any) {
        return GameApiFp(this.configuration).clearLanguageTranslations(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
     * @summary Copy a full game definition
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public copyFullDefinition(id: string, options?: any) {
        return GameApiFp(this.configuration).copyFullDefinition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
     * @summary Create a time-limited token that grants access to the hotlink preview of this game
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public createGamePreviewToken(id: string, options?: any) {
        return GameApiFp(this.configuration).createGamePreviewToken(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Update releases of the given game
     * @param {string} id 
     * @param {GameReleasePostDto} gameReleasePostDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public createRelease(id: string, gameReleasePostDto: GameReleasePostDto, options?: any) {
        return GameApiFp(this.configuration).createRelease(id, gameReleasePostDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
     * @summary Delete all sessions of the given game
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public deleteAllGameSessions(id: string, options?: any) {
        return GameApiFp(this.configuration).deleteAllGameSessions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | admin        |  | company      | admin        | 
     * @summary Delete game by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public deleteGame(id: string, options?: any) {
        return GameApiFp(this.configuration).deleteGame(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
     * @summary Delete game session
     * @param {string} id 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public deleteGameSession(id: string, sessionId: string, options?: any) {
        return GameApiFp(this.configuration).deleteGameSession(id, sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game_release | admin        | 
     * @summary Delete releases of the given game
     * @param {string} releaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public deleteRelease(releaseId: string, options?: any) {
        return GameApiFp(this.configuration).deleteRelease(releaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
     * @summary Duplicate a game
     * @param {string} id 
     * @param {DuplicateGameDto} duplicateGameDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public duplicate(id: string, duplicateGameDto: DuplicateGameDto, options?: any) {
        return GameApiFp(this.configuration).duplicate(id, duplicateGameDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
     * @summary Find game by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public findGameById(id: string, options?: any) {
        return GameApiFp(this.configuration).findGameById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Get languages of the given game
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public gameLanguages(id: string, options?: any) {
        return GameApiFp(this.configuration).gameLanguages(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Get releases of the given game
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public gameReleases(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return GameApiFp(this.configuration).gameReleases(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
     * @summary Get reviews of the given game
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public gameReviews(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return GameApiFp(this.configuration).gameReviews(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
     * @summary Get sessions of the given game
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public gameSessions(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return GameApiFp(this.configuration).gameSessions(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
     * @summary Count sessions of the given game
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public gameSessionsCount(id: string, options?: any) {
        return GameApiFp(this.configuration).gameSessionsCount(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
     * @summary Get game QR Code
     * @param {string} id 
     * @param {string} environment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public getGameQR(id: string, environment: string, options?: any) {
        return GameApiFp(this.configuration).getGameQR(id, environment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Get given game variable by ID.
     * @param {string} id 
     * @param {string} variable 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public getGameVariableById(id: string, variable: string, options?: any) {
        return GameApiFp(this.configuration).getGameVariableById(id, variable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Get variables of the given game
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public getGameVariables(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return GameApiFp(this.configuration).getGameVariables(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
     * @summary Paginate games the user has access to, searchable by name
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [companyId] Confine the search to one organization. Required unless the caller is a super admin
     * @param {string} [whitelabelId] Confine the search to one brand
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public paginateAllGames(skip: number, take: number, companyId?: string, whitelabelId?: string, keyword?: string, options?: any) {
        return GameApiFp(this.configuration).paginateAllGames(skip, take, companyId, whitelabelId, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Remove variable with given ID from this game
     * @param {string} id 
     * @param {string} variable 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public removeGameVariable(id: string, variable: string, options?: any) {
        return GameApiFp(this.configuration).removeGameVariable(id, variable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Remove language with given ID from this game
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public removeLanguage(id: string, language: string, options?: any) {
        return GameApiFp(this.configuration).removeLanguage(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
     * @summary Reset the scoreboard (set all scores hidden)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public resetScoreboard(id: string, options?: any) {
        return GameApiFp(this.configuration).resetScoreboard(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Sort game variables
     * @param {string} id 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public sortGameVariables(id: string, requestBody: Array<string>, options?: any) {
        return GameApiFp(this.configuration).sortGameVariables(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Update game by id (partial update)
     * @param {string} id 
     * @param {GamePutDto} gamePutDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public updateGame(id: string, gamePutDto: GamePutDto, options?: any) {
        return GameApiFp(this.configuration).updateGame(id, gamePutDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Update language
     * @param {string} id 
     * @param {string} language 
     * @param {UpdateGameLanguageDto} updateGameLanguageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public updateGameLanguage(id: string, language: string, updateGameLanguageDto: UpdateGameLanguageDto, options?: any) {
        return GameApiFp(this.configuration).updateGameLanguage(id, language, updateGameLanguageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Update variable
     * @param {string} id 
     * @param {string} variable 
     * @param {UpdateGameVariableDto} updateGameVariableDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameApi
     */
    public updateGameVariable(id: string, variable: string, updateGameVariableDto: UpdateGameVariableDto, options?: any) {
        return GameApiFp(this.configuration).updateGameVariable(id, variable, updateGameVariableDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GamePublicApi - axios parameter creator
 * @export
 */
export const GamePublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get public game by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicGameById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPublicGameById.');
            }
            const localVarPath = `/game/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GamePublicApi - functional programming interface
 * @export
 */
export const GamePublicApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get public game by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicGameById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GamePublicDto>> {
            const localVarAxiosArgs = await GamePublicApiAxiosParamCreator(configuration).getPublicGameById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GamePublicApi - factory interface
 * @export
 */
export const GamePublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get public game by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicGameById(id: string, options?: any): AxiosPromise<GamePublicDto> {
            return GamePublicApiFp(configuration).getPublicGameById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GamePublicApi - object-oriented interface
 * @export
 * @class GamePublicApi
 * @extends {BaseAPI}
 */
export class GamePublicApi extends BaseAPI {
    /**
     * 
     * @summary Get public game by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamePublicApi
     */
    public getPublicGameById(id: string, options?: any) {
        return GamePublicApiFp(this.configuration).getPublicGameById(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HotlinkApi - axios parameter creator
 * @export
 */
export const HotlinkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get game data for hotlink preview
         * @param {string} gameId Game ID
         * @param {string} token Time-limited preview token issued for this game
         * @param {string} [scenarioId] Optional base scenario ID
         * @param {string} [sceneId] Optional Scene ID
         * @param {string} [language] Optional language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGamePreview: async (gameId: string, token: string, scenarioId?: string, sceneId?: string, language?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling getGamePreview.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling getGamePreview.');
            }
            const localVarPath = `/hotlink/game`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gameId !== undefined) {
                localVarQueryParameter['gameId'] = gameId;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (scenarioId !== undefined) {
                localVarQueryParameter['scenarioId'] = scenarioId;
            }

            if (sceneId !== undefined) {
                localVarQueryParameter['sceneId'] = sceneId;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HotlinkApi - functional programming interface
 * @export
 */
export const HotlinkApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get game data for hotlink preview
         * @param {string} gameId Game ID
         * @param {string} token Time-limited preview token issued for this game
         * @param {string} [scenarioId] Optional base scenario ID
         * @param {string} [sceneId] Optional Scene ID
         * @param {string} [language] Optional language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGamePreview(gameId: string, token: string, scenarioId?: string, sceneId?: string, language?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HotlinkDeployEventDto>> {
            const localVarAxiosArgs = await HotlinkApiAxiosParamCreator(configuration).getGamePreview(gameId, token, scenarioId, sceneId, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HotlinkApi - factory interface
 * @export
 */
export const HotlinkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get game data for hotlink preview
         * @param {string} gameId Game ID
         * @param {string} token Time-limited preview token issued for this game
         * @param {string} [scenarioId] Optional base scenario ID
         * @param {string} [sceneId] Optional Scene ID
         * @param {string} [language] Optional language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGamePreview(gameId: string, token: string, scenarioId?: string, sceneId?: string, language?: string, options?: any): AxiosPromise<HotlinkDeployEventDto> {
            return HotlinkApiFp(configuration).getGamePreview(gameId, token, scenarioId, sceneId, language, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HotlinkApi - object-oriented interface
 * @export
 * @class HotlinkApi
 * @extends {BaseAPI}
 */
export class HotlinkApi extends BaseAPI {
    /**
     * 
     * @summary Get game data for hotlink preview
     * @param {string} gameId Game ID
     * @param {string} token Time-limited preview token issued for this game
     * @param {string} [scenarioId] Optional base scenario ID
     * @param {string} [sceneId] Optional Scene ID
     * @param {string} [language] Optional language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HotlinkApi
     */
    public getGamePreview(gameId: string, token: string, scenarioId?: string, sceneId?: string, language?: string, options?: any) {
        return HotlinkApiFp(this.configuration).getGamePreview(gameId, token, scenarioId, sceneId, language, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MarkdownPageApi - axios parameter creator
 * @export
 */
export const MarkdownPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Get all markdown pages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allMarkdownPages: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/builder/markdown-page/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new markdown page
         * @param {MarkdownPageEntity} markdownPageEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMarkdownPage: async (markdownPageEntity: MarkdownPageEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'markdownPageEntity' is not null or undefined
            if (markdownPageEntity === null || markdownPageEntity === undefined) {
                throw new RequiredError('markdownPageEntity','Required parameter markdownPageEntity was null or undefined when calling createMarkdownPage.');
            }
            const localVarPath = `/builder/markdown-page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof markdownPageEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(markdownPageEntity !== undefined ? markdownPageEntity : {}) : (markdownPageEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete markdown page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarkdownPage: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteMarkdownPage.');
            }
            const localVarPath = `/builder/markdown-page/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate markdown pages
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMarkdownPages: async (skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling findMarkdownPages.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling findMarkdownPages.');
            }
            const localVarPath = `/builder/markdown-page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | viewer       | 
         * @summary Find all markdown pages for given whitelabel and language 
         * @param {string} whitelabelId 
         * @param {string} languageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWhitelabelMarkdownPageContent: async (whitelabelId: string, languageId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'whitelabelId' is not null or undefined
            if (whitelabelId === null || whitelabelId === undefined) {
                throw new RequiredError('whitelabelId','Required parameter whitelabelId was null or undefined when calling findWhitelabelMarkdownPageContent.');
            }
            // verify required parameter 'languageId' is not null or undefined
            if (languageId === null || languageId === undefined) {
                throw new RequiredError('languageId','Required parameter languageId was null or undefined when calling findWhitelabelMarkdownPageContent.');
            }
            const localVarPath = `/builder/markdown-page/content/{whitelabelId}/{languageId}`
                .replace(`{${"whitelabelId"}}`, encodeURIComponent(String(whitelabelId)))
                .replace(`{${"languageId"}}`, encodeURIComponent(String(languageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get markdown page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkdownPageById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getMarkdownPageById.');
            }
            const localVarPath = `/builder/markdown-page/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | editor       | 
         * @summary Get a markdown page.
         * @param {string} whitelabelId 
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkdownPageContent: async (whitelabelId: string, languageId: string, pageId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'whitelabelId' is not null or undefined
            if (whitelabelId === null || whitelabelId === undefined) {
                throw new RequiredError('whitelabelId','Required parameter whitelabelId was null or undefined when calling getMarkdownPageContent.');
            }
            // verify required parameter 'languageId' is not null or undefined
            if (languageId === null || languageId === undefined) {
                throw new RequiredError('languageId','Required parameter languageId was null or undefined when calling getMarkdownPageContent.');
            }
            // verify required parameter 'pageId' is not null or undefined
            if (pageId === null || pageId === undefined) {
                throw new RequiredError('pageId','Required parameter pageId was null or undefined when calling getMarkdownPageContent.');
            }
            const localVarPath = `/builder/markdown-page/content/{whitelabelId}/{languageId}/{pageId}`
                .replace(`{${"whitelabelId"}}`, encodeURIComponent(String(whitelabelId)))
                .replace(`{${"languageId"}}`, encodeURIComponent(String(languageId)))
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | editor       | 
         * @summary Put markdown page content
         * @param {string} whitelabelId 
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {MarkdownPageContentPutDto} markdownPageContentPutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMarkdownPageContent: async (whitelabelId: string, languageId: string, pageId: string, markdownPageContentPutDto: MarkdownPageContentPutDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'whitelabelId' is not null or undefined
            if (whitelabelId === null || whitelabelId === undefined) {
                throw new RequiredError('whitelabelId','Required parameter whitelabelId was null or undefined when calling putMarkdownPageContent.');
            }
            // verify required parameter 'languageId' is not null or undefined
            if (languageId === null || languageId === undefined) {
                throw new RequiredError('languageId','Required parameter languageId was null or undefined when calling putMarkdownPageContent.');
            }
            // verify required parameter 'pageId' is not null or undefined
            if (pageId === null || pageId === undefined) {
                throw new RequiredError('pageId','Required parameter pageId was null or undefined when calling putMarkdownPageContent.');
            }
            // verify required parameter 'markdownPageContentPutDto' is not null or undefined
            if (markdownPageContentPutDto === null || markdownPageContentPutDto === undefined) {
                throw new RequiredError('markdownPageContentPutDto','Required parameter markdownPageContentPutDto was null or undefined when calling putMarkdownPageContent.');
            }
            const localVarPath = `/builder/markdown-page/content/{whitelabelId}/{languageId}/{pageId}`
                .replace(`{${"whitelabelId"}}`, encodeURIComponent(String(whitelabelId)))
                .replace(`{${"languageId"}}`, encodeURIComponent(String(languageId)))
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof markdownPageContentPutDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(markdownPageContentPutDto !== undefined ? markdownPageContentPutDto : {}) : (markdownPageContentPutDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update markdown page by id (partial update)
         * @param {string} id 
         * @param {MarkdownPageUpdateDto} markdownPageUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarkdownPage: async (id: string, markdownPageUpdateDto: MarkdownPageUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateMarkdownPage.');
            }
            // verify required parameter 'markdownPageUpdateDto' is not null or undefined
            if (markdownPageUpdateDto === null || markdownPageUpdateDto === undefined) {
                throw new RequiredError('markdownPageUpdateDto','Required parameter markdownPageUpdateDto was null or undefined when calling updateMarkdownPage.');
            }
            const localVarPath = `/builder/markdown-page/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof markdownPageUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(markdownPageUpdateDto !== undefined ? markdownPageUpdateDto : {}) : (markdownPageUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarkdownPageApi - functional programming interface
 * @export
 */
export const MarkdownPageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Get all markdown pages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allMarkdownPages(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MarkdownPageEntity>>> {
            const localVarAxiosArgs = await MarkdownPageApiAxiosParamCreator(configuration).allMarkdownPages(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create new markdown page
         * @param {MarkdownPageEntity} markdownPageEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMarkdownPage(markdownPageEntity: MarkdownPageEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkdownPageEntity>> {
            const localVarAxiosArgs = await MarkdownPageApiAxiosParamCreator(configuration).createMarkdownPage(markdownPageEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete markdown page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMarkdownPage(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkdownPageEntity>> {
            const localVarAxiosArgs = await MarkdownPageApiAxiosParamCreator(configuration).deleteMarkdownPage(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate markdown pages
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMarkdownPages(skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MarkdownPageEntity>>> {
            const localVarAxiosArgs = await MarkdownPageApiAxiosParamCreator(configuration).findMarkdownPages(skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | viewer       | 
         * @summary Find all markdown pages for given whitelabel and language 
         * @param {string} whitelabelId 
         * @param {string} languageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findWhitelabelMarkdownPageContent(whitelabelId: string, languageId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkdownPageContentEntity>> {
            const localVarAxiosArgs = await MarkdownPageApiAxiosParamCreator(configuration).findWhitelabelMarkdownPageContent(whitelabelId, languageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get markdown page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarkdownPageById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkdownPageEntity>> {
            const localVarAxiosArgs = await MarkdownPageApiAxiosParamCreator(configuration).getMarkdownPageById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | editor       | 
         * @summary Get a markdown page.
         * @param {string} whitelabelId 
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarkdownPageContent(whitelabelId: string, languageId: string, pageId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkdownPageContentEntity>> {
            const localVarAxiosArgs = await MarkdownPageApiAxiosParamCreator(configuration).getMarkdownPageContent(whitelabelId, languageId, pageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | editor       | 
         * @summary Put markdown page content
         * @param {string} whitelabelId 
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {MarkdownPageContentPutDto} markdownPageContentPutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putMarkdownPageContent(whitelabelId: string, languageId: string, pageId: string, markdownPageContentPutDto: MarkdownPageContentPutDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MarkdownPageApiAxiosParamCreator(configuration).putMarkdownPageContent(whitelabelId, languageId, pageId, markdownPageContentPutDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update markdown page by id (partial update)
         * @param {string} id 
         * @param {MarkdownPageUpdateDto} markdownPageUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMarkdownPage(id: string, markdownPageUpdateDto: MarkdownPageUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkdownPageEntity>> {
            const localVarAxiosArgs = await MarkdownPageApiAxiosParamCreator(configuration).updateMarkdownPage(id, markdownPageUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MarkdownPageApi - factory interface
 * @export
 */
export const MarkdownPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Get all markdown pages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allMarkdownPages(options?: any): AxiosPromise<Array<MarkdownPageEntity>> {
            return MarkdownPageApiFp(configuration).allMarkdownPages(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new markdown page
         * @param {MarkdownPageEntity} markdownPageEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMarkdownPage(markdownPageEntity: MarkdownPageEntity, options?: any): AxiosPromise<MarkdownPageEntity> {
            return MarkdownPageApiFp(configuration).createMarkdownPage(markdownPageEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete markdown page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarkdownPage(id: string, options?: any): AxiosPromise<MarkdownPageEntity> {
            return MarkdownPageApiFp(configuration).deleteMarkdownPage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
         * @summary Paginate markdown pages
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMarkdownPages(skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<MarkdownPageEntity>> {
            return MarkdownPageApiFp(configuration).findMarkdownPages(skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | viewer       | 
         * @summary Find all markdown pages for given whitelabel and language 
         * @param {string} whitelabelId 
         * @param {string} languageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWhitelabelMarkdownPageContent(whitelabelId: string, languageId: string, options?: any): AxiosPromise<MarkdownPageContentEntity> {
            return MarkdownPageApiFp(configuration).findWhitelabelMarkdownPageContent(whitelabelId, languageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get markdown page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkdownPageById(id: string, options?: any): AxiosPromise<MarkdownPageEntity> {
            return MarkdownPageApiFp(configuration).getMarkdownPageById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | editor       | 
         * @summary Get a markdown page.
         * @param {string} whitelabelId 
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkdownPageContent(whitelabelId: string, languageId: string, pageId: string, options?: any): AxiosPromise<MarkdownPageContentEntity> {
            return MarkdownPageApiFp(configuration).getMarkdownPageContent(whitelabelId, languageId, pageId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | editor       | 
         * @summary Put markdown page content
         * @param {string} whitelabelId 
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {MarkdownPageContentPutDto} markdownPageContentPutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMarkdownPageContent(whitelabelId: string, languageId: string, pageId: string, markdownPageContentPutDto: MarkdownPageContentPutDto, options?: any): AxiosPromise<void> {
            return MarkdownPageApiFp(configuration).putMarkdownPageContent(whitelabelId, languageId, pageId, markdownPageContentPutDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update markdown page by id (partial update)
         * @param {string} id 
         * @param {MarkdownPageUpdateDto} markdownPageUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarkdownPage(id: string, markdownPageUpdateDto: MarkdownPageUpdateDto, options?: any): AxiosPromise<MarkdownPageEntity> {
            return MarkdownPageApiFp(configuration).updateMarkdownPage(id, markdownPageUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MarkdownPageApi - object-oriented interface
 * @export
 * @class MarkdownPageApi
 * @extends {BaseAPI}
 */
export class MarkdownPageApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
     * @summary Get all markdown pages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkdownPageApi
     */
    public allMarkdownPages(options?: any) {
        return MarkdownPageApiFp(this.configuration).allMarkdownPages(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new markdown page
     * @param {MarkdownPageEntity} markdownPageEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkdownPageApi
     */
    public createMarkdownPage(markdownPageEntity: MarkdownPageEntity, options?: any) {
        return MarkdownPageApiFp(this.configuration).createMarkdownPage(markdownPageEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete markdown page by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkdownPageApi
     */
    public deleteMarkdownPage(id: string, options?: any) {
        return MarkdownPageApiFp(this.configuration).deleteMarkdownPage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | viewer       | 
     * @summary Paginate markdown pages
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkdownPageApi
     */
    public findMarkdownPages(skip: number, take: number, keyword?: string, options?: any) {
        return MarkdownPageApiFp(this.configuration).findMarkdownPages(skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | viewer       | 
     * @summary Find all markdown pages for given whitelabel and language 
     * @param {string} whitelabelId 
     * @param {string} languageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkdownPageApi
     */
    public findWhitelabelMarkdownPageContent(whitelabelId: string, languageId: string, options?: any) {
        return MarkdownPageApiFp(this.configuration).findWhitelabelMarkdownPageContent(whitelabelId, languageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get markdown page by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkdownPageApi
     */
    public getMarkdownPageById(id: string, options?: any) {
        return MarkdownPageApiFp(this.configuration).getMarkdownPageById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | editor       | 
     * @summary Get a markdown page.
     * @param {string} whitelabelId 
     * @param {string} languageId 
     * @param {string} pageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkdownPageApi
     */
    public getMarkdownPageContent(whitelabelId: string, languageId: string, pageId: string, options?: any) {
        return MarkdownPageApiFp(this.configuration).getMarkdownPageContent(whitelabelId, languageId, pageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | whitelabel   | editor       | 
     * @summary Put markdown page content
     * @param {string} whitelabelId 
     * @param {string} languageId 
     * @param {string} pageId 
     * @param {MarkdownPageContentPutDto} markdownPageContentPutDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkdownPageApi
     */
    public putMarkdownPageContent(whitelabelId: string, languageId: string, pageId: string, markdownPageContentPutDto: MarkdownPageContentPutDto, options?: any) {
        return MarkdownPageApiFp(this.configuration).putMarkdownPageContent(whitelabelId, languageId, pageId, markdownPageContentPutDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update markdown page by id (partial update)
     * @param {string} id 
     * @param {MarkdownPageUpdateDto} markdownPageUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkdownPageApi
     */
    public updateMarkdownPage(id: string, markdownPageUpdateDto: MarkdownPageUpdateDto, options?: any) {
        return MarkdownPageApiFp(this.configuration).updateMarkdownPage(id, markdownPageUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OnDemandPlaylistApi - axios parameter creator
 * @export
 */
export const OnDemandPlaylistApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new on-demand playlist
         * @param {OnDemandPlaylistEntity} onDemandPlaylistEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnDemandPlaylist: async (onDemandPlaylistEntity: OnDemandPlaylistEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'onDemandPlaylistEntity' is not null or undefined
            if (onDemandPlaylistEntity === null || onDemandPlaylistEntity === undefined) {
                throw new RequiredError('onDemandPlaylistEntity','Required parameter onDemandPlaylistEntity was null or undefined when calling createOnDemandPlaylist.');
            }
            const localVarPath = `/builder/on-demand-playlist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof onDemandPlaylistEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(onDemandPlaylistEntity !== undefined ? onDemandPlaylistEntity : {}) : (onDemandPlaylistEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Delete on-demand playlist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnDemandPlaylist: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteOnDemandPlaylist.');
            }
            const localVarPath = `/builder/on-demand-playlist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | viewer       | 
         * @summary Get base language of OnDemandPlaylist
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandPlaylistBaseLanguage: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOnDemandPlaylistBaseLanguage.');
            }
            const localVarPath = `/builder/on_demand_playlist/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | viewer       | 
         * @summary Get on-demand playlist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandPlaylistById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOnDemandPlaylistById.');
            }
            const localVarPath = `/builder/on-demand-playlist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Get full translation of OnDemandPlaylist
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandPlaylistTranslation: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOnDemandPlaylistTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling getOnDemandPlaylistTranslation.');
            }
            const localVarPath = `/builder/on_demand_playlist/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Get all translations of OnDemandPlaylist without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandPlaylistTranslations: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOnDemandPlaylistTranslations.');
            }
            const localVarPath = `/builder/on_demand_playlist/{id}/translation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Remove translation of OnDemandPlaylist
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOnDemandPlaylistTranslation: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeOnDemandPlaylistTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling removeOnDemandPlaylistTranslation.');
            }
            const localVarPath = `/builder/on_demand_playlist/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Set base language of OnDemandPlaylist
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOnDemandPlaylistBaseLanguage: async (id: string, baseLanguageDto: BaseLanguageDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setOnDemandPlaylistBaseLanguage.');
            }
            // verify required parameter 'baseLanguageDto' is not null or undefined
            if (baseLanguageDto === null || baseLanguageDto === undefined) {
                throw new RequiredError('baseLanguageDto','Required parameter baseLanguageDto was null or undefined when calling setOnDemandPlaylistBaseLanguage.');
            }
            const localVarPath = `/builder/on_demand_playlist/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof baseLanguageDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(baseLanguageDto !== undefined ? baseLanguageDto : {}) : (baseLanguageDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Update on-demand playlist by id (partial update)
         * @param {string} id 
         * @param {OnDemandPlaylistEntity} onDemandPlaylistEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnDemandPlaylist: async (id: string, onDemandPlaylistEntity: OnDemandPlaylistEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOnDemandPlaylist.');
            }
            // verify required parameter 'onDemandPlaylistEntity' is not null or undefined
            if (onDemandPlaylistEntity === null || onDemandPlaylistEntity === undefined) {
                throw new RequiredError('onDemandPlaylistEntity','Required parameter onDemandPlaylistEntity was null or undefined when calling updateOnDemandPlaylist.');
            }
            const localVarPath = `/builder/on-demand-playlist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof onDemandPlaylistEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(onDemandPlaylistEntity !== undefined ? onDemandPlaylistEntity : {}) : (onDemandPlaylistEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Update translations of OnDemandPlaylist
         * @param {string} id 
         * @param {string} language 
         * @param {OnDemandPlaylistTranslationEntity} onDemandPlaylistTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnDemandPlaylistTranslation: async (id: string, language: string, onDemandPlaylistTranslationEntity: OnDemandPlaylistTranslationEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOnDemandPlaylistTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling updateOnDemandPlaylistTranslation.');
            }
            // verify required parameter 'onDemandPlaylistTranslationEntity' is not null or undefined
            if (onDemandPlaylistTranslationEntity === null || onDemandPlaylistTranslationEntity === undefined) {
                throw new RequiredError('onDemandPlaylistTranslationEntity','Required parameter onDemandPlaylistTranslationEntity was null or undefined when calling updateOnDemandPlaylistTranslation.');
            }
            const localVarPath = `/builder/on_demand_playlist/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof onDemandPlaylistTranslationEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(onDemandPlaylistTranslationEntity !== undefined ? onDemandPlaylistTranslationEntity : {}) : (onDemandPlaylistTranslationEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnDemandPlaylistApi - functional programming interface
 * @export
 */
export const OnDemandPlaylistApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new on-demand playlist
         * @param {OnDemandPlaylistEntity} onDemandPlaylistEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOnDemandPlaylist(onDemandPlaylistEntity: OnDemandPlaylistEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandPlaylistEntity>> {
            const localVarAxiosArgs = await OnDemandPlaylistApiAxiosParamCreator(configuration).createOnDemandPlaylist(onDemandPlaylistEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Delete on-demand playlist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOnDemandPlaylist(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandPlaylistEntity>> {
            const localVarAxiosArgs = await OnDemandPlaylistApiAxiosParamCreator(configuration).deleteOnDemandPlaylist(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | viewer       | 
         * @summary Get base language of OnDemandPlaylist
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnDemandPlaylistBaseLanguage(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseLanguageDto>> {
            const localVarAxiosArgs = await OnDemandPlaylistApiAxiosParamCreator(configuration).getOnDemandPlaylistBaseLanguage(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | viewer       | 
         * @summary Get on-demand playlist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnDemandPlaylistById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandPlaylistEntity>> {
            const localVarAxiosArgs = await OnDemandPlaylistApiAxiosParamCreator(configuration).getOnDemandPlaylistById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Get full translation of OnDemandPlaylist
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnDemandPlaylistTranslation(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OnDemandPlaylistTranslationEntity>>> {
            const localVarAxiosArgs = await OnDemandPlaylistApiAxiosParamCreator(configuration).getOnDemandPlaylistTranslation(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Get all translations of OnDemandPlaylist without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnDemandPlaylistTranslations(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OnDemandPlaylistTranslationEntity>>> {
            const localVarAxiosArgs = await OnDemandPlaylistApiAxiosParamCreator(configuration).getOnDemandPlaylistTranslations(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Remove translation of OnDemandPlaylist
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeOnDemandPlaylistTranslation(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OnDemandPlaylistApiAxiosParamCreator(configuration).removeOnDemandPlaylistTranslation(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Set base language of OnDemandPlaylist
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOnDemandPlaylistBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandPlaylistEntity>> {
            const localVarAxiosArgs = await OnDemandPlaylistApiAxiosParamCreator(configuration).setOnDemandPlaylistBaseLanguage(id, baseLanguageDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Update on-demand playlist by id (partial update)
         * @param {string} id 
         * @param {OnDemandPlaylistEntity} onDemandPlaylistEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOnDemandPlaylist(id: string, onDemandPlaylistEntity: OnDemandPlaylistEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandPlaylistEntity>> {
            const localVarAxiosArgs = await OnDemandPlaylistApiAxiosParamCreator(configuration).updateOnDemandPlaylist(id, onDemandPlaylistEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Update translations of OnDemandPlaylist
         * @param {string} id 
         * @param {string} language 
         * @param {OnDemandPlaylistTranslationEntity} onDemandPlaylistTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOnDemandPlaylistTranslation(id: string, language: string, onDemandPlaylistTranslationEntity: OnDemandPlaylistTranslationEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandPlaylistTranslationEntity>> {
            const localVarAxiosArgs = await OnDemandPlaylistApiAxiosParamCreator(configuration).updateOnDemandPlaylistTranslation(id, language, onDemandPlaylistTranslationEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OnDemandPlaylistApi - factory interface
 * @export
 */
export const OnDemandPlaylistApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new on-demand playlist
         * @param {OnDemandPlaylistEntity} onDemandPlaylistEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnDemandPlaylist(onDemandPlaylistEntity: OnDemandPlaylistEntity, options?: any): AxiosPromise<OnDemandPlaylistEntity> {
            return OnDemandPlaylistApiFp(configuration).createOnDemandPlaylist(onDemandPlaylistEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Delete on-demand playlist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnDemandPlaylist(id: string, options?: any): AxiosPromise<OnDemandPlaylistEntity> {
            return OnDemandPlaylistApiFp(configuration).deleteOnDemandPlaylist(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | viewer       | 
         * @summary Get base language of OnDemandPlaylist
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandPlaylistBaseLanguage(id: string, options?: any): AxiosPromise<BaseLanguageDto> {
            return OnDemandPlaylistApiFp(configuration).getOnDemandPlaylistBaseLanguage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | viewer       | 
         * @summary Get on-demand playlist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandPlaylistById(id: string, options?: any): AxiosPromise<OnDemandPlaylistEntity> {
            return OnDemandPlaylistApiFp(configuration).getOnDemandPlaylistById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Get full translation of OnDemandPlaylist
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandPlaylistTranslation(id: string, language: string, options?: any): AxiosPromise<Array<OnDemandPlaylistTranslationEntity>> {
            return OnDemandPlaylistApiFp(configuration).getOnDemandPlaylistTranslation(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Get all translations of OnDemandPlaylist without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandPlaylistTranslations(id: string, options?: any): AxiosPromise<Array<OnDemandPlaylistTranslationEntity>> {
            return OnDemandPlaylistApiFp(configuration).getOnDemandPlaylistTranslations(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Remove translation of OnDemandPlaylist
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOnDemandPlaylistTranslation(id: string, language: string, options?: any): AxiosPromise<void> {
            return OnDemandPlaylistApiFp(configuration).removeOnDemandPlaylistTranslation(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Set base language of OnDemandPlaylist
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOnDemandPlaylistBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any): AxiosPromise<OnDemandPlaylistEntity> {
            return OnDemandPlaylistApiFp(configuration).setOnDemandPlaylistBaseLanguage(id, baseLanguageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Update on-demand playlist by id (partial update)
         * @param {string} id 
         * @param {OnDemandPlaylistEntity} onDemandPlaylistEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnDemandPlaylist(id: string, onDemandPlaylistEntity: OnDemandPlaylistEntity, options?: any): AxiosPromise<OnDemandPlaylistEntity> {
            return OnDemandPlaylistApiFp(configuration).updateOnDemandPlaylist(id, onDemandPlaylistEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
         * @summary Update translations of OnDemandPlaylist
         * @param {string} id 
         * @param {string} language 
         * @param {OnDemandPlaylistTranslationEntity} onDemandPlaylistTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnDemandPlaylistTranslation(id: string, language: string, onDemandPlaylistTranslationEntity: OnDemandPlaylistTranslationEntity, options?: any): AxiosPromise<OnDemandPlaylistTranslationEntity> {
            return OnDemandPlaylistApiFp(configuration).updateOnDemandPlaylistTranslation(id, language, onDemandPlaylistTranslationEntity, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnDemandPlaylistApi - object-oriented interface
 * @export
 * @class OnDemandPlaylistApi
 * @extends {BaseAPI}
 */
export class OnDemandPlaylistApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
     * @summary Create new on-demand playlist
     * @param {OnDemandPlaylistEntity} onDemandPlaylistEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandPlaylistApi
     */
    public createOnDemandPlaylist(onDemandPlaylistEntity: OnDemandPlaylistEntity, options?: any) {
        return OnDemandPlaylistApiFp(this.configuration).createOnDemandPlaylist(onDemandPlaylistEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
     * @summary Delete on-demand playlist by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandPlaylistApi
     */
    public deleteOnDemandPlaylist(id: string, options?: any) {
        return OnDemandPlaylistApiFp(this.configuration).deleteOnDemandPlaylist(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | viewer       | 
     * @summary Get base language of OnDemandPlaylist
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandPlaylistApi
     */
    public getOnDemandPlaylistBaseLanguage(id: string, options?: any) {
        return OnDemandPlaylistApiFp(this.configuration).getOnDemandPlaylistBaseLanguage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | viewer       | 
     * @summary Get on-demand playlist by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandPlaylistApi
     */
    public getOnDemandPlaylistById(id: string, options?: any) {
        return OnDemandPlaylistApiFp(this.configuration).getOnDemandPlaylistById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
     * @summary Get full translation of OnDemandPlaylist
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandPlaylistApi
     */
    public getOnDemandPlaylistTranslation(id: string, language: string, options?: any) {
        return OnDemandPlaylistApiFp(this.configuration).getOnDemandPlaylistTranslation(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
     * @summary Get all translations of OnDemandPlaylist without data
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandPlaylistApi
     */
    public getOnDemandPlaylistTranslations(id: string, options?: any) {
        return OnDemandPlaylistApiFp(this.configuration).getOnDemandPlaylistTranslations(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
     * @summary Remove translation of OnDemandPlaylist
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandPlaylistApi
     */
    public removeOnDemandPlaylistTranslation(id: string, language: string, options?: any) {
        return OnDemandPlaylistApiFp(this.configuration).removeOnDemandPlaylistTranslation(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
     * @summary Set base language of OnDemandPlaylist
     * @param {string} id 
     * @param {BaseLanguageDto} baseLanguageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandPlaylistApi
     */
    public setOnDemandPlaylistBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any) {
        return OnDemandPlaylistApiFp(this.configuration).setOnDemandPlaylistBaseLanguage(id, baseLanguageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
     * @summary Update on-demand playlist by id (partial update)
     * @param {string} id 
     * @param {OnDemandPlaylistEntity} onDemandPlaylistEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandPlaylistApi
     */
    public updateOnDemandPlaylist(id: string, onDemandPlaylistEntity: OnDemandPlaylistEntity, options?: any) {
        return OnDemandPlaylistApiFp(this.configuration).updateOnDemandPlaylist(id, onDemandPlaylistEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_playlist | editor       | 
     * @summary Update translations of OnDemandPlaylist
     * @param {string} id 
     * @param {string} language 
     * @param {OnDemandPlaylistTranslationEntity} onDemandPlaylistTranslationEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandPlaylistApi
     */
    public updateOnDemandPlaylistTranslation(id: string, language: string, onDemandPlaylistTranslationEntity: OnDemandPlaylistTranslationEntity, options?: any) {
        return OnDemandPlaylistApiFp(this.configuration).updateOnDemandPlaylistTranslation(id, language, onDemandPlaylistTranslationEntity, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OnDemandVideoApi - axios parameter creator
 * @export
 */
export const OnDemandVideoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new on-demand video
         * @param {OnDemandVideoEntity} onDemandVideoEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnDemandVideo: async (onDemandVideoEntity: OnDemandVideoEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'onDemandVideoEntity' is not null or undefined
            if (onDemandVideoEntity === null || onDemandVideoEntity === undefined) {
                throw new RequiredError('onDemandVideoEntity','Required parameter onDemandVideoEntity was null or undefined when calling createOnDemandVideo.');
            }
            const localVarPath = `/builder/on-demand-video`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof onDemandVideoEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(onDemandVideoEntity !== undefined ? onDemandVideoEntity : {}) : (onDemandVideoEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       |  | division     | editor       | 
         * @summary Delete on-demand video by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnDemandVideo: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteOnDemandVideo.');
            }
            const localVarPath = `/builder/on-demand-video/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | viewer       | 
         * @summary Get base language of OnDemandVideo
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandVideoBaseLanguage: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOnDemandVideoBaseLanguage.');
            }
            const localVarPath = `/builder/on_demand_video/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | viewer       | 
         * @summary Get on-demand video by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandVideoById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOnDemandVideoById.');
            }
            const localVarPath = `/builder/on-demand-video/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Get full translation of OnDemandVideo
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandVideoTranslation: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOnDemandVideoTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling getOnDemandVideoTranslation.');
            }
            const localVarPath = `/builder/on_demand_video/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Get all translations of OnDemandVideo without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandVideoTranslations: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOnDemandVideoTranslations.');
            }
            const localVarPath = `/builder/on_demand_video/{id}/translation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Remove translation of OnDemandVideo
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOnDemandVideoTranslation: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeOnDemandVideoTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling removeOnDemandVideoTranslation.');
            }
            const localVarPath = `/builder/on_demand_video/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Set base language of OnDemandVideo
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOnDemandVideoBaseLanguage: async (id: string, baseLanguageDto: BaseLanguageDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setOnDemandVideoBaseLanguage.');
            }
            // verify required parameter 'baseLanguageDto' is not null or undefined
            if (baseLanguageDto === null || baseLanguageDto === undefined) {
                throw new RequiredError('baseLanguageDto','Required parameter baseLanguageDto was null or undefined when calling setOnDemandVideoBaseLanguage.');
            }
            const localVarPath = `/builder/on_demand_video/{id}/language`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof baseLanguageDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(baseLanguageDto !== undefined ? baseLanguageDto : {}) : (baseLanguageDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Update on-demand video by id (partial update)
         * @param {string} id 
         * @param {OnDemandVideoEntity} onDemandVideoEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnDemandVideo: async (id: string, onDemandVideoEntity: OnDemandVideoEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOnDemandVideo.');
            }
            // verify required parameter 'onDemandVideoEntity' is not null or undefined
            if (onDemandVideoEntity === null || onDemandVideoEntity === undefined) {
                throw new RequiredError('onDemandVideoEntity','Required parameter onDemandVideoEntity was null or undefined when calling updateOnDemandVideo.');
            }
            const localVarPath = `/builder/on-demand-video/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof onDemandVideoEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(onDemandVideoEntity !== undefined ? onDemandVideoEntity : {}) : (onDemandVideoEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Update translations of OnDemandVideo
         * @param {string} id 
         * @param {string} language 
         * @param {OnDemandVideoTranslationEntity} onDemandVideoTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnDemandVideoTranslation: async (id: string, language: string, onDemandVideoTranslationEntity: OnDemandVideoTranslationEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOnDemandVideoTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling updateOnDemandVideoTranslation.');
            }
            // verify required parameter 'onDemandVideoTranslationEntity' is not null or undefined
            if (onDemandVideoTranslationEntity === null || onDemandVideoTranslationEntity === undefined) {
                throw new RequiredError('onDemandVideoTranslationEntity','Required parameter onDemandVideoTranslationEntity was null or undefined when calling updateOnDemandVideoTranslation.');
            }
            const localVarPath = `/builder/on_demand_video/{id}/translation/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof onDemandVideoTranslationEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(onDemandVideoTranslationEntity !== undefined ? onDemandVideoTranslationEntity : {}) : (onDemandVideoTranslationEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnDemandVideoApi - functional programming interface
 * @export
 */
export const OnDemandVideoApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new on-demand video
         * @param {OnDemandVideoEntity} onDemandVideoEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOnDemandVideo(onDemandVideoEntity: OnDemandVideoEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandVideoEntity>> {
            const localVarAxiosArgs = await OnDemandVideoApiAxiosParamCreator(configuration).createOnDemandVideo(onDemandVideoEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       |  | division     | editor       | 
         * @summary Delete on-demand video by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOnDemandVideo(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandVideoEntity>> {
            const localVarAxiosArgs = await OnDemandVideoApiAxiosParamCreator(configuration).deleteOnDemandVideo(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | viewer       | 
         * @summary Get base language of OnDemandVideo
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnDemandVideoBaseLanguage(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseLanguageDto>> {
            const localVarAxiosArgs = await OnDemandVideoApiAxiosParamCreator(configuration).getOnDemandVideoBaseLanguage(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | viewer       | 
         * @summary Get on-demand video by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnDemandVideoById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandVideoEntity>> {
            const localVarAxiosArgs = await OnDemandVideoApiAxiosParamCreator(configuration).getOnDemandVideoById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Get full translation of OnDemandVideo
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnDemandVideoTranslation(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OnDemandVideoTranslationEntity>>> {
            const localVarAxiosArgs = await OnDemandVideoApiAxiosParamCreator(configuration).getOnDemandVideoTranslation(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Get all translations of OnDemandVideo without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnDemandVideoTranslations(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OnDemandVideoTranslationEntity>>> {
            const localVarAxiosArgs = await OnDemandVideoApiAxiosParamCreator(configuration).getOnDemandVideoTranslations(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Remove translation of OnDemandVideo
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeOnDemandVideoTranslation(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OnDemandVideoApiAxiosParamCreator(configuration).removeOnDemandVideoTranslation(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Set base language of OnDemandVideo
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOnDemandVideoBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandVideoEntity>> {
            const localVarAxiosArgs = await OnDemandVideoApiAxiosParamCreator(configuration).setOnDemandVideoBaseLanguage(id, baseLanguageDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Update on-demand video by id (partial update)
         * @param {string} id 
         * @param {OnDemandVideoEntity} onDemandVideoEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOnDemandVideo(id: string, onDemandVideoEntity: OnDemandVideoEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandVideoEntity>> {
            const localVarAxiosArgs = await OnDemandVideoApiAxiosParamCreator(configuration).updateOnDemandVideo(id, onDemandVideoEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Update translations of OnDemandVideo
         * @param {string} id 
         * @param {string} language 
         * @param {OnDemandVideoTranslationEntity} onDemandVideoTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOnDemandVideoTranslation(id: string, language: string, onDemandVideoTranslationEntity: OnDemandVideoTranslationEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDemandVideoTranslationEntity>> {
            const localVarAxiosArgs = await OnDemandVideoApiAxiosParamCreator(configuration).updateOnDemandVideoTranslation(id, language, onDemandVideoTranslationEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OnDemandVideoApi - factory interface
 * @export
 */
export const OnDemandVideoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Create new on-demand video
         * @param {OnDemandVideoEntity} onDemandVideoEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnDemandVideo(onDemandVideoEntity: OnDemandVideoEntity, options?: any): AxiosPromise<OnDemandVideoEntity> {
            return OnDemandVideoApiFp(configuration).createOnDemandVideo(onDemandVideoEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       |  | division     | editor       | 
         * @summary Delete on-demand video by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnDemandVideo(id: string, options?: any): AxiosPromise<OnDemandVideoEntity> {
            return OnDemandVideoApiFp(configuration).deleteOnDemandVideo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | viewer       | 
         * @summary Get base language of OnDemandVideo
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandVideoBaseLanguage(id: string, options?: any): AxiosPromise<BaseLanguageDto> {
            return OnDemandVideoApiFp(configuration).getOnDemandVideoBaseLanguage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | viewer       | 
         * @summary Get on-demand video by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandVideoById(id: string, options?: any): AxiosPromise<OnDemandVideoEntity> {
            return OnDemandVideoApiFp(configuration).getOnDemandVideoById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Get full translation of OnDemandVideo
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandVideoTranslation(id: string, language: string, options?: any): AxiosPromise<Array<OnDemandVideoTranslationEntity>> {
            return OnDemandVideoApiFp(configuration).getOnDemandVideoTranslation(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Get all translations of OnDemandVideo without data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnDemandVideoTranslations(id: string, options?: any): AxiosPromise<Array<OnDemandVideoTranslationEntity>> {
            return OnDemandVideoApiFp(configuration).getOnDemandVideoTranslations(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Remove translation of OnDemandVideo
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOnDemandVideoTranslation(id: string, language: string, options?: any): AxiosPromise<void> {
            return OnDemandVideoApiFp(configuration).removeOnDemandVideoTranslation(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Set base language of OnDemandVideo
         * @param {string} id 
         * @param {BaseLanguageDto} baseLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOnDemandVideoBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any): AxiosPromise<OnDemandVideoEntity> {
            return OnDemandVideoApiFp(configuration).setOnDemandVideoBaseLanguage(id, baseLanguageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Update on-demand video by id (partial update)
         * @param {string} id 
         * @param {OnDemandVideoEntity} onDemandVideoEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnDemandVideo(id: string, onDemandVideoEntity: OnDemandVideoEntity, options?: any): AxiosPromise<OnDemandVideoEntity> {
            return OnDemandVideoApiFp(configuration).updateOnDemandVideo(id, onDemandVideoEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
         * @summary Update translations of OnDemandVideo
         * @param {string} id 
         * @param {string} language 
         * @param {OnDemandVideoTranslationEntity} onDemandVideoTranslationEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnDemandVideoTranslation(id: string, language: string, onDemandVideoTranslationEntity: OnDemandVideoTranslationEntity, options?: any): AxiosPromise<OnDemandVideoTranslationEntity> {
            return OnDemandVideoApiFp(configuration).updateOnDemandVideoTranslation(id, language, onDemandVideoTranslationEntity, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnDemandVideoApi - object-oriented interface
 * @export
 * @class OnDemandVideoApi
 * @extends {BaseAPI}
 */
export class OnDemandVideoApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
     * @summary Create new on-demand video
     * @param {OnDemandVideoEntity} onDemandVideoEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandVideoApi
     */
    public createOnDemandVideo(onDemandVideoEntity: OnDemandVideoEntity, options?: any) {
        return OnDemandVideoApiFp(this.configuration).createOnDemandVideo(onDemandVideoEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       |  | division     | editor       | 
     * @summary Delete on-demand video by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandVideoApi
     */
    public deleteOnDemandVideo(id: string, options?: any) {
        return OnDemandVideoApiFp(this.configuration).deleteOnDemandVideo(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | viewer       | 
     * @summary Get base language of OnDemandVideo
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandVideoApi
     */
    public getOnDemandVideoBaseLanguage(id: string, options?: any) {
        return OnDemandVideoApiFp(this.configuration).getOnDemandVideoBaseLanguage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | viewer       | 
     * @summary Get on-demand video by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandVideoApi
     */
    public getOnDemandVideoById(id: string, options?: any) {
        return OnDemandVideoApiFp(this.configuration).getOnDemandVideoById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
     * @summary Get full translation of OnDemandVideo
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandVideoApi
     */
    public getOnDemandVideoTranslation(id: string, language: string, options?: any) {
        return OnDemandVideoApiFp(this.configuration).getOnDemandVideoTranslation(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
     * @summary Get all translations of OnDemandVideo without data
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandVideoApi
     */
    public getOnDemandVideoTranslations(id: string, options?: any) {
        return OnDemandVideoApiFp(this.configuration).getOnDemandVideoTranslations(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
     * @summary Remove translation of OnDemandVideo
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandVideoApi
     */
    public removeOnDemandVideoTranslation(id: string, language: string, options?: any) {
        return OnDemandVideoApiFp(this.configuration).removeOnDemandVideoTranslation(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
     * @summary Set base language of OnDemandVideo
     * @param {string} id 
     * @param {BaseLanguageDto} baseLanguageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandVideoApi
     */
    public setOnDemandVideoBaseLanguage(id: string, baseLanguageDto: BaseLanguageDto, options?: any) {
        return OnDemandVideoApiFp(this.configuration).setOnDemandVideoBaseLanguage(id, baseLanguageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
     * @summary Update on-demand video by id (partial update)
     * @param {string} id 
     * @param {OnDemandVideoEntity} onDemandVideoEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandVideoApi
     */
    public updateOnDemandVideo(id: string, onDemandVideoEntity: OnDemandVideoEntity, options?: any) {
        return OnDemandVideoApiFp(this.configuration).updateOnDemandVideo(id, onDemandVideoEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | on_demand_video | editor       | 
     * @summary Update translations of OnDemandVideo
     * @param {string} id 
     * @param {string} language 
     * @param {OnDemandVideoTranslationEntity} onDemandVideoTranslationEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnDemandVideoApi
     */
    public updateOnDemandVideoTranslation(id: string, language: string, onDemandVideoTranslationEntity: OnDemandVideoTranslationEntity, options?: any) {
        return OnDemandVideoApiFp(this.configuration).updateOnDemandVideoTranslation(id, language, onDemandVideoTranslationEntity, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PageApi - axios parameter creator
 * @export
 */
export const PageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create a division-local page
         * @param {string} id 
         * @param {PageCreateDto} pageCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPageInDivision: async (id: string, pageCreateDto: PageCreateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createPageInDivision.');
            }
            // verify required parameter 'pageCreateDto' is not null or undefined
            if (pageCreateDto === null || pageCreateDto === undefined) {
                throw new RequiredError('pageCreateDto','Required parameter pageCreateDto was null or undefined when calling createPageInDivision.');
            }
            const localVarPath = `/builder/division/{id}/pages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageCreateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageCreateDto !== undefined ? pageCreateDto : {}) : (pageCreateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
         * @summary Delete page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePage: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deletePage.');
            }
            const localVarPath = `/builder/pages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Remove a distribution\'s translation layer for one language
         * @param {string} id 
         * @param {string} divisionId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageDistributionTranslation: async (id: string, divisionId: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deletePageDistributionTranslation.');
            }
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling deletePageDistributionTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling deletePageDistributionTranslation.');
            }
            const localVarPath = `/builder/pages/{id}/distributions/{divisionId}/translations/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Remove a master page\'s translation for one language (draft and published)
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageTranslation: async (id: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deletePageTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling deletePageTranslation.');
            }
            const localVarPath = `/builder/pages/{id}/translations/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
         * @summary Duplicate a page into a new draft in the same set or project (blocks, translations and settings), or straight into another set of the same workspace
         * @param {string} id 
         * @param {PageDuplicateDto} [pageDuplicateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePage: async (id: string, pageDuplicateDto?: PageDuplicateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling duplicatePage.');
            }
            const localVarPath = `/builder/pages/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageDuplicateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageDuplicateDto !== undefined ? pageDuplicateDto : {}) : (pageDuplicateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @summary Get page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPageById.');
            }
            const localVarPath = `/builder/pages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @summary Get what a project currently serves: the master\'s published snapshot resolved through the distribution\'s published layers, including the raw overrides and master fields. Pass ?language= to resolve a specific translation; an unknown language degrades to the untranslated result.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResolvedPageDistribution: async (id: string, divisionId: string, language: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getResolvedPageDistribution.');
            }
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getResolvedPageDistribution.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling getResolvedPageDistribution.');
            }
            const localVarPath = `/builder/pages/{id}/distributions/{divisionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @summary List the projects a master page is distributed to
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPageDistributions: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling listPageDistributions.');
            }
            const localVarPath = `/builder/pages/{id}/distributions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary List the master pages available to a project — every page the sets distributed to it reach it with, each flagged with whether the project has taken it
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPageDistributionsInDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling listPageDistributionsInDivision.');
            }
            const localVarPath = `/builder/division/{id}/page-distributions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Everything wrong with what this project serves: links a visitor can see but not follow, and addresses more than one page answers on
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPageIssuesInDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling listPageIssuesInDivision.');
            }
            const localVarPath = `/builder/division/{id}/page-issues`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Move a page to a new parent and/or sibling position in the sitemap
         * @param {string} id 
         * @param {PageMoveDto} pageMoveDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        movePage: async (id: string, pageMoveDto: PageMoveDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling movePage.');
            }
            // verify required parameter 'pageMoveDto' is not null or undefined
            if (pageMoveDto === null || pageMoveDto === undefined) {
                throw new RequiredError('pageMoveDto','Required parameter pageMoveDto was null or undefined when calling movePage.');
            }
            const localVarPath = `/builder/pages/{id}/move`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageMoveDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageMoveDto !== undefined ? pageMoveDto : {}) : (pageMoveDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
         * @summary Move a workspace page to another set of the same workspace; it is unpublished and starts fresh in the new set\'s projects
         * @param {string} id 
         * @param {PageMoveToSetDto} pageMoveToSetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        movePageToSet: async (id: string, pageMoveToSetDto: PageMoveToSetDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling movePageToSet.');
            }
            // verify required parameter 'pageMoveToSetDto' is not null or undefined
            if (pageMoveToSetDto === null || pageMoveToSetDto === undefined) {
                throw new RequiredError('pageMoveToSetDto','Required parameter pageMoveToSetDto was null or undefined when calling movePageToSet.');
            }
            const localVarPath = `/builder/pages/{id}/page-set`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageMoveToSetDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageMoveToSetDto !== undefined ? pageMoveToSetDto : {}) : (pageMoveToSetDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate the division-local pages of a project
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginatePagesInDivision: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginatePagesInDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginatePagesInDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginatePagesInDivision.');
            }
            const localVarPath = `/builder/division/{id}/pages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Publish page by id, snapshotting the current blocks
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPage: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling publishPage.');
            }
            const localVarPath = `/builder/pages/{id}/publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Publish a project\'s copy of the page — its overrides and every translation of them — making it what the project serves
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPageDistribution: async (id: string, divisionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling publishPageDistribution.');
            }
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling publishPageDistribution.');
            }
            const localVarPath = `/builder/pages/{id}/distributions/{divisionId}/publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Take a page for one project, or give it back. Only taken pages appear on the project\'s site; giving one back keeps its overrides and translations for when the project takes it again.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {PageTakenDto} pageTakenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPageDistributionTaken: async (id: string, divisionId: string, pageTakenDto: PageTakenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setPageDistributionTaken.');
            }
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling setPageDistributionTaken.');
            }
            // verify required parameter 'pageTakenDto' is not null or undefined
            if (pageTakenDto === null || pageTakenDto === undefined) {
                throw new RequiredError('pageTakenDto','Required parameter pageTakenDto was null or undefined when calling setPageDistributionTaken.');
            }
            const localVarPath = `/builder/pages/{id}/distributions/{divisionId}/taken`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageTakenDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageTakenDto !== undefined ? pageTakenDto : {}) : (pageTakenDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Replace which of the available master pages the project takes. A full replace: pages left out are given back, keeping their overrides for a later take.
         * @param {string} id 
         * @param {DivisionPagesTakenDto} divisionPagesTakenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPagesTakenInDivision: async (id: string, divisionPagesTakenDto: DivisionPagesTakenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setPagesTakenInDivision.');
            }
            // verify required parameter 'divisionPagesTakenDto' is not null or undefined
            if (divisionPagesTakenDto === null || divisionPagesTakenDto === undefined) {
                throw new RequiredError('divisionPagesTakenDto','Required parameter divisionPagesTakenDto was null or undefined when calling setPagesTakenInDivision.');
            }
            const localVarPath = `/builder/division/{id}/page-distributions/taken`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof divisionPagesTakenDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(divisionPagesTakenDto !== undefined ? divisionPagesTakenDto : {}) : (divisionPagesTakenDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Unpublish page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpublishPage: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling unpublishPage.');
            }
            const localVarPath = `/builder/pages/{id}/unpublish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Update page by id (partial update, saves the full block stack)
         * @param {string} id 
         * @param {PageUpdateDto} pageUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePage: async (id: string, pageUpdateDto: PageUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updatePage.');
            }
            // verify required parameter 'pageUpdateDto' is not null or undefined
            if (pageUpdateDto === null || pageUpdateDto === undefined) {
                throw new RequiredError('pageUpdateDto','Required parameter pageUpdateDto was null or undefined when calling updatePage.');
            }
            const localVarPath = `/builder/pages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageUpdateDto !== undefined ? pageUpdateDto : {}) : (pageUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Set what the project\'s home and events pages do about its brand colour — omit color to follow the project\'s own, send \"none\" for the master\'s, or a hex to replace it
         * @param {string} id 
         * @param {string} divisionId 
         * @param {PageDistributionColorDto} pageDistributionColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageDistributionColor: async (id: string, divisionId: string, pageDistributionColorDto: PageDistributionColorDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updatePageDistributionColor.');
            }
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling updatePageDistributionColor.');
            }
            // verify required parameter 'pageDistributionColorDto' is not null or undefined
            if (pageDistributionColorDto === null || pageDistributionColorDto === undefined) {
                throw new RequiredError('pageDistributionColorDto','Required parameter pageDistributionColorDto was null or undefined when calling updatePageDistributionColor.');
            }
            const localVarPath = `/builder/pages/{id}/distributions/{divisionId}/color`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageDistributionColorDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageDistributionColorDto !== undefined ? pageDistributionColorDto : {}) : (pageDistributionColorDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Replace a distribution\'s overrides (full replace)
         * @param {string} id 
         * @param {string} divisionId 
         * @param {PageOverridesDto} pageOverridesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageDistributionOverrides: async (id: string, divisionId: string, pageOverridesDto: PageOverridesDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updatePageDistributionOverrides.');
            }
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling updatePageDistributionOverrides.');
            }
            // verify required parameter 'pageOverridesDto' is not null or undefined
            if (pageOverridesDto === null || pageOverridesDto === undefined) {
                throw new RequiredError('pageOverridesDto','Required parameter pageOverridesDto was null or undefined when calling updatePageDistributionOverrides.');
            }
            const localVarPath = `/builder/pages/{id}/distributions/{divisionId}/overrides`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageOverridesDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageOverridesDto !== undefined ? pageOverridesDto : {}) : (pageOverridesDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Replace a distribution\'s translation layer for one language (full replace)
         * @param {string} id 
         * @param {string} divisionId 
         * @param {string} language 
         * @param {PageTranslationDto} pageTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageDistributionTranslation: async (id: string, divisionId: string, language: string, pageTranslationDto: PageTranslationDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updatePageDistributionTranslation.');
            }
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling updatePageDistributionTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling updatePageDistributionTranslation.');
            }
            // verify required parameter 'pageTranslationDto' is not null or undefined
            if (pageTranslationDto === null || pageTranslationDto === undefined) {
                throw new RequiredError('pageTranslationDto','Required parameter pageTranslationDto was null or undefined when calling updatePageDistributionTranslation.');
            }
            const localVarPath = `/builder/pages/{id}/distributions/{divisionId}/translations/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageTranslationDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageTranslationDto !== undefined ? pageTranslationDto : {}) : (pageTranslationDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Replace a master page\'s translation layer for one language (full replace)
         * @param {string} id 
         * @param {string} language 
         * @param {PageTranslationDto} pageTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageTranslation: async (id: string, language: string, pageTranslationDto: PageTranslationDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updatePageTranslation.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling updatePageTranslation.');
            }
            // verify required parameter 'pageTranslationDto' is not null or undefined
            if (pageTranslationDto === null || pageTranslationDto === undefined) {
                throw new RequiredError('pageTranslationDto','Required parameter pageTranslationDto was null or undefined when calling updatePageTranslation.');
            }
            const localVarPath = `/builder/pages/{id}/translations/{language}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageTranslationDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageTranslationDto !== undefined ? pageTranslationDto : {}) : (pageTranslationDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PageApi - functional programming interface
 * @export
 */
export const PageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create a division-local page
         * @param {string} id 
         * @param {PageCreateDto} pageCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPageInDivision(id: string, pageCreateDto: PageCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).createPageInDivision(id, pageCreateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
         * @summary Delete page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePage(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).deletePage(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Remove a distribution\'s translation layer for one language
         * @param {string} id 
         * @param {string} divisionId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageDistributionTranslation(id: string, divisionId: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDistributionEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).deletePageDistributionTranslation(id, divisionId, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Remove a master page\'s translation for one language (draft and published)
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageTranslation(id: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).deletePageTranslation(id, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
         * @summary Duplicate a page into a new draft in the same set or project (blocks, translations and settings), or straight into another set of the same workspace
         * @param {string} id 
         * @param {PageDuplicateDto} [pageDuplicateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicatePage(id: string, pageDuplicateDto?: PageDuplicateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).duplicatePage(id, pageDuplicateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @summary Get page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @summary Get what a project currently serves: the master\'s published snapshot resolved through the distribution\'s published layers, including the raw overrides and master fields. Pass ?language= to resolve a specific translation; an unknown language degrades to the untranslated result.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResolvedPageDistribution(id: string, divisionId: string, language: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDistributionResolvedDto>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getResolvedPageDistribution(id, divisionId, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @summary List the projects a master page is distributed to
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPageDistributions(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageDistributionEntity>>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).listPageDistributions(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary List the master pages available to a project — every page the sets distributed to it reach it with, each flagged with whether the project has taken it
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPageDistributionsInDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageDistributionEntity>>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).listPageDistributionsInDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Everything wrong with what this project serves: links a visitor can see but not follow, and addresses more than one page answers on
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPageIssuesInDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageIssuesDto>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).listPageIssuesInDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Move a page to a new parent and/or sibling position in the sitemap
         * @param {string} id 
         * @param {PageMoveDto} pageMoveDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async movePage(id: string, pageMoveDto: PageMoveDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).movePage(id, pageMoveDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
         * @summary Move a workspace page to another set of the same workspace; it is unpublished and starts fresh in the new set\'s projects
         * @param {string} id 
         * @param {PageMoveToSetDto} pageMoveToSetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async movePageToSet(id: string, pageMoveToSetDto: PageMoveToSetDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).movePageToSet(id, pageMoveToSetDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate the division-local pages of a project
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginatePagesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageEntity>>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).paginatePagesInDivision(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Publish page by id, snapshotting the current blocks
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishPage(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).publishPage(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Publish a project\'s copy of the page — its overrides and every translation of them — making it what the project serves
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishPageDistribution(id: string, divisionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDistributionEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).publishPageDistribution(id, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Take a page for one project, or give it back. Only taken pages appear on the project\'s site; giving one back keeps its overrides and translations for when the project takes it again.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {PageTakenDto} pageTakenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPageDistributionTaken(id: string, divisionId: string, pageTakenDto: PageTakenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDistributionEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).setPageDistributionTaken(id, divisionId, pageTakenDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Replace which of the available master pages the project takes. A full replace: pages left out are given back, keeping their overrides for a later take.
         * @param {string} id 
         * @param {DivisionPagesTakenDto} divisionPagesTakenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPagesTakenInDivision(id: string, divisionPagesTakenDto: DivisionPagesTakenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageDistributionEntity>>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).setPagesTakenInDivision(id, divisionPagesTakenDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Unpublish page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unpublishPage(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).unpublishPage(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Update page by id (partial update, saves the full block stack)
         * @param {string} id 
         * @param {PageUpdateDto} pageUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePage(id: string, pageUpdateDto: PageUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).updatePage(id, pageUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Set what the project\'s home and events pages do about its brand colour — omit color to follow the project\'s own, send \"none\" for the master\'s, or a hex to replace it
         * @param {string} id 
         * @param {string} divisionId 
         * @param {PageDistributionColorDto} pageDistributionColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePageDistributionColor(id: string, divisionId: string, pageDistributionColorDto: PageDistributionColorDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).updatePageDistributionColor(id, divisionId, pageDistributionColorDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Replace a distribution\'s overrides (full replace)
         * @param {string} id 
         * @param {string} divisionId 
         * @param {PageOverridesDto} pageOverridesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePageDistributionOverrides(id: string, divisionId: string, pageOverridesDto: PageOverridesDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDistributionEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).updatePageDistributionOverrides(id, divisionId, pageOverridesDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Replace a distribution\'s translation layer for one language (full replace)
         * @param {string} id 
         * @param {string} divisionId 
         * @param {string} language 
         * @param {PageTranslationDto} pageTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePageDistributionTranslation(id: string, divisionId: string, language: string, pageTranslationDto: PageTranslationDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDistributionEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).updatePageDistributionTranslation(id, divisionId, language, pageTranslationDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Replace a master page\'s translation layer for one language (full replace)
         * @param {string} id 
         * @param {string} language 
         * @param {PageTranslationDto} pageTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePageTranslation(id: string, language: string, pageTranslationDto: PageTranslationDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).updatePageTranslation(id, language, pageTranslationDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PageApi - factory interface
 * @export
 */
export const PageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create a division-local page
         * @param {string} id 
         * @param {PageCreateDto} pageCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPageInDivision(id: string, pageCreateDto: PageCreateDto, options?: any): AxiosPromise<PageEntity> {
            return PageApiFp(configuration).createPageInDivision(id, pageCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
         * @summary Delete page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePage(id: string, options?: any): AxiosPromise<PageEntity> {
            return PageApiFp(configuration).deletePage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Remove a distribution\'s translation layer for one language
         * @param {string} id 
         * @param {string} divisionId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageDistributionTranslation(id: string, divisionId: string, language: string, options?: any): AxiosPromise<PageDistributionEntity> {
            return PageApiFp(configuration).deletePageDistributionTranslation(id, divisionId, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Remove a master page\'s translation for one language (draft and published)
         * @param {string} id 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageTranslation(id: string, language: string, options?: any): AxiosPromise<PageEntity> {
            return PageApiFp(configuration).deletePageTranslation(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
         * @summary Duplicate a page into a new draft in the same set or project (blocks, translations and settings), or straight into another set of the same workspace
         * @param {string} id 
         * @param {PageDuplicateDto} [pageDuplicateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePage(id: string, pageDuplicateDto?: PageDuplicateDto, options?: any): AxiosPromise<PageEntity> {
            return PageApiFp(configuration).duplicatePage(id, pageDuplicateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @summary Get page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageById(id: string, options?: any): AxiosPromise<PageEntity> {
            return PageApiFp(configuration).getPageById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @summary Get what a project currently serves: the master\'s published snapshot resolved through the distribution\'s published layers, including the raw overrides and master fields. Pass ?language= to resolve a specific translation; an unknown language degrades to the untranslated result.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResolvedPageDistribution(id: string, divisionId: string, language: string, options?: any): AxiosPromise<PageDistributionResolvedDto> {
            return PageApiFp(configuration).getResolvedPageDistribution(id, divisionId, language, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @summary List the projects a master page is distributed to
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPageDistributions(id: string, options?: any): AxiosPromise<Array<PageDistributionEntity>> {
            return PageApiFp(configuration).listPageDistributions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary List the master pages available to a project — every page the sets distributed to it reach it with, each flagged with whether the project has taken it
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPageDistributionsInDivision(id: string, options?: any): AxiosPromise<Array<PageDistributionEntity>> {
            return PageApiFp(configuration).listPageDistributionsInDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Everything wrong with what this project serves: links a visitor can see but not follow, and addresses more than one page answers on
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPageIssuesInDivision(id: string, options?: any): AxiosPromise<PageIssuesDto> {
            return PageApiFp(configuration).listPageIssuesInDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Move a page to a new parent and/or sibling position in the sitemap
         * @param {string} id 
         * @param {PageMoveDto} pageMoveDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        movePage(id: string, pageMoveDto: PageMoveDto, options?: any): AxiosPromise<PageEntity> {
            return PageApiFp(configuration).movePage(id, pageMoveDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
         * @summary Move a workspace page to another set of the same workspace; it is unpublished and starts fresh in the new set\'s projects
         * @param {string} id 
         * @param {PageMoveToSetDto} pageMoveToSetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        movePageToSet(id: string, pageMoveToSetDto: PageMoveToSetDto, options?: any): AxiosPromise<PageEntity> {
            return PageApiFp(configuration).movePageToSet(id, pageMoveToSetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @summary Paginate the division-local pages of a project
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginatePagesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<PageEntity>> {
            return PageApiFp(configuration).paginatePagesInDivision(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Publish page by id, snapshotting the current blocks
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPage(id: string, options?: any): AxiosPromise<PageEntity> {
            return PageApiFp(configuration).publishPage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Publish a project\'s copy of the page — its overrides and every translation of them — making it what the project serves
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPageDistribution(id: string, divisionId: string, options?: any): AxiosPromise<PageDistributionEntity> {
            return PageApiFp(configuration).publishPageDistribution(id, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Take a page for one project, or give it back. Only taken pages appear on the project\'s site; giving one back keeps its overrides and translations for when the project takes it again.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {PageTakenDto} pageTakenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPageDistributionTaken(id: string, divisionId: string, pageTakenDto: PageTakenDto, options?: any): AxiosPromise<PageDistributionEntity> {
            return PageApiFp(configuration).setPageDistributionTaken(id, divisionId, pageTakenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Replace which of the available master pages the project takes. A full replace: pages left out are given back, keeping their overrides for a later take.
         * @param {string} id 
         * @param {DivisionPagesTakenDto} divisionPagesTakenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPagesTakenInDivision(id: string, divisionPagesTakenDto: DivisionPagesTakenDto, options?: any): AxiosPromise<Array<PageDistributionEntity>> {
            return PageApiFp(configuration).setPagesTakenInDivision(id, divisionPagesTakenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Unpublish page by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpublishPage(id: string, options?: any): AxiosPromise<PageEntity> {
            return PageApiFp(configuration).unpublishPage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Update page by id (partial update, saves the full block stack)
         * @param {string} id 
         * @param {PageUpdateDto} pageUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePage(id: string, pageUpdateDto: PageUpdateDto, options?: any): AxiosPromise<PageEntity> {
            return PageApiFp(configuration).updatePage(id, pageUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Set what the project\'s home and events pages do about its brand colour — omit color to follow the project\'s own, send \"none\" for the master\'s, or a hex to replace it
         * @param {string} id 
         * @param {string} divisionId 
         * @param {PageDistributionColorDto} pageDistributionColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageDistributionColor(id: string, divisionId: string, pageDistributionColorDto: PageDistributionColorDto, options?: any): AxiosPromise<DivisionEntity> {
            return PageApiFp(configuration).updatePageDistributionColor(id, divisionId, pageDistributionColorDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Replace a distribution\'s overrides (full replace)
         * @param {string} id 
         * @param {string} divisionId 
         * @param {PageOverridesDto} pageOverridesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageDistributionOverrides(id: string, divisionId: string, pageOverridesDto: PageOverridesDto, options?: any): AxiosPromise<PageDistributionEntity> {
            return PageApiFp(configuration).updatePageDistributionOverrides(id, divisionId, pageOverridesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Replace a distribution\'s translation layer for one language (full replace)
         * @param {string} id 
         * @param {string} divisionId 
         * @param {string} language 
         * @param {PageTranslationDto} pageTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageDistributionTranslation(id: string, divisionId: string, language: string, pageTranslationDto: PageTranslationDto, options?: any): AxiosPromise<PageDistributionEntity> {
            return PageApiFp(configuration).updatePageDistributionTranslation(id, divisionId, language, pageTranslationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
         * @summary Replace a master page\'s translation layer for one language (full replace)
         * @param {string} id 
         * @param {string} language 
         * @param {PageTranslationDto} pageTranslationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageTranslation(id: string, language: string, pageTranslationDto: PageTranslationDto, options?: any): AxiosPromise<PageEntity> {
            return PageApiFp(configuration).updatePageTranslation(id, language, pageTranslationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PageApi - object-oriented interface
 * @export
 * @class PageApi
 * @extends {BaseAPI}
 */
export class PageApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Create a division-local page
     * @param {string} id 
     * @param {PageCreateDto} pageCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public createPageInDivision(id: string, pageCreateDto: PageCreateDto, options?: any) {
        return PageApiFp(this.configuration).createPageInDivision(id, pageCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
     * @summary Delete page by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public deletePage(id: string, options?: any) {
        return PageApiFp(this.configuration).deletePage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Remove a distribution\'s translation layer for one language
     * @param {string} id 
     * @param {string} divisionId 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public deletePageDistributionTranslation(id: string, divisionId: string, language: string, options?: any) {
        return PageApiFp(this.configuration).deletePageDistributionTranslation(id, divisionId, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Remove a master page\'s translation for one language (draft and published)
     * @param {string} id 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public deletePageTranslation(id: string, language: string, options?: any) {
        return PageApiFp(this.configuration).deletePageTranslation(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
     * @summary Duplicate a page into a new draft in the same set or project (blocks, translations and settings), or straight into another set of the same workspace
     * @param {string} id 
     * @param {PageDuplicateDto} [pageDuplicateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public duplicatePage(id: string, pageDuplicateDto?: PageDuplicateDto, options?: any) {
        return PageApiFp(this.configuration).duplicatePage(id, pageDuplicateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
     * @summary Get page by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageById(id: string, options?: any) {
        return PageApiFp(this.configuration).getPageById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
     * @summary Get what a project currently serves: the master\'s published snapshot resolved through the distribution\'s published layers, including the raw overrides and master fields. Pass ?language= to resolve a specific translation; an unknown language degrades to the untranslated result.
     * @param {string} id 
     * @param {string} divisionId 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getResolvedPageDistribution(id: string, divisionId: string, language: string, options?: any) {
        return PageApiFp(this.configuration).getResolvedPageDistribution(id, divisionId, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
     * @summary List the projects a master page is distributed to
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public listPageDistributions(id: string, options?: any) {
        return PageApiFp(this.configuration).listPageDistributions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary List the master pages available to a project — every page the sets distributed to it reach it with, each flagged with whether the project has taken it
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public listPageDistributionsInDivision(id: string, options?: any) {
        return PageApiFp(this.configuration).listPageDistributionsInDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Everything wrong with what this project serves: links a visitor can see but not follow, and addresses more than one page answers on
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public listPageIssuesInDivision(id: string, options?: any) {
        return PageApiFp(this.configuration).listPageIssuesInDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Move a page to a new parent and/or sibling position in the sitemap
     * @param {string} id 
     * @param {PageMoveDto} pageMoveDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public movePage(id: string, pageMoveDto: PageMoveDto, options?: any) {
        return PageApiFp(this.configuration).movePage(id, pageMoveDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       |  | division     | editor       | 
     * @summary Move a workspace page to another set of the same workspace; it is unpublished and starts fresh in the new set\'s projects
     * @param {string} id 
     * @param {PageMoveToSetDto} pageMoveToSetDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public movePageToSet(id: string, pageMoveToSetDto: PageMoveToSetDto, options?: any) {
        return PageApiFp(this.configuration).movePageToSet(id, pageMoveToSetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @summary Paginate the division-local pages of a project
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public paginatePagesInDivision(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return PageApiFp(this.configuration).paginatePagesInDivision(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Publish page by id, snapshotting the current blocks
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public publishPage(id: string, options?: any) {
        return PageApiFp(this.configuration).publishPage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Publish a project\'s copy of the page — its overrides and every translation of them — making it what the project serves
     * @param {string} id 
     * @param {string} divisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public publishPageDistribution(id: string, divisionId: string, options?: any) {
        return PageApiFp(this.configuration).publishPageDistribution(id, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Take a page for one project, or give it back. Only taken pages appear on the project\'s site; giving one back keeps its overrides and translations for when the project takes it again.
     * @param {string} id 
     * @param {string} divisionId 
     * @param {PageTakenDto} pageTakenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public setPageDistributionTaken(id: string, divisionId: string, pageTakenDto: PageTakenDto, options?: any) {
        return PageApiFp(this.configuration).setPageDistributionTaken(id, divisionId, pageTakenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Replace which of the available master pages the project takes. A full replace: pages left out are given back, keeping their overrides for a later take.
     * @param {string} id 
     * @param {DivisionPagesTakenDto} divisionPagesTakenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public setPagesTakenInDivision(id: string, divisionPagesTakenDto: DivisionPagesTakenDto, options?: any) {
        return PageApiFp(this.configuration).setPagesTakenInDivision(id, divisionPagesTakenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Unpublish page by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public unpublishPage(id: string, options?: any) {
        return PageApiFp(this.configuration).unpublishPage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Update page by id (partial update, saves the full block stack)
     * @param {string} id 
     * @param {PageUpdateDto} pageUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public updatePage(id: string, pageUpdateDto: PageUpdateDto, options?: any) {
        return PageApiFp(this.configuration).updatePage(id, pageUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Set what the project\'s home and events pages do about its brand colour — omit color to follow the project\'s own, send \"none\" for the master\'s, or a hex to replace it
     * @param {string} id 
     * @param {string} divisionId 
     * @param {PageDistributionColorDto} pageDistributionColorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public updatePageDistributionColor(id: string, divisionId: string, pageDistributionColorDto: PageDistributionColorDto, options?: any) {
        return PageApiFp(this.configuration).updatePageDistributionColor(id, divisionId, pageDistributionColorDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Replace a distribution\'s overrides (full replace)
     * @param {string} id 
     * @param {string} divisionId 
     * @param {PageOverridesDto} pageOverridesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public updatePageDistributionOverrides(id: string, divisionId: string, pageOverridesDto: PageOverridesDto, options?: any) {
        return PageApiFp(this.configuration).updatePageDistributionOverrides(id, divisionId, pageOverridesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Replace a distribution\'s translation layer for one language (full replace)
     * @param {string} id 
     * @param {string} divisionId 
     * @param {string} language 
     * @param {PageTranslationDto} pageTranslationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public updatePageDistributionTranslation(id: string, divisionId: string, language: string, pageTranslationDto: PageTranslationDto, options?: any) {
        return PageApiFp(this.configuration).updatePageDistributionTranslation(id, divisionId, language, pageTranslationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | editor       | 
     * @summary Replace a master page\'s translation layer for one language (full replace)
     * @param {string} id 
     * @param {string} language 
     * @param {PageTranslationDto} pageTranslationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public updatePageTranslation(id: string, language: string, pageTranslationDto: PageTranslationDto, options?: any) {
        return PageApiFp(this.configuration).updatePageTranslation(id, language, pageTranslationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PageAnalyticsApi - axios parameter creator
 * @export
 */
export const PageAnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPageAnalyticsFunnel: async (companyId: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling getCompanyPageAnalyticsFunnel.');
            }
            const localVarPath = `/builder/analytics/pages/company/{companyId}/funnel`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {'quarter-day' | 'day' | 'month'} bucket 
         * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPageAnalyticsSeries: async (companyId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling getCompanyPageAnalyticsSeries.');
            }
            // verify required parameter 'bucket' is not null or undefined
            if (bucket === null || bucket === undefined) {
                throw new RequiredError('bucket','Required parameter bucket was null or undefined when calling getCompanyPageAnalyticsSeries.');
            }
            const localVarPath = `/builder/analytics/pages/company/{companyId}/series`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (bucket !== undefined) {
                localVarQueryParameter['bucket'] = bucket;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPageAnalyticsSummary: async (companyId: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling getCompanyPageAnalyticsSummary.');
            }
            const localVarPath = `/builder/analytics/pages/company/{companyId}/summary`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {'language' | 'device' | 'country'} by 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAnalyticsBreakdown: async (divisionId: string, by: 'language' | 'device' | 'country', from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getPageAnalyticsBreakdown.');
            }
            // verify required parameter 'by' is not null or undefined
            if (by === null || by === undefined) {
                throw new RequiredError('by','Required parameter by was null or undefined when calling getPageAnalyticsBreakdown.');
            }
            const localVarPath = `/builder/analytics/pages/{divisionId}/breakdown`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (by !== undefined) {
                localVarQueryParameter['by'] = by;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAnalyticsFunnel: async (divisionId: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getPageAnalyticsFunnel.');
            }
            const localVarPath = `/builder/analytics/pages/{divisionId}/funnel`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {string} groupId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAnalyticsGroupSources: async (divisionId: string, groupId: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getPageAnalyticsGroupSources.');
            }
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new RequiredError('groupId','Required parameter groupId was null or undefined when calling getPageAnalyticsGroupSources.');
            }
            const localVarPath = `/builder/analytics/pages/{divisionId}/sources/{groupId}`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)))
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {'quarter-day' | 'day' | 'month'} bucket 
         * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAnalyticsSeries: async (divisionId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getPageAnalyticsSeries.');
            }
            // verify required parameter 'bucket' is not null or undefined
            if (bucket === null || bucket === undefined) {
                throw new RequiredError('bucket','Required parameter bucket was null or undefined when calling getPageAnalyticsSeries.');
            }
            const localVarPath = `/builder/analytics/pages/{divisionId}/series`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (bucket !== undefined) {
                localVarQueryParameter['bucket'] = bucket;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAnalyticsSummary: async (divisionId: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getPageAnalyticsSummary.');
            }
            const localVarPath = `/builder/analytics/pages/{divisionId}/summary`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @param {string} pageId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [divisionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageBlockStats: async (pageId: string, from?: string, to?: string, divisionId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageId' is not null or undefined
            if (pageId === null || pageId === undefined) {
                throw new RequiredError('pageId','Required parameter pageId was null or undefined when calling getPageBlockStats.');
            }
            const localVarPath = `/builder/analytics/pages/page/{pageId}/blocks`
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @param {string} pageId 
         * @param {'quarter-day' | 'day' | 'month'} bucket 
         * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [divisionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageOverview: async (pageId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, divisionId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageId' is not null or undefined
            if (pageId === null || pageId === undefined) {
                throw new RequiredError('pageId','Required parameter pageId was null or undefined when calling getPageOverview.');
            }
            // verify required parameter 'bucket' is not null or undefined
            if (bucket === null || bucket === undefined) {
                throw new RequiredError('bucket','Required parameter bucket was null or undefined when calling getPageOverview.');
            }
            const localVarPath = `/builder/analytics/pages/page/{pageId}/overview`
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (bucket !== undefined) {
                localVarQueryParameter['bucket'] = bucket;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateCompanyPageAnalyticsPages: async (companyId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling paginateCompanyPageAnalyticsPages.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateCompanyPageAnalyticsPages.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateCompanyPageAnalyticsPages.');
            }
            const localVarPath = `/builder/analytics/pages/company/{companyId}/pages`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateCompanyPageAnalyticsProjects: async (companyId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling paginateCompanyPageAnalyticsProjects.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateCompanyPageAnalyticsProjects.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateCompanyPageAnalyticsProjects.');
            }
            const localVarPath = `/builder/analytics/pages/company/{companyId}/projects`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginatePageAnalyticsPages: async (divisionId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling paginatePageAnalyticsPages.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginatePageAnalyticsPages.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginatePageAnalyticsPages.');
            }
            const localVarPath = `/builder/analytics/pages/{divisionId}/pages`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginatePageAnalyticsSources: async (divisionId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling paginatePageAnalyticsSources.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginatePageAnalyticsSources.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginatePageAnalyticsSources.');
            }
            const localVarPath = `/builder/analytics/pages/{divisionId}/sources`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PageAnalyticsApi - functional programming interface
 * @export
 */
export const PageAnalyticsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyPageAnalyticsFunnel(companyId: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAnalyticsFunnelDto>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).getCompanyPageAnalyticsFunnel(companyId, from, to, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {'quarter-day' | 'day' | 'month'} bucket 
         * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyPageAnalyticsSeries(companyId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageAnalyticsSeriesPointDto>>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).getCompanyPageAnalyticsSeries(companyId, bucket, timezone, from, to, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyPageAnalyticsSummary(companyId: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAnalyticsSummaryDto>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).getCompanyPageAnalyticsSummary(companyId, from, to, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {'language' | 'device' | 'country'} by 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageAnalyticsBreakdown(divisionId: string, by: 'language' | 'device' | 'country', from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageAnalyticsCountDto>>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).getPageAnalyticsBreakdown(divisionId, by, from, to, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageAnalyticsFunnel(divisionId: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAnalyticsFunnelDto>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).getPageAnalyticsFunnel(divisionId, from, to, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {string} groupId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageAnalyticsGroupSources(divisionId: string, groupId: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageAnalyticsSourceDto>>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).getPageAnalyticsGroupSources(divisionId, groupId, from, to, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {'quarter-day' | 'day' | 'month'} bucket 
         * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageAnalyticsSeries(divisionId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageAnalyticsSeriesPointDto>>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).getPageAnalyticsSeries(divisionId, bucket, timezone, from, to, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageAnalyticsSummary(divisionId: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAnalyticsSummaryDto>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).getPageAnalyticsSummary(divisionId, from, to, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @param {string} pageId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [divisionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageBlockStats(pageId: string, from?: string, to?: string, divisionId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageBlockStatsDto>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).getPageBlockStats(pageId, from, to, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @param {string} pageId 
         * @param {'quarter-day' | 'day' | 'month'} bucket 
         * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [divisionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageOverview(pageId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, divisionId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageOverviewDto>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).getPageOverview(pageId, bucket, timezone, from, to, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateCompanyPageAnalyticsPages(companyId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageAnalyticsPageDto>>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).paginateCompanyPageAnalyticsPages(companyId, skip, take, from, to, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateCompanyPageAnalyticsProjects(companyId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageAnalyticsProjectDto>>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).paginateCompanyPageAnalyticsProjects(companyId, skip, take, from, to, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginatePageAnalyticsPages(divisionId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageAnalyticsPageDto>>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).paginatePageAnalyticsPages(divisionId, skip, take, from, to, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginatePageAnalyticsSources(divisionId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageAnalyticsSourceDto>>> {
            const localVarAxiosArgs = await PageAnalyticsApiAxiosParamCreator(configuration).paginatePageAnalyticsSources(divisionId, skip, take, from, to, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PageAnalyticsApi - factory interface
 * @export
 */
export const PageAnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPageAnalyticsFunnel(companyId: string, from?: string, to?: string, options?: any): AxiosPromise<PageAnalyticsFunnelDto> {
            return PageAnalyticsApiFp(configuration).getCompanyPageAnalyticsFunnel(companyId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {'quarter-day' | 'day' | 'month'} bucket 
         * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPageAnalyticsSeries(companyId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, options?: any): AxiosPromise<Array<PageAnalyticsSeriesPointDto>> {
            return PageAnalyticsApiFp(configuration).getCompanyPageAnalyticsSeries(companyId, bucket, timezone, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPageAnalyticsSummary(companyId: string, from?: string, to?: string, options?: any): AxiosPromise<PageAnalyticsSummaryDto> {
            return PageAnalyticsApiFp(configuration).getCompanyPageAnalyticsSummary(companyId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {'language' | 'device' | 'country'} by 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAnalyticsBreakdown(divisionId: string, by: 'language' | 'device' | 'country', from?: string, to?: string, options?: any): AxiosPromise<Array<PageAnalyticsCountDto>> {
            return PageAnalyticsApiFp(configuration).getPageAnalyticsBreakdown(divisionId, by, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAnalyticsFunnel(divisionId: string, from?: string, to?: string, options?: any): AxiosPromise<PageAnalyticsFunnelDto> {
            return PageAnalyticsApiFp(configuration).getPageAnalyticsFunnel(divisionId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {string} groupId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAnalyticsGroupSources(divisionId: string, groupId: string, from?: string, to?: string, options?: any): AxiosPromise<Array<PageAnalyticsSourceDto>> {
            return PageAnalyticsApiFp(configuration).getPageAnalyticsGroupSources(divisionId, groupId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {'quarter-day' | 'day' | 'month'} bucket 
         * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAnalyticsSeries(divisionId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, options?: any): AxiosPromise<Array<PageAnalyticsSeriesPointDto>> {
            return PageAnalyticsApiFp(configuration).getPageAnalyticsSeries(divisionId, bucket, timezone, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAnalyticsSummary(divisionId: string, from?: string, to?: string, options?: any): AxiosPromise<PageAnalyticsSummaryDto> {
            return PageAnalyticsApiFp(configuration).getPageAnalyticsSummary(divisionId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @param {string} pageId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [divisionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageBlockStats(pageId: string, from?: string, to?: string, divisionId?: string, options?: any): AxiosPromise<PageBlockStatsDto> {
            return PageAnalyticsApiFp(configuration).getPageBlockStats(pageId, from, to, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
         * @param {string} pageId 
         * @param {'quarter-day' | 'day' | 'month'} bucket 
         * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [divisionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageOverview(pageId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, divisionId?: string, options?: any): AxiosPromise<PageOverviewDto> {
            return PageAnalyticsApiFp(configuration).getPageOverview(pageId, bucket, timezone, from, to, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateCompanyPageAnalyticsPages(companyId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any): AxiosPromise<Array<PageAnalyticsPageDto>> {
            return PageAnalyticsApiFp(configuration).paginateCompanyPageAnalyticsPages(companyId, skip, take, from, to, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
         * @param {string} companyId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateCompanyPageAnalyticsProjects(companyId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any): AxiosPromise<Array<PageAnalyticsProjectDto>> {
            return PageAnalyticsApiFp(configuration).paginateCompanyPageAnalyticsProjects(companyId, skip, take, from, to, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginatePageAnalyticsPages(divisionId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any): AxiosPromise<Array<PageAnalyticsPageDto>> {
            return PageAnalyticsApiFp(configuration).paginatePageAnalyticsPages(divisionId, skip, take, from, to, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
         * @param {string} divisionId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginatePageAnalyticsSources(divisionId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any): AxiosPromise<Array<PageAnalyticsSourceDto>> {
            return PageAnalyticsApiFp(configuration).paginatePageAnalyticsSources(divisionId, skip, take, from, to, keyword, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PageAnalyticsApi - object-oriented interface
 * @export
 * @class PageAnalyticsApi
 * @extends {BaseAPI}
 */
export class PageAnalyticsApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
     * @param {string} companyId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public getCompanyPageAnalyticsFunnel(companyId: string, from?: string, to?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).getCompanyPageAnalyticsFunnel(companyId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
     * @param {string} companyId 
     * @param {'quarter-day' | 'day' | 'month'} bucket 
     * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public getCompanyPageAnalyticsSeries(companyId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).getCompanyPageAnalyticsSeries(companyId, bucket, timezone, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
     * @param {string} companyId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public getCompanyPageAnalyticsSummary(companyId: string, from?: string, to?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).getCompanyPageAnalyticsSummary(companyId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @param {string} divisionId 
     * @param {'language' | 'device' | 'country'} by 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public getPageAnalyticsBreakdown(divisionId: string, by: 'language' | 'device' | 'country', from?: string, to?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).getPageAnalyticsBreakdown(divisionId, by, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @param {string} divisionId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public getPageAnalyticsFunnel(divisionId: string, from?: string, to?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).getPageAnalyticsFunnel(divisionId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @param {string} divisionId 
     * @param {string} groupId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public getPageAnalyticsGroupSources(divisionId: string, groupId: string, from?: string, to?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).getPageAnalyticsGroupSources(divisionId, groupId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @param {string} divisionId 
     * @param {'quarter-day' | 'day' | 'month'} bucket 
     * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public getPageAnalyticsSeries(divisionId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).getPageAnalyticsSeries(divisionId, bucket, timezone, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @param {string} divisionId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public getPageAnalyticsSummary(divisionId: string, from?: string, to?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).getPageAnalyticsSummary(divisionId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
     * @param {string} pageId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [divisionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public getPageBlockStats(pageId: string, from?: string, to?: string, divisionId?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).getPageBlockStats(pageId, from, to, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | page         | viewer       | 
     * @param {string} pageId 
     * @param {'quarter-day' | 'day' | 'month'} bucket 
     * @param {string} [timezone] The IANA time zone whose clock the buckets follow.
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [divisionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public getPageOverview(pageId: string, bucket: 'quarter-day' | 'day' | 'month', timezone?: string, from?: string, to?: string, divisionId?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).getPageOverview(pageId, bucket, timezone, from, to, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
     * @param {string} companyId 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public paginateCompanyPageAnalyticsPages(companyId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).paginateCompanyPageAnalyticsPages(companyId, skip, take, from, to, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | admin        | 
     * @param {string} companyId 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public paginateCompanyPageAnalyticsProjects(companyId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).paginateCompanyPageAnalyticsProjects(companyId, skip, take, from, to, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @param {string} divisionId 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public paginatePageAnalyticsPages(divisionId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).paginatePageAnalyticsPages(divisionId, skip, take, from, to, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | viewer       | 
     * @param {string} divisionId 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageAnalyticsApi
     */
    public paginatePageAnalyticsSources(divisionId: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any) {
        return PageAnalyticsApiFp(this.configuration).paginatePageAnalyticsSources(divisionId, skip, take, from, to, keyword, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PageSetApi - axios parameter creator
 * @export
 */
export const PageSetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Create a page in a set
         * @param {string} id 
         * @param {PageCreateDto} pageCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPageInPageSet: async (id: string, pageCreateDto: PageCreateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createPageInPageSet.');
            }
            // verify required parameter 'pageCreateDto' is not null or undefined
            if (pageCreateDto === null || pageCreateDto === undefined) {
                throw new RequiredError('pageCreateDto','Required parameter pageCreateDto was null or undefined when calling createPageInPageSet.');
            }
            const localVarPath = `/builder/page-sets/{id}/pages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageCreateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageCreateDto !== undefined ? pageCreateDto : {}) : (pageCreateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Delete a page set by id (must be empty)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageSet: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deletePageSet.');
            }
            const localVarPath = `/builder/page-sets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Distribute a set into projects (idempotent, add-only; existing projects keep their per-page overrides)
         * @param {string} id 
         * @param {PageSetDistributeDto} pageSetDistributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        distributePageSet: async (id: string, pageSetDistributeDto: PageSetDistributeDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling distributePageSet.');
            }
            // verify required parameter 'pageSetDistributeDto' is not null or undefined
            if (pageSetDistributeDto === null || pageSetDistributeDto === undefined) {
                throw new RequiredError('pageSetDistributeDto','Required parameter pageSetDistributeDto was null or undefined when calling distributePageSet.');
            }
            const localVarPath = `/builder/page-sets/{id}/distributions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageSetDistributeDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageSetDistributeDto !== undefined ? pageSetDistributeDto : {}) : (pageSetDistributeDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
         * @summary Get a page set by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageSetById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPageSetById.');
            }
            const localVarPath = `/builder/page-sets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
         * @summary List the projects a set is distributed to
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPageSetDistributions: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling listPageSetDistributions.');
            }
            const localVarPath = `/builder/page-sets/{id}/distributions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
         * @summary Paginate the pages in a set
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginatePagesInPageSet: async (id: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling paginatePagesInPageSet.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginatePagesInPageSet.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginatePagesInPageSet.');
            }
            const localVarPath = `/builder/page-sets/{id}/pages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Remove a set\'s distribution to a project, deleting the project\'s overrides for every page in the set
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undistributePageSet: async (id: string, divisionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling undistributePageSet.');
            }
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling undistributePageSet.');
            }
            const localVarPath = `/builder/page-sets/{id}/distributions/{divisionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Update a page set by id
         * @param {string} id 
         * @param {PageSetUpdateDto} pageSetUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageSet: async (id: string, pageSetUpdateDto: PageSetUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updatePageSet.');
            }
            // verify required parameter 'pageSetUpdateDto' is not null or undefined
            if (pageSetUpdateDto === null || pageSetUpdateDto === undefined) {
                throw new RequiredError('pageSetUpdateDto','Required parameter pageSetUpdateDto was null or undefined when calling updatePageSet.');
            }
            const localVarPath = `/builder/page-sets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pageSetUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageSetUpdateDto !== undefined ? pageSetUpdateDto : {}) : (pageSetUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PageSetApi - functional programming interface
 * @export
 */
export const PageSetApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Create a page in a set
         * @param {string} id 
         * @param {PageCreateDto} pageCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPageInPageSet(id: string, pageCreateDto: PageCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEntity>> {
            const localVarAxiosArgs = await PageSetApiAxiosParamCreator(configuration).createPageInPageSet(id, pageCreateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Delete a page set by id (must be empty)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePageSet(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageSetEntity>> {
            const localVarAxiosArgs = await PageSetApiAxiosParamCreator(configuration).deletePageSet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Distribute a set into projects (idempotent, add-only; existing projects keep their per-page overrides)
         * @param {string} id 
         * @param {PageSetDistributeDto} pageSetDistributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async distributePageSet(id: string, pageSetDistributeDto: PageSetDistributeDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageSetDistributionEntity>>> {
            const localVarAxiosArgs = await PageSetApiAxiosParamCreator(configuration).distributePageSet(id, pageSetDistributeDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
         * @summary Get a page set by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageSetById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageSetEntity>> {
            const localVarAxiosArgs = await PageSetApiAxiosParamCreator(configuration).getPageSetById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
         * @summary List the projects a set is distributed to
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPageSetDistributions(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageSetDistributionEntity>>> {
            const localVarAxiosArgs = await PageSetApiAxiosParamCreator(configuration).listPageSetDistributions(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
         * @summary Paginate the pages in a set
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginatePagesInPageSet(id: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PageEntity>>> {
            const localVarAxiosArgs = await PageSetApiAxiosParamCreator(configuration).paginatePagesInPageSet(id, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Remove a set\'s distribution to a project, deleting the project\'s overrides for every page in the set
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undistributePageSet(id: string, divisionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PageSetApiAxiosParamCreator(configuration).undistributePageSet(id, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Update a page set by id
         * @param {string} id 
         * @param {PageSetUpdateDto} pageSetUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePageSet(id: string, pageSetUpdateDto: PageSetUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageSetEntity>> {
            const localVarAxiosArgs = await PageSetApiAxiosParamCreator(configuration).updatePageSet(id, pageSetUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PageSetApi - factory interface
 * @export
 */
export const PageSetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Create a page in a set
         * @param {string} id 
         * @param {PageCreateDto} pageCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPageInPageSet(id: string, pageCreateDto: PageCreateDto, options?: any): AxiosPromise<PageEntity> {
            return PageSetApiFp(configuration).createPageInPageSet(id, pageCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
         * @summary Delete a page set by id (must be empty)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePageSet(id: string, options?: any): AxiosPromise<PageSetEntity> {
            return PageSetApiFp(configuration).deletePageSet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Distribute a set into projects (idempotent, add-only; existing projects keep their per-page overrides)
         * @param {string} id 
         * @param {PageSetDistributeDto} pageSetDistributeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        distributePageSet(id: string, pageSetDistributeDto: PageSetDistributeDto, options?: any): AxiosPromise<Array<PageSetDistributionEntity>> {
            return PageSetApiFp(configuration).distributePageSet(id, pageSetDistributeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
         * @summary Get a page set by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageSetById(id: string, options?: any): AxiosPromise<PageSetEntity> {
            return PageSetApiFp(configuration).getPageSetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
         * @summary List the projects a set is distributed to
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPageSetDistributions(id: string, options?: any): AxiosPromise<Array<PageSetDistributionEntity>> {
            return PageSetApiFp(configuration).listPageSetDistributions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
         * @summary Paginate the pages in a set
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginatePagesInPageSet(id: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<PageEntity>> {
            return PageSetApiFp(configuration).paginatePagesInPageSet(id, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Remove a set\'s distribution to a project, deleting the project\'s overrides for every page in the set
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undistributePageSet(id: string, divisionId: string, options?: any): AxiosPromise<void> {
            return PageSetApiFp(configuration).undistributePageSet(id, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
         * @summary Update a page set by id
         * @param {string} id 
         * @param {PageSetUpdateDto} pageSetUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePageSet(id: string, pageSetUpdateDto: PageSetUpdateDto, options?: any): AxiosPromise<PageSetEntity> {
            return PageSetApiFp(configuration).updatePageSet(id, pageSetUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PageSetApi - object-oriented interface
 * @export
 * @class PageSetApi
 * @extends {BaseAPI}
 */
export class PageSetApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
     * @summary Create a page in a set
     * @param {string} id 
     * @param {PageCreateDto} pageCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageSetApi
     */
    public createPageInPageSet(id: string, pageCreateDto: PageCreateDto, options?: any) {
        return PageSetApiFp(this.configuration).createPageInPageSet(id, pageCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | company      | editor       | 
     * @summary Delete a page set by id (must be empty)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageSetApi
     */
    public deletePageSet(id: string, options?: any) {
        return PageSetApiFp(this.configuration).deletePageSet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
     * @summary Distribute a set into projects (idempotent, add-only; existing projects keep their per-page overrides)
     * @param {string} id 
     * @param {PageSetDistributeDto} pageSetDistributeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageSetApi
     */
    public distributePageSet(id: string, pageSetDistributeDto: PageSetDistributeDto, options?: any) {
        return PageSetApiFp(this.configuration).distributePageSet(id, pageSetDistributeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
     * @summary Get a page set by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageSetApi
     */
    public getPageSetById(id: string, options?: any) {
        return PageSetApiFp(this.configuration).getPageSetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
     * @summary List the projects a set is distributed to
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageSetApi
     */
    public listPageSetDistributions(id: string, options?: any) {
        return PageSetApiFp(this.configuration).listPageSetDistributions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | viewer       | 
     * @summary Paginate the pages in a set
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageSetApi
     */
    public paginatePagesInPageSet(id: string, skip: number, take: number, keyword?: string, options?: any) {
        return PageSetApiFp(this.configuration).paginatePagesInPageSet(id, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
     * @summary Remove a set\'s distribution to a project, deleting the project\'s overrides for every page in the set
     * @param {string} id 
     * @param {string} divisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageSetApi
     */
    public undistributePageSet(id: string, divisionId: string, options?: any) {
        return PageSetApiFp(this.configuration).undistributePageSet(id, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | pageSet      | editor       | 
     * @summary Update a page set by id
     * @param {string} id 
     * @param {PageSetUpdateDto} pageSetUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageSetApi
     */
    public updatePageSet(id: string, pageSetUpdateDto: PageSetUpdateDto, options?: any) {
        return PageSetApiFp(this.configuration).updatePageSet(id, pageSetUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QRCodeApi - axios parameter creator
 * @export
 */
export const QRCodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if given QR Code is valid.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfQrCodeValid: async (id: string, divisionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling checkIfQrCodeValid.');
            }
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling checkIfQrCodeValid.');
            }
            const localVarPath = `/qr/valid/{id}/{divisionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create new QR for division
         * @param {QRCodeEntity} qRCodeEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQRForDivision: async (qRCodeEntity: QRCodeEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'qRCodeEntity' is not null or undefined
            if (qRCodeEntity === null || qRCodeEntity === undefined) {
                throw new RequiredError('qRCodeEntity','Required parameter qRCodeEntity was null or undefined when calling createQRForDivision.');
            }
            const localVarPath = `/builder/qr/division`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof qRCodeEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(qRCodeEntity !== undefined ? qRCodeEntity : {}) : (qRCodeEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Create new QR for game
         * @param {QRCodeEntity} qRCodeEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQRForGame: async (qRCodeEntity: QRCodeEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'qRCodeEntity' is not null or undefined
            if (qRCodeEntity === null || qRCodeEntity === undefined) {
                throw new RequiredError('qRCodeEntity','Required parameter qRCodeEntity was null or undefined when calling createQRForGame.');
            }
            const localVarPath = `/builder/qr/game`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof qRCodeEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(qRCodeEntity !== undefined ? qRCodeEntity : {}) : (qRCodeEntity || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create one QR per name for a division, opening the same page
         * @param {string} divisionId 
         * @param {QRCodeBulkCreateDto} qRCodeBulkCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQRsForDivision: async (divisionId: string, qRCodeBulkCreateDto: QRCodeBulkCreateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling createQRsForDivision.');
            }
            // verify required parameter 'qRCodeBulkCreateDto' is not null or undefined
            if (qRCodeBulkCreateDto === null || qRCodeBulkCreateDto === undefined) {
                throw new RequiredError('qRCodeBulkCreateDto','Required parameter qRCodeBulkCreateDto was null or undefined when calling createQRsForDivision.');
            }
            const localVarPath = `/builder/qr/division/{divisionId}/bulk`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof qRCodeBulkCreateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(qRCodeBulkCreateDto !== undefined ? qRCodeBulkCreateDto : {}) : (qRCodeBulkCreateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       |  | division     | editor       | 
         * @summary Delete QR by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQR: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteQR.');
            }
            const localVarPath = `/builder/qr/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Create new QR for game
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreatePreviewLink: async (gameId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling getOrCreatePreviewLink.');
            }
            const localVarPath = `/builder/qr/game/preview/{gameId}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get QR by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getQRById.');
            }
            const localVarPath = `/builder/qr/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get QR data by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRDataById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getQRDataById.');
            }
            const localVarPath = `/builder/qr/data/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | qr_code      | superadmin   | 
         * @summary Move QR Code to a different game
         * @param {string} id 
         * @param {QRCodeMoveDto} qRCodeMoveDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveQRCodeToGame: async (id: string, qRCodeMoveDto: QRCodeMoveDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling moveQRCodeToGame.');
            }
            // verify required parameter 'qRCodeMoveDto' is not null or undefined
            if (qRCodeMoveDto === null || qRCodeMoveDto === undefined) {
                throw new RequiredError('qRCodeMoveDto','Required parameter qRCodeMoveDto was null or undefined when calling moveQRCodeToGame.');
            }
            const localVarPath = `/builder/qr/{id}/move`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof qRCodeMoveDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(qRCodeMoveDto !== undefined ? qRCodeMoveDto : {}) : (qRCodeMoveDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate QRCodes for a specific game id
         * @param {string} divisionId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [pageId] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateQRCodesForDivision: async (divisionId: string, skip: number, take: number, pageId?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling paginateQRCodesForDivision.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateQRCodesForDivision.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateQRCodesForDivision.');
            }
            const localVarPath = `/builder/qr/division/{divisionId}`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (pageId !== undefined) {
                localVarQueryParameter['pageId'] = pageId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Paginate QRCodes for a specific game id
         * @param {string} gameId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateQRCodesForGame: async (gameId: string, skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling paginateQRCodesForGame.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateQRCodesForGame.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateQRCodesForGame.');
            }
            const localVarPath = `/builder/qr/game/{gameId}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request QR Code data and register a hit for it. This endpoint is used by the webserver to register qr code hits and inject qrcode data into the page.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestQRCodeData: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling requestQRCodeData.');
            }
            const localVarPath = `/qr/{id}/request`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get redirect URL for QR Code. Used by legacy linking server to redirect to the main application.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestRedirectUri: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling requestRedirectUri.');
            }
            const localVarPath = `/qr/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update QR by id (partial update)
         * @param {string} id 
         * @param {QRCodeUpdateDto} qRCodeUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQR: async (id: string, qRCodeUpdateDto: QRCodeUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateQR.');
            }
            // verify required parameter 'qRCodeUpdateDto' is not null or undefined
            if (qRCodeUpdateDto === null || qRCodeUpdateDto === undefined) {
                throw new RequiredError('qRCodeUpdateDto','Required parameter qRCodeUpdateDto was null or undefined when calling updateQR.');
            }
            const localVarPath = `/builder/qr/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof qRCodeUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(qRCodeUpdateDto !== undefined ? qRCodeUpdateDto : {}) : (qRCodeUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QRCodeApi - functional programming interface
 * @export
 */
export const QRCodeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if given QR Code is valid.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkIfQrCodeValid(id: string, divisionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).checkIfQrCodeValid(id, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create new QR for division
         * @param {QRCodeEntity} qRCodeEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQRForDivision(qRCodeEntity: QRCodeEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QRCodeEntity>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).createQRForDivision(qRCodeEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Create new QR for game
         * @param {QRCodeEntity} qRCodeEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQRForGame(qRCodeEntity: QRCodeEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QRCodeEntity>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).createQRForGame(qRCodeEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create one QR per name for a division, opening the same page
         * @param {string} divisionId 
         * @param {QRCodeBulkCreateDto} qRCodeBulkCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQRsForDivision(divisionId: string, qRCodeBulkCreateDto: QRCodeBulkCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QRCodeEntity>>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).createQRsForDivision(divisionId, qRCodeBulkCreateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       |  | division     | editor       | 
         * @summary Delete QR by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQR(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QRCodeEntity>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).deleteQR(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Create new QR for game
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrCreatePreviewLink(gameId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrDto>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).getOrCreatePreviewLink(gameId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get QR by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQRById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QRCodeEntity>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).getQRById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get QR data by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQRDataById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrDto>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).getQRDataById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | qr_code      | superadmin   | 
         * @summary Move QR Code to a different game
         * @param {string} id 
         * @param {QRCodeMoveDto} qRCodeMoveDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveQRCodeToGame(id: string, qRCodeMoveDto: QRCodeMoveDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QRCodeEntity>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).moveQRCodeToGame(id, qRCodeMoveDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate QRCodes for a specific game id
         * @param {string} divisionId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [pageId] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateQRCodesForDivision(divisionId: string, skip: number, take: number, pageId?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QRCodeEntity>>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).paginateQRCodesForDivision(divisionId, skip, take, pageId, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Paginate QRCodes for a specific game id
         * @param {string} gameId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateQRCodesForGame(gameId: string, skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QRCodeEntity>>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).paginateQRCodesForGame(gameId, skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Request QR Code data and register a hit for it. This endpoint is used by the webserver to register qr code hits and inject qrcode data into the page.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestQRCodeData(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QRCodeRequestDto>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).requestQRCodeData(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get redirect URL for QR Code. Used by legacy linking server to redirect to the main application.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestRedirectUri(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrRedirectDto>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).requestRedirectUri(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update QR by id (partial update)
         * @param {string} id 
         * @param {QRCodeUpdateDto} qRCodeUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQR(id: string, qRCodeUpdateDto: QRCodeUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QRCodeUpdateDto>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).updateQR(id, qRCodeUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * QRCodeApi - factory interface
 * @export
 */
export const QRCodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Check if given QR Code is valid.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfQrCodeValid(id: string, divisionId: string, options?: any): AxiosPromise<void> {
            return QRCodeApiFp(configuration).checkIfQrCodeValid(id, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create new QR for division
         * @param {QRCodeEntity} qRCodeEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQRForDivision(qRCodeEntity: QRCodeEntity, options?: any): AxiosPromise<QRCodeEntity> {
            return QRCodeApiFp(configuration).createQRForDivision(qRCodeEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Create new QR for game
         * @param {QRCodeEntity} qRCodeEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQRForGame(qRCodeEntity: QRCodeEntity, options?: any): AxiosPromise<QRCodeEntity> {
            return QRCodeApiFp(configuration).createQRForGame(qRCodeEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Create one QR per name for a division, opening the same page
         * @param {string} divisionId 
         * @param {QRCodeBulkCreateDto} qRCodeBulkCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQRsForDivision(divisionId: string, qRCodeBulkCreateDto: QRCodeBulkCreateDto, options?: any): AxiosPromise<Array<QRCodeEntity>> {
            return QRCodeApiFp(configuration).createQRsForDivision(divisionId, qRCodeBulkCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       |  | division     | editor       | 
         * @summary Delete QR by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQR(id: string, options?: any): AxiosPromise<QRCodeEntity> {
            return QRCodeApiFp(configuration).deleteQR(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Create new QR for game
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreatePreviewLink(gameId: string, options?: any): AxiosPromise<QrDto> {
            return QRCodeApiFp(configuration).getOrCreatePreviewLink(gameId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get QR by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRById(id: string, options?: any): AxiosPromise<QRCodeEntity> {
            return QRCodeApiFp(configuration).getQRById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get QR data by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRDataById(id: string, options?: any): AxiosPromise<QrDto> {
            return QRCodeApiFp(configuration).getQRDataById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | qr_code      | superadmin   | 
         * @summary Move QR Code to a different game
         * @param {string} id 
         * @param {QRCodeMoveDto} qRCodeMoveDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveQRCodeToGame(id: string, qRCodeMoveDto: QRCodeMoveDto, options?: any): AxiosPromise<QRCodeEntity> {
            return QRCodeApiFp(configuration).moveQRCodeToGame(id, qRCodeMoveDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
         * @summary Paginate QRCodes for a specific game id
         * @param {string} divisionId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [pageId] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateQRCodesForDivision(divisionId: string, skip: number, take: number, pageId?: string, keyword?: string, options?: any): AxiosPromise<Array<QRCodeEntity>> {
            return QRCodeApiFp(configuration).paginateQRCodesForDivision(divisionId, skip, take, pageId, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
         * @summary Paginate QRCodes for a specific game id
         * @param {string} gameId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateQRCodesForGame(gameId: string, skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<QRCodeEntity>> {
            return QRCodeApiFp(configuration).paginateQRCodesForGame(gameId, skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request QR Code data and register a hit for it. This endpoint is used by the webserver to register qr code hits and inject qrcode data into the page.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestQRCodeData(id: string, options?: any): AxiosPromise<QRCodeRequestDto> {
            return QRCodeApiFp(configuration).requestQRCodeData(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get redirect URL for QR Code. Used by legacy linking server to redirect to the main application.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestRedirectUri(id: string, options?: any): AxiosPromise<QrRedirectDto> {
            return QRCodeApiFp(configuration).requestRedirectUri(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update QR by id (partial update)
         * @param {string} id 
         * @param {QRCodeUpdateDto} qRCodeUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQR(id: string, qRCodeUpdateDto: QRCodeUpdateDto, options?: any): AxiosPromise<QRCodeUpdateDto> {
            return QRCodeApiFp(configuration).updateQR(id, qRCodeUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QRCodeApi - object-oriented interface
 * @export
 * @class QRCodeApi
 * @extends {BaseAPI}
 */
export class QRCodeApi extends BaseAPI {
    /**
     * 
     * @summary Check if given QR Code is valid.
     * @param {string} id 
     * @param {string} divisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public checkIfQrCodeValid(id: string, divisionId: string, options?: any) {
        return QRCodeApiFp(this.configuration).checkIfQrCodeValid(id, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Create new QR for division
     * @param {QRCodeEntity} qRCodeEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public createQRForDivision(qRCodeEntity: QRCodeEntity, options?: any) {
        return QRCodeApiFp(this.configuration).createQRForDivision(qRCodeEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Create new QR for game
     * @param {QRCodeEntity} qRCodeEntity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public createQRForGame(qRCodeEntity: QRCodeEntity, options?: any) {
        return QRCodeApiFp(this.configuration).createQRForGame(qRCodeEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Create one QR per name for a division, opening the same page
     * @param {string} divisionId 
     * @param {QRCodeBulkCreateDto} qRCodeBulkCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public createQRsForDivision(divisionId: string, qRCodeBulkCreateDto: QRCodeBulkCreateDto, options?: any) {
        return QRCodeApiFp(this.configuration).createQRsForDivision(divisionId, qRCodeBulkCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       |  | division     | editor       | 
     * @summary Delete QR by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public deleteQR(id: string, options?: any) {
        return QRCodeApiFp(this.configuration).deleteQR(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Create new QR for game
     * @param {string} gameId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public getOrCreatePreviewLink(gameId: string, options?: any) {
        return QRCodeApiFp(this.configuration).getOrCreatePreviewLink(gameId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get QR by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public getQRById(id: string, options?: any) {
        return QRCodeApiFp(this.configuration).getQRById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get QR data by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public getQRDataById(id: string, options?: any) {
        return QRCodeApiFp(this.configuration).getQRDataById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | qr_code      | superadmin   | 
     * @summary Move QR Code to a different game
     * @param {string} id 
     * @param {QRCodeMoveDto} qRCodeMoveDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public moveQRCodeToGame(id: string, qRCodeMoveDto: QRCodeMoveDto, options?: any) {
        return QRCodeApiFp(this.configuration).moveQRCodeToGame(id, qRCodeMoveDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | division     | editor       | 
     * @summary Paginate QRCodes for a specific game id
     * @param {string} divisionId 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [pageId] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public paginateQRCodesForDivision(divisionId: string, skip: number, take: number, pageId?: string, keyword?: string, options?: any) {
        return QRCodeApiFp(this.configuration).paginateQRCodesForDivision(divisionId, skip, take, pageId, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | editor       | 
     * @summary Paginate QRCodes for a specific game id
     * @param {string} gameId 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public paginateQRCodesForGame(gameId: string, skip: number, take: number, keyword?: string, options?: any) {
        return QRCodeApiFp(this.configuration).paginateQRCodesForGame(gameId, skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request QR Code data and register a hit for it. This endpoint is used by the webserver to register qr code hits and inject qrcode data into the page.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public requestQRCodeData(id: string, options?: any) {
        return QRCodeApiFp(this.configuration).requestQRCodeData(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get redirect URL for QR Code. Used by legacy linking server to redirect to the main application.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public requestRedirectUri(id: string, options?: any) {
        return QRCodeApiFp(this.configuration).requestRedirectUri(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update QR by id (partial update)
     * @param {string} id 
     * @param {QRCodeUpdateDto} qRCodeUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public updateQR(id: string, qRCodeUpdateDto: QRCodeUpdateDto, options?: any) {
        return QRCodeApiFp(this.configuration).updateQR(id, qRCodeUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QRCodeAnalyticsApi - axios parameter creator
 * @export
 */
export const QRCodeAnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRCodeCountries: async (id: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getQRCodeCountries.');
            }
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling getQRCodeCountries.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling getQRCodeCountries.');
            }
            const localVarPath = `/builder/qr/analytics/{id}/countries`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRCodeCounts: async (id: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getQRCodeCounts.');
            }
            const localVarPath = `/builder/qr/analytics/{id}/counts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get total hit counts for every QR code of a game at once
         * @param {string} gameId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRCodeCountsForGame: async (gameId: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling getQRCodeCountsForGame.');
            }
            const localVarPath = `/builder/qr/analytics/game/{gameId}/counts`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRCodeDeviceStats: async (id: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getQRCodeDeviceStats.');
            }
            const localVarPath = `/builder/qr/analytics/{id}/devicestats`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sessions for a given whitelabel over a specific span of time
         * @param {string} id 
         * @param {GraphRequestDto} graphRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRCodeHitsGraphData: async (id: string, graphRequestDto: GraphRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getQRCodeHitsGraphData.');
            }
            // verify required parameter 'graphRequestDto' is not null or undefined
            if (graphRequestDto === null || graphRequestDto === undefined) {
                throw new RequiredError('graphRequestDto','Required parameter graphRequestDto was null or undefined when calling getQRCodeHitsGraphData.');
            }
            const localVarPath = `/builder/qr/analytics/{id}/graphdata`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof graphRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(graphRequestDto !== undefined ? graphRequestDto : {}) : (graphRequestDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QRCodeAnalyticsApi - functional programming interface
 * @export
 */
export const QRCodeAnalyticsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQRCodeCountries(id: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnalyticsDisplayValueDto>>> {
            const localVarAxiosArgs = await QRCodeAnalyticsApiAxiosParamCreator(configuration).getQRCodeCountries(id, skip, take, from, to, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQRCodeCounts(id: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnalyticsDisplayValueDto>>> {
            const localVarAxiosArgs = await QRCodeAnalyticsApiAxiosParamCreator(configuration).getQRCodeCounts(id, from, to, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get total hit counts for every QR code of a game at once
         * @param {string} gameId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQRCodeCountsForGame(gameId: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QRCodeCountResult>>> {
            const localVarAxiosArgs = await QRCodeAnalyticsApiAxiosParamCreator(configuration).getQRCodeCountsForGame(gameId, from, to, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQRCodeDeviceStats(id: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnalyticsDisplayValueDto>>> {
            const localVarAxiosArgs = await QRCodeAnalyticsApiAxiosParamCreator(configuration).getQRCodeDeviceStats(id, from, to, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get sessions for a given whitelabel over a specific span of time
         * @param {string} id 
         * @param {GraphRequestDto} graphRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQRCodeHitsGraphData(id: string, graphRequestDto: GraphRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GraphPlatformDto>>> {
            const localVarAxiosArgs = await QRCodeAnalyticsApiAxiosParamCreator(configuration).getQRCodeHitsGraphData(id, graphRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * QRCodeAnalyticsApi - factory interface
 * @export
 */
export const QRCodeAnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRCodeCountries(id: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any): AxiosPromise<Array<AnalyticsDisplayValueDto>> {
            return QRCodeAnalyticsApiFp(configuration).getQRCodeCountries(id, skip, take, from, to, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRCodeCounts(id: string, from?: string, to?: string, options?: any): AxiosPromise<Array<AnalyticsDisplayValueDto>> {
            return QRCodeAnalyticsApiFp(configuration).getQRCodeCounts(id, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
         * @summary Get total hit counts for every QR code of a game at once
         * @param {string} gameId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRCodeCountsForGame(gameId: string, from?: string, to?: string, options?: any): AxiosPromise<Array<QRCodeCountResult>> {
            return QRCodeAnalyticsApiFp(configuration).getQRCodeCountsForGame(gameId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRCodeDeviceStats(id: string, from?: string, to?: string, options?: any): AxiosPromise<Array<AnalyticsDisplayValueDto>> {
            return QRCodeAnalyticsApiFp(configuration).getQRCodeDeviceStats(id, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sessions for a given whitelabel over a specific span of time
         * @param {string} id 
         * @param {GraphRequestDto} graphRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRCodeHitsGraphData(id: string, graphRequestDto: GraphRequestDto, options?: any): AxiosPromise<Array<GraphPlatformDto>> {
            return QRCodeAnalyticsApiFp(configuration).getQRCodeHitsGraphData(id, graphRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QRCodeAnalyticsApi - object-oriented interface
 * @export
 * @class QRCodeAnalyticsApi
 * @extends {BaseAPI}
 */
export class QRCodeAnalyticsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeAnalyticsApi
     */
    public getQRCodeCountries(id: string, skip: number, take: number, from?: string, to?: string, keyword?: string, options?: any) {
        return QRCodeAnalyticsApiFp(this.configuration).getQRCodeCountries(id, skip, take, from, to, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeAnalyticsApi
     */
    public getQRCodeCounts(id: string, from?: string, to?: string, options?: any) {
        return QRCodeAnalyticsApiFp(this.configuration).getQRCodeCounts(id, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | viewer       | 
     * @summary Get total hit counts for every QR code of a game at once
     * @param {string} gameId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeAnalyticsApi
     */
    public getQRCodeCountsForGame(gameId: string, from?: string, to?: string, options?: any) {
        return QRCodeAnalyticsApiFp(this.configuration).getQRCodeCountsForGame(gameId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeAnalyticsApi
     */
    public getQRCodeDeviceStats(id: string, from?: string, to?: string, options?: any) {
        return QRCodeAnalyticsApiFp(this.configuration).getQRCodeDeviceStats(id, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sessions for a given whitelabel over a specific span of time
     * @param {string} id 
     * @param {GraphRequestDto} graphRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeAnalyticsApi
     */
    public getQRCodeHitsGraphData(id: string, graphRequestDto: GraphRequestDto, options?: any) {
        return QRCodeAnalyticsApiFp(this.configuration).getQRCodeHitsGraphData(id, graphRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResetPasswordApi - axios parameter creator
 * @export
 */
export const ResetPasswordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordWithToken: async (resetPasswordDto: ResetPasswordDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordDto' is not null or undefined
            if (resetPasswordDto === null || resetPasswordDto === undefined) {
                throw new RequiredError('resetPasswordDto','Required parameter resetPasswordDto was null or undefined when calling changePasswordWithToken.');
            }
            const localVarPath = `/builder/reset-password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof resetPasswordDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(resetPasswordDto !== undefined ? resetPasswordDto : {}) : (resetPasswordDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestResetPasswordDto} requestResetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestResetPassword: async (requestResetPasswordDto: RequestResetPasswordDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestResetPasswordDto' is not null or undefined
            if (requestResetPasswordDto === null || requestResetPasswordDto === undefined) {
                throw new RequiredError('requestResetPasswordDto','Required parameter requestResetPasswordDto was null or undefined when calling requestResetPassword.');
            }
            const localVarPath = `/builder/reset-password/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestResetPasswordDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestResetPasswordDto !== undefined ? requestResetPasswordDto : {}) : (requestResetPasswordDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyResetTokenDto} verifyResetTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyResetToken: async (verifyResetTokenDto: VerifyResetTokenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyResetTokenDto' is not null or undefined
            if (verifyResetTokenDto === null || verifyResetTokenDto === undefined) {
                throw new RequiredError('verifyResetTokenDto','Required parameter verifyResetTokenDto was null or undefined when calling verifyResetToken.');
            }
            const localVarPath = `/builder/reset-password/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof verifyResetTokenDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(verifyResetTokenDto !== undefined ? verifyResetTokenDto : {}) : (verifyResetTokenDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResetPasswordApi - functional programming interface
 * @export
 */
export const ResetPasswordApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePasswordWithToken(resetPasswordDto: ResetPasswordDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnedAccessToken>> {
            const localVarAxiosArgs = await ResetPasswordApiAxiosParamCreator(configuration).changePasswordWithToken(resetPasswordDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RequestResetPasswordDto} requestResetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestResetPassword(requestResetPasswordDto: RequestResetPasswordDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleOkResponse>> {
            const localVarAxiosArgs = await ResetPasswordApiAxiosParamCreator(configuration).requestResetPassword(requestResetPasswordDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {VerifyResetTokenDto} verifyResetTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyResetToken(verifyResetTokenDto: VerifyResetTokenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyResetTokenResponseDto>> {
            const localVarAxiosArgs = await ResetPasswordApiAxiosParamCreator(configuration).verifyResetToken(verifyResetTokenDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ResetPasswordApi - factory interface
 * @export
 */
export const ResetPasswordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordWithToken(resetPasswordDto: ResetPasswordDto, options?: any): AxiosPromise<ReturnedAccessToken> {
            return ResetPasswordApiFp(configuration).changePasswordWithToken(resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RequestResetPasswordDto} requestResetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestResetPassword(requestResetPasswordDto: RequestResetPasswordDto, options?: any): AxiosPromise<SimpleOkResponse> {
            return ResetPasswordApiFp(configuration).requestResetPassword(requestResetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VerifyResetTokenDto} verifyResetTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyResetToken(verifyResetTokenDto: VerifyResetTokenDto, options?: any): AxiosPromise<VerifyResetTokenResponseDto> {
            return ResetPasswordApiFp(configuration).verifyResetToken(verifyResetTokenDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResetPasswordApi - object-oriented interface
 * @export
 * @class ResetPasswordApi
 * @extends {BaseAPI}
 */
export class ResetPasswordApi extends BaseAPI {
    /**
     * 
     * @param {ResetPasswordDto} resetPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResetPasswordApi
     */
    public changePasswordWithToken(resetPasswordDto: ResetPasswordDto, options?: any) {
        return ResetPasswordApiFp(this.configuration).changePasswordWithToken(resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RequestResetPasswordDto} requestResetPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResetPasswordApi
     */
    public requestResetPassword(requestResetPasswordDto: RequestResetPasswordDto, options?: any) {
        return ResetPasswordApiFp(this.configuration).requestResetPassword(requestResetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VerifyResetTokenDto} verifyResetTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResetPasswordApi
     */
    public verifyResetToken(verifyResetTokenDto: VerifyResetTokenDto, options?: any) {
        return ResetPasswordApiFp(this.configuration).verifyResetToken(verifyResetTokenDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SessionApi - axios parameter creator
 * @export
 */
export const SessionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get session by id)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getSessionById.');
            }
            const localVarPath = `/builder/session/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | session      | admin        | 
         * @summary Update session by id (partial update)
         * @param {string} id 
         * @param {SessionCrudUpdateDto} sessionCrudUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSession: async (id: string, sessionCrudUpdateDto: SessionCrudUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling putSession.');
            }
            // verify required parameter 'sessionCrudUpdateDto' is not null or undefined
            if (sessionCrudUpdateDto === null || sessionCrudUpdateDto === undefined) {
                throw new RequiredError('sessionCrudUpdateDto','Required parameter sessionCrudUpdateDto was null or undefined when calling putSession.');
            }
            const localVarPath = `/builder/session/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof sessionCrudUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(sessionCrudUpdateDto !== undefined ? sessionCrudUpdateDto : {}) : (sessionCrudUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | session      | admin        | 
         * @summary Remove variables from a single session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeVariablesFromSession: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeVariablesFromSession.');
            }
            const localVarPath = `/builder/session/{id}/remove-session-variables`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Remove variables from sessions before a certain date.
         * @param {string} gameId 
         * @param {SessionsRemoveVariablesDto} sessionsRemoveVariablesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeVariablesFromSessions: async (gameId: string, sessionsRemoveVariablesDto: SessionsRemoveVariablesDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling removeVariablesFromSessions.');
            }
            // verify required parameter 'sessionsRemoveVariablesDto' is not null or undefined
            if (sessionsRemoveVariablesDto === null || sessionsRemoveVariablesDto === undefined) {
                throw new RequiredError('sessionsRemoveVariablesDto','Required parameter sessionsRemoveVariablesDto was null or undefined when calling removeVariablesFromSessions.');
            }
            const localVarPath = `/builder/session/{gameId}/remove-variables`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof sessionsRemoveVariablesDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(sessionsRemoveVariablesDto !== undefined ? sessionsRemoveVariablesDto : {}) : (sessionsRemoveVariablesDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionApi - functional programming interface
 * @export
 */
export const SessionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get session by id)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SessionApiAxiosParamCreator(configuration).getSessionById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | session      | admin        | 
         * @summary Update session by id (partial update)
         * @param {string} id 
         * @param {SessionCrudUpdateDto} sessionCrudUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSession(id: string, sessionCrudUpdateDto: SessionCrudUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SessionApiAxiosParamCreator(configuration).putSession(id, sessionCrudUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | session      | admin        | 
         * @summary Remove variables from a single session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeVariablesFromSession(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SessionApiAxiosParamCreator(configuration).removeVariablesFromSession(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Remove variables from sessions before a certain date.
         * @param {string} gameId 
         * @param {SessionsRemoveVariablesDto} sessionsRemoveVariablesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeVariablesFromSessions(gameId: string, sessionsRemoveVariablesDto: SessionsRemoveVariablesDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleOkResponse>> {
            const localVarAxiosArgs = await SessionApiAxiosParamCreator(configuration).removeVariablesFromSessions(gameId, sessionsRemoveVariablesDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SessionApi - factory interface
 * @export
 */
export const SessionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get session by id)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionById(id: string, options?: any): AxiosPromise<void> {
            return SessionApiFp(configuration).getSessionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | session      | admin        | 
         * @summary Update session by id (partial update)
         * @param {string} id 
         * @param {SessionCrudUpdateDto} sessionCrudUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSession(id: string, sessionCrudUpdateDto: SessionCrudUpdateDto, options?: any): AxiosPromise<void> {
            return SessionApiFp(configuration).putSession(id, sessionCrudUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | session      | admin        | 
         * @summary Remove variables from a single session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeVariablesFromSession(id: string, options?: any): AxiosPromise<void> {
            return SessionApiFp(configuration).removeVariablesFromSession(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
         * @summary Remove variables from sessions before a certain date.
         * @param {string} gameId 
         * @param {SessionsRemoveVariablesDto} sessionsRemoveVariablesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeVariablesFromSessions(gameId: string, sessionsRemoveVariablesDto: SessionsRemoveVariablesDto, options?: any): AxiosPromise<SimpleOkResponse> {
            return SessionApiFp(configuration).removeVariablesFromSessions(gameId, sessionsRemoveVariablesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionApi - object-oriented interface
 * @export
 * @class SessionApi
 * @extends {BaseAPI}
 */
export class SessionApi extends BaseAPI {
    /**
     * 
     * @summary Get session by id)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    public getSessionById(id: string, options?: any) {
        return SessionApiFp(this.configuration).getSessionById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | session      | admin        | 
     * @summary Update session by id (partial update)
     * @param {string} id 
     * @param {SessionCrudUpdateDto} sessionCrudUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    public putSession(id: string, sessionCrudUpdateDto: SessionCrudUpdateDto, options?: any) {
        return SessionApiFp(this.configuration).putSession(id, sessionCrudUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | session      | admin        | 
     * @summary Remove variables from a single session
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    public removeVariablesFromSession(id: string, options?: any) {
        return SessionApiFp(this.configuration).removeVariablesFromSession(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | game         | admin        | 
     * @summary Remove variables from sessions before a certain date.
     * @param {string} gameId 
     * @param {SessionsRemoveVariablesDto} sessionsRemoveVariablesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    public removeVariablesFromSessions(gameId: string, sessionsRemoveVariablesDto: SessionsRemoveVariablesDto, options?: any) {
        return SessionApiFp(this.configuration).removeVariablesFromSessions(gameId, sessionsRemoveVariablesDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SessionJournalApi - axios parameter creator
 * @export
 */
export const SessionJournalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the journal entries captured for a session.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionJournal: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getSessionJournal.');
            }
            const localVarPath = `/builder/session/{id}/journal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Paginate all sessions that have a recorded journal.
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [gameId] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateSessionJournals: async (skip: number, take: number, gameId?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateSessionJournals.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateSessionJournals.');
            }
            const localVarPath = `/builder/session-journals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (gameId !== undefined) {
                localVarQueryParameter['gameId'] = gameId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionJournalApi - functional programming interface
 * @export
 */
export const SessionJournalApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the journal entries captured for a session.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionJournal(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalEventsDto>> {
            const localVarAxiosArgs = await SessionJournalApiAxiosParamCreator(configuration).getSessionJournal(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Paginate all sessions that have a recorded journal.
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [gameId] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateSessionJournals(skip: number, take: number, gameId?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SessionJournalItemDto>>> {
            const localVarAxiosArgs = await SessionJournalApiAxiosParamCreator(configuration).paginateSessionJournals(skip, take, gameId, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SessionJournalApi - factory interface
 * @export
 */
export const SessionJournalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get the journal entries captured for a session.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionJournal(id: string, options?: any): AxiosPromise<JournalEventsDto> {
            return SessionJournalApiFp(configuration).getSessionJournal(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Paginate all sessions that have a recorded journal.
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [gameId] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateSessionJournals(skip: number, take: number, gameId?: string, keyword?: string, options?: any): AxiosPromise<Array<SessionJournalItemDto>> {
            return SessionJournalApiFp(configuration).paginateSessionJournals(skip, take, gameId, keyword, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionJournalApi - object-oriented interface
 * @export
 * @class SessionJournalApi
 * @extends {BaseAPI}
 */
export class SessionJournalApi extends BaseAPI {
    /**
     * 
     * @summary Get the journal entries captured for a session.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionJournalApi
     */
    public getSessionJournal(id: string, options?: any) {
        return SessionJournalApiFp(this.configuration).getSessionJournal(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Paginate all sessions that have a recorded journal.
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [gameId] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionJournalApi
     */
    public paginateSessionJournals(skip: number, take: number, gameId?: string, keyword?: string, options?: any) {
        return SessionJournalApiFp(this.configuration).paginateSessionJournals(skip, take, gameId, keyword, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TranslationApi - axios parameter creator
 * @export
 */
export const TranslationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Translate texts using AI
         * @param {AiTranslateRequestDto} aiTranslateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiTranslate: async (aiTranslateRequestDto: AiTranslateRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiTranslateRequestDto' is not null or undefined
            if (aiTranslateRequestDto === null || aiTranslateRequestDto === undefined) {
                throw new RequiredError('aiTranslateRequestDto','Required parameter aiTranslateRequestDto was null or undefined when calling aiTranslate.');
            }
            const localVarPath = `/builder/translation/ai`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof aiTranslateRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(aiTranslateRequestDto !== undefined ? aiTranslateRequestDto : {}) : (aiTranslateRequestDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deliver new tokens to the token database
         * @param {DeliverTokensDto} deliverTokensDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliverTokens: async (deliverTokensDto: DeliverTokensDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliverTokensDto' is not null or undefined
            if (deliverTokensDto === null || deliverTokensDto === undefined) {
                throw new RequiredError('deliverTokensDto','Required parameter deliverTokensDto was null or undefined when calling deliverTokens.');
            }
            const localVarPath = `/builder/translation/deliver/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deliverTokensDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deliverTokensDto !== undefined ? deliverTokensDto : {}) : (deliverTokensDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download translations from poeditor remote
         * @param {string} languageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTranslations: async (languageId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'languageId' is not null or undefined
            if (languageId === null || languageId === undefined) {
                throw new RequiredError('languageId','Required parameter languageId was null or undefined when calling downloadTranslations.');
            }
            const localVarPath = `/builder/translation/download/{languageId}`
                .replace(`{${"languageId"}}`, encodeURIComponent(String(languageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTranslations: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/builder/translation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get specific translations, specified by languages in the filter.
         * @param {Array<string>} langs 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecificTranslations: async (langs: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'langs' is not null or undefined
            if (langs === null || langs === undefined) {
                throw new RequiredError('langs','Required parameter langs was null or undefined when calling getSpecificTranslations.');
            }
            const localVarPath = `/builder/translation/specific`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (langs) {
                localVarQueryParameter['langs'] = langs;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranslationApi - functional programming interface
 * @export
 */
export const TranslationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Translate texts using AI
         * @param {AiTranslateRequestDto} aiTranslateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiTranslate(aiTranslateRequestDto: AiTranslateRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiTranslateResponseDto>> {
            const localVarAxiosArgs = await TranslationApiAxiosParamCreator(configuration).aiTranslate(aiTranslateRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deliver new tokens to the token database
         * @param {DeliverTokensDto} deliverTokensDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliverTokens(deliverTokensDto: DeliverTokensDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverTokensResultDto>> {
            const localVarAxiosArgs = await TranslationApiAxiosParamCreator(configuration).deliverTokens(deliverTokensDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Download translations from poeditor remote
         * @param {string} languageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadTranslations(languageId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadTranslationsResultDto>> {
            const localVarAxiosArgs = await TranslationApiAxiosParamCreator(configuration).downloadTranslations(languageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTranslations(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageTranslationsDto>>> {
            const localVarAxiosArgs = await TranslationApiAxiosParamCreator(configuration).getAllTranslations(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get specific translations, specified by languages in the filter.
         * @param {Array<string>} langs 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpecificTranslations(langs: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageTranslationsDto>>> {
            const localVarAxiosArgs = await TranslationApiAxiosParamCreator(configuration).getSpecificTranslations(langs, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TranslationApi - factory interface
 * @export
 */
export const TranslationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
         * @summary Translate texts using AI
         * @param {AiTranslateRequestDto} aiTranslateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiTranslate(aiTranslateRequestDto: AiTranslateRequestDto, options?: any): AxiosPromise<AiTranslateResponseDto> {
            return TranslationApiFp(configuration).aiTranslate(aiTranslateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deliver new tokens to the token database
         * @param {DeliverTokensDto} deliverTokensDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliverTokens(deliverTokensDto: DeliverTokensDto, options?: any): AxiosPromise<DeliverTokensResultDto> {
            return TranslationApiFp(configuration).deliverTokens(deliverTokensDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download translations from poeditor remote
         * @param {string} languageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTranslations(languageId: string, options?: any): AxiosPromise<DownloadTranslationsResultDto> {
            return TranslationApiFp(configuration).downloadTranslations(languageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTranslations(options?: any): AxiosPromise<Array<LanguageTranslationsDto>> {
            return TranslationApiFp(configuration).getAllTranslations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get specific translations, specified by languages in the filter.
         * @param {Array<string>} langs 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecificTranslations(langs: Array<string>, options?: any): AxiosPromise<Array<LanguageTranslationsDto>> {
            return TranslationApiFp(configuration).getSpecificTranslations(langs, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranslationApi - object-oriented interface
 * @export
 * @class TranslationApi
 * @extends {BaseAPI}
 */
export class TranslationApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | authenticated | 
     * @summary Translate texts using AI
     * @param {AiTranslateRequestDto} aiTranslateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationApi
     */
    public aiTranslate(aiTranslateRequestDto: AiTranslateRequestDto, options?: any) {
        return TranslationApiFp(this.configuration).aiTranslate(aiTranslateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deliver new tokens to the token database
     * @param {DeliverTokensDto} deliverTokensDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationApi
     */
    public deliverTokens(deliverTokensDto: DeliverTokensDto, options?: any) {
        return TranslationApiFp(this.configuration).deliverTokens(deliverTokensDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download translations from poeditor remote
     * @param {string} languageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationApi
     */
    public downloadTranslations(languageId: string, options?: any) {
        return TranslationApiFp(this.configuration).downloadTranslations(languageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all translations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationApi
     */
    public getAllTranslations(options?: any) {
        return TranslationApiFp(this.configuration).getAllTranslations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get specific translations, specified by languages in the filter.
     * @param {Array<string>} langs 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationApi
     */
    public getSpecificTranslations(langs: Array<string>, options?: any) {
        return TranslationApiFp(this.configuration).getSpecificTranslations(langs, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Convert user account to builder user account
         * @param {string} id 
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChangePassword: async (id: string, changePasswordDto: ChangePasswordDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminChangePassword.');
            }
            // verify required parameter 'changePasswordDto' is not null or undefined
            if (changePasswordDto === null || changePasswordDto === undefined) {
                throw new RequiredError('changePasswordDto','Required parameter changePasswordDto was null or undefined when calling adminChangePassword.');
            }
            const localVarPath = `/builder/user/{id}/changePassword`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof changePasswordDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(changePasswordDto !== undefined ? changePasswordDto : {}) : (changePasswordDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Convert user account to builder user account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertToBuilder: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling convertToBuilder.');
            }
            const localVarPath = `/builder/user/{id}/convert`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new user
         * @param {UserCreateDto} userCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (userCreateDto: UserCreateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userCreateDto' is not null or undefined
            if (userCreateDto === null || userCreateDto === undefined) {
                throw new RequiredError('userCreateDto','Required parameter userCreateDto was null or undefined when calling createUser.');
            }
            const localVarPath = `/builder/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userCreateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userCreateDto !== undefined ? userCreateDto : {}) : (userCreateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteUser.');
            }
            const localVarPath = `/builder/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find in all users
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUser: async (skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling findUser.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling findUser.');
            }
            const localVarPath = `/builder/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find user by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUserById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findUserById.');
            }
            const localVarPath = `/builder/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Invite user to a specific resource
         * @param {InviteAccessControlDto} inviteAccessControlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser: async (inviteAccessControlDto: InviteAccessControlDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteAccessControlDto' is not null or undefined
            if (inviteAccessControlDto === null || inviteAccessControlDto === undefined) {
                throw new RequiredError('inviteAccessControlDto','Required parameter inviteAccessControlDto was null or undefined when calling inviteUser.');
            }
            const localVarPath = `/builder/user/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inviteAccessControlDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inviteAccessControlDto !== undefined ? inviteAccessControlDto : {}) : (inviteAccessControlDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user by id (partial update)
         * @param {string} id 
         * @param {UserUpdateDto} userUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (id: string, userUpdateDto: UserUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateUser.');
            }
            // verify required parameter 'userUpdateDto' is not null or undefined
            if (userUpdateDto === null || userUpdateDto === undefined) {
                throw new RequiredError('userUpdateDto','Required parameter userUpdateDto was null or undefined when calling updateUser.');
            }
            const localVarPath = `/builder/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userUpdateDto !== undefined ? userUpdateDto : {}) : (userUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Convert user account to builder user account
         * @param {string} id 
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminChangePassword(id: string, changePasswordDto: ChangePasswordDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).adminChangePassword(id, changePasswordDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Convert user account to builder user account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertToBuilder(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).convertToBuilder(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create new user
         * @param {UserCreateDto} userCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(userCreateDto: UserCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).createUser(userCreateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete user by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RawQueryResult>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).deleteUser(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find in all users
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUser(skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEntity>>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).findUser(skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find user by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUserById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).findUserById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Invite user to a specific resource
         * @param {InviteAccessControlDto} inviteAccessControlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUser(inviteAccessControlDto: InviteAccessControlDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessControlEntity>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).inviteUser(inviteAccessControlDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update user by id (partial update)
         * @param {string} id 
         * @param {UserUpdateDto} userUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(id: string, userUpdateDto: UserUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RawQueryResult>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).updateUser(id, userUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Convert user account to builder user account
         * @param {string} id 
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChangePassword(id: string, changePasswordDto: ChangePasswordDto, options?: any): AxiosPromise<UserEntity> {
            return UserApiFp(configuration).adminChangePassword(id, changePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Convert user account to builder user account
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertToBuilder(id: string, options?: any): AxiosPromise<UserEntity> {
            return UserApiFp(configuration).convertToBuilder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new user
         * @param {UserCreateDto} userCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userCreateDto: UserCreateDto, options?: any): AxiosPromise<UserEntity> {
            return UserApiFp(configuration).createUser(userCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(id: string, options?: any): AxiosPromise<RawQueryResult> {
            return UserApiFp(configuration).deleteUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find in all users
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUser(skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<UserEntity>> {
            return UserApiFp(configuration).findUser(skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find user by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUserById(id: string, options?: any): AxiosPromise<UserEntity> {
            return UserApiFp(configuration).findUserById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
         * @summary Invite user to a specific resource
         * @param {InviteAccessControlDto} inviteAccessControlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser(inviteAccessControlDto: InviteAccessControlDto, options?: any): AxiosPromise<AccessControlEntity> {
            return UserApiFp(configuration).inviteUser(inviteAccessControlDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user by id (partial update)
         * @param {string} id 
         * @param {UserUpdateDto} userUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(id: string, userUpdateDto: UserUpdateDto, options?: any): AxiosPromise<RawQueryResult> {
            return UserApiFp(configuration).updateUser(id, userUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Convert user account to builder user account
     * @param {string} id 
     * @param {ChangePasswordDto} changePasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public adminChangePassword(id: string, changePasswordDto: ChangePasswordDto, options?: any) {
        return UserApiFp(this.configuration).adminChangePassword(id, changePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Convert user account to builder user account
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public convertToBuilder(id: string, options?: any) {
        return UserApiFp(this.configuration).convertToBuilder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new user
     * @param {UserCreateDto} userCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public createUser(userCreateDto: UserCreateDto, options?: any) {
        return UserApiFp(this.configuration).createUser(userCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteUser(id: string, options?: any) {
        return UserApiFp(this.configuration).deleteUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find in all users
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public findUser(skip: number, take: number, keyword?: string, options?: any) {
        return UserApiFp(this.configuration).findUser(skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find user by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public findUserById(id: string, options?: any) {
        return UserApiFp(this.configuration).findUserById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | editor       | 
     * @summary Invite user to a specific resource
     * @param {InviteAccessControlDto} inviteAccessControlDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public inviteUser(inviteAccessControlDto: InviteAccessControlDto, options?: any) {
        return UserApiFp(this.configuration).inviteUser(inviteAccessControlDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user by id (partial update)
     * @param {string} id 
     * @param {UserUpdateDto} userUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateUser(id: string, userUpdateDto: UserUpdateDto, options?: any) {
        return UserApiFp(this.configuration).updateUser(id, userUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserAccountApi - axios parameter creator
 * @export
 */
export const UserAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Paginate events in which the user is a contact person
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordDto: ChangePasswordDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordDto' is not null or undefined
            if (changePasswordDto === null || changePasswordDto === undefined) {
                throw new RequiredError('changePasswordDto','Required parameter changePasswordDto was null or undefined when calling changePassword.');
            }
            const localVarPath = `/builder/me/changePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof changePasswordDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(changePasswordDto !== undefined ? changePasswordDto : {}) : (changePasswordDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find current user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyAccount: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/builder/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Paginate divisions in which the user is a contact person
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateDivisionsForContact: async (skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateDivisionsForContact.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateDivisionsForContact.');
            }
            const localVarPath = `/builder/me/divisionsForContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Paginate events which user is hosting
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [divisionId] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEventsCreatedByUser: async (skip: number, take: number, divisionId?: string, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateEventsCreatedByUser.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateEventsCreatedByUser.');
            }
            const localVarPath = `/builder/me/eventsHostedByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (divisionId !== undefined) {
                localVarQueryParameter['divisionId'] = divisionId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Paginate games created by user
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateGamesCreatedByUser: async (skip: number, take: number, keyword?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'skip' is not null or undefined
            if (skip === null || skip === undefined) {
                throw new RequiredError('skip','Required parameter skip was null or undefined when calling paginateGamesCreatedByUser.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling paginateGamesCreatedByUser.');
            }
            const localVarPath = `/builder/me/gamesCreatedByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark canvas guidance steps seen or unseen (merged, not replaced)
         * @param {UpdateSeenGuidanceDto} updateSeenGuidanceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeenCanvasGuidance: async (updateSeenGuidanceDto: UpdateSeenGuidanceDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSeenGuidanceDto' is not null or undefined
            if (updateSeenGuidanceDto === null || updateSeenGuidanceDto === undefined) {
                throw new RequiredError('updateSeenGuidanceDto','Required parameter updateSeenGuidanceDto was null or undefined when calling updateSeenCanvasGuidance.');
            }
            const localVarPath = `/builder/me/canvas-guidance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateSeenGuidanceDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateSeenGuidanceDto !== undefined ? updateSeenGuidanceDto : {}) : (updateSeenGuidanceDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark page editor guidance steps seen or unseen (merged, not replaced)
         * @param {UpdateSeenGuidanceDto} updateSeenGuidanceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeenPagesGuidance: async (updateSeenGuidanceDto: UpdateSeenGuidanceDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSeenGuidanceDto' is not null or undefined
            if (updateSeenGuidanceDto === null || updateSeenGuidanceDto === undefined) {
                throw new RequiredError('updateSeenGuidanceDto','Required parameter updateSeenGuidanceDto was null or undefined when calling updateSeenPagesGuidance.');
            }
            const localVarPath = `/builder/me/pages-guidance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateSeenGuidanceDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateSeenGuidanceDto !== undefined ? updateSeenGuidanceDto : {}) : (updateSeenGuidanceDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user account by id (partial update)
         * @param {UserEditAccount} userEditAccount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccount: async (userEditAccount: UserEditAccount, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userEditAccount' is not null or undefined
            if (userEditAccount === null || userEditAccount === undefined) {
                throw new RequiredError('userEditAccount','Required parameter userEditAccount was null or undefined when calling updateUserAccount.');
            }
            const localVarPath = `/builder/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userEditAccount !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userEditAccount !== undefined ? userEditAccount : {}) : (userEditAccount || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAccountApi - functional programming interface
 * @export
 */
export const UserAccountApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Paginate events in which the user is a contact person
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordDto: ChangePasswordDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleOkResponse>> {
            const localVarAxiosArgs = await UserAccountApiAxiosParamCreator(configuration).changePassword(changePasswordDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find current user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMyAccount(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyAccountDto>> {
            const localVarAxiosArgs = await UserAccountApiAxiosParamCreator(configuration).findMyAccount(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Paginate divisions in which the user is a contact person
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateDivisionsForContact(skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DivisionEntity>>> {
            const localVarAxiosArgs = await UserAccountApiAxiosParamCreator(configuration).paginateDivisionsForContact(skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Paginate events which user is hosting
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [divisionId] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateEventsCreatedByUser(skip: number, take: number, divisionId?: string, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventEntity>>> {
            const localVarAxiosArgs = await UserAccountApiAxiosParamCreator(configuration).paginateEventsCreatedByUser(skip, take, divisionId, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Paginate games created by user
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paginateGamesCreatedByUser(skip: number, take: number, keyword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameEntity>>> {
            const localVarAxiosArgs = await UserAccountApiAxiosParamCreator(configuration).paginateGamesCreatedByUser(skip, take, keyword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Mark canvas guidance steps seen or unseen (merged, not replaced)
         * @param {UpdateSeenGuidanceDto} updateSeenGuidanceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSeenCanvasGuidance(updateSeenGuidanceDto: UpdateSeenGuidanceDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await UserAccountApiAxiosParamCreator(configuration).updateSeenCanvasGuidance(updateSeenGuidanceDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Mark page editor guidance steps seen or unseen (merged, not replaced)
         * @param {UpdateSeenGuidanceDto} updateSeenGuidanceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSeenPagesGuidance(updateSeenGuidanceDto: UpdateSeenGuidanceDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await UserAccountApiAxiosParamCreator(configuration).updateSeenPagesGuidance(updateSeenGuidanceDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update user account by id (partial update)
         * @param {UserEditAccount} userEditAccount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserAccount(userEditAccount: UserEditAccount, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RawQueryResult>> {
            const localVarAxiosArgs = await UserAccountApiAxiosParamCreator(configuration).updateUserAccount(userEditAccount, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserAccountApi - factory interface
 * @export
 */
export const UserAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Paginate events in which the user is a contact person
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordDto: ChangePasswordDto, options?: any): AxiosPromise<SimpleOkResponse> {
            return UserAccountApiFp(configuration).changePassword(changePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find current user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyAccount(options?: any): AxiosPromise<MyAccountDto> {
            return UserAccountApiFp(configuration).findMyAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Paginate divisions in which the user is a contact person
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateDivisionsForContact(skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<DivisionEntity>> {
            return UserAccountApiFp(configuration).paginateDivisionsForContact(skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Paginate events which user is hosting
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [divisionId] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEventsCreatedByUser(skip: number, take: number, divisionId?: string, keyword?: string, options?: any): AxiosPromise<Array<EventEntity>> {
            return UserAccountApiFp(configuration).paginateEventsCreatedByUser(skip, take, divisionId, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Paginate games created by user
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateGamesCreatedByUser(skip: number, take: number, keyword?: string, options?: any): AxiosPromise<Array<GameEntity>> {
            return UserAccountApiFp(configuration).paginateGamesCreatedByUser(skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark canvas guidance steps seen or unseen (merged, not replaced)
         * @param {UpdateSeenGuidanceDto} updateSeenGuidanceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeenCanvasGuidance(updateSeenGuidanceDto: UpdateSeenGuidanceDto, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return UserAccountApiFp(configuration).updateSeenCanvasGuidance(updateSeenGuidanceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark page editor guidance steps seen or unseen (merged, not replaced)
         * @param {UpdateSeenGuidanceDto} updateSeenGuidanceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeenPagesGuidance(updateSeenGuidanceDto: UpdateSeenGuidanceDto, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return UserAccountApiFp(configuration).updateSeenPagesGuidance(updateSeenGuidanceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user account by id (partial update)
         * @param {UserEditAccount} userEditAccount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccount(userEditAccount: UserEditAccount, options?: any): AxiosPromise<RawQueryResult> {
            return UserAccountApiFp(configuration).updateUserAccount(userEditAccount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAccountApi - object-oriented interface
 * @export
 * @class UserAccountApi
 * @extends {BaseAPI}
 */
export class UserAccountApi extends BaseAPI {
    /**
     * 
     * @summary Paginate events in which the user is a contact person
     * @param {ChangePasswordDto} changePasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountApi
     */
    public changePassword(changePasswordDto: ChangePasswordDto, options?: any) {
        return UserAccountApiFp(this.configuration).changePassword(changePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find current user account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountApi
     */
    public findMyAccount(options?: any) {
        return UserAccountApiFp(this.configuration).findMyAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Paginate divisions in which the user is a contact person
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountApi
     */
    public paginateDivisionsForContact(skip: number, take: number, keyword?: string, options?: any) {
        return UserAccountApiFp(this.configuration).paginateDivisionsForContact(skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Paginate events which user is hosting
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [divisionId] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountApi
     */
    public paginateEventsCreatedByUser(skip: number, take: number, divisionId?: string, keyword?: string, options?: any) {
        return UserAccountApiFp(this.configuration).paginateEventsCreatedByUser(skip, take, divisionId, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Paginate games created by user
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountApi
     */
    public paginateGamesCreatedByUser(skip: number, take: number, keyword?: string, options?: any) {
        return UserAccountApiFp(this.configuration).paginateGamesCreatedByUser(skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark canvas guidance steps seen or unseen (merged, not replaced)
     * @param {UpdateSeenGuidanceDto} updateSeenGuidanceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountApi
     */
    public updateSeenCanvasGuidance(updateSeenGuidanceDto: UpdateSeenGuidanceDto, options?: any) {
        return UserAccountApiFp(this.configuration).updateSeenCanvasGuidance(updateSeenGuidanceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark page editor guidance steps seen or unseen (merged, not replaced)
     * @param {UpdateSeenGuidanceDto} updateSeenGuidanceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountApi
     */
    public updateSeenPagesGuidance(updateSeenGuidanceDto: UpdateSeenGuidanceDto, options?: any) {
        return UserAccountApiFp(this.configuration).updateSeenPagesGuidance(updateSeenGuidanceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user account by id (partial update)
     * @param {UserEditAccount} userEditAccount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountApi
     */
    public updateUserAccount(userEditAccount: UserEditAccount, options?: any) {
        return UserAccountApiFp(this.configuration).updateUserAccount(userEditAccount, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserAuthApi - axios parameter creator
 * @export
 */
export const UserAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Enable
         * @param {TwoFactorEnableDto} twoFactorEnableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enable2FA: async (twoFactorEnableDto: TwoFactorEnableDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'twoFactorEnableDto' is not null or undefined
            if (twoFactorEnableDto === null || twoFactorEnableDto === undefined) {
                throw new RequiredError('twoFactorEnableDto','Required parameter twoFactorEnableDto was null or undefined when calling enable2FA.');
            }
            const localVarPath = `/builder/user/auth/2fa/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof twoFactorEnableDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(twoFactorEnableDto !== undefined ? twoFactorEnableDto : {}) : (twoFactorEnableDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Enable
         * @param {TwoFactorAuthDto} twoFactorAuthDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enable2FAVerify: async (twoFactorAuthDto: TwoFactorAuthDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'twoFactorAuthDto' is not null or undefined
            if (twoFactorAuthDto === null || twoFactorAuthDto === undefined) {
                throw new RequiredError('twoFactorAuthDto','Required parameter twoFactorAuthDto was null or undefined when calling enable2FAVerify.');
            }
            const localVarPath = `/builder/user/auth/2fa/enable/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof twoFactorAuthDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(twoFactorAuthDto !== undefined ? twoFactorAuthDto : {}) : (twoFactorAuthDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with given credentials
         * @param {CredentialsDto} credentialsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (credentialsDto: CredentialsDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialsDto' is not null or undefined
            if (credentialsDto === null || credentialsDto === undefined) {
                throw new RequiredError('credentialsDto','Required parameter credentialsDto was null or undefined when calling login.');
            }
            const localVarPath = `/builder/user/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof credentialsDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(credentialsDto !== undefined ? credentialsDto : {}) : (credentialsDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with 2fa token
         * @param {TwoFactorAuthDto} twoFactorAuthDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWith2FA: async (twoFactorAuthDto: TwoFactorAuthDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'twoFactorAuthDto' is not null or undefined
            if (twoFactorAuthDto === null || twoFactorAuthDto === undefined) {
                throw new RequiredError('twoFactorAuthDto','Required parameter twoFactorAuthDto was null or undefined when calling loginWith2FA.');
            }
            const localVarPath = `/builder/user/auth/login/2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof twoFactorAuthDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(twoFactorAuthDto !== undefined ? twoFactorAuthDto : {}) : (twoFactorAuthDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Invalidates the currently used Accesstoken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/builder/user/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an account
         * @param {UserRegisterWithTokenDto} userRegisterWithTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (userRegisterWithTokenDto: UserRegisterWithTokenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegisterWithTokenDto' is not null or undefined
            if (userRegisterWithTokenDto === null || userRegisterWithTokenDto === undefined) {
                throw new RequiredError('userRegisterWithTokenDto','Required parameter userRegisterWithTokenDto was null or undefined when calling register.');
            }
            const localVarPath = `/builder/user/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userRegisterWithTokenDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userRegisterWithTokenDto !== undefined ? userRegisterWithTokenDto : {}) : (userRegisterWithTokenDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a token to register an account
         * @param {UserRegisterDto} userRegisterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestRegisterToken: async (userRegisterDto: UserRegisterDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegisterDto' is not null or undefined
            if (userRegisterDto === null || userRegisterDto === undefined) {
                throw new RequiredError('userRegisterDto','Required parameter userRegisterDto was null or undefined when calling requestRegisterToken.');
            }
            const localVarPath = `/builder/user/auth/register/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userRegisterDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userRegisterDto !== undefined ? userRegisterDto : {}) : (userRegisterDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve an access token to user data
         * @param {ResolveAccessTokenDto} resolveAccessTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAccessToken: async (resolveAccessTokenDto: ResolveAccessTokenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resolveAccessTokenDto' is not null or undefined
            if (resolveAccessTokenDto === null || resolveAccessTokenDto === undefined) {
                throw new RequiredError('resolveAccessTokenDto','Required parameter resolveAccessTokenDto was null or undefined when calling resolveAccessToken.');
            }
            const localVarPath = `/builder/user/auth/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof resolveAccessTokenDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(resolveAccessTokenDto !== undefined ? resolveAccessTokenDto : {}) : (resolveAccessTokenDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAuthApi - functional programming interface
 * @export
 */
export const UserAuthApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Enable
         * @param {TwoFactorEnableDto} twoFactorEnableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enable2FA(twoFactorEnableDto: TwoFactorEnableDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TwoFactorResponseDto>> {
            const localVarAxiosArgs = await UserAuthApiAxiosParamCreator(configuration).enable2FA(twoFactorEnableDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Enable
         * @param {TwoFactorAuthDto} twoFactorAuthDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enable2FAVerify(twoFactorAuthDto: TwoFactorAuthDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TwoFactorEnableDto>> {
            const localVarAxiosArgs = await UserAuthApiAxiosParamCreator(configuration).enable2FAVerify(twoFactorAuthDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Login with given credentials
         * @param {CredentialsDto} credentialsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(credentialsDto: CredentialsDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnedAccessToken>> {
            const localVarAxiosArgs = await UserAuthApiAxiosParamCreator(configuration).login(credentialsDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Login with 2fa token
         * @param {TwoFactorAuthDto} twoFactorAuthDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWith2FA(twoFactorAuthDto: TwoFactorAuthDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnedAccessToken>> {
            const localVarAxiosArgs = await UserAuthApiAxiosParamCreator(configuration).loginWith2FA(twoFactorAuthDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Invalidates the currently used Accesstoken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RawQueryResult>> {
            const localVarAxiosArgs = await UserAuthApiAxiosParamCreator(configuration).logout(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create an account
         * @param {UserRegisterWithTokenDto} userRegisterWithTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(userRegisterWithTokenDto: UserRegisterWithTokenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnedAccessToken>> {
            const localVarAxiosArgs = await UserAuthApiAxiosParamCreator(configuration).register(userRegisterWithTokenDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Request a token to register an account
         * @param {UserRegisterDto} userRegisterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestRegisterToken(userRegisterDto: UserRegisterDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleOkResponse>> {
            const localVarAxiosArgs = await UserAuthApiAxiosParamCreator(configuration).requestRegisterToken(userRegisterDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Resolve an access token to user data
         * @param {ResolveAccessTokenDto} resolveAccessTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveAccessToken(resolveAccessTokenDto: ResolveAccessTokenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnedAccessToken>> {
            const localVarAxiosArgs = await UserAuthApiAxiosParamCreator(configuration).resolveAccessToken(resolveAccessTokenDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserAuthApi - factory interface
 * @export
 */
export const UserAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Enable
         * @param {TwoFactorEnableDto} twoFactorEnableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enable2FA(twoFactorEnableDto: TwoFactorEnableDto, options?: any): AxiosPromise<TwoFactorResponseDto> {
            return UserAuthApiFp(configuration).enable2FA(twoFactorEnableDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Enable
         * @param {TwoFactorAuthDto} twoFactorAuthDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enable2FAVerify(twoFactorAuthDto: TwoFactorAuthDto, options?: any): AxiosPromise<TwoFactorEnableDto> {
            return UserAuthApiFp(configuration).enable2FAVerify(twoFactorAuthDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with given credentials
         * @param {CredentialsDto} credentialsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(credentialsDto: CredentialsDto, options?: any): AxiosPromise<ReturnedAccessToken> {
            return UserAuthApiFp(configuration).login(credentialsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with 2fa token
         * @param {TwoFactorAuthDto} twoFactorAuthDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWith2FA(twoFactorAuthDto: TwoFactorAuthDto, options?: any): AxiosPromise<ReturnedAccessToken> {
            return UserAuthApiFp(configuration).loginWith2FA(twoFactorAuthDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
         * @summary Invalidates the currently used Accesstoken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<RawQueryResult> {
            return UserAuthApiFp(configuration).logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an account
         * @param {UserRegisterWithTokenDto} userRegisterWithTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(userRegisterWithTokenDto: UserRegisterWithTokenDto, options?: any): AxiosPromise<ReturnedAccessToken> {
            return UserAuthApiFp(configuration).register(userRegisterWithTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a token to register an account
         * @param {UserRegisterDto} userRegisterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestRegisterToken(userRegisterDto: UserRegisterDto, options?: any): AxiosPromise<SimpleOkResponse> {
            return UserAuthApiFp(configuration).requestRegisterToken(userRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve an access token to user data
         * @param {ResolveAccessTokenDto} resolveAccessTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAccessToken(resolveAccessTokenDto: ResolveAccessTokenDto, options?: any): AxiosPromise<ReturnedAccessToken> {
            return UserAuthApiFp(configuration).resolveAccessToken(resolveAccessTokenDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAuthApi - object-oriented interface
 * @export
 * @class UserAuthApi
 * @extends {BaseAPI}
 */
export class UserAuthApi extends BaseAPI {
    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
     * @summary Enable
     * @param {TwoFactorEnableDto} twoFactorEnableDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public enable2FA(twoFactorEnableDto: TwoFactorEnableDto, options?: any) {
        return UserAuthApiFp(this.configuration).enable2FA(twoFactorEnableDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
     * @summary Enable
     * @param {TwoFactorAuthDto} twoFactorAuthDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public enable2FAVerify(twoFactorAuthDto: TwoFactorAuthDto, options?: any) {
        return UserAuthApiFp(this.configuration).enable2FAVerify(twoFactorAuthDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with given credentials
     * @param {CredentialsDto} credentialsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public login(credentialsDto: CredentialsDto, options?: any) {
        return UserAuthApiFp(this.configuration).login(credentialsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with 2fa token
     * @param {TwoFactorAuthDto} twoFactorAuthDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public loginWith2FA(twoFactorAuthDto: TwoFactorAuthDto, options?: any) {
        return UserAuthApiFp(this.configuration).loginWith2FA(twoFactorAuthDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ### Access | Scope        | Role         |  | ------------ | ------------ |  | *            | host         | 
     * @summary Invalidates the currently used Accesstoken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public logout(options?: any) {
        return UserAuthApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an account
     * @param {UserRegisterWithTokenDto} userRegisterWithTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public register(userRegisterWithTokenDto: UserRegisterWithTokenDto, options?: any) {
        return UserAuthApiFp(this.configuration).register(userRegisterWithTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a token to register an account
     * @param {UserRegisterDto} userRegisterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public requestRegisterToken(userRegisterDto: UserRegisterDto, options?: any) {
        return UserAuthApiFp(this.configuration).requestRegisterToken(userRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve an access token to user data
     * @param {ResolveAccessTokenDto} resolveAccessTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAuthApi
     */
    public resolveAccessToken(resolveAccessTokenDto: ResolveAccessTokenDto, options?: any) {
        return UserAuthApiFp(this.configuration).resolveAccessToken(resolveAccessTokenDto, options).then((request) => request(this.axios, this.basePath));
    }
}


